{
  "bulbasaur": {
    "num": 1,
    "name": "Bulbasaur",
    "types": [
      "Grass",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 50,
      "def": 50,
      "spe": 45,
      "spa": 65,
      "spd": 65
    },
    "abilities": {
      "0": "Harvest",
      "1": "Overgrow"
    },
    "weightkg": 6.9,
    "evos": [
      "Ivysaur"
    ],
    "eggGroups": [
      "Monster",
      "Grass"
    ]
  },
  "ivysaur": {
    "num": 2,
    "name": "Ivysaur",
    "types": [
      "Grass",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 70,
      "def": 75,
      "spe": 60,
      "spa": 85,
      "spd": 85
    },
    "abilities": {
      "0": "Harvest",
      "1": "Overgrow"
    },
    "weightkg": 6.9,
    "prevo": "Bulbasaur",
    "evoLevel": 17,
    "evos": [
      "Venusaur"
    ],
    "eggGroups": [
      "Monster",
      "Grass"
    ]
  },
  "venusaur": {
    "num": 3,
    "name": "Venusaur",
    "types": [
      "Grass",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 100,
      "atk": 100,
      "def": 85,
      "spe": 65,
      "spa": 100,
      "spd": 100
    },
    "abilities": {
      "0": "Harvest",
      "1": "Solar Rush"
    },
    "weightkg": 100.0,
    "prevo": "Ivysaur",
    "evoLevel": 36,
    "eggGroups": [
      "Monster",
      "Grass"
    ],
    "formes": [
      "Venusaur",
      "Venusaur-Mega"
    ]
  },
  "venusaurmega": {
    "num": 3,
    "name": "Venusaur-Mega",
    "types": [
      "Grass",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 100,
      "atk": 120,
      "def": 123,
      "spe": 60,
      "spa": 124,
      "spd": 123
    },
    "abilities": {
      "0": "Thick Fat",
      "1": "Grassy Guard"
    },
    "weightkg": 155.5,
    "eggGroups": [
      "Monster",
      "Grass"
    ],
    "baseSpecies": "Venusaur",
    "forme": "Mega",
    "formes": [
      "Venusaur",
      "Venusaur-Mega"
    ],
    "requiredItems": [
      "Mega Stone I",
      "Venusaurite"
    ]
  },
  "charmander": {
    "num": 4,
    "name": "Charmander",
    "types": [
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 58,
      "def": 45,
      "spe": 62,
      "spa": 65,
      "spd": 45
    },
    "abilities": {
      "0": "Blaze",
      "1": "Moxie"
    },
    "weightkg": 8.5,
    "evos": [
      "Charmeleon"
    ],
    "eggGroups": [
      "Monster",
      "Dragon"
    ]
  },
  "charmeleon": {
    "num": 5,
    "name": "Charmeleon",
    "types": [
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 58,
      "atk": 93,
      "def": 52,
      "spe": 87,
      "spa": 93,
      "spd": 52
    },
    "abilities": {
      "0": "Blaze",
      "1": "Moxie"
    },
    "weightkg": 19.0,
    "prevo": "Charmander",
    "evoLevel": 17,
    "evos": [
      "Charizard"
    ],
    "eggGroups": [
      "Monster",
      "Dragon"
    ]
  },
  "charizard": {
    "num": 6,
    "name": "Charizard",
    "types": [
      "Fire",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 78,
      "atk": 111,
      "def": 70,
      "spe": 100,
      "spa": 121,
      "spd": 70
    },
    "abilities": {
      "0": "Ruthless",
      "1": "Moxie"
    },
    "weightkg": 90.5,
    "prevo": "Charmeleon",
    "evoLevel": 36,
    "eggGroups": [
      "Monster",
      "Dragon"
    ],
    "formes": [
      "Charizard",
      "Charizard-Mega-X",
      "Charizard-Mega-Y"
    ]
  },
  "charizardmegax": {
    "num": 6,
    "name": "Charizard-Mega-X",
    "types": [
      "Fire",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 78,
      "atk": 145,
      "def": 90,
      "spe": 102,
      "spa": 145,
      "spd": 90
    },
    "abilities": {
      "0": "Sheer Force",
      "1": "Levitate"
    },
    "weightkg": 110.5,
    "eggGroups": [
      "Monster",
      "Dragon"
    ],
    "baseSpecies": "Charizard",
    "forme": "Mega-X",
    "formes": [
      "Charizard",
      "Charizard-Mega-X",
      "Charizard-Mega-Y"
    ],
    "requiredItems": [
      "Charizardite X"
    ]
  },
  "charizardmegay": {
    "num": 6,
    "name": "Charizard-Mega-Y",
    "types": [
      "Fire",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 78,
      "atk": 132,
      "def": 70,
      "spe": 111,
      "spa": 159,
      "spd": 100
    },
    "abilities": {
      "0": "Drought",
      "1": "Aerilate"
    },
    "weightkg": 100.5,
    "eggGroups": [
      "Monster",
      "Dragon"
    ],
    "baseSpecies": "Charizard",
    "forme": "Mega-Y",
    "formes": [
      "Charizard",
      "Charizard-Mega-X",
      "Charizard-Mega-Y"
    ],
    "requiredItems": [
      "Charizardite Y"
    ]
  },
  "squirtle": {
    "num": 7,
    "name": "Squirtle",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 44,
      "atk": 48,
      "def": 70,
      "spe": 43,
      "spa": 50,
      "spd": 65
    },
    "abilities": {
      "0": "Shell Armor",
      "1": "Torrent"
    },
    "weightkg": 9.0,
    "evos": [
      "Wartortle"
    ],
    "eggGroups": [
      "Monster",
      "Water 1"
    ]
  },
  "wartortle": {
    "num": 8,
    "name": "Wartortle",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 59,
      "atk": 63,
      "def": 95,
      "spe": 58,
      "spa": 80,
      "spd": 80
    },
    "abilities": {
      "0": "Shell Armor",
      "1": "Torrent"
    },
    "weightkg": 22.5,
    "prevo": "Squirtle",
    "evoLevel": 17,
    "evos": [
      "Blastoise"
    ],
    "eggGroups": [
      "Monster",
      "Water 1"
    ]
  },
  "blastoise": {
    "num": 9,
    "name": "Blastoise",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 84,
      "atk": 73,
      "def": 125,
      "spe": 43,
      "spa": 120,
      "spd": 105
    },
    "abilities": {
      "0": "Shell Armor",
      "1": "Bulletproof"
    },
    "weightkg": 85.5,
    "prevo": "Wartortle",
    "evoLevel": 36,
    "eggGroups": [
      "Monster",
      "Water 1"
    ],
    "formes": [
      "Blastoise",
      "Blastoise-Mega"
    ]
  },
  "blastoisemega": {
    "num": 9,
    "name": "Blastoise-Mega",
    "types": [
      "Water",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 84,
      "atk": 123,
      "def": 135,
      "spe": 33,
      "spa": 160,
      "spd": 115
    },
    "abilities": {
      "0": "Mega Launcher",
      "1": "Rapid Fire"
    },
    "weightkg": 101.1,
    "eggGroups": [
      "Monster",
      "Water 1"
    ],
    "baseSpecies": "Blastoise",
    "forme": "Mega",
    "formes": [
      "Blastoise",
      "Blastoise-Mega"
    ],
    "requiredItems": [
      "Mega Stone I",
      "Blastoisinite"
    ]
  },
  "caterpie": {
    "num": 10,
    "name": "Caterpie",
    "types": [
      "Bug"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 35,
      "atk": 30,
      "def": 35,
      "spe": 45,
      "spa": 55,
      "spd": 50
    },
    "abilities": {
      "0": "Sap Sipper",
      "1": "Shield Dust"
    },
    "weightkg": 2.9,
    "evos": [
      "Metapod"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "metapod": {
    "num": 11,
    "name": "Metapod",
    "types": [
      "Bug"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 40,
      "def": 95,
      "spe": 30,
      "spa": 55,
      "spd": 80
    },
    "abilities": {
      "0": "Sturdy",
      "1": "Battle Armor"
    },
    "weightkg": 9.9,
    "prevo": "Caterpie",
    "evoLevel": 10,
    "evos": [
      "Butterfree"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "butterfree": {
    "num": 12,
    "name": "Butterfree",
    "types": [
      "Bug",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 45,
      "def": 60,
      "spe": 95,
      "spa": 110,
      "spd": 100
    },
    "abilities": {
      "0": "Unburden",
      "1": "Prankster"
    },
    "weightkg": 32.0,
    "prevo": "Metapod",
    "evoLevel": 20,
    "eggGroups": [
      "Bug"
    ]
  },
  "weedle": {
    "num": 13,
    "name": "Weedle",
    "types": [
      "Bug",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 35,
      "atk": 60,
      "def": 40,
      "spe": 50,
      "spa": 30,
      "spd": 35
    },
    "abilities": {
      "0": "Poison Touch",
      "1": "Sap Sipper"
    },
    "weightkg": 3.2,
    "evos": [
      "Kakuna"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "kakuna": {
    "num": 14,
    "name": "Kakuna",
    "types": [
      "Bug",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 60,
      "def": 85,
      "spe": 35,
      "spa": 40,
      "spd": 60
    },
    "abilities": {
      "0": "Battle Armor",
      "1": "Sturdy"
    },
    "weightkg": 10.0,
    "prevo": "Weedle",
    "evoLevel": 10,
    "evos": [
      "Beedrill"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "beedrill": {
    "num": 15,
    "name": "Beedrill",
    "types": [
      "Bug",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 120,
      "def": 65,
      "spe": 120,
      "spa": 45,
      "spd": 65
    },
    "abilities": {
      "0": "Ruthless",
      "1": "Levitate"
    },
    "weightkg": 29.5,
    "prevo": "Kakuna",
    "evoLevel": 20,
    "eggGroups": [
      "Bug"
    ],
    "formes": [
      "Beedrill",
      "Beedrill-Mega"
    ]
  },
  "beedrillmega": {
    "num": 15,
    "name": "Beedrill-Mega",
    "types": [
      "Bug",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 160,
      "def": 75,
      "spe": 160,
      "spa": 45,
      "spd": 75
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Levitate"
    },
    "weightkg": 40.5,
    "eggGroups": [
      "Bug"
    ],
    "baseSpecies": "Beedrill",
    "forme": "Mega",
    "formes": [
      "Beedrill",
      "Beedrill-Mega"
    ],
    "requiredItems": [
      "Mega Stone I",
      "Beedrillite"
    ]
  },
  "pidgey": {
    "num": 16,
    "name": "Pidgey",
    "types": [
      "Normal",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 60,
      "def": 45,
      "spe": 85,
      "spa": 35,
      "spd": 45
    },
    "abilities": {
      "0": "Defiant",
      "1": "Emergency Exit"
    },
    "weightkg": 1.8,
    "evos": [
      "Pidgeotto"
    ],
    "eggGroups": [
      "Flying"
    ]
  },
  "pidgeotto": {
    "num": 17,
    "name": "Pidgeotto",
    "types": [
      "Normal",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 80,
      "def": 60,
      "spe": 105,
      "spa": 50,
      "spd": 60
    },
    "abilities": {
      "0": "Defiant",
      "1": "Speed Boost"
    },
    "weightkg": 30.0,
    "prevo": "Pidgey",
    "evoLevel": 15,
    "evos": [
      "Pidgeot"
    ],
    "eggGroups": [
      "Flying"
    ]
  },
  "pidgeot": {
    "num": 18,
    "name": "Pidgeot",
    "types": [
      "Normal",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 85,
      "atk": 100,
      "def": 85,
      "spe": 125,
      "spa": 70,
      "spd": 85
    },
    "abilities": {
      "0": "Defiant",
      "1": "Speed Boost"
    },
    "weightkg": 39.5,
    "prevo": "Pidgeotto",
    "evoLevel": 31,
    "eggGroups": [
      "Flying"
    ],
    "formes": [
      "Pidgeot",
      "Pidgeot-Mega"
    ]
  },
  "pidgeotmega": {
    "num": 18,
    "name": "Pidgeot-Mega",
    "types": [
      "Normal",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 85,
      "atk": 115,
      "def": 85,
      "spe": 145,
      "spa": 135,
      "spd": 85
    },
    "abilities": {
      "0": "No Guard",
      "1": "Guarding Gale"
    },
    "weightkg": 50.5,
    "eggGroups": [
      "Flying"
    ],
    "baseSpecies": "Pidgeot",
    "forme": "Mega",
    "formes": [
      "Pidgeot",
      "Pidgeot-Mega"
    ],
    "requiredItems": [
      "Mega Stone I",
      "Pidgeotite"
    ]
  },
  "rattata": {
    "num": 19,
    "name": "Rattata",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 47,
      "atk": 69,
      "def": 42,
      "spe": 90,
      "spa": 40,
      "spd": 42
    },
    "abilities": {
      "0": "Hustle",
      "1": "Defiant",
      "H": "Guts"
    },
    "weightkg": 3.5,
    "evos": [
      "Raticate"
    ],
    "eggGroups": [
      "Field"
    ],
    "formes": [
      "Rattata",
      "Rattata-Alola"
    ]
  },
  "rattataalola": {
    "num": 19,
    "name": "Rattata-Alola",
    "types": [
      "Dark",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 47,
      "atk": 69,
      "def": 42,
      "spe": 90,
      "spa": 40,
      "spd": 42
    },
    "abilities": {
      "0": "Hustle",
      "1": "Pickpocket",
      "H": "Guts"
    },
    "weightkg": 3.8,
    "evos": [
      "Raticate-Alola-Totem",
      "Raticate-Alola"
    ],
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Rattata",
    "forme": "Alola",
    "formes": [
      "Rattata",
      "Rattata-Alola"
    ]
  },
  "raticate": {
    "num": 20,
    "name": "Raticate",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 109,
      "def": 72,
      "spe": 107,
      "spa": 50,
      "spd": 72
    },
    "abilities": {
      "0": "Hustle",
      "1": "Strong Jaw",
      "H": "Guts"
    },
    "weightkg": 18.5,
    "prevo": "Rattata",
    "evoLevel": 20,
    "eggGroups": [
      "Field"
    ],
    "formes": [
      "Raticate",
      "Raticate-Alola",
      "Raticate-Alola-Totem"
    ]
  },
  "raticatealola": {
    "num": 20,
    "name": "Raticate-Alola",
    "types": [
      "Dark",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 94,
      "atk": 109,
      "def": 80,
      "spe": 77,
      "spa": 40,
      "spd": 80
    },
    "abilities": {
      "0": "Hustle",
      "1": "Strong Jaw",
      "H": "Guts"
    },
    "weightkg": 25.5,
    "prevo": "Rattata-Alola",
    "evoLevel": 20,
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Raticate",
    "forme": "Alola",
    "formes": [
      "Raticate",
      "Raticate-Alola",
      "Raticate-Alola-Totem"
    ]
  },
  "raticatealolatotem": {
    "num": 20,
    "name": "Raticate-Alola-Totem",
    "types": [
      "Dark",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 119,
      "atk": 114,
      "def": 90,
      "spe": 62,
      "spa": 40,
      "spd": 90
    },
    "abilities": {
      "0": "Hustle",
      "1": "Metabolism",
      "H": "Guts"
    },
    "weightkg": 105.0,
    "prevo": "Rattata-Alola",
    "evoLevel": 20,
    "evoType": "useItem",
    "evoItem": "Strange Souvenir",
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Raticate",
    "forme": "Alola-Totem",
    "formes": [
      "Raticate",
      "Raticate-Alola",
      "Raticate-Alola-Totem"
    ]
  },
  "spearow": {
    "num": 21,
    "name": "Spearow",
    "types": [
      "Electric",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 75,
      "def": 45,
      "spe": 103,
      "spa": 31,
      "spd": 51
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Defiant"
    },
    "weightkg": 2.0,
    "evos": [
      "Fearow"
    ],
    "eggGroups": [
      "Flying"
    ]
  },
  "fearow": {
    "num": 22,
    "name": "Fearow",
    "types": [
      "Electric",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 120,
      "def": 75,
      "spe": 133,
      "spa": 41,
      "spd": 81
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Reckless"
    },
    "weightkg": 38.0,
    "prevo": "Spearow",
    "evoLevel": 22,
    "eggGroups": [
      "Flying"
    ]
  },
  "ekans": {
    "num": 23,
    "name": "Ekans",
    "types": [
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 65,
      "def": 55,
      "spe": 70,
      "spa": 60,
      "spd": 55
    },
    "abilities": {
      "0": "Unnerve",
      "1": "Intimidate"
    },
    "weightkg": 6.9,
    "evos": [
      "Arbok"
    ],
    "eggGroups": [
      "Field",
      "Dragon"
    ]
  },
  "arbok": {
    "num": 24,
    "name": "Arbok",
    "types": [
      "Poison",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 105,
      "atk": 105,
      "def": 80,
      "spe": 80,
      "spa": 85,
      "spd": 80
    },
    "abilities": {
      "0": "Sheer Force",
      "1": "Intimidate"
    },
    "weightkg": 65.0,
    "prevo": "Ekans",
    "evoLevel": 22,
    "eggGroups": [
      "Field",
      "Dragon"
    ]
  },
  "pikachu": {
    "num": 25,
    "name": "Pikachu",
    "types": [
      "Electric"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 70,
      "def": 45,
      "spe": 115,
      "spa": 90,
      "spd": 50
    },
    "abilities": {
      "0": "Galvanize",
      "1": "Lightning Rod"
    },
    "weightkg": 6.0,
    "prevo": "Pichu",
    "evoLevel": 15,
    "evos": [
      "Raichu",
      "Raichu-Alola"
    ],
    "eggGroups": [
      "Field",
      "Fairy"
    ],
    "formes": [
      "Pikachu"
    ]
  },
  "raichu": {
    "num": 26,
    "name": "Raichu",
    "types": [
      "Electric"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 95,
      "def": 65,
      "spe": 125,
      "spa": 110,
      "spd": 85
    },
    "abilities": {
      "0": "Instinct",
      "1": "Electric Surge"
    },
    "weightkg": 30.0,
    "prevo": "Pikachu",
    "evoLevel": 33,
    "evoType": "levelHold",
    "evoItem": "Electric Gem",
    "eggGroups": [
      "Field",
      "Fairy"
    ],
    "formes": [
      "Raichu",
      "Raichu-Alola"
    ]
  },
  "raichualola": {
    "num": 26,
    "name": "Raichu-Alola",
    "types": [
      "Electric",
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 85,
      "def": 60,
      "spe": 130,
      "spa": 110,
      "spd": 95
    },
    "abilities": {
      "0": "Levitate",
      "1": "Psychic Surge"
    },
    "weightkg": 21.0,
    "prevo": "Pikachu",
    "evoLevel": 33,
    "evoType": "levelHold",
    "evoItem": "Psychic Gem",
    "eggGroups": [
      "Field",
      "Fairy"
    ],
    "baseSpecies": "Raichu",
    "forme": "Alola",
    "formes": [
      "Raichu",
      "Raichu-Alola"
    ]
  },
  "sandshrew": {
    "num": 27,
    "name": "Sandshrew",
    "types": [
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 75,
      "def": 95,
      "spe": 50,
      "spa": 20,
      "spd": 60
    },
    "abilities": {
      "0": "Sand Force",
      "1": "Rough Skin"
    },
    "weightkg": 12.0,
    "evos": [
      "Sandslash"
    ],
    "eggGroups": [
      "Field"
    ],
    "formes": [
      "Sandshrew",
      "Sandshrew-Alola"
    ]
  },
  "sandshrewalola": {
    "num": 27,
    "name": "Sandshrew-Alola",
    "types": [
      "Ice",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 70,
      "def": 110,
      "spe": 40,
      "spa": 10,
      "spd": 70
    },
    "abilities": {
      "0": "Refrigerate",
      "1": "Sturdy"
    },
    "weightkg": 40.0,
    "evos": [
      "Sandslash-Alola"
    ],
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Sandshrew",
    "forme": "Alola",
    "formes": [
      "Sandshrew",
      "Sandshrew-Alola"
    ]
  },
  "sandslash": {
    "num": 28,
    "name": "Sandslash",
    "types": [
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 110,
      "def": 115,
      "spe": 110,
      "spa": 45,
      "spd": 70
    },
    "abilities": {
      "0": "Sand Rush",
      "1": "Tough Claws"
    },
    "weightkg": 29.5,
    "prevo": "Sandshrew",
    "evoLevel": 22,
    "eggGroups": [
      "Field"
    ],
    "formes": [
      "Sandslash",
      "Sandslash-Alola"
    ]
  },
  "sandslashalola": {
    "num": 28,
    "name": "Sandslash-Alola",
    "types": [
      "Ice",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 115,
      "def": 125,
      "spe": 100,
      "spa": 25,
      "spd": 85
    },
    "abilities": {
      "0": "Slush Rush",
      "1": "Technician"
    },
    "weightkg": 55.0,
    "prevo": "Sandshrew-Alola",
    "evoLevel": 22,
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Sandslash",
    "forme": "Alola",
    "formes": [
      "Sandslash",
      "Sandslash-Alola"
    ]
  },
  "nidoranf": {
    "num": 29,
    "name": "NidoranF",
    "types": [
      "Poison",
      "Normal"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 45,
      "atk": 65,
      "def": 65,
      "spe": 65,
      "spa": 40,
      "spd": 55
    },
    "abilities": {
      "0": "Multiscale",
      "1": "Rough Skin"
    },
    "weightkg": 60.0,
    "evos": [
      "Nidorina"
    ],
    "eggGroups": [
      "Monster",
      "Field"
    ]
  },
  "nidorina": {
    "num": 30,
    "name": "Nidorina",
    "types": [
      "Poison",
      "Normal"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 69,
      "atk": 83,
      "def": 92,
      "spe": 86,
      "spa": 50,
      "spd": 75
    },
    "abilities": {
      "0": "Multiscale",
      "1": "Rough Skin"
    },
    "weightkg": 20.0,
    "prevo": "NidoranF",
    "evoLevel": 20,
    "evos": [
      "Nidoqueen"
    ],
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "nidoqueen": {
    "num": 31,
    "name": "Nidoqueen",
    "types": [
      "Poison",
      "Ground"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 90,
      "atk": 131,
      "def": 123,
      "spe": 81,
      "spa": 60,
      "spd": 90
    },
    "abilities": {
      "0": "Multiscale",
      "1": "Intimidate",
      "H": "Queenly Majesty"
    },
    "weightkg": 60.0,
    "prevo": "Nidorina",
    "evoLevel": 40,
    "evoType": "levelHold",
    "evoItem": "Ground Gem",
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "nidoranm": {
    "num": 32,
    "name": "NidoranM",
    "types": [
      "Poison",
      "Normal"
    ],
    "gender": "M",
    "baseStats": {
      "hp": 45,
      "atk": 72,
      "def": 58,
      "spe": 70,
      "spa": 40,
      "spd": 50
    },
    "abilities": {
      "0": "Merciless",
      "1": "Hustle"
    },
    "weightkg": 9.0,
    "evos": [
      "Nidorino"
    ],
    "eggGroups": [
      "Monster",
      "Field"
    ]
  },
  "nidorino": {
    "num": 33,
    "name": "Nidorino",
    "types": [
      "Poison",
      "Normal"
    ],
    "gender": "M",
    "baseStats": {
      "hp": 60,
      "atk": 101,
      "def": 83,
      "spe": 96,
      "spa": 50,
      "spd": 65
    },
    "abilities": {
      "0": "Merciless",
      "1": "Hustle"
    },
    "weightkg": 19.5,
    "prevo": "NidoranM",
    "evoLevel": 20,
    "evos": [
      "Nidoking"
    ],
    "eggGroups": [
      "Monster",
      "Field"
    ]
  },
  "nidoking": {
    "num": 34,
    "name": "Nidoking",
    "types": [
      "Poison",
      "Ground"
    ],
    "gender": "M",
    "baseStats": {
      "hp": 90,
      "atk": 141,
      "def": 118,
      "spe": 91,
      "spa": 55,
      "spd": 80
    },
    "abilities": {
      "0": "Sheer Force",
      "1": "Hustle"
    },
    "weightkg": 62.0,
    "prevo": "Nidorino",
    "evoLevel": 40,
    "evoType": "levelHold",
    "evoItem": "Ground Gem",
    "eggGroups": [
      "Monster",
      "Field"
    ]
  },
  "clefairy": {
    "num": 35,
    "name": "Clefairy",
    "types": [
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 70,
      "atk": 70,
      "def": 70,
      "spe": 45,
      "spa": 90,
      "spd": 95
    },
    "abilities": {
      "0": "Unaware",
      "1": "Magic Guard",
      "H": "Friend Guard"
    },
    "weightkg": 7.5,
    "prevo": "Cleffa",
    "evoLevel": 16,
    "evos": [
      "Clefable"
    ],
    "eggGroups": [
      "Fairy"
    ]
  },
  "clefable": {
    "num": 36,
    "name": "Clefable",
    "types": [
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 85,
      "atk": 80,
      "def": 85,
      "spe": 60,
      "spa": 115,
      "spd": 125
    },
    "abilities": {
      "0": "Unaware",
      "1": "Magic Guard",
      "H": "Interstellar"
    },
    "weightkg": 40.0,
    "prevo": "Clefairy",
    "evoLevel": 32,
    "eggGroups": [
      "Fairy"
    ]
  },
  "vulpix": {
    "num": 37,
    "name": "Vulpix",
    "types": [
      "Fire",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 45,
      "atk": 45,
      "def": 45,
      "spe": 77,
      "spa": 88,
      "spd": 70
    },
    "abilities": {
      "0": "Drought",
      "1": "Solar Power"
    },
    "weightkg": 9.9,
    "evos": [
      "Ninetales"
    ],
    "eggGroups": [
      "Field"
    ],
    "formes": [
      "Vulpix",
      "Vulpix-Alola"
    ]
  },
  "vulpixalola": {
    "num": 37,
    "name": "Vulpix-Alola",
    "types": [
      "Ice",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 45,
      "atk": 40,
      "def": 45,
      "spe": 77,
      "spa": 85,
      "spd": 78
    },
    "abilities": {
      "0": "Snow Warning",
      "1": "Slush Rush"
    },
    "weightkg": 9.9,
    "evos": [
      "Ninetales-Alola"
    ],
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Vulpix",
    "forme": "Alola",
    "formes": [
      "Vulpix",
      "Vulpix-Alola"
    ]
  },
  "ninetales": {
    "num": 38,
    "name": "Ninetales",
    "types": [
      "Fairy",
      "Fire"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 73,
      "atk": 57,
      "def": 75,
      "spe": 109,
      "spa": 112,
      "spd": 109
    },
    "abilities": {
      "0": "Drought",
      "1": "Serene Grace",
      "H": "Magic Guard"
    },
    "weightkg": 19.9,
    "prevo": "Vulpix",
    "evoLevel": 30,
    "eggGroups": [
      "Field"
    ],
    "formes": [
      "Ninetales",
      "Ninetales-Alola"
    ]
  },
  "ninetalesalola": {
    "num": 38,
    "name": "Ninetales-Alola",
    "types": [
      "Fairy",
      "Ice"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 73,
      "atk": 57,
      "def": 75,
      "spe": 109,
      "spa": 109,
      "spd": 112
    },
    "abilities": {
      "0": "Snow Warning",
      "1": "Serene Grace",
      "H": "Magic Guard"
    },
    "weightkg": 19.9,
    "prevo": "Vulpix-Alola",
    "evoLevel": 30,
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Ninetales",
    "forme": "Alola",
    "formes": [
      "Ninetales",
      "Ninetales-Alola"
    ]
  },
  "jigglypuff": {
    "num": 39,
    "name": "Jigglypuff",
    "types": [
      "Normal",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 50,
      "atk": 35,
      "def": 50,
      "spe": 45,
      "spa": 85,
      "spd": 85
    },
    "abilities": {
      "0": "Huge Power",
      "1": "Fluffy"
    },
    "weightkg": 5.5,
    "prevo": "Igglybuff",
    "evoLevel": 17,
    "evos": [
      "Wigglytuff"
    ],
    "eggGroups": [
      "Fairy"
    ]
  },
  "wigglytuff": {
    "num": 40,
    "name": "Wigglytuff",
    "types": [
      "Normal",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 100,
      "atk": 50,
      "def": 75,
      "spe": 55,
      "spa": 100,
      "spd": 100
    },
    "abilities": {
      "0": "Huge Power",
      "1": "Fluffy"
    },
    "weightkg": 12.0,
    "prevo": "Jigglypuff",
    "evoLevel": 29,
    "eggGroups": [
      "Fairy"
    ]
  },
  "zubat": {
    "num": 41,
    "name": "Zubat",
    "types": [
      "Poison",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 55,
      "def": 40,
      "spe": 105,
      "spa": 50,
      "spd": 40
    },
    "abilities": {
      "0": "Merciless",
      "1": "Unnerve",
      "H": "Stakeout"
    },
    "weightkg": 7.5,
    "evos": [
      "Golbat"
    ],
    "eggGroups": [
      "Flying"
    ]
  },
  "golbat": {
    "num": 42,
    "name": "Golbat",
    "types": [
      "Poison",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 85,
      "atk": 85,
      "def": 80,
      "spe": 105,
      "spa": 80,
      "spd": 80
    },
    "abilities": {
      "0": "Merciless",
      "1": "Intimidate",
      "H": "Stakeout"
    },
    "weightkg": 55.0,
    "prevo": "Zubat",
    "evoLevel": 20,
    "evos": [
      "Crobat"
    ],
    "eggGroups": [
      "Flying"
    ]
  },
  "oddish": {
    "num": 43,
    "name": "Oddish",
    "types": [
      "Grass",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 35,
      "def": 65,
      "spe": 30,
      "spa": 75,
      "spd": 70
    },
    "abilities": {
      "0": "Grassy Guard",
      "1": "Prankster"
    },
    "weightkg": 5.4,
    "evos": [
      "Gloom"
    ],
    "eggGroups": [
      "Grass"
    ]
  },
  "gloom": {
    "num": 44,
    "name": "Gloom",
    "types": [
      "Grass",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 65,
      "def": 80,
      "spe": 40,
      "spa": 90,
      "spd": 85
    },
    "abilities": {
      "0": "Grassy Guard",
      "1": "Prankster"
    },
    "weightkg": 8.6,
    "prevo": "Oddish",
    "evoLevel": 16,
    "evos": [
      "Vileplume",
      "Bellossom"
    ],
    "eggGroups": [
      "Grass"
    ]
  },
  "vileplume": {
    "num": 45,
    "name": "Vileplume",
    "types": [
      "Grass",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 85,
      "atk": 80,
      "def": 95,
      "spe": 50,
      "spa": 115,
      "spd": 110
    },
    "abilities": {
      "0": "Grassy Surge",
      "1": "Prankster"
    },
    "weightkg": 18.6,
    "prevo": "Gloom",
    "evoLevel": 32,
    "evoType": "levelHold",
    "evoItem": "Poison Gem",
    "eggGroups": [
      "Grass"
    ]
  },
  "paras": {
    "num": 46,
    "name": "Paras",
    "types": [
      "Bug",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 70,
      "def": 80,
      "spe": 30,
      "spa": 60,
      "spd": 80
    },
    "abilities": {
      "0": "Tough Claws",
      "1": "Dry Skin"
    },
    "weightkg": 5.4,
    "evos": [
      "Parasect"
    ],
    "eggGroups": [
      "Bug",
      "Grass"
    ]
  },
  "parasect": {
    "num": 47,
    "name": "Parasect",
    "types": [
      "Bug",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 85,
      "atk": 100,
      "def": 110,
      "spe": 30,
      "spa": 90,
      "spd": 110
    },
    "abilities": {
      "0": "Tough Claws",
      "1": "Regenerator"
    },
    "weightkg": 29.5,
    "prevo": "Paras",
    "evoLevel": 25,
    "eggGroups": [
      "Bug",
      "Grass"
    ]
  },
  "venonat": {
    "num": 48,
    "name": "Venonat",
    "types": [
      "Bug",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 40,
      "def": 60,
      "spe": 66,
      "spa": 82,
      "spd": 92
    },
    "abilities": {
      "0": "Fluffy",
      "1": "Wimp Out",
      "H": "Tinted Lens"
    },
    "weightkg": 30.0,
    "evos": [
      "Venomoth"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "venomoth": {
    "num": 49,
    "name": "Venomoth",
    "types": [
      "Bug",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 65,
      "def": 65,
      "spe": 111,
      "spa": 117,
      "spd": 97
    },
    "abilities": {
      "0": "Levitate",
      "1": "Multiscale",
      "H": "Tinted Lens"
    },
    "weightkg": 12.5,
    "prevo": "Venonat",
    "evoLevel": 25,
    "evoType": "levelHold",
    "evoItem": "Bug Gem",
    "eggGroups": [
      "Bug"
    ]
  },
  "diglett": {
    "num": 50,
    "name": "Diglett",
    "types": [
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 25,
      "atk": 65,
      "def": 50,
      "spe": 115,
      "spa": 25,
      "spd": 50
    },
    "abilities": {
      "0": "Hustle",
      "1": "Wimp Out",
      "H": "Arena Trap"
    },
    "weightkg": 0.8,
    "evos": [
      "Dugtrio"
    ],
    "eggGroups": [
      "Field"
    ],
    "formes": [
      "Diglett",
      "Diglett-Alola"
    ]
  },
  "diglettalola": {
    "num": 50,
    "name": "Diglett-Alola",
    "types": [
      "Ground",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 25,
      "atk": 65,
      "def": 60,
      "spe": 105,
      "spa": 25,
      "spd": 50
    },
    "abilities": {
      "0": "Hustle",
      "1": "Wimp Out",
      "H": "Arena Trap"
    },
    "weightkg": 1.0,
    "evos": [
      "Dugtrio-Alola"
    ],
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Diglett",
    "forme": "Alola",
    "formes": [
      "Diglett",
      "Diglett-Alola"
    ]
  },
  "dugtrio": {
    "num": 51,
    "name": "Dugtrio",
    "types": [
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 105,
      "def": 70,
      "spe": 130,
      "spa": 30,
      "spd": 70
    },
    "abilities": {
      "0": "Hustle",
      "1": "Expertise",
      "H": "Arena Trap"
    },
    "weightkg": 33.3,
    "prevo": "Diglett",
    "evoLevel": 20,
    "eggGroups": [
      "Field"
    ],
    "formes": [
      "Dugtrio",
      "Dugtrio-Alola"
    ]
  },
  "dugtrioalola": {
    "num": 51,
    "name": "Dugtrio-Alola",
    "types": [
      "Ground",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 105,
      "def": 80,
      "spe": 120,
      "spa": 40,
      "spd": 60
    },
    "abilities": {
      "0": "Hustle",
      "1": "Expertise",
      "H": "Arena Trap"
    },
    "weightkg": 66.6,
    "prevo": "Diglett-Alola",
    "evoLevel": 20,
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Dugtrio",
    "forme": "Alola",
    "formes": [
      "Dugtrio",
      "Dugtrio-Alola"
    ]
  },
  "meowth": {
    "num": 52,
    "name": "Meowth",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 65,
      "def": 35,
      "spe": 95,
      "spa": 55,
      "spd": 40
    },
    "abilities": {
      "0": "Prankster",
      "1": "Moxie"
    },
    "weightkg": 4.2,
    "evos": [
      "Persian"
    ],
    "eggGroups": [
      "Field"
    ],
    "formes": [
      "Meowth",
      "Meowth-Alola"
    ]
  },
  "meowthalola": {
    "num": 52,
    "name": "Meowth-Alola",
    "types": [
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 60,
      "def": 35,
      "spe": 95,
      "spa": 65,
      "spd": 40
    },
    "abilities": {
      "0": "Prankster",
      "1": "Hubris"
    },
    "weightkg": 4.2,
    "evos": [
      "Persian-Alola"
    ],
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Meowth",
    "forme": "Alola",
    "formes": [
      "Meowth",
      "Meowth-Alola"
    ]
  },
  "persian": {
    "num": 53,
    "name": "Persian",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 102,
      "def": 65,
      "spe": 118,
      "spa": 90,
      "spd": 70
    },
    "abilities": {
      "0": "Super Luck",
      "1": "Moxie"
    },
    "weightkg": 32.0,
    "prevo": "Meowth",
    "evoLevel": 22,
    "eggGroups": [
      "Field"
    ],
    "formes": [
      "Persian",
      "Persian-Alola"
    ]
  },
  "persianalola": {
    "num": 53,
    "name": "Persian-Alola",
    "types": [
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 102,
      "def": 65,
      "spe": 115,
      "spa": 93,
      "spd": 70
    },
    "abilities": {
      "0": "Fur Coat",
      "1": "Hubris"
    },
    "weightkg": 33.0,
    "prevo": "Meowth-Alola",
    "evoLevel": 22,
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Persian",
    "forme": "Alola",
    "formes": [
      "Persian",
      "Persian-Alola"
    ]
  },
  "psyduck": {
    "num": 54,
    "name": "Psyduck",
    "types": [
      "Water",
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 55,
      "def": 50,
      "spe": 55,
      "spa": 80,
      "spd": 60
    },
    "abilities": {
      "0": "Swift Swim",
      "1": "Unaware"
    },
    "weightkg": 19.6,
    "evos": [
      "Golduck"
    ],
    "eggGroups": [
      "Water 1",
      "Field"
    ]
  },
  "golduck": {
    "num": 55,
    "name": "Golduck",
    "types": [
      "Water",
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 82,
      "def": 78,
      "spe": 101,
      "spa": 114,
      "spd": 80
    },
    "abilities": {
      "0": "Swift Swim",
      "1": "Magic Guard"
    },
    "weightkg": 76.6,
    "prevo": "Psyduck",
    "evoLevel": 25,
    "eggGroups": [
      "Water 1",
      "Field"
    ]
  },
  "mankey": {
    "num": 56,
    "name": "Mankey",
    "types": [
      "Fighting",
      "Electric"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 85,
      "def": 45,
      "spe": 115,
      "spa": 30,
      "spd": 45
    },
    "abilities": {
      "0": "Hustle",
      "1": "Defiant"
    },
    "weightkg": 28.0,
    "evos": [
      "Primeape"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "primeape": {
    "num": 57,
    "name": "Primeape",
    "types": [
      "Fighting",
      "Electric"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 130,
      "def": 80,
      "spe": 115,
      "spa": 60,
      "spd": 80
    },
    "abilities": {
      "0": "Hustle",
      "1": "Reckless"
    },
    "weightkg": 32.0,
    "prevo": "Mankey",
    "evoLevel": 26,
    "eggGroups": [
      "Field"
    ]
  },
  "growlithe": {
    "num": 58,
    "name": "Growlithe",
    "types": [
      "Fire",
      "Ice"
    ],
    "genderRatio": {
      "M": 0.75,
      "F": 0.25
    },
    "baseStats": {
      "hp": 55,
      "atk": 75,
      "def": 55,
      "spe": 85,
      "spa": 75,
      "spd": 55
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Refrigerate",
      "H": "Flash Fire"
    },
    "weightkg": 19.0,
    "evos": [
      "Arcanine"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "arcanine": {
    "num": 59,
    "name": "Arcanine",
    "types": [
      "Fire",
      "Ice"
    ],
    "genderRatio": {
      "M": 0.75,
      "F": 0.25
    },
    "baseStats": {
      "hp": 90,
      "atk": 120,
      "def": 80,
      "spe": 115,
      "spa": 90,
      "spd": 80
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Refrigerate",
      "H": "Flash Fire"
    },
    "weightkg": 155.0,
    "prevo": "Growlithe",
    "evoLevel": 35,
    "eggGroups": [
      "Field"
    ]
  },
  "poliwag": {
    "num": 60,
    "name": "Poliwag",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 50,
      "def": 40,
      "spe": 75,
      "spa": 60,
      "spd": 55
    },
    "abilities": {
      "0": "Swift Swim",
      "1": "Gooey"
    },
    "weightkg": 12.4,
    "evos": [
      "Poliwhirl"
    ],
    "eggGroups": [
      "Water 1"
    ]
  },
  "poliwhirl": {
    "num": 61,
    "name": "Poliwhirl",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 80,
      "def": 80,
      "spe": 65,
      "spa": 80,
      "spd": 80
    },
    "abilities": {
      "0": "Swift Swim",
      "1": "Gooey"
    },
    "weightkg": 20.0,
    "prevo": "Poliwag",
    "evoLevel": 17,
    "evos": [
      "Poliwrath",
      "Politoed"
    ],
    "eggGroups": [
      "Water 1"
    ]
  },
  "poliwrath": {
    "num": 62,
    "name": "Poliwrath",
    "types": [
      "Water",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 95,
      "atk": 140,
      "def": 95,
      "spe": 60,
      "spa": 70,
      "spd": 90
    },
    "abilities": {
      "0": "Swift Swim",
      "1": "Stamina"
    },
    "weightkg": 54.0,
    "prevo": "Poliwhirl",
    "evoLevel": 34,
    "evoType": "levelHold",
    "evoItem": "Fighting Gem",
    "eggGroups": [
      "Water 1"
    ]
  },
  "abra": {
    "num": 63,
    "name": "Abra",
    "types": [
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.75,
      "F": 0.25
    },
    "baseStats": {
      "hp": 35,
      "atk": 20,
      "def": 25,
      "spe": 90,
      "spa": 95,
      "spd": 60
    },
    "abilities": {
      "0": "Levitate",
      "1": "Trace"
    },
    "weightkg": 19.5,
    "evos": [
      "Kadabra"
    ],
    "eggGroups": [
      "Human-Like"
    ]
  },
  "kadabra": {
    "num": 64,
    "name": "Kadabra",
    "types": [
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.75,
      "F": 0.25
    },
    "baseStats": {
      "hp": 55,
      "atk": 35,
      "def": 40,
      "spe": 105,
      "spa": 115,
      "spd": 75
    },
    "abilities": {
      "0": "Magic Guard",
      "1": "Trace"
    },
    "weightkg": 56.5,
    "prevo": "Abra",
    "evoLevel": 18,
    "evos": [
      "Alakazam"
    ],
    "eggGroups": [
      "Human-Like"
    ]
  },
  "alakazam": {
    "num": 65,
    "name": "Alakazam",
    "types": [
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.75,
      "F": 0.25
    },
    "baseStats": {
      "hp": 70,
      "atk": 50,
      "def": 50,
      "spe": 120,
      "spa": 135,
      "spd": 100
    },
    "abilities": {
      "0": "Magic Guard",
      "1": "Trace"
    },
    "weightkg": 48.0,
    "prevo": "Kadabra",
    "evoLevel": 33,
    "eggGroups": [
      "Human-Like"
    ],
    "formes": [
      "Alakazam",
      "Alakazam-Mega"
    ]
  },
  "alakazammega": {
    "num": 65,
    "name": "Alakazam-Mega",
    "types": [
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.75,
      "F": 0.25
    },
    "baseStats": {
      "hp": 70,
      "atk": 50,
      "def": 65,
      "spe": 135,
      "spa": 180,
      "spd": 125
    },
    "abilities": {
      "0": "Sixth Sense",
      "1": "Levitate"
    },
    "weightkg": 48.0,
    "eggGroups": [
      "Human-Like"
    ],
    "baseSpecies": "Alakazam",
    "forme": "Mega",
    "formes": [
      "Alakazam",
      "Alakazam-Mega"
    ],
    "requiredItems": [
      "Mega Stone I"
    ]
  },
  "machop": {
    "num": 66,
    "name": "Machop",
    "types": [
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.75,
      "F": 0.25
    },
    "baseStats": {
      "hp": 50,
      "atk": 90,
      "def": 70,
      "spe": 40,
      "spa": 30,
      "spd": 50
    },
    "abilities": {
      "0": "Moxie",
      "1": "Defiant"
    },
    "weightkg": 19.5,
    "evos": [
      "Machoke"
    ],
    "eggGroups": [
      "Human-Like"
    ]
  },
  "machoke": {
    "num": 67,
    "name": "Machoke",
    "types": [
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.75,
      "F": 0.25
    },
    "baseStats": {
      "hp": 80,
      "atk": 120,
      "def": 85,
      "spe": 55,
      "spa": 40,
      "spd": 60
    },
    "abilities": {
      "0": "Moxie",
      "1": "Defiant"
    },
    "weightkg": 70.5,
    "prevo": "Machop",
    "evoLevel": 20,
    "evos": [
      "Machamp"
    ],
    "eggGroups": [
      "Human-Like"
    ]
  },
  "machamp": {
    "num": 68,
    "name": "Machamp",
    "types": [
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.75,
      "F": 0.25
    },
    "baseStats": {
      "hp": 95,
      "atk": 150,
      "def": 100,
      "spe": 70,
      "spa": 50,
      "spd": 85
    },
    "abilities": {
      "0": "Moxie",
      "1": "Sheer Force"
    },
    "weightkg": 130.0,
    "prevo": "Machoke",
    "evoLevel": 36,
    "evoType": "levelHold",
    "evoItem": "Fighting Gem",
    "eggGroups": [
      "Human-Like"
    ]
  },
  "bellsprout": {
    "num": 69,
    "name": "Bellsprout",
    "types": [
      "Grass",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 65,
      "def": 35,
      "spe": 65,
      "spa": 75,
      "spd": 35
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Metabolism"
    },
    "weightkg": 4.0,
    "evos": [
      "Weepinbell"
    ],
    "eggGroups": [
      "Grass"
    ]
  },
  "weepinbell": {
    "num": 70,
    "name": "Weepinbell",
    "types": [
      "Grass",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 80,
      "def": 80,
      "spe": 55,
      "spa": 90,
      "spd": 80
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Metabolism"
    },
    "weightkg": 6.4,
    "prevo": "Bellsprout",
    "evoLevel": 15,
    "evos": [
      "Victreebel"
    ],
    "eggGroups": [
      "Grass"
    ]
  },
  "victreebel": {
    "num": 71,
    "name": "Victreebel",
    "types": [
      "Grass",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 100,
      "atk": 105,
      "def": 80,
      "spe": 70,
      "spa": 115,
      "spd": 80
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Intimidate"
    },
    "weightkg": 15.5,
    "prevo": "Weepinbell",
    "evoLevel": 31,
    "eggGroups": [
      "Grass"
    ]
  },
  "tentacool": {
    "num": 72,
    "name": "Tentacool",
    "types": [
      "Water",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 40,
      "def": 40,
      "spe": 70,
      "spa": 70,
      "spd": 100
    },
    "abilities": {
      "0": "Energy Shield",
      "1": "Adaptability"
    },
    "weightkg": 45.5,
    "evos": [
      "Tentacruel"
    ],
    "eggGroups": [
      "Water 3"
    ]
  },
  "tentacruel": {
    "num": 73,
    "name": "Tentacruel",
    "types": [
      "Water",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 70,
      "def": 70,
      "spe": 100,
      "spa": 110,
      "spd": 120
    },
    "abilities": {
      "0": "Energy Shield",
      "1": "Adaptability"
    },
    "weightkg": 55.0,
    "prevo": "Tentacool",
    "evoLevel": 30,
    "eggGroups": [
      "Water 3"
    ]
  },
  "geodude": {
    "num": 74,
    "name": "Geodude",
    "types": [
      "Rock",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 80,
      "def": 100,
      "spe": 20,
      "spa": 30,
      "spd": 50
    },
    "abilities": {
      "0": "Rough Skin",
      "1": "Sturdy"
    },
    "weightkg": 20.0,
    "evos": [
      "Graveler"
    ],
    "eggGroups": [
      "Mineral"
    ],
    "formes": [
      "Geodude",
      "Geodude-Alola"
    ]
  },
  "geodudealola": {
    "num": 74,
    "name": "Geodude-Alola",
    "types": [
      "Rock",
      "Electric"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 80,
      "def": 100,
      "spe": 20,
      "spa": 30,
      "spd": 50
    },
    "abilities": {
      "0": "Galvanize",
      "1": "Sturdy",
      "H": "Magnet Pull"
    },
    "weightkg": 20.3,
    "evos": [
      "Graveler-Alola"
    ],
    "eggGroups": [
      "Mineral"
    ],
    "baseSpecies": "Geodude",
    "forme": "Alola",
    "formes": [
      "Geodude",
      "Geodude-Alola"
    ]
  },
  "graveler": {
    "num": 75,
    "name": "Graveler",
    "types": [
      "Rock",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 110,
      "def": 115,
      "spe": 65,
      "spa": 35,
      "spd": 55
    },
    "abilities": {
      "0": "Rough Skin",
      "1": "Sturdy"
    },
    "weightkg": 105.0,
    "prevo": "Geodude",
    "evoLevel": 20,
    "evos": [
      "Golem"
    ],
    "eggGroups": [
      "Mineral"
    ],
    "formes": [
      "Graveler",
      "Graveler-Alola"
    ]
  },
  "graveleralola": {
    "num": 75,
    "name": "Graveler-Alola",
    "types": [
      "Rock",
      "Electric"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 110,
      "def": 115,
      "spe": 60,
      "spa": 35,
      "spd": 60
    },
    "abilities": {
      "0": "Galvanize",
      "1": "Sturdy",
      "H": "Magnet Pull"
    },
    "weightkg": 110.0,
    "prevo": "Geodude-Alola",
    "evoLevel": 20,
    "evos": [
      "Golem-Alola"
    ],
    "eggGroups": [
      "Mineral"
    ],
    "baseSpecies": "Graveler",
    "forme": "Alola",
    "formes": [
      "Graveler",
      "Graveler-Alola"
    ]
  },
  "golem": {
    "num": 76,
    "name": "Golem",
    "types": [
      "Rock",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 120,
      "def": 130,
      "spe": 95,
      "spa": 55,
      "spd": 70
    },
    "abilities": {
      "0": "Headstrong",
      "1": "Sturdy"
    },
    "weightkg": 300.0,
    "prevo": "Graveler",
    "evoLevel": 36,
    "evoType": "levelHold",
    "evoItem": "Rock Gem",
    "eggGroups": [
      "Mineral"
    ],
    "formes": [
      "Golem",
      "Golem-Alola"
    ]
  },
  "golemalola": {
    "num": 76,
    "name": "Golem-Alola",
    "types": [
      "Rock",
      "Electric"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 120,
      "def": 130,
      "spe": 45,
      "spa": 105,
      "spd": 70
    },
    "abilities": {
      "0": "Galvanize",
      "1": "Sturdy",
      "H": "Magnet Pull"
    },
    "weightkg": 316.0,
    "prevo": "Graveler-Alola",
    "evoLevel": 36,
    "evoType": "levelHold",
    "evoItem": "Rock Gem",
    "eggGroups": [
      "Mineral"
    ],
    "baseSpecies": "Golem",
    "forme": "Alola",
    "formes": [
      "Golem",
      "Golem-Alola"
    ]
  },
  "ponyta": {
    "num": 77,
    "name": "Ponyta",
    "types": [
      "Fire",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 55,
      "atk": 85,
      "def": 55,
      "spe": 110,
      "spa": 70,
      "spd": 55
    },
    "abilities": {
      "0": "Speed Boost",
      "1": "Competitive"
    },
    "weightkg": 30.0,
    "evos": [
      "Rapidash"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "rapidash": {
    "num": 78,
    "name": "Rapidash",
    "types": [
      "Fire",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 110,
      "def": 70,
      "spe": 125,
      "spa": 100,
      "spd": 70
    },
    "abilities": {
      "0": "Reckless",
      "1": "Speed Boost",
      "H": "Guts"
    },
    "weightkg": 95.0,
    "prevo": "Ponyta",
    "evoLevel": 30,
    "eggGroups": [
      "Field"
    ]
  },
  "slowpoke": {
    "num": 79,
    "name": "Slowpoke",
    "types": [
      "Water",
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 65,
      "def": 65,
      "spe": 10,
      "spa": 65,
      "spd": 80
    },
    "abilities": {
      "0": "Unaware",
      "1": "Regenerator"
    },
    "weightkg": 36.0,
    "evos": [
      "Slowbro",
      "Slowking"
    ],
    "eggGroups": [
      "Monster",
      "Water 1"
    ]
  },
  "slowbro": {
    "num": 80,
    "name": "Slowbro",
    "types": [
      "Water",
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 95,
      "atk": 85,
      "def": 115,
      "spe": 25,
      "spa": 100,
      "spd": 95
    },
    "abilities": {
      "0": "Unaware",
      "1": "Regenerator",
      "H": "Simple"
    },
    "weightkg": 78.5,
    "prevo": "Slowpoke",
    "evoLevel": 29,
    "evoType": "levelHold",
    "evoItem": "Water Gem",
    "eggGroups": [
      "Monster",
      "Water 1"
    ],
    "formes": [
      "Slowbro",
      "Slowbro-Mega"
    ]
  },
  "slowbromega": {
    "num": 80,
    "name": "Slowbro-Mega",
    "types": [
      "Water",
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 95,
      "atk": 85,
      "def": 180,
      "spe": 25,
      "spa": 100,
      "spd": 130
    },
    "abilities": {
      "0": "Bulletproof",
      "1": "Shell Armor"
    },
    "weightkg": 120.0,
    "eggGroups": [
      "Monster",
      "Water 1"
    ],
    "baseSpecies": "Slowbro",
    "forme": "Mega",
    "formes": [
      "Slowbro",
      "Slowbro-Mega"
    ],
    "requiredItems": [
      "Mega Stone I"
    ]
  },
  "magnemite": {
    "num": 81,
    "name": "Magnemite",
    "types": [
      "Electric",
      "Steel"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 25,
      "atk": 35,
      "def": 90,
      "spe": 45,
      "spa": 95,
      "spd": 70
    },
    "abilities": {
      "0": "Levitate",
      "1": "Galvanize",
      "H": "Magnet Pull"
    },
    "weightkg": 6.0,
    "evos": [
      "Magneton"
    ],
    "eggGroups": [
      "Mineral"
    ]
  },
  "magneton": {
    "num": 82,
    "name": "Magneton",
    "types": [
      "Electric",
      "Steel"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 60,
      "atk": 45,
      "def": 95,
      "spe": 80,
      "spa": 120,
      "spd": 80
    },
    "abilities": {
      "0": "Levitate",
      "1": "Galvanize",
      "H": "Magnet Pull"
    },
    "weightkg": 60.0,
    "prevo": "Magnemite",
    "evoLevel": 25,
    "evos": [
      "Magnezone"
    ],
    "eggGroups": [
      "Mineral"
    ]
  },
  "farfetchd": {
    "num": 83,
    "name": "Farfetch’d",
    "types": [
      "Fighting",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 67,
      "atk": 109,
      "def": 70,
      "spe": 106,
      "spa": 58,
      "spd": 70
    },
    "abilities": {
      "0": "Super Luck",
      "1": "Unburden"
    },
    "weightkg": 15.0,
    "eggGroups": [
      "Flying",
      "Field"
    ]
  },
  "doduo": {
    "num": 84,
    "name": "Doduo",
    "types": [
      "Ground",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 85,
      "def": 45,
      "spe": 110,
      "spa": 35,
      "spd": 45
    },
    "abilities": {
      "0": "Emergency Exit",
      "1": "Defiant"
    },
    "weightkg": 39.2,
    "evos": [
      "Dodrio"
    ],
    "eggGroups": [
      "Flying"
    ]
  },
  "dodrio": {
    "num": 85,
    "name": "Dodrio",
    "types": [
      "Ground",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 115,
      "def": 70,
      "spe": 125,
      "spa": 60,
      "spd": 70
    },
    "abilities": {
      "0": "Reckless",
      "1": "Moxie"
    },
    "weightkg": 85.2,
    "prevo": "Doduo",
    "evoLevel": 26,
    "eggGroups": [
      "Flying"
    ]
  },
  "seel": {
    "num": 86,
    "name": "Seel",
    "types": [
      "Water",
      "Ice"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 65,
      "def": 55,
      "spe": 45,
      "spa": 65,
      "spd": 75
    },
    "abilities": {
      "0": "Swift Swim",
      "1": "Fur Coat"
    },
    "weightkg": 90.0,
    "evos": [
      "Dewgong"
    ],
    "eggGroups": [
      "Water 1",
      "Field"
    ]
  },
  "dewgong": {
    "num": 87,
    "name": "Dewgong",
    "types": [
      "Water",
      "Ice"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 100,
      "atk": 90,
      "def": 80,
      "spe": 70,
      "spa": 90,
      "spd": 105
    },
    "abilities": {
      "0": "Swift Swim",
      "1": "Fur Coat"
    },
    "weightkg": 120.0,
    "prevo": "Seel",
    "evoLevel": 29,
    "eggGroups": [
      "Water 1",
      "Field"
    ]
  },
  "grimer": {
    "num": 88,
    "name": "Grimer",
    "types": [
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 80,
      "def": 60,
      "spe": 15,
      "spa": 70,
      "spd": 85
    },
    "abilities": {
      "0": "Water Absorb",
      "1": "Regenerator",
      "H": "Corrosion"
    },
    "weightkg": 30.0,
    "evos": [
      "Muk"
    ],
    "eggGroups": [
      "Amorphous"
    ],
    "formes": [
      "Grimer",
      "Grimer-Alola"
    ]
  },
  "grimeralola": {
    "num": 88,
    "name": "Grimer-Alola",
    "types": [
      "Poison",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 85,
      "def": 60,
      "spe": 15,
      "spa": 70,
      "spd": 80
    },
    "abilities": {
      "0": "Merciless",
      "1": "Regenerator"
    },
    "weightkg": 42.0,
    "evos": [
      "Muk-Alola"
    ],
    "eggGroups": [
      "Amorphous"
    ],
    "baseSpecies": "Grimer",
    "forme": "Alola",
    "formes": [
      "Grimer",
      "Grimer-Alola"
    ]
  },
  "muk": {
    "num": 89,
    "name": "Muk",
    "types": [
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 110,
      "atk": 110,
      "def": 80,
      "spe": 15,
      "spa": 90,
      "spd": 120
    },
    "abilities": {
      "0": "Water Absorb",
      "1": "Regenerator",
      "H": "Corrosion"
    },
    "weightkg": 30.0,
    "prevo": "Grimer",
    "evoLevel": 31,
    "eggGroups": [
      "Amorphous"
    ],
    "formes": [
      "Muk",
      "Muk-Alola"
    ]
  },
  "mukalola": {
    "num": 89,
    "name": "Muk-Alola",
    "types": [
      "Poison",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 110,
      "atk": 115,
      "def": 85,
      "spe": 15,
      "spa": 90,
      "spd": 110
    },
    "abilities": {
      "0": "Merciless",
      "1": "Regenerator"
    },
    "weightkg": 52.0,
    "prevo": "Grimer-Alola",
    "evoLevel": 31,
    "eggGroups": [
      "Amorphous"
    ],
    "baseSpecies": "Muk",
    "forme": "Alola",
    "formes": [
      "Muk",
      "Muk-Alola"
    ]
  },
  "shellder": {
    "num": 90,
    "name": "Shellder",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 55,
      "atk": 60,
      "def": 120,
      "spe": 50,
      "spa": 30,
      "spd": 55
    },
    "abilities": {
      "0": "Sturdy",
      "1": "Technician"
    },
    "weightkg": 4.0,
    "evos": [
      "Cloyster"
    ],
    "eggGroups": [
      "Water 3"
    ]
  },
  "cloyster": {
    "num": 91,
    "name": "Cloyster",
    "types": [
      "Water",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 95,
      "def": 180,
      "spe": 70,
      "spa": 40,
      "spd": 70
    },
    "abilities": {
      "0": "Bulletproof",
      "1": "Technician"
    },
    "weightkg": 132.5,
    "prevo": "Shellder",
    "evoLevel": 29,
    "eggGroups": [
      "Water 3"
    ]
  },
  "gastly": {
    "num": 92,
    "name": "Gastly",
    "types": [
      "Ghost",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 30,
      "atk": 10,
      "def": 30,
      "spe": 100,
      "spa": 95,
      "spd": 65
    },
    "abilities": {
      "0": "Levitate",
      "1": "Merciless"
    },
    "weightkg": 0.1,
    "evos": [
      "Haunter"
    ],
    "eggGroups": [
      "Amorphous"
    ]
  },
  "haunter": {
    "num": 93,
    "name": "Haunter",
    "types": [
      "Ghost",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 95,
      "def": 45,
      "spe": 115,
      "spa": 115,
      "spd": 70
    },
    "abilities": {
      "0": "Levitate",
      "1": "Ruthless"
    },
    "weightkg": 0.1,
    "prevo": "Gastly",
    "evoLevel": 20,
    "evos": [
      "Gengar"
    ],
    "eggGroups": [
      "Amorphous"
    ]
  },
  "gengar": {
    "num": 94,
    "name": "Gengar",
    "types": [
      "Ghost",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 70,
      "def": 60,
      "spe": 115,
      "spa": 130,
      "spd": 85
    },
    "abilities": {
      "0": "Sinister",
      "1": "Merciless"
    },
    "weightkg": 40.5,
    "prevo": "Haunter",
    "evoLevel": 36,
    "evoType": "levelHold",
    "evoItem": "Ghost Gem",
    "eggGroups": [
      "Amorphous"
    ],
    "formes": [
      "Gengar",
      "Gengar-Mega"
    ]
  },
  "gengarmega": {
    "num": 94,
    "name": "Gengar-Mega",
    "types": [
      "Ghost",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 80,
      "def": 60,
      "spe": 130,
      "spa": 175,
      "spd": 115
    },
    "abilities": {
      "0": "Psychic Surge",
      "1": "Sixth Sense",
      "H": "Shadow Tag"
    },
    "weightkg": 40.5,
    "eggGroups": [
      "Amorphous"
    ],
    "baseSpecies": "Gengar",
    "forme": "Mega",
    "formes": [
      "Gengar",
      "Gengar-Mega"
    ],
    "requiredItems": [
      "Mega Stone I",
      "Gengarite"
    ]
  },
  "onix": {
    "num": 95,
    "name": "Onix",
    "types": [
      "Rock",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 120,
      "atk": 120,
      "def": 140,
      "spe": 70,
      "spa": 30,
      "spd": 45
    },
    "abilities": {
      "0": "Sand Rush",
      "1": "Solid Rock"
    },
    "weightkg": 210.0,
    "evos": [
      "Steelix"
    ],
    "eggGroups": [
      "Mineral"
    ]
  },
  "drowzee": {
    "num": 96,
    "name": "Drowzee",
    "types": [
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 48,
      "def": 80,
      "spe": 42,
      "spa": 90,
      "spd": 100
    },
    "abilities": {
      "0": "Thick Fat",
      "1": "Metabolism"
    },
    "weightkg": 32.4,
    "evos": [
      "Hypno"
    ],
    "eggGroups": [
      "Human-Like"
    ]
  },
  "hypno": {
    "num": 97,
    "name": "Hypno",
    "types": [
      "Psychic",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 85,
      "atk": 73,
      "def": 80,
      "spe": 67,
      "spa": 115,
      "spd": 115
    },
    "abilities": {
      "0": "Bad Dreams",
      "1": "Sinister"
    },
    "weightkg": 75.6,
    "prevo": "Drowzee",
    "evoLevel": 24,
    "eggGroups": [
      "Human-Like"
    ]
  },
  "krabby": {
    "num": 98,
    "name": "Krabby",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 105,
      "def": 90,
      "spe": 70,
      "spa": 25,
      "spd": 40
    },
    "abilities": {
      "0": "Tough Claws",
      "1": "Sturdy"
    },
    "weightkg": 6.5,
    "evos": [
      "Kingler"
    ],
    "eggGroups": [
      "Water 3"
    ]
  },
  "kingler": {
    "num": 99,
    "name": "Kingler",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 130,
      "def": 115,
      "spe": 75,
      "spa": 50,
      "spd": 80
    },
    "abilities": {
      "0": "Tough Claws",
      "1": "Sturdy"
    },
    "weightkg": 60.0,
    "prevo": "Krabby",
    "evoLevel": 28,
    "eggGroups": [
      "Water 3"
    ]
  },
  "voltorb": {
    "num": 100,
    "name": "Voltorb",
    "types": [
      "Electric"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 40,
      "atk": 20,
      "def": 40,
      "spe": 120,
      "spa": 100,
      "spd": 50
    },
    "abilities": {
      "0": "Galvanize",
      "1": "Berserk"
    },
    "weightkg": 10.4,
    "evos": [
      "Electrode"
    ],
    "eggGroups": [
      "Mineral"
    ]
  },
  "electrode": {
    "num": 101,
    "name": "Electrode",
    "types": [
      "Electric"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 60,
      "atk": 35,
      "def": 70,
      "spe": 155,
      "spa": 135,
      "spd": 80
    },
    "abilities": {
      "0": "Galvanize",
      "1": "Berserk"
    },
    "weightkg": 66.6,
    "prevo": "Voltorb",
    "evoLevel": 26,
    "eggGroups": [
      "Mineral"
    ]
  },
  "exeggcute": {
    "num": 102,
    "name": "Exeggcute",
    "types": [
      "Grass",
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 45,
      "def": 85,
      "spe": 30,
      "spa": 90,
      "spd": 85
    },
    "abilities": {
      "0": "Grassy Guard",
      "1": "Harvest"
    },
    "weightkg": 2.5,
    "evos": [
      "Exeggutor",
      "Exeggutor-Alola"
    ],
    "eggGroups": [
      "Grass"
    ]
  },
  "exeggutor": {
    "num": 103,
    "name": "Exeggutor",
    "types": [
      "Grass",
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 95,
      "atk": 100,
      "def": 90,
      "spe": 50,
      "spa": 125,
      "spd": 115
    },
    "abilities": {
      "0": "Solar Rush",
      "1": "Harvest",
      "H": "Grassy Guard"
    },
    "weightkg": 120.0,
    "prevo": "Exeggcute",
    "evoLevel": 35,
    "evoType": "levelHold",
    "evoItem": "Psychic Gem",
    "eggGroups": [
      "Grass"
    ],
    "formes": [
      "Exeggutor",
      "Exeggutor-Alola"
    ]
  },
  "exeggutoralola": {
    "num": 103,
    "name": "Exeggutor-Alola",
    "types": [
      "Grass",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 120,
      "atk": 125,
      "def": 90,
      "spe": 50,
      "spa": 100,
      "spd": 90
    },
    "abilities": {
      "0": "Solar Rush",
      "1": "Headstrong",
      "H": "Grassy Guard"
    },
    "weightkg": 415.6,
    "prevo": "Exeggcute",
    "evoLevel": 35,
    "evoType": "levelHold",
    "evoItem": "Dragon Gem",
    "eggGroups": [
      "Grass"
    ],
    "baseSpecies": "Exeggutor",
    "forme": "Alola",
    "formes": [
      "Exeggutor",
      "Exeggutor-Alola"
    ]
  },
  "cubone": {
    "num": 104,
    "name": "Cubone",
    "types": [
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 50,
      "def": 90,
      "spe": 65,
      "spa": 35,
      "spd": 60
    },
    "abilities": {
      "0": "Technician",
      "1": "Wimp Out"
    },
    "weightkg": 6.5,
    "evos": [
      "Marowak",
      "Marowak-Alola",
      "Marowak-Alola-Totem"
    ],
    "eggGroups": [
      "Monster"
    ]
  },
  "marowak": {
    "num": 105,
    "name": "Marowak",
    "types": [
      "Ground",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 80,
      "def": 115,
      "spe": 90,
      "spa": 50,
      "spd": 80
    },
    "abilities": {
      "0": "Technician",
      "1": "Headstrong"
    },
    "weightkg": 45.0,
    "prevo": "Cubone",
    "evoLevel": 28,
    "evoType": "levelHold",
    "evoItem": "Fighting Gem",
    "eggGroups": [
      "Monster"
    ],
    "formes": [
      "Marowak",
      "Marowak-Alola",
      "Marowak-Alola-Totem"
    ]
  },
  "marowakalola": {
    "num": 105,
    "name": "Marowak-Alola",
    "types": [
      "Ghost",
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 80,
      "def": 110,
      "spe": 95,
      "spa": 50,
      "spd": 80
    },
    "abilities": {
      "0": "Technician",
      "1": "Headstrong"
    },
    "weightkg": 34.0,
    "prevo": "Cubone",
    "evoLevel": 28,
    "evoType": "levelHold",
    "evoItem": "Ghost Gem",
    "eggGroups": [
      "Monster"
    ],
    "baseSpecies": "Marowak",
    "forme": "Alola",
    "formes": [
      "Marowak",
      "Marowak-Alola",
      "Marowak-Alola-Totem"
    ]
  },
  "marowakalolatotem": {
    "num": 105,
    "name": "Marowak-Alola-Totem",
    "types": [
      "Ghost",
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 80,
      "def": 110,
      "spe": 95,
      "spa": 105,
      "spd": 80
    },
    "abilities": {
      "0": "Technician",
      "1": "Lightning Rod"
    },
    "weightkg": 98.0,
    "prevo": "Cubone",
    "evoLevel": 28,
    "evoType": "levelHold",
    "evoItem": "Strange Souvenir",
    "eggGroups": [
      "Monster"
    ],
    "baseSpecies": "Marowak",
    "forme": "Alola-Totem",
    "formes": [
      "Marowak",
      "Marowak-Alola",
      "Marowak-Alola-Totem"
    ]
  },
  "hitmonlee": {
    "num": 106,
    "name": "Hitmonlee",
    "types": [
      "Fighting"
    ],
    "gender": "M",
    "baseStats": {
      "hp": 70,
      "atk": 130,
      "def": 75,
      "spe": 105,
      "spa": 35,
      "spd": 110
    },
    "abilities": {
      "0": "Reckless",
      "1": "Unburden"
    },
    "weightkg": 49.8,
    "prevo": "Tyrogue",
    "evoLevel": 24,
    "eggGroups": [
      "Human-Like"
    ]
  },
  "hitmonchan": {
    "num": 107,
    "name": "Hitmonchan",
    "types": [
      "Fighting"
    ],
    "gender": "M",
    "baseStats": {
      "hp": 70,
      "atk": 120,
      "def": 85,
      "spe": 110,
      "spa": 30,
      "spd": 110
    },
    "abilities": {
      "0": "Proficiency",
      "1": "Rapid Fire"
    },
    "weightkg": 50.2,
    "prevo": "Tyrogue",
    "evoLevel": 24,
    "eggGroups": [
      "Human-Like"
    ]
  },
  "lickitung": {
    "num": 108,
    "name": "Lickitung",
    "types": [
      "Normal",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 90,
      "atk": 85,
      "def": 95,
      "spe": 30,
      "spa": 85,
      "spd": 95
    },
    "abilities": {
      "0": "Unaware",
      "1": "Liquid Veil"
    },
    "weightkg": 65.5,
    "evos": [
      "Lickilicky"
    ],
    "eggGroups": [
      "Monster"
    ]
  },
  "koffing": {
    "num": 109,
    "name": "Koffing",
    "types": [
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 35,
      "def": 95,
      "spe": 40,
      "spa": 80,
      "spd": 75
    },
    "abilities": {
      "0": "Levitate",
      "1": "Flash Fire",
      "H": "Flare Boost"
    },
    "weightkg": 1.0,
    "evos": [
      "Weezing"
    ],
    "eggGroups": [
      "Amorphous"
    ]
  },
  "weezing": {
    "num": 110,
    "name": "Weezing",
    "types": [
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 60,
      "def": 130,
      "spe": 60,
      "spa": 110,
      "spd": 95
    },
    "abilities": {
      "0": "Levitate",
      "1": "Flash Fire",
      "H": "Flare Boost"
    },
    "weightkg": 9.5,
    "prevo": "Koffing",
    "evoLevel": 31,
    "eggGroups": [
      "Amorphous"
    ]
  },
  "rhyhorn": {
    "num": 111,
    "name": "Rhyhorn",
    "types": [
      "Ground",
      "Rock"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 118,
      "def": 115,
      "spe": 92,
      "spa": 30,
      "spd": 45
    },
    "abilities": {
      "0": "Hustle",
      "1": "Reckless"
    },
    "weightkg": 115.0,
    "evos": [
      "Rhydon"
    ],
    "eggGroups": [
      "Monster",
      "Field"
    ]
  },
  "rhydon": {
    "num": 112,
    "name": "Rhydon",
    "types": [
      "Ground",
      "Rock"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 105,
      "atk": 133,
      "def": 120,
      "spe": 62,
      "spa": 35,
      "spd": 70
    },
    "abilities": {
      "0": "Sheer Force",
      "1": "Battle Armor"
    },
    "weightkg": 120.0,
    "prevo": "Rhyhorn",
    "evoLevel": 35,
    "evoType": "levelHold",
    "evoItem": "Rock Gem",
    "evos": [
      "Rhyperior"
    ],
    "eggGroups": [
      "Monster",
      "Field"
    ]
  },
  "chansey": {
    "num": 113,
    "name": "Chansey",
    "types": [
      "Normal",
      "Fairy"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 150,
      "atk": 20,
      "def": 40,
      "spe": 40,
      "spa": 80,
      "spd": 120
    },
    "abilities": {
      "0": "Serene Grace",
      "1": "Super Luck",
      "H": "Friend Guard"
    },
    "weightkg": 34.6,
    "prevo": "Happiny",
    "evoLevel": 20,
    "evos": [
      "Blissey"
    ],
    "eggGroups": [
      "Fairy"
    ]
  },
  "tangela": {
    "num": 114,
    "name": "Tangela",
    "types": [
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 60,
      "def": 115,
      "spe": 65,
      "spa": 100,
      "spd": 75
    },
    "abilities": {
      "0": "Unaware",
      "1": "Regenerator"
    },
    "weightkg": 35.0,
    "evos": [
      "Tangrowth"
    ],
    "eggGroups": [
      "Grass"
    ]
  },
  "kangaskhan": {
    "num": 115,
    "name": "Kangaskhan",
    "types": [
      "Normal"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 105,
      "atk": 120,
      "def": 90,
      "spe": 90,
      "spa": 40,
      "spd": 80
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Instinct"
    },
    "weightkg": 80.0,
    "eggGroups": [
      "Monster"
    ],
    "formes": [
      "Kangaskhan",
      "Kangaskhan-Mega"
    ]
  },
  "kangaskhanmega": {
    "num": 115,
    "name": "Kangaskhan-Mega",
    "types": [
      "Normal"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 105,
      "atk": 130,
      "def": 110,
      "spe": 100,
      "spa": 90,
      "spd": 90
    },
    "abilities": {
      "0": "Expertise",
      "1": "Intimidate"
    },
    "weightkg": 100.0,
    "eggGroups": [
      "Monster"
    ],
    "baseSpecies": "Kangaskhan",
    "forme": "Mega",
    "formes": [
      "Kangaskhan",
      "Kangaskhan-Mega"
    ],
    "requiredItems": [
      "Mega Stone I",
      "Kangaskhanite"
    ]
  },
  "horsea": {
    "num": 116,
    "name": "Horsea",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 40,
      "def": 70,
      "spe": 75,
      "spa": 85,
      "spd": 50
    },
    "abilities": {
      "0": "Swift Swim",
      "1": "Rapid Fire"
    },
    "weightkg": 8.0,
    "evos": [
      "Seadra"
    ],
    "eggGroups": [
      "Water 1",
      "Dragon"
    ]
  },
  "seadra": {
    "num": 117,
    "name": "Seadra",
    "types": [
      "Water",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 55,
      "atk": 70,
      "def": 95,
      "spe": 90,
      "spa": 105,
      "spd": 65
    },
    "abilities": {
      "0": "Swift Swim",
      "1": "Rapid Fire"
    },
    "weightkg": 25.0,
    "prevo": "Horsea",
    "evoLevel": 25,
    "evos": [
      "Kingdra"
    ],
    "eggGroups": [
      "Water 1",
      "Dragon"
    ]
  },
  "goldeen": {
    "num": 118,
    "name": "Goldeen",
    "types": [
      "Water",
      "Ghost"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 72,
      "def": 60,
      "spe": 83,
      "spa": 75,
      "spd": 70
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Lightning Rod"
    },
    "weightkg": 15.0,
    "evos": [
      "Seaking"
    ],
    "eggGroups": [
      "Water 2"
    ]
  },
  "seaking": {
    "num": 119,
    "name": "Seaking",
    "types": [
      "Water",
      "Ghost"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 112,
      "def": 65,
      "spe": 98,
      "spa": 90,
      "spd": 90
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Lightning Rod"
    },
    "weightkg": 39.0,
    "prevo": "Goldeen",
    "evoLevel": 25,
    "eggGroups": [
      "Water 2"
    ]
  },
  "staryu": {
    "num": 120,
    "name": "Staryu",
    "types": [
      "Water",
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 35,
      "atk": 30,
      "def": 55,
      "spe": 97,
      "spa": 103,
      "spd": 80
    },
    "abilities": {
      "0": "Energy Shield",
      "1": "Neuroforce"
    },
    "weightkg": 34.5,
    "evos": [
      "Starmie"
    ],
    "eggGroups": [
      "Water 3"
    ]
  },
  "starmie": {
    "num": 121,
    "name": "Starmie",
    "types": [
      "Water",
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 70,
      "atk": 45,
      "def": 85,
      "spe": 117,
      "spa": 123,
      "spd": 95
    },
    "abilities": {
      "0": "Energy Shield",
      "1": "Neuroforce",
      "H": "Interstellar"
    },
    "weightkg": 80.0,
    "prevo": "Staryu",
    "evoLevel": 29,
    "eggGroups": [
      "Water 3"
    ]
  },
  "mrmime": {
    "num": 122,
    "name": "Mr. Mime",
    "types": [
      "Psychic",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 45,
      "def": 65,
      "spe": 90,
      "spa": 115,
      "spd": 150
    },
    "abilities": {
      "0": "Technician",
      "1": "Energy Shield"
    },
    "weightkg": 54.5,
    "prevo": "Mime Jr.",
    "evoLevel": 25,
    "eggGroups": [
      "Human-Like"
    ]
  },
  "scyther": {
    "num": 123,
    "name": "Scyther",
    "types": [
      "Bug",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 130,
      "def": 80,
      "spe": 135,
      "spa": 40,
      "spd": 80
    },
    "abilities": {
      "0": "Technician",
      "1": "Speed Boost"
    },
    "weightkg": 56.0,
    "evos": [
      "Scizor"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "jynx": {
    "num": 124,
    "name": "Jynx",
    "types": [
      "Ice",
      "Psychic"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 70,
      "atk": 50,
      "def": 60,
      "spe": 95,
      "spa": 125,
      "spd": 125
    },
    "abilities": {
      "0": "Serene Grace",
      "1": "Dry Skin",
      "H": "Magic Guard"
    },
    "weightkg": 40.6,
    "prevo": "Smoochum",
    "evoLevel": 23,
    "eggGroups": [
      "Human-Like"
    ]
  },
  "electabuzz": {
    "num": 125,
    "name": "Electabuzz",
    "types": [
      "Electric"
    ],
    "genderRatio": {
      "M": 0.75,
      "F": 0.25
    },
    "baseStats": {
      "hp": 70,
      "atk": 99,
      "def": 65,
      "spe": 117,
      "spa": 99,
      "spd": 75
    },
    "abilities": {
      "0": "Volt Rush",
      "1": "Electric Surge"
    },
    "weightkg": 30.0,
    "prevo": "Elekid",
    "evoLevel": 20,
    "evos": [
      "Electivire"
    ],
    "eggGroups": [
      "Human-Like"
    ]
  },
  "magmar": {
    "num": 126,
    "name": "Magmar",
    "types": [
      "Fire"
    ],
    "genderRatio": {
      "M": 0.75,
      "F": 0.25
    },
    "baseStats": {
      "hp": 70,
      "atk": 95,
      "def": 70,
      "spe": 97,
      "spa": 108,
      "spd": 85
    },
    "abilities": {
      "0": "Drought",
      "1": "Solar Rush"
    },
    "weightkg": 44.5,
    "prevo": "Magby",
    "evoLevel": 20,
    "evos": [
      "Magmortar"
    ],
    "eggGroups": [
      "Human-Like"
    ]
  },
  "pinsir": {
    "num": 127,
    "name": "Pinsir",
    "types": [
      "Bug",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 135,
      "def": 123,
      "spe": 87,
      "spa": 30,
      "spd": 80
    },
    "abilities": {
      "0": "Moxie",
      "1": "Hustle",
      "H": "Mold Breaker"
    },
    "weightkg": 55.0,
    "eggGroups": [
      "Bug"
    ],
    "formes": [
      "Pinsir",
      "Pinsir-Mega"
    ]
  },
  "pinsirmega": {
    "num": 127,
    "name": "Pinsir-Mega",
    "types": [
      "Bug",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 165,
      "def": 128,
      "spe": 117,
      "spa": 60,
      "spd": 95
    },
    "abilities": {
      "0": "Aerilate",
      "1": "Hustle"
    },
    "weightkg": 59.0,
    "eggGroups": [
      "Bug"
    ],
    "baseSpecies": "Pinsir",
    "forme": "Mega",
    "formes": [
      "Pinsir",
      "Pinsir-Mega"
    ],
    "requiredItems": [
      "Mega Stone I",
      "Pinsirite"
    ]
  },
  "tauros": {
    "num": 128,
    "name": "Tauros",
    "types": [
      "Normal"
    ],
    "gender": "M",
    "baseStats": {
      "hp": 90,
      "atk": 124,
      "def": 95,
      "spe": 116,
      "spa": 40,
      "spd": 70
    },
    "abilities": {
      "0": "Stamina",
      "1": "Reckless"
    },
    "weightkg": 88.4,
    "eggGroups": [
      "Field"
    ]
  },
  "magikarp": {
    "num": 129,
    "name": "Magikarp",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 30,
      "atk": 10,
      "def": 55,
      "spe": 40,
      "spa": 10,
      "spd": 55
    },
    "abilities": {
      "0": "Wimp Out",
      "1": "Rattled"
    },
    "weightkg": 10.0,
    "evos": [
      "Gyarados"
    ],
    "eggGroups": [
      "Water 2",
      "Dragon"
    ]
  },
  "gyarados": {
    "num": 130,
    "name": "Gyarados",
    "types": [
      "Water",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 114,
      "atk": 125,
      "def": 80,
      "spe": 81,
      "spa": 120,
      "spd": 80
    },
    "abilities": {
      "0": "Berserk",
      "1": "Intimidate"
    },
    "weightkg": 235.0,
    "prevo": "Magikarp",
    "evoLevel": 40,
    "eggGroups": [
      "Water 2",
      "Dragon"
    ],
    "formes": [
      "Gyarados",
      "Gyarados-Mega"
    ]
  },
  "gyaradosmega": {
    "num": 130,
    "name": "Gyarados-Mega",
    "types": [
      "Water",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 114,
      "atk": 160,
      "def": 90,
      "spe": 86,
      "spa": 160,
      "spd": 90
    },
    "abilities": {
      "0": "Swift Swim",
      "1": "Multiscale"
    },
    "weightkg": 305.0,
    "eggGroups": [
      "Water 2",
      "Dragon"
    ],
    "baseSpecies": "Gyarados",
    "forme": "Mega",
    "formes": [
      "Gyarados",
      "Gyarados-Mega"
    ],
    "requiredItems": [
      "Mega Stone II",
      "Gyaradosite"
    ]
  },
  "lapras": {
    "num": 131,
    "name": "Lapras",
    "types": [
      "Water",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 130,
      "atk": 60,
      "def": 115,
      "spe": 50,
      "spa": 105,
      "spd": 115
    },
    "abilities": {
      "0": "Shell Armor",
      "1": "Stamina"
    },
    "weightkg": 220.0,
    "eggGroups": [
      "Monster",
      "Water 1"
    ]
  },
  "ditto": {
    "num": 132,
    "name": "Ditto",
    "types": [
      "Normal"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 50,
      "atk": 50,
      "def": 50,
      "spe": 50,
      "spa": 50,
      "spd": 100
    },
    "abilities": {
      "0": "Imposter",
      "1": "Regenerator"
    },
    "weightkg": 4.0,
    "eggGroups": [
      "Ditto"
    ]
  },
  "eevee": {
    "num": 133,
    "name": "Eevee",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 55,
      "atk": 60,
      "def": 55,
      "spe": 75,
      "spa": 60,
      "spd": 65
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Versatility"
    },
    "weightkg": 6.5,
    "evos": [
      "Leafeon",
      "Glaceon",
      "Jolteon",
      "Vaporeon",
      "Flareon",
      "Sylveon",
      "Espeon",
      "Umbreon"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "vaporeon": {
    "num": 134,
    "name": "Vaporeon",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 65,
      "atk": 60,
      "def": 80,
      "spe": 80,
      "spa": 110,
      "spd": 130
    },
    "abilities": {
      "0": "Drizzle",
      "1": "Regenerator",
      "H": "Evoboost"
    },
    "weightkg": 29.0,
    "prevo": "Eevee",
    "evoLevel": 25,
    "evoType": "levelHold",
    "evoItem": "Water Gem",
    "evoCondition": "in the day",
    "eggGroups": [
      "Field"
    ]
  },
  "jolteon": {
    "num": 135,
    "name": "Jolteon",
    "types": [
      "Electric"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 65,
      "atk": 65,
      "def": 60,
      "spe": 130,
      "spa": 110,
      "spd": 95
    },
    "abilities": {
      "0": "Electric Surge",
      "1": "Galvanize",
      "H": "Evoboost"
    },
    "weightkg": 24.5,
    "prevo": "Eevee",
    "evoLevel": 25,
    "evoType": "levelHold",
    "evoItem": "Electric Gem",
    "evoCondition": "in the day",
    "eggGroups": [
      "Field"
    ]
  },
  "flareon": {
    "num": 136,
    "name": "Flareon",
    "types": [
      "Fire"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 65,
      "atk": 80,
      "def": 65,
      "spe": 90,
      "spa": 115,
      "spd": 110
    },
    "abilities": {
      "0": "Drought",
      "1": "Fluffy",
      "H": "Evoboost"
    },
    "weightkg": 25.0,
    "prevo": "Eevee",
    "evoLevel": 25,
    "evoType": "levelHold",
    "evoItem": "Fire Gem",
    "evoCondition": "in the day",
    "eggGroups": [
      "Field"
    ]
  },
  "porygon": {
    "num": 137,
    "name": "Porygon",
    "types": [
      "Electric",
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 75,
      "atk": 40,
      "def": 90,
      "spe": 40,
      "spa": 95,
      "spd": 100
    },
    "abilities": {
      "0": "Database",
      "1": "Levitate"
    },
    "weightkg": 36.5,
    "evos": [
      "Porygon2"
    ],
    "eggGroups": [
      "Mineral"
    ]
  },
  "omanyte": {
    "num": 138,
    "name": "Omanyte",
    "types": [
      "Rock",
      "Water"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 45,
      "atk": 40,
      "def": 100,
      "spe": 45,
      "spa": 90,
      "spd": 80
    },
    "abilities": {
      "0": "Weak Armor",
      "1": "Shell Armor"
    },
    "weightkg": 7.5,
    "evos": [
      "Omastar"
    ],
    "eggGroups": [
      "Water 1",
      "Water 3"
    ]
  },
  "omastar": {
    "num": 139,
    "name": "Omastar",
    "types": [
      "Rock",
      "Water"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 70,
      "atk": 60,
      "def": 140,
      "spe": 55,
      "spa": 115,
      "spd": 110
    },
    "abilities": {
      "0": "Weak Armor",
      "1": "Shell Armor"
    },
    "weightkg": 35.0,
    "prevo": "Omanyte",
    "evoLevel": 33,
    "eggGroups": [
      "Water 1",
      "Water 3"
    ]
  },
  "kabuto": {
    "num": 140,
    "name": "Kabuto",
    "types": [
      "Rock",
      "Water"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 50,
      "atk": 80,
      "def": 110,
      "spe": 55,
      "spa": 30,
      "spd": 75
    },
    "abilities": {
      "0": "Swift Swim",
      "1": "Sturdy"
    },
    "weightkg": 11.5,
    "evos": [
      "Kabutops"
    ],
    "eggGroups": [
      "Water 1",
      "Water 3"
    ]
  },
  "kabutops": {
    "num": 141,
    "name": "Kabutops",
    "types": [
      "Rock",
      "Water"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 70,
      "atk": 135,
      "def": 115,
      "spe": 110,
      "spa": 40,
      "spd": 80
    },
    "abilities": {
      "0": "Swift Swim",
      "1": "Ruthless"
    },
    "weightkg": 40.5,
    "prevo": "Kabuto",
    "evoLevel": 33,
    "eggGroups": [
      "Water 1",
      "Water 3"
    ]
  },
  "aerodactyl": {
    "num": 142,
    "name": "Aerodactyl",
    "types": [
      "Rock",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 90,
      "atk": 125,
      "def": 80,
      "spe": 130,
      "spa": 50,
      "spd": 75
    },
    "abilities": {
      "0": "Strong Jaw",
      "1": "Intimidate"
    },
    "weightkg": 59.0,
    "eggGroups": [
      "Flying"
    ],
    "formes": [
      "Aerodactyl",
      "Aerodactyl-Mega"
    ]
  },
  "aerodactylmega": {
    "num": 142,
    "name": "Aerodactyl-Mega",
    "types": [
      "Rock",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 90,
      "atk": 145,
      "def": 110,
      "spe": 150,
      "spa": 60,
      "spd": 95
    },
    "abilities": {
      "0": "Tough Claws",
      "1": "Aerilate"
    },
    "weightkg": 79.0,
    "eggGroups": [
      "Flying"
    ],
    "baseSpecies": "Aerodactyl",
    "forme": "Mega",
    "formes": [
      "Aerodactyl",
      "Aerodactyl-Mega"
    ],
    "requiredItems": [
      "Mega Stone I"
    ]
  },
  "snorlax": {
    "num": 143,
    "name": "Snorlax",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 160,
      "atk": 120,
      "def": 85,
      "spe": 10,
      "spa": 65,
      "spd": 110
    },
    "abilities": {
      "0": "Metabolism",
      "1": "Comatose",
      "H": "Unaware"
    },
    "weightkg": 460.0,
    "prevo": "Munchlax",
    "evoLevel": 33,
    "eggGroups": [
      "Monster"
    ]
  },
  "articuno": {
    "num": 144,
    "name": "Articuno",
    "types": [
      "Ice",
      "Flying"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 90,
      "atk": 60,
      "def": 95,
      "spe": 105,
      "spa": 125,
      "spd": 125
    },
    "abilities": {
      "0": "Guarding Gale",
      "1": "Snow Warning",
      "H": "Dazzling"
    },
    "weightkg": 55.4,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "zapdos": {
    "num": 145,
    "name": "Zapdos",
    "types": [
      "Electric",
      "Flying"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 90,
      "atk": 90,
      "def": 85,
      "spe": 115,
      "spa": 125,
      "spd": 95
    },
    "abilities": {
      "0": "Guarding Gale",
      "1": "Volt Absorb",
      "H": "Dazzling"
    },
    "weightkg": 52.6,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "moltres": {
    "num": 146,
    "name": "Moltres",
    "types": [
      "Fire",
      "Flying"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 90,
      "atk": 90,
      "def": 90,
      "spe": 105,
      "spa": 125,
      "spd": 100
    },
    "abilities": {
      "0": "Guarding Gale",
      "1": "Solar Power",
      "H": "Dazzling"
    },
    "weightkg": 60.0,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "dratini": {
    "num": 147,
    "name": "Dratini",
    "types": [
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 55,
      "atk": 45,
      "def": 55,
      "spe": 55,
      "spa": 80,
      "spd": 70
    },
    "abilities": {
      "0": "Regenerator",
      "1": "Swift Swim"
    },
    "weightkg": 3.3,
    "evos": [
      "Dragonair"
    ],
    "eggGroups": [
      "Water 1",
      "Dragon"
    ]
  },
  "dragonair": {
    "num": 148,
    "name": "Dragonair",
    "types": [
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 90,
      "atk": 60,
      "def": 80,
      "spe": 70,
      "spa": 90,
      "spd": 90
    },
    "abilities": {
      "0": "Regenerator",
      "1": "Drizzle",
      "H": "Marvel Scale"
    },
    "weightkg": 16.5,
    "prevo": "Dratini",
    "evoLevel": 25,
    "evos": [
      "Dragonite"
    ],
    "eggGroups": [
      "Water 1",
      "Dragon"
    ]
  },
  "dragonite": {
    "num": 149,
    "name": "Dragonite",
    "types": [
      "Dragon",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 110,
      "atk": 120,
      "def": 90,
      "spe": 80,
      "spa": 110,
      "spd": 90
    },
    "abilities": {
      "0": "Aerilate",
      "1": "Drizzle",
      "H": "Multiscale"
    },
    "weightkg": 210.0,
    "prevo": "Dragonair",
    "evoLevel": 45,
    "evoType": "levelHold",
    "evoItem": "Flying Gem",
    "eggGroups": [
      "Water 1",
      "Dragon"
    ]
  },
  "mewtwo": {
    "num": 150,
    "name": "Mewtwo",
    "types": [
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 100,
      "atk": 100,
      "def": 80,
      "spe": 135,
      "spa": 200,
      "spd": 135
    },
    "abilities": {
      "0": "Psychic Surge"
    },
    "weightkg": 122.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "formes": [
      "Mewtwo",
      "Mewtwo-Mega-X",
      "Mewtwo-Mega-Y"
    ],
    "unusable": true
  },
  "mewtwomegax": {
    "num": 150,
    "name": "Mewtwo-Mega-X",
    "types": [
      "Psychic",
      "Fighting"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 100,
      "atk": 200,
      "def": 100,
      "spe": 165,
      "spa": 150,
      "spd": 135
    },
    "abilities": {
      "0": "Expertise"
    },
    "weightkg": 127.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Mewtwo",
    "forme": "Mega-X",
    "formes": [
      "Mewtwo",
      "Mewtwo-Mega-X",
      "Mewtwo-Mega-Y"
    ],
    "requiredItems": [
      "Mewtwonite X"
    ],
    "unusable": true
  },
  "mewtwomegay": {
    "num": 150,
    "name": "Mewtwo-Mega-Y",
    "types": [
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 100,
      "atk": 60,
      "def": 60,
      "spe": 180,
      "spa": 250,
      "spd": 200
    },
    "abilities": {
      "0": "Hubris"
    },
    "weightkg": 33.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Mewtwo",
    "forme": "Mega-Y",
    "formes": [
      "Mewtwo",
      "Mewtwo-Mega-X",
      "Mewtwo-Mega-Y"
    ],
    "requiredItems": [
      "Mewtwonite Y"
    ],
    "unusable": true
  },
  "mew": {
    "num": 151,
    "name": "Mew",
    "types": [
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 100,
      "atk": 100,
      "def": 100,
      "spe": 100,
      "spa": 100,
      "spd": 100
    },
    "abilities": {
      "0": "Prankster",
      "1": "Illusion"
    },
    "weightkg": 4.0,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "chikorita": {
    "num": 152,
    "name": "Chikorita",
    "types": [
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 47,
      "atk": 47,
      "def": 65,
      "spe": 43,
      "spa": 53,
      "spd": 65
    },
    "abilities": {
      "0": "Overgrow",
      "1": "Harvest"
    },
    "weightkg": 6.4,
    "evos": [
      "Bayleef"
    ],
    "eggGroups": [
      "Monster",
      "Grass"
    ]
  },
  "bayleef": {
    "num": 153,
    "name": "Bayleef",
    "types": [
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 67,
      "atk": 62,
      "def": 85,
      "spe": 53,
      "spa": 78,
      "spd": 90
    },
    "abilities": {
      "0": "Overgrow",
      "1": "Harvest"
    },
    "weightkg": 15.8,
    "prevo": "Chikorita",
    "evoLevel": 17,
    "evos": [
      "Meganium"
    ],
    "eggGroups": [
      "Monster",
      "Grass"
    ]
  },
  "meganium": {
    "num": 154,
    "name": "Meganium",
    "types": [
      "Grass",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 117,
      "atk": 67,
      "def": 100,
      "spe": 48,
      "spa": 93,
      "spd": 125
    },
    "abilities": {
      "0": "Regenerator",
      "1": "Harvest",
      "H": "Grassy Guard"
    },
    "weightkg": 100.5,
    "prevo": "Bayleef",
    "evoLevel": 36,
    "eggGroups": [
      "Monster",
      "Grass"
    ]
  },
  "cyndaquil": {
    "num": 155,
    "name": "Cyndaquil",
    "types": [
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 43,
      "atk": 54,
      "def": 43,
      "spe": 67,
      "spa": 70,
      "spd": 43
    },
    "abilities": {
      "0": "Blaze",
      "1": "Instinct"
    },
    "weightkg": 7.9,
    "evos": [
      "Quilava"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "quilava": {
    "num": 156,
    "name": "Quilava",
    "types": [
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 58,
      "atk": 69,
      "def": 58,
      "spe": 93,
      "spa": 99,
      "spd": 58
    },
    "abilities": {
      "0": "Blaze",
      "1": "Instinct"
    },
    "weightkg": 19.0,
    "prevo": "Cyndaquil",
    "evoLevel": 17,
    "evos": [
      "Typhlosion"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "typhlosion": {
    "num": 157,
    "name": "Typhlosion",
    "types": [
      "Fire",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 78,
      "atk": 97,
      "def": 78,
      "spe": 103,
      "spa": 116,
      "spd": 78
    },
    "abilities": {
      "0": "Proficiency",
      "1": "Instinct"
    },
    "weightkg": 79.5,
    "prevo": "Quilava",
    "evoLevel": 36,
    "eggGroups": [
      "Field"
    ]
  },
  "totodile": {
    "num": 158,
    "name": "Totodile",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 70,
      "def": 65,
      "spe": 52,
      "spa": 35,
      "spd": 48
    },
    "abilities": {
      "0": "Torrent",
      "1": "Strong Jaw"
    },
    "weightkg": 9.5,
    "evos": [
      "Croconaw"
    ],
    "eggGroups": [
      "Monster",
      "Water 1"
    ]
  },
  "croconaw": {
    "num": 159,
    "name": "Croconaw",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 100,
      "def": 85,
      "spe": 72,
      "spa": 50,
      "spd": 63
    },
    "abilities": {
      "0": "Torrent",
      "1": "Strong Jaw"
    },
    "weightkg": 25.0,
    "prevo": "Totodile",
    "evoLevel": 17,
    "evos": [
      "Feraligatr"
    ],
    "eggGroups": [
      "Monster",
      "Water 1"
    ]
  },
  "feraligatr": {
    "num": 160,
    "name": "Feraligatr",
    "types": [
      "Water",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 85,
      "atk": 125,
      "def": 100,
      "spe": 97,
      "spa": 60,
      "spd": 83
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Sheer Force"
    },
    "weightkg": 88.8,
    "prevo": "Croconaw",
    "evoLevel": 36,
    "eggGroups": [
      "Monster",
      "Water 1"
    ]
  },
  "sentret": {
    "num": 161,
    "name": "Sentret",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 55,
      "def": 45,
      "spe": 95,
      "spa": 45,
      "spd": 45
    },
    "abilities": {
      "0": "Simple",
      "1": "Emergency Exit"
    },
    "weightkg": 6.0,
    "evos": [
      "Furret"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "furret": {
    "num": 162,
    "name": "Furret",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 85,
      "atk": 80,
      "def": 65,
      "spe": 115,
      "spa": 60,
      "spd": 75
    },
    "abilities": {
      "0": "Simple",
      "1": "Fur Coat"
    },
    "weightkg": 32.5,
    "prevo": "Sentret",
    "evoLevel": 20,
    "eggGroups": [
      "Field"
    ]
  },
  "hoothoot": {
    "num": 163,
    "name": "Hoothoot",
    "types": [
      "Psychic",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 51,
      "atk": 30,
      "def": 56,
      "spe": 51,
      "spa": 66,
      "spd": 76
    },
    "abilities": {
      "0": "Contrary",
      "1": "Hubris",
      "H": "Tinted Lens"
    },
    "weightkg": 21.2,
    "evos": [
      "Noctowl"
    ],
    "eggGroups": [
      "Flying"
    ]
  },
  "noctowl": {
    "num": 164,
    "name": "Noctowl",
    "types": [
      "Psychic",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 76,
      "atk": 50,
      "def": 76,
      "spe": 96,
      "spa": 106,
      "spd": 111
    },
    "abilities": {
      "0": "Contrary",
      "1": "Hubris",
      "H": "Tinted Lens"
    },
    "weightkg": 40.8,
    "prevo": "Hoothoot",
    "evoLevel": 22,
    "eggGroups": [
      "Flying"
    ]
  },
  "ledyba": {
    "num": 165,
    "name": "Ledyba",
    "types": [
      "Bug",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 20,
      "def": 50,
      "spe": 65,
      "spa": 60,
      "spd": 95
    },
    "abilities": {
      "0": "Wimp Out",
      "1": "Technician"
    },
    "weightkg": 10.8,
    "evos": [
      "Ledian"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "ledian": {
    "num": 166,
    "name": "Ledian",
    "types": [
      "Bug",
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 70,
      "def": 50,
      "spe": 110,
      "spa": 110,
      "spd": 120
    },
    "abilities": {
      "0": "Levitate",
      "1": "Technician",
      "H": "Tinted Lens"
    },
    "weightkg": 35.6,
    "prevo": "Ledyba",
    "evoLevel": 22,
    "eggGroups": [
      "Bug"
    ]
  },
  "spinarak": {
    "num": 167,
    "name": "Spinarak",
    "types": [
      "Bug",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 66,
      "def": 55,
      "spe": 79,
      "spa": 35,
      "spd": 55
    },
    "abilities": {
      "0": "Unnerve",
      "1": "Merciless",
      "H": "Quick Feet"
    },
    "weightkg": 8.5,
    "evos": [
      "Ariados"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "ariados": {
    "num": 168,
    "name": "Ariados",
    "types": [
      "Bug",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 111,
      "def": 80,
      "spe": 99,
      "spa": 40,
      "spd": 80
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Ruthless",
      "H": "Quick Feet"
    },
    "weightkg": 33.5,
    "prevo": "Spinarak",
    "evoLevel": 20,
    "eggGroups": [
      "Bug"
    ]
  },
  "crobat": {
    "num": 169,
    "name": "Crobat",
    "types": [
      "Poison",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 85,
      "atk": 90,
      "def": 70,
      "spe": 145,
      "spa": 90,
      "spd": 70
    },
    "abilities": {
      "0": "Instinct",
      "1": "Intimidate",
      "H": "Stakeout"
    },
    "weightkg": 75.0,
    "prevo": "Golbat",
    "evoLevel": 33,
    "evoType": "levelHold",
    "evoItem": "Flying Gem",
    "eggGroups": [
      "Flying"
    ]
  },
  "chinchou": {
    "num": 170,
    "name": "Chinchou",
    "types": [
      "Water",
      "Electric"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 38,
      "def": 65,
      "spe": 42,
      "spa": 95,
      "spd": 115
    },
    "abilities": {
      "0": "Dazzling",
      "1": "Lightning Rod"
    },
    "weightkg": 12.0,
    "evos": [
      "Lanturn"
    ],
    "eggGroups": [
      "Water 2"
    ]
  },
  "lanturn": {
    "num": 171,
    "name": "Lanturn",
    "types": [
      "Water",
      "Electric"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 100,
      "atk": 48,
      "def": 80,
      "spe": 67,
      "spa": 115,
      "spd": 125
    },
    "abilities": {
      "0": "Swift Swim",
      "1": "Lightning Rod",
      "H": "Dazzling"
    },
    "weightkg": 22.5,
    "prevo": "Chinchou",
    "evoLevel": 29,
    "evoType": "levelHold",
    "evoItem": "Electric Gem",
    "eggGroups": [
      "Water 2"
    ]
  },
  "pichu": {
    "num": 172,
    "name": "Pichu",
    "types": [
      "Electric"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 50,
      "def": 35,
      "spe": 60,
      "spa": 75,
      "spd": 40
    },
    "abilities": {
      "0": "Galvanize",
      "1": "Lightning Rod"
    },
    "weightkg": 2.0,
    "evos": [
      "Pikachu"
    ],
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "cleffa": {
    "num": 173,
    "name": "Cleffa",
    "types": [
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 50,
      "atk": 40,
      "def": 60,
      "spe": 30,
      "spa": 70,
      "spd": 80
    },
    "abilities": {
      "0": "Unaware",
      "1": "Magic Guard",
      "H": "Friend Guard"
    },
    "weightkg": 3.0,
    "evos": [
      "Clefairy"
    ],
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "igglybuff": {
    "num": 174,
    "name": "Igglybuff",
    "types": [
      "Normal",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 30,
      "atk": 20,
      "def": 30,
      "spe": 40,
      "spa": 65,
      "spd": 65
    },
    "abilities": {
      "0": "Huge Power",
      "1": "Fluffy"
    },
    "weightkg": 1.0,
    "evos": [
      "Jigglypuff"
    ],
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "togepi": {
    "num": 175,
    "name": "Togepi",
    "types": [
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 45,
      "atk": 20,
      "def": 85,
      "spe": 20,
      "spa": 65,
      "spd": 95
    },
    "abilities": {
      "0": "Trace",
      "1": "Magic Bounce"
    },
    "weightkg": 1.5,
    "evos": [
      "Togetic"
    ],
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "togetic": {
    "num": 176,
    "name": "Togetic",
    "types": [
      "Fairy",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 65,
      "atk": 40,
      "def": 85,
      "spe": 40,
      "spa": 90,
      "spd": 120
    },
    "abilities": {
      "0": "Trace",
      "1": "Magic Bounce"
    },
    "weightkg": 3.2,
    "prevo": "Togepi",
    "evoLevel": 17,
    "evos": [
      "Togekiss"
    ],
    "eggGroups": [
      "Flying",
      "Fairy"
    ]
  },
  "natu": {
    "num": 177,
    "name": "Natu",
    "types": [
      "Psychic",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 35,
      "def": 55,
      "spe": 50,
      "spa": 80,
      "spd": 90
    },
    "abilities": {
      "0": "Magic Bounce",
      "1": "Trace"
    },
    "weightkg": 2.0,
    "evos": [
      "Xatu"
    ],
    "eggGroups": [
      "Flying"
    ]
  },
  "xatu": {
    "num": 178,
    "name": "Xatu",
    "types": [
      "Psychic",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 55,
      "def": 90,
      "spe": 70,
      "spa": 115,
      "spd": 125
    },
    "abilities": {
      "0": "Magic Bounce",
      "1": "Sixth Sense"
    },
    "weightkg": 15.0,
    "prevo": "Natu",
    "evoLevel": 25,
    "eggGroups": [
      "Flying"
    ]
  },
  "mareep": {
    "num": 179,
    "name": "Mareep",
    "types": [
      "Electric"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 40,
      "def": 50,
      "spe": 45,
      "spa": 70,
      "spd": 65
    },
    "abilities": {
      "0": "Unaware",
      "1": "Lightning Rod"
    },
    "weightkg": 7.8,
    "evos": [
      "Flaaffy"
    ],
    "eggGroups": [
      "Monster",
      "Field"
    ]
  },
  "flaaffy": {
    "num": 180,
    "name": "Flaaffy",
    "types": [
      "Electric"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 65,
      "def": 65,
      "spe": 50,
      "spa": 90,
      "spd": 85
    },
    "abilities": {
      "0": "Unaware",
      "1": "Lightning Rod"
    },
    "weightkg": 13.3,
    "prevo": "Mareep",
    "evoLevel": 17,
    "evos": [
      "Ampharos"
    ],
    "eggGroups": [
      "Monster",
      "Field"
    ]
  },
  "ampharos": {
    "num": 181,
    "name": "Ampharos",
    "types": [
      "Electric"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 90,
      "atk": 75,
      "def": 85,
      "spe": 55,
      "spa": 115,
      "spd": 115
    },
    "abilities": {
      "0": "Dazzling",
      "1": "Lightning Rod",
      "H": "Unaware"
    },
    "weightkg": 61.5,
    "prevo": "Flaaffy",
    "evoLevel": 30,
    "eggGroups": [
      "Monster",
      "Field"
    ],
    "formes": [
      "Ampharos",
      "Ampharos-Mega"
    ]
  },
  "ampharosmega": {
    "num": 181,
    "name": "Ampharos-Mega",
    "types": [
      "Electric",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 90,
      "atk": 95,
      "def": 85,
      "spe": 55,
      "spa": 165,
      "spd": 145
    },
    "abilities": {
      "0": "Fluffy",
      "1": "Volt Rush"
    },
    "weightkg": 61.5,
    "eggGroups": [
      "Monster",
      "Field"
    ],
    "baseSpecies": "Ampharos",
    "forme": "Mega",
    "formes": [
      "Ampharos",
      "Ampharos-Mega"
    ],
    "requiredItems": [
      "Mega Stone I",
      "Ampharosite"
    ]
  },
  "bellossom": {
    "num": 182,
    "name": "Bellossom",
    "types": [
      "Fairy",
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 65,
      "def": 95,
      "spe": 95,
      "spa": 105,
      "spd": 110
    },
    "abilities": {
      "0": "Drought",
      "1": "Queenly Majesty"
    },
    "weightkg": 5.8,
    "prevo": "Gloom",
    "evoLevel": 32,
    "evoType": "levelHold",
    "evoItem": "Fairy Gem",
    "eggGroups": [
      "Grass"
    ]
  },
  "marill": {
    "num": 183,
    "name": "Marill",
    "types": [
      "Fire",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 35,
      "def": 65,
      "spe": 55,
      "spa": 90,
      "spd": 90
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Huge Power"
    },
    "weightkg": 8.5,
    "prevo": "Azurill",
    "evoLevel": 17,
    "evos": [
      "Azumarill"
    ],
    "eggGroups": [
      "Water 1",
      "Fairy"
    ]
  },
  "azumarill": {
    "num": 184,
    "name": "Azumarill",
    "types": [
      "Fire",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 100,
      "atk": 55,
      "def": 85,
      "spe": 60,
      "spa": 115,
      "spd": 100
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Huge Power"
    },
    "weightkg": 28.5,
    "prevo": "Marill",
    "evoLevel": 32,
    "eggGroups": [
      "Water 1",
      "Fairy"
    ]
  },
  "sudowoodo": {
    "num": 185,
    "name": "Sudowoodo",
    "types": [
      "Rock"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 105,
      "def": 115,
      "spe": 75,
      "spa": 30,
      "spd": 85
    },
    "abilities": {
      "0": "Contrary",
      "1": "Sap Sipper"
    },
    "weightkg": 38.0,
    "prevo": "Bonsly",
    "evoLevel": 20,
    "eggGroups": [
      "Mineral"
    ]
  },
  "politoed": {
    "num": 186,
    "name": "Politoed",
    "types": [
      "Water",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 75,
      "def": 80,
      "spe": 95,
      "spa": 105,
      "spd": 115
    },
    "abilities": {
      "0": "Drizzle",
      "1": "Amplifier"
    },
    "weightkg": 33.9,
    "prevo": "Poliwhirl",
    "evoLevel": 34,
    "evoType": "levelHold",
    "evoItem": "Water Gem",
    "eggGroups": [
      "Water 1"
    ]
  },
  "hoppip": {
    "num": 187,
    "name": "Hoppip",
    "types": [
      "Grass",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 35,
      "def": 40,
      "spe": 75,
      "spa": 55,
      "spd": 55
    },
    "abilities": {
      "0": "Regenerator",
      "1": "Guarding Gale"
    },
    "weightkg": 3.0,
    "evos": [
      "Skiploom"
    ],
    "eggGroups": [
      "Fairy",
      "Grass"
    ]
  },
  "skiploom": {
    "num": 188,
    "name": "Skiploom",
    "types": [
      "Grass",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 55,
      "atk": 45,
      "def": 65,
      "spe": 95,
      "spa": 75,
      "spd": 75
    },
    "abilities": {
      "0": "Regenerator",
      "1": "Guarding Gale"
    },
    "weightkg": 3.0,
    "prevo": "Hoppip",
    "evoLevel": 15,
    "evos": [
      "Jumpluff"
    ],
    "eggGroups": [
      "Fairy",
      "Grass"
    ]
  },
  "jumpluff": {
    "num": 189,
    "name": "Jumpluff",
    "types": [
      "Grass",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 55,
      "def": 80,
      "spe": 125,
      "spa": 95,
      "spd": 95
    },
    "abilities": {
      "0": "Regenerator",
      "1": "Guarding Gale"
    },
    "weightkg": 3.0,
    "prevo": "Skiploom",
    "evoLevel": 26,
    "eggGroups": [
      "Fairy",
      "Grass"
    ]
  },
  "aipom": {
    "num": 190,
    "name": "Aipom",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 74,
      "def": 50,
      "spe": 106,
      "spa": 40,
      "spd": 50
    },
    "abilities": {
      "0": "Prankster",
      "1": "Technician"
    },
    "weightkg": 11.5,
    "evos": [
      "Ambipom"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "sunkern": {
    "num": 191,
    "name": "Sunkern",
    "types": [
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 30,
      "def": 70,
      "spe": 30,
      "spa": 80,
      "spd": 80
    },
    "abilities": {
      "0": "Simple",
      "1": "Grassy Guard"
    },
    "weightkg": 1.8,
    "evos": [
      "Sunflora"
    ],
    "eggGroups": [
      "Grass"
    ]
  },
  "sunflora": {
    "num": 192,
    "name": "Sunflora",
    "types": [
      "Grass",
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 45,
      "def": 85,
      "spe": 45,
      "spa": 120,
      "spd": 110
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Drought",
      "H": "Sweltering Sun"
    },
    "weightkg": 8.5,
    "prevo": "Sunkern",
    "evoLevel": 20,
    "eggGroups": [
      "Grass"
    ]
  },
  "yanma": {
    "num": 193,
    "name": "Yanma",
    "types": [
      "Bug",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 49,
      "atk": 66,
      "def": 49,
      "spe": 126,
      "spa": 96,
      "spd": 49
    },
    "abilities": {
      "0": "Aerilate",
      "1": "Amplifier"
    },
    "weightkg": 38.0,
    "evos": [
      "Yanmega"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "wooper": {
    "num": 194,
    "name": "Wooper",
    "types": [
      "Water",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 55,
      "atk": 50,
      "def": 65,
      "spe": 15,
      "spa": 50,
      "spd": 65
    },
    "abilities": {
      "0": "Simple",
      "1": "Unaware"
    },
    "weightkg": 8.5,
    "evos": [
      "Quagsire"
    ],
    "eggGroups": [
      "Water 1",
      "Field"
    ]
  },
  "quagsire": {
    "num": 195,
    "name": "Quagsire",
    "types": [
      "Water",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 95,
      "atk": 85,
      "def": 95,
      "spe": 25,
      "spa": 85,
      "spd": 95
    },
    "abilities": {
      "0": "Simple",
      "1": "Unaware"
    },
    "weightkg": 75.0,
    "prevo": "Wooper",
    "evoLevel": 20,
    "eggGroups": [
      "Water 1",
      "Field"
    ]
  },
  "espeon": {
    "num": 196,
    "name": "Espeon",
    "types": [
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 65,
      "atk": 65,
      "def": 60,
      "spe": 110,
      "spa": 115,
      "spd": 110
    },
    "abilities": {
      "0": "Psychic Surge",
      "1": "Solar Power",
      "H": "Evoboost"
    },
    "weightkg": 26.5,
    "prevo": "Eevee",
    "evoLevel": 25,
    "evoType": "levelHold",
    "evoItem": "Psychic Gem",
    "evoCondition": "in the day",
    "eggGroups": [
      "Field"
    ]
  },
  "umbreon": {
    "num": 197,
    "name": "Umbreon",
    "types": [
      "Dark"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 65,
      "atk": 65,
      "def": 80,
      "spe": 90,
      "spa": 95,
      "spd": 130
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Dark Aura",
      "H": "Poison Heal"
    },
    "weightkg": 27.0,
    "prevo": "Eevee",
    "evoLevel": 25,
    "evoType": "levelHold",
    "evoItem": "Dark Gem",
    "evoCondition": "in the night",
    "eggGroups": [
      "Field"
    ]
  },
  "murkrow": {
    "num": 198,
    "name": "Murkrow",
    "types": [
      "Dark",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 57,
      "atk": 85,
      "def": 51,
      "spe": 106,
      "spa": 85,
      "spd": 51
    },
    "abilities": {
      "0": "Prankster",
      "1": "Super Luck"
    },
    "weightkg": 2.1,
    "evos": [
      "Honchkrow"
    ],
    "eggGroups": [
      "Flying"
    ]
  },
  "slowking": {
    "num": 199,
    "name": "Slowking",
    "types": [
      "Water",
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 95,
      "atk": 70,
      "def": 95,
      "spe": 25,
      "spa": 115,
      "spd": 115
    },
    "abilities": {
      "0": "Hubris",
      "1": "Regenerator"
    },
    "weightkg": 79.5,
    "prevo": "Slowpoke",
    "evoLevel": 29,
    "evoType": "levelHold",
    "evoItem": "Psychic Gem",
    "eggGroups": [
      "Monster",
      "Water 1"
    ]
  },
  "misdreavus": {
    "num": 200,
    "name": "Misdreavus",
    "types": [
      "Ghost",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 30,
      "def": 45,
      "spe": 110,
      "spa": 110,
      "spd": 110
    },
    "abilities": {
      "0": "Levitate",
      "1": "Pixilate"
    },
    "weightkg": 1.0,
    "evos": [
      "Mismagius"
    ],
    "eggGroups": [
      "Amorphous"
    ]
  },
  "unown": {
    "num": 201,
    "name": "Unown",
    "types": [
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 2,
      "atk": 51,
      "def": 2,
      "spe": 72,
      "spa": 72,
      "spd": 2
    },
    "abilities": {
      "0": "Wonder Guard"
    },
    "weightkg": 5.0,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "wobbuffet": {
    "num": 202,
    "name": "Wobbuffet",
    "types": [
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 190,
      "atk": 33,
      "def": 118,
      "spe": 33,
      "spa": 33,
      "spd": 118
    },
    "abilities": {
      "0": "Emergency Exit",
      "1": "Magic Bounce",
      "H": "Shadow Tag"
    },
    "weightkg": 28.5,
    "prevo": "Wynaut",
    "evoLevel": 30,
    "evoType": "levelHold",
    "evoItem": "Psychic Gem",
    "eggGroups": [
      "Amorphous"
    ]
  },
  "girafarig": {
    "num": 203,
    "name": "Girafarig",
    "types": [
      "Normal",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 95,
      "def": 80,
      "spe": 100,
      "spa": 110,
      "spd": 80
    },
    "abilities": {
      "0": "Contrary",
      "1": "Psychic Surge"
    },
    "weightkg": 41.5,
    "eggGroups": [
      "Field"
    ]
  },
  "pineco": {
    "num": 204,
    "name": "Pineco",
    "types": [
      "Bug"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 65,
      "def": 95,
      "spe": 15,
      "spa": 65,
      "spd": 80
    },
    "abilities": {
      "0": "Sturdy",
      "1": "Rough Skin"
    },
    "weightkg": 7.2,
    "evos": [
      "Forretress"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "forretress": {
    "num": 205,
    "name": "Forretress",
    "types": [
      "Bug",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 100,
      "def": 140,
      "spe": 20,
      "spa": 100,
      "spd": 100
    },
    "abilities": {
      "0": "Bulletproof",
      "1": "Rapid Fire"
    },
    "weightkg": 125.8,
    "prevo": "Pineco",
    "evoLevel": 29,
    "eggGroups": [
      "Bug"
    ]
  },
  "dunsparce": {
    "num": 206,
    "name": "Dunsparce",
    "types": [
      "Fairy",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 100,
      "atk": 85,
      "def": 105,
      "spe": 45,
      "spa": 85,
      "spd": 105
    },
    "abilities": {
      "0": "Instinct",
      "1": "Simple",
      "H": "Serene Grace"
    },
    "weightkg": 14.0,
    "eggGroups": [
      "Field"
    ]
  },
  "gligar": {
    "num": 207,
    "name": "Gligar",
    "types": [
      "Poison",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 95,
      "def": 115,
      "spe": 105,
      "spa": 35,
      "spd": 65
    },
    "abilities": {
      "0": "Prankster",
      "1": "Tough Claws"
    },
    "weightkg": 64.8,
    "evos": [
      "Gliscor"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "steelix": {
    "num": 208,
    "name": "Steelix",
    "types": [
      "Steel",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 130,
      "atk": 130,
      "def": 180,
      "spe": 30,
      "spa": 30,
      "spd": 100
    },
    "abilities": {
      "0": "Sand Stream",
      "1": "Sheer Force"
    },
    "weightkg": 400.0,
    "prevo": "Onix",
    "evoLevel": 40,
    "evoType": "levelHold",
    "evoItem": "Steel Gem",
    "eggGroups": [
      "Mineral"
    ],
    "formes": [
      "Steelix",
      "Steelix-Mega"
    ]
  },
  "steelixmega": {
    "num": 208,
    "name": "Steelix-Mega",
    "types": [
      "Steel",
      "Rock"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 130,
      "atk": 160,
      "def": 200,
      "spe": 20,
      "spa": 30,
      "spd": 160
    },
    "abilities": {
      "0": "Sand Force",
      "1": "Energy Shield"
    },
    "weightkg": 740.0,
    "eggGroups": [
      "Mineral"
    ],
    "baseSpecies": "Steelix",
    "forme": "Mega",
    "formes": [
      "Steelix",
      "Steelix-Mega"
    ],
    "requiredItems": [
      "Mega Stone II"
    ]
  },
  "snubbull": {
    "num": 209,
    "name": "Snubbull",
    "types": [
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 65,
      "atk": 80,
      "def": 65,
      "spe": 55,
      "spa": 40,
      "spd": 65
    },
    "abilities": {
      "0": "Strong Jaw",
      "1": "Intimidate",
      "H": "Quick Feet"
    },
    "weightkg": 7.8,
    "evos": [
      "Granbull"
    ],
    "eggGroups": [
      "Field",
      "Fairy"
    ]
  },
  "granbull": {
    "num": 210,
    "name": "Granbull",
    "types": [
      "Fairy",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 90,
      "atk": 130,
      "def": 95,
      "spe": 70,
      "spa": 60,
      "spd": 80
    },
    "abilities": {
      "0": "Sheer Force",
      "1": "Intimidate",
      "H": "Quick Feet"
    },
    "weightkg": 48.7,
    "prevo": "Snubbull",
    "evoLevel": 26,
    "eggGroups": [
      "Field",
      "Fairy"
    ]
  },
  "qwilfish": {
    "num": 211,
    "name": "Qwilfish",
    "types": [
      "Water",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 95,
      "def": 95,
      "spe": 95,
      "spa": 95,
      "spd": 80
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Instinct"
    },
    "weightkg": 3.9,
    "eggGroups": [
      "Water 2"
    ]
  },
  "scizor": {
    "num": 212,
    "name": "Scizor",
    "types": [
      "Bug",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 130,
      "def": 120,
      "spe": 95,
      "spa": 40,
      "spd": 80
    },
    "abilities": {
      "0": "Technician",
      "1": "Proficiency"
    },
    "weightkg": 118.0,
    "prevo": "Scyther",
    "evoLevel": 35,
    "evoType": "levelHold",
    "evoItem": "Steel Gem",
    "eggGroups": [
      "Bug"
    ],
    "formes": [
      "Scizor",
      "Scizor-Mega"
    ]
  },
  "scizormega": {
    "num": 212,
    "name": "Scizor-Mega",
    "types": [
      "Bug",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 165,
      "def": 150,
      "spe": 100,
      "spa": 50,
      "spd": 100
    },
    "abilities": {
      "0": "Tough Claws",
      "1": "Intimidate"
    },
    "weightkg": 125.0,
    "eggGroups": [
      "Bug"
    ],
    "baseSpecies": "Scizor",
    "forme": "Mega",
    "formes": [
      "Scizor",
      "Scizor-Mega"
    ],
    "requiredItems": [
      "Mega Stone I",
      "Scizorite"
    ]
  },
  "shuckle": {
    "num": 213,
    "name": "Shuckle",
    "types": [
      "Bug",
      "Rock"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 10,
      "def": 230,
      "spe": 10,
      "spa": 10,
      "spd": 230
    },
    "abilities": {
      "0": "Simple",
      "1": "Shell Armor",
      "H": "Oblivious"
    },
    "weightkg": 20.5,
    "eggGroups": [
      "Bug"
    ]
  },
  "heracross": {
    "num": 214,
    "name": "Heracross",
    "types": [
      "Bug",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 130,
      "def": 113,
      "spe": 92,
      "spa": 40,
      "spd": 80
    },
    "abilities": {
      "0": "Skill Link",
      "1": "Ruthless",
      "H": "Guts"
    },
    "weightkg": 54.0,
    "eggGroups": [
      "Bug"
    ],
    "formes": [
      "Heracross",
      "Heracross-Mega"
    ]
  },
  "heracrossmega": {
    "num": 214,
    "name": "Heracross-Mega",
    "types": [
      "Bug",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 190,
      "def": 148,
      "spe": 67,
      "spa": 40,
      "spd": 110
    },
    "abilities": {
      "0": "Hustle",
      "1": "Technician"
    },
    "weightkg": 62.5,
    "eggGroups": [
      "Bug"
    ],
    "baseSpecies": "Heracross",
    "forme": "Mega",
    "formes": [
      "Heracross",
      "Heracross-Mega"
    ],
    "requiredItems": [
      "Mega Stone I",
      "Heracronite"
    ]
  },
  "sneasel": {
    "num": 215,
    "name": "Sneasel",
    "types": [
      "Dark",
      "Ice"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 55,
      "atk": 105,
      "def": 55,
      "spe": 118,
      "spa": 42,
      "spd": 55
    },
    "abilities": {
      "0": "Refrigerate",
      "1": "Technician"
    },
    "weightkg": 28.0,
    "evos": [
      "Weavile"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "teddiursa": {
    "num": 216,
    "name": "Teddiursa",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 62,
      "atk": 80,
      "def": 65,
      "spe": 53,
      "spa": 45,
      "spd": 65
    },
    "abilities": {
      "0": "Hustle",
      "1": "Metabolism"
    },
    "weightkg": 8.8,
    "evos": [
      "Ursaring"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "ursaring": {
    "num": 217,
    "name": "Ursaring",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 102,
      "atk": 135,
      "def": 80,
      "spe": 83,
      "spa": 55,
      "spd": 80
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Tough Claws",
      "H": "Quick Feet"
    },
    "weightkg": 125.8,
    "prevo": "Teddiursa",
    "evoLevel": 29,
    "eggGroups": [
      "Field"
    ]
  },
  "slugma": {
    "num": 218,
    "name": "Slugma",
    "types": [
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 40,
      "def": 60,
      "spe": 20,
      "spa": 95,
      "spd": 95
    },
    "abilities": {
      "0": "Sweltering Sun",
      "1": "Drought"
    },
    "weightkg": 35.0,
    "evos": [
      "Magcargo"
    ],
    "eggGroups": [
      "Amorphous"
    ]
  },
  "magcargo": {
    "num": 219,
    "name": "Magcargo",
    "types": [
      "Fire",
      "Rock"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 50,
      "def": 120,
      "spe": 30,
      "spa": 135,
      "spd": 120
    },
    "abilities": {
      "0": "Sweltering Sun",
      "1": "Drought"
    },
    "weightkg": 55.0,
    "prevo": "Slugma",
    "evoLevel": 31,
    "eggGroups": [
      "Amorphous"
    ]
  },
  "swinub": {
    "num": 220,
    "name": "Swinub",
    "types": [
      "Ice",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 65,
      "def": 60,
      "spe": 50,
      "spa": 50,
      "spd": 50
    },
    "abilities": {
      "0": "Refrigerate",
      "1": "Resilient"
    },
    "weightkg": 6.5,
    "evos": [
      "Piloswine"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "piloswine": {
    "num": 221,
    "name": "Piloswine",
    "types": [
      "Ice",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 105,
      "atk": 105,
      "def": 90,
      "spe": 50,
      "spa": 60,
      "spd": 70
    },
    "abilities": {
      "0": "Refrigerate",
      "1": "Resilient",
      "H": "Unaware"
    },
    "weightkg": 55.8,
    "prevo": "Swinub",
    "evoLevel": 20,
    "evos": [
      "Mamoswine"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "corsola": {
    "num": 222,
    "name": "Corsola",
    "types": [
      "Water",
      "Rock"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 65,
      "atk": 55,
      "def": 125,
      "spe": 35,
      "spa": 95,
      "spd": 125
    },
    "abilities": {
      "0": "Rough Skin",
      "1": "Regenerator"
    },
    "weightkg": 5.0,
    "eggGroups": [
      "Water 1",
      "Water 3"
    ]
  },
  "remoraid": {
    "num": 223,
    "name": "Remoraid",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 35,
      "atk": 65,
      "def": 40,
      "spe": 95,
      "spa": 95,
      "spd": 40
    },
    "abilities": {
      "0": "Versatility",
      "1": "Rapid Fire"
    },
    "weightkg": 12.0,
    "evos": [
      "Octillery"
    ],
    "eggGroups": [
      "Water 1",
      "Water 2"
    ]
  },
  "octillery": {
    "num": 224,
    "name": "Octillery",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 115,
      "def": 80,
      "spe": 40,
      "spa": 125,
      "spd": 100
    },
    "abilities": {
      "0": "Versatility",
      "1": "Rapid Fire"
    },
    "weightkg": 28.5,
    "prevo": "Remoraid",
    "evoLevel": 28,
    "eggGroups": [
      "Water 1",
      "Water 2"
    ]
  },
  "delibird": {
    "num": 225,
    "name": "Delibird",
    "types": [
      "Ice",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 75,
      "def": 70,
      "spe": 90,
      "spa": 90,
      "spd": 85
    },
    "abilities": {
      "0": "Pixilate",
      "1": "Technician"
    },
    "weightkg": 16.0,
    "eggGroups": [
      "Water 1",
      "Field"
    ]
  },
  "mantine": {
    "num": 226,
    "name": "Mantine",
    "types": [
      "Water",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 115,
      "atk": 40,
      "def": 85,
      "spe": 80,
      "spa": 90,
      "spd": 140
    },
    "abilities": {
      "0": "Swift Swim",
      "1": "Guarding Gale",
      "H": "Water Absorb"
    },
    "weightkg": 220.0,
    "prevo": "Mantyke",
    "evoLevel": 31,
    "eggGroups": [
      "Water 1"
    ]
  },
  "skarmory": {
    "num": 227,
    "name": "Skarmory",
    "types": [
      "Steel",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 116,
      "def": 116,
      "spe": 123,
      "spa": 40,
      "spd": 70
    },
    "abilities": {
      "0": "Ruthless",
      "1": "Intimidate"
    },
    "weightkg": 50.5,
    "eggGroups": [
      "Flying"
    ]
  },
  "houndour": {
    "num": 228,
    "name": "Houndour",
    "types": [
      "Dark",
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 65,
      "def": 40,
      "spe": 80,
      "spa": 85,
      "spd": 50
    },
    "abilities": {
      "0": "Unnerve",
      "1": "Sinister"
    },
    "weightkg": 10.8,
    "evos": [
      "Houndoom"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "houndoom": {
    "num": 229,
    "name": "Houndoom",
    "types": [
      "Dark",
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 95,
      "def": 60,
      "spe": 105,
      "spa": 120,
      "spd": 80
    },
    "abilities": {
      "0": "Ruthless",
      "1": "Sinister"
    },
    "weightkg": 35.0,
    "prevo": "Houndour",
    "evoLevel": 29,
    "eggGroups": [
      "Field"
    ],
    "formes": [
      "Houndoom",
      "Houndoom-Mega"
    ]
  },
  "houndoommega": {
    "num": 229,
    "name": "Houndoom-Mega",
    "types": [
      "Dark",
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 110,
      "def": 90,
      "spe": 115,
      "spa": 155,
      "spd": 90
    },
    "abilities": {
      "0": "Hubris",
      "1": "Dark Aura"
    },
    "weightkg": 49.5,
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Houndoom",
    "forme": "Mega",
    "formes": [
      "Houndoom",
      "Houndoom-Mega"
    ],
    "requiredItems": [
      "Mega Stone I"
    ]
  },
  "kingdra": {
    "num": 230,
    "name": "Kingdra",
    "types": [
      "Water",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 85,
      "atk": 95,
      "def": 100,
      "spe": 95,
      "spa": 125,
      "spd": 100
    },
    "abilities": {
      "0": "Drizzle",
      "1": "Mega Launcher"
    },
    "weightkg": 152.0,
    "prevo": "Seadra",
    "evoLevel": 45,
    "evoType": "levelHold",
    "evoItem": "Dragon Gem",
    "eggGroups": [
      "Water 1",
      "Dragon"
    ]
  },
  "phanpy": {
    "num": 231,
    "name": "Phanpy",
    "types": [
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 85,
      "def": 85,
      "spe": 40,
      "spa": 30,
      "spd": 65
    },
    "abilities": {
      "0": "Hustle",
      "1": "Dry Skin"
    },
    "weightkg": 33.5,
    "evos": [
      "Donphan"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "donphan": {
    "num": 232,
    "name": "Donphan",
    "types": [
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 100,
      "atk": 130,
      "def": 130,
      "spe": 70,
      "spa": 40,
      "spd": 80
    },
    "abilities": {
      "0": "Sheer Force",
      "1": "Speed Boost"
    },
    "weightkg": 120.0,
    "prevo": "Phanpy",
    "evoLevel": 34,
    "eggGroups": [
      "Field"
    ]
  },
  "porygon2": {
    "num": 233,
    "name": "Porygon2",
    "types": [
      "Electric",
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 75,
      "atk": 60,
      "def": 100,
      "spe": 60,
      "spa": 105,
      "spd": 150
    },
    "abilities": {
      "0": "Energy Shield",
      "1": "Levitate"
    },
    "weightkg": 32.5,
    "prevo": "Porygon",
    "evoType": "other",
    "evoItem": "Hotfix",
    "evoCondition": "level 35) or Porygon-Z (level-up holding Hotfix at level 40",
    "evos": [
      "Porygon-Z"
    ],
    "eggGroups": [
      "Mineral"
    ]
  },
  "stantler": {
    "num": 234,
    "name": "Stantler",
    "types": [
      "Normal",
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 83,
      "atk": 105,
      "def": 73,
      "spe": 106,
      "spa": 95,
      "spd": 73
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Energy Shield"
    },
    "weightkg": 71.2,
    "eggGroups": [
      "Field"
    ]
  },
  "smeargle": {
    "num": 235,
    "name": "Smeargle",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 70,
      "def": 70,
      "spe": 95,
      "spa": 70,
      "spd": 70
    },
    "abilities": {
      "0": "Prankster",
      "1": "Versatility"
    },
    "weightkg": 58.0,
    "eggGroups": [
      "Field"
    ]
  },
  "tyrogue": {
    "num": 236,
    "name": "Tyrogue",
    "types": [
      "Fighting"
    ],
    "gender": "M",
    "baseStats": {
      "hp": 45,
      "atk": 80,
      "def": 70,
      "spe": 85,
      "spa": 25,
      "spd": 45
    },
    "abilities": {
      "0": "Defiant",
      "1": "Emergency Exit"
    },
    "weightkg": 21.0,
    "evos": [
      "Hitmonchan",
      "Hitmonlee",
      "Hitmontop"
    ],
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "hitmontop": {
    "num": 237,
    "name": "Hitmontop",
    "types": [
      "Fighting"
    ],
    "gender": "M",
    "baseStats": {
      "hp": 70,
      "atk": 110,
      "def": 95,
      "spe": 100,
      "spa": 40,
      "spd": 110
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Technician"
    },
    "weightkg": 48.0,
    "prevo": "Tyrogue",
    "evoLevel": 24,
    "eggGroups": [
      "Human-Like"
    ]
  },
  "smoochum": {
    "num": 238,
    "name": "Smoochum",
    "types": [
      "Ice",
      "Psychic"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 45,
      "atk": 30,
      "def": 45,
      "spe": 75,
      "spa": 90,
      "spd": 90
    },
    "abilities": {
      "0": "Serene Grace",
      "1": "Dry Skin"
    },
    "weightkg": 6.0,
    "evos": [
      "Jynx"
    ],
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "elekid": {
    "num": 239,
    "name": "Elekid",
    "types": [
      "Electric"
    ],
    "genderRatio": {
      "M": 0.75,
      "F": 0.25
    },
    "baseStats": {
      "hp": 45,
      "atk": 73,
      "def": 40,
      "spe": 97,
      "spa": 75,
      "spd": 45
    },
    "abilities": {
      "0": "Volt Rush",
      "1": "Lightning Rod"
    },
    "weightkg": 23.5,
    "evos": [
      "Electabuzz"
    ],
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "magby": {
    "num": 240,
    "name": "Magby",
    "types": [
      "Fire"
    ],
    "genderRatio": {
      "M": 0.75,
      "F": 0.25
    },
    "baseStats": {
      "hp": 45,
      "atk": 65,
      "def": 45,
      "spe": 83,
      "spa": 82,
      "spd": 55
    },
    "abilities": {
      "0": "Flash Fire",
      "1": "Solar Rush"
    },
    "weightkg": 21.4,
    "evos": [
      "Magmar"
    ],
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "miltank": {
    "num": 241,
    "name": "Miltank",
    "types": [
      "Normal"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 105,
      "atk": 100,
      "def": 105,
      "spe": 80,
      "spa": 40,
      "spd": 105
    },
    "abilities": {
      "0": "Thick Fat",
      "1": "Sap Sipper"
    },
    "weightkg": 75.5,
    "eggGroups": [
      "Field"
    ]
  },
  "blissey": {
    "num": 242,
    "name": "Blissey",
    "types": [
      "Normal",
      "Fairy"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 180,
      "atk": 30,
      "def": 60,
      "spe": 45,
      "spa": 85,
      "spd": 150
    },
    "abilities": {
      "0": "Serene Grace",
      "1": "Misty Surge",
      "H": "Friend Guard"
    },
    "weightkg": 46.8,
    "prevo": "Chansey",
    "evoLevel": 32,
    "evoType": "levelHold",
    "evoItem": "Normal Gem",
    "eggGroups": [
      "Fairy"
    ]
  },
  "raikou": {
    "num": 243,
    "name": "Raikou",
    "types": [
      "Electric",
      "Dark"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 80,
      "atk": 122,
      "def": 70,
      "spe": 136,
      "spa": 122,
      "spd": 70
    },
    "abilities": {
      "0": "Drizzle",
      "1": "Strong Jaw",
      "H": "Dazzling"
    },
    "weightkg": 178.0,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "entei": {
    "num": 244,
    "name": "Entei",
    "types": [
      "Fire",
      "Ground"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 80,
      "atk": 127,
      "def": 85,
      "spe": 106,
      "spa": 117,
      "spd": 85
    },
    "abilities": {
      "0": "Drought",
      "1": "Intimidate"
    },
    "weightkg": 198.0,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "suicune": {
    "num": 245,
    "name": "Suicune",
    "types": [
      "Water",
      "Ice"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 80,
      "atk": 75,
      "def": 85,
      "spe": 116,
      "spa": 117,
      "spd": 127
    },
    "abilities": {
      "0": "Snow Warning",
      "1": "Serene Grace"
    },
    "weightkg": 187.0,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "larvitar": {
    "num": 246,
    "name": "Larvitar",
    "types": [
      "Rock",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 79,
      "def": 90,
      "spe": 46,
      "spa": 45,
      "spd": 50
    },
    "abilities": {
      "0": "Hustle",
      "1": "Sand Rush"
    },
    "weightkg": 72.0,
    "evos": [
      "Pupitar"
    ],
    "eggGroups": [
      "Monster"
    ]
  },
  "pupitar": {
    "num": 247,
    "name": "Pupitar",
    "types": [
      "Rock",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 94,
      "def": 115,
      "spe": 51,
      "spa": 65,
      "spd": 85
    },
    "abilities": {
      "0": "Hustle",
      "1": "Shell Armor"
    },
    "weightkg": 202.0,
    "prevo": "Larvitar",
    "evoLevel": 25,
    "evos": [
      "Tyranitar"
    ],
    "eggGroups": [
      "Monster"
    ]
  },
  "tyranitar": {
    "num": 248,
    "name": "Tyranitar",
    "types": [
      "Rock",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 110,
      "atk": 134,
      "def": 115,
      "spe": 61,
      "spa": 95,
      "spd": 85
    },
    "abilities": {
      "0": "Bulletproof",
      "1": "Sand Stream"
    },
    "weightkg": 202.0,
    "prevo": "Pupitar",
    "evoLevel": 45,
    "evoType": "levelHold",
    "evoItem": "Dark Gem",
    "eggGroups": [
      "Monster"
    ],
    "formes": [
      "Tyranitar",
      "Tyranitar-Mega"
    ]
  },
  "tyranitarmega": {
    "num": 248,
    "name": "Tyranitar-Mega",
    "types": [
      "Rock",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 110,
      "atk": 164,
      "def": 150,
      "spe": 61,
      "spa": 120,
      "spd": 95
    },
    "abilities": {
      "0": "Berserk",
      "1": "Sand Force"
    },
    "weightkg": 255.0,
    "eggGroups": [
      "Monster"
    ],
    "baseSpecies": "Tyranitar",
    "forme": "Mega",
    "formes": [
      "Tyranitar",
      "Tyranitar-Mega"
    ],
    "requiredItems": [
      "Mega Stone II"
    ]
  },
  "lugia": {
    "num": 249,
    "name": "Lugia",
    "types": [
      "Psychic",
      "Flying"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 156,
      "atk": 110,
      "def": 110,
      "spe": 110,
      "spa": 110,
      "spd": 154
    },
    "abilities": {
      "0": "Stormy Seas",
      "1": "Multiscale"
    },
    "weightkg": 216.0,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "hooh": {
    "num": 250,
    "name": "Ho-Oh",
    "types": [
      "Fairy",
      "Flying"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 156,
      "atk": 130,
      "def": 90,
      "spe": 90,
      "spa": 130,
      "spd": 154
    },
    "abilities": {
      "0": "Sweltering Sun",
      "1": "Regenerator"
    },
    "weightkg": 199.0,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "celebi": {
    "num": 251,
    "name": "Celebi",
    "types": [
      "Psychic",
      "Grass"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 65,
      "atk": 60,
      "def": 80,
      "spe": 110,
      "spa": 135,
      "spd": 150
    },
    "abilities": {
      "0": "Grassy Surge",
      "1": "Psychic Surge",
      "H": "Magic Guard"
    },
    "weightkg": 5.0,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "treecko": {
    "num": 252,
    "name": "Treecko",
    "types": [
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 60,
      "def": 40,
      "spe": 70,
      "spa": 70,
      "spd": 40
    },
    "abilities": {
      "0": "Overgrow",
      "1": "Technician"
    },
    "weightkg": 5.0,
    "evos": [
      "Grovyle"
    ],
    "eggGroups": [
      "Monster",
      "Dragon"
    ]
  },
  "grovyle": {
    "num": 253,
    "name": "Grovyle",
    "types": [
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 95,
      "def": 45,
      "spe": 115,
      "spa": 85,
      "spd": 45
    },
    "abilities": {
      "0": "Overgrow",
      "1": "Technician"
    },
    "weightkg": 21.6,
    "prevo": "Treecko",
    "evoLevel": 17,
    "evos": [
      "Sceptile"
    ],
    "eggGroups": [
      "Monster",
      "Dragon"
    ]
  },
  "sceptile": {
    "num": 254,
    "name": "Sceptile",
    "types": [
      "Grass",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 115,
      "def": 65,
      "spe": 125,
      "spa": 105,
      "spd": 65
    },
    "abilities": {
      "0": "Proficiency",
      "1": "Super Luck"
    },
    "weightkg": 52.2,
    "prevo": "Grovyle",
    "evoLevel": 36,
    "eggGroups": [
      "Monster",
      "Dragon"
    ],
    "formes": [
      "Sceptile",
      "Sceptile-Mega"
    ]
  },
  "sceptilemega": {
    "num": 254,
    "name": "Sceptile-Mega",
    "types": [
      "Grass",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 75,
      "atk": 145,
      "def": 70,
      "spe": 145,
      "spa": 145,
      "spd": 70
    },
    "abilities": {
      "0": "Solar Power",
      "1": "Instinct"
    },
    "weightkg": 55.2,
    "eggGroups": [
      "Monster",
      "Dragon"
    ],
    "baseSpecies": "Sceptile",
    "forme": "Mega",
    "formes": [
      "Sceptile",
      "Sceptile-Mega"
    ],
    "requiredItems": [
      "Mega Stone I"
    ]
  },
  "torchic": {
    "num": 255,
    "name": "Torchic",
    "types": [
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 60,
      "def": 45,
      "spe": 55,
      "spa": 70,
      "spd": 45
    },
    "abilities": {
      "0": "Speed Boost",
      "1": "Blaze"
    },
    "weightkg": 2.5,
    "evos": [
      "Combusken"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "combusken": {
    "num": 256,
    "name": "Combusken",
    "types": [
      "Fire",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 90,
      "def": 60,
      "spe": 75,
      "spa": 85,
      "spd": 60
    },
    "abilities": {
      "0": "Speed Boost",
      "1": "Blaze"
    },
    "weightkg": 19.5,
    "prevo": "Torchic",
    "evoLevel": 17,
    "evos": [
      "Blaziken"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "blaziken": {
    "num": 257,
    "name": "Blaziken",
    "types": [
      "Fire",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 120,
      "def": 70,
      "spe": 105,
      "spa": 110,
      "spd": 70
    },
    "abilities": {
      "0": "Speed Boost",
      "1": "Reckless"
    },
    "weightkg": 52.0,
    "prevo": "Combusken",
    "evoLevel": 36,
    "eggGroups": [
      "Field"
    ],
    "formes": [
      "Blaziken",
      "Blaziken-Mega"
    ]
  },
  "blazikenmega": {
    "num": 257,
    "name": "Blaziken-Mega",
    "types": [
      "Fire",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 75,
      "atk": 160,
      "def": 75,
      "spe": 115,
      "spa": 150,
      "spd": 75
    },
    "abilities": {
      "0": "No Guard",
      "1": "Speed Boost"
    },
    "weightkg": 52.0,
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Blaziken",
    "forme": "Mega",
    "formes": [
      "Blaziken",
      "Blaziken-Mega"
    ],
    "requiredItems": [
      "Mega Stone I"
    ]
  },
  "mudkip": {
    "num": 258,
    "name": "Mudkip",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 65,
      "def": 50,
      "spe": 40,
      "spa": 60,
      "spd": 50
    },
    "abilities": {
      "0": "Water Absorb",
      "1": "Torrent"
    },
    "weightkg": 7.6,
    "evos": [
      "Marshtomp"
    ],
    "eggGroups": [
      "Monster",
      "Water 1"
    ]
  },
  "marshtomp": {
    "num": 259,
    "name": "Marshtomp",
    "types": [
      "Water",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 85,
      "def": 80,
      "spe": 50,
      "spa": 80,
      "spd": 70
    },
    "abilities": {
      "0": "Water Absorb",
      "1": "Torrent"
    },
    "weightkg": 28.0,
    "prevo": "Mudkip",
    "evoLevel": 17,
    "evos": [
      "Swampert"
    ],
    "eggGroups": [
      "Monster",
      "Water 1"
    ]
  },
  "swampert": {
    "num": 260,
    "name": "Swampert",
    "types": [
      "Water",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 100,
      "atk": 120,
      "def": 90,
      "spe": 60,
      "spa": 90,
      "spd": 90
    },
    "abilities": {
      "0": "Water Absorb",
      "1": "Hydration"
    },
    "weightkg": 81.9,
    "prevo": "Marshtomp",
    "evoLevel": 36,
    "eggGroups": [
      "Monster",
      "Water 1"
    ],
    "formes": [
      "Swampert",
      "Swampert-Mega"
    ]
  },
  "swampertmega": {
    "num": 260,
    "name": "Swampert-Mega",
    "types": [
      "Water",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 100,
      "atk": 170,
      "def": 120,
      "spe": 65,
      "spa": 95,
      "spd": 100
    },
    "abilities": {
      "0": "Headstrong",
      "1": "Swift Swim"
    },
    "weightkg": 102.0,
    "eggGroups": [
      "Monster",
      "Water 1"
    ],
    "baseSpecies": "Swampert",
    "forme": "Mega",
    "formes": [
      "Swampert",
      "Swampert-Mega"
    ],
    "requiredItems": [
      "Mega Stone I",
      "Swampertite"
    ]
  },
  "poochyena": {
    "num": 261,
    "name": "Poochyena",
    "types": [
      "Dark",
      "Rock"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 90,
      "def": 70,
      "spe": 90,
      "spa": 30,
      "spd": 45
    },
    "abilities": {
      "0": "Moxie",
      "1": "Defiant",
      "H": "Stakeout"
    },
    "weightkg": 13.6,
    "evos": [
      "Mightyena"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "mightyena": {
    "num": 262,
    "name": "Mightyena",
    "types": [
      "Dark",
      "Rock"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 125,
      "def": 90,
      "spe": 110,
      "spa": 60,
      "spd": 60
    },
    "abilities": {
      "0": "Moxie",
      "1": "Strong Jaw",
      "H": "Stakeout"
    },
    "weightkg": 37.0,
    "prevo": "Poochyena",
    "evoLevel": 22,
    "eggGroups": [
      "Field"
    ]
  },
  "zigzagoon": {
    "num": 263,
    "name": "Zigzagoon",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 48,
      "atk": 60,
      "def": 51,
      "spe": 80,
      "spa": 30,
      "spd": 51
    },
    "abilities": {
      "0": "Hustle",
      "1": "Speed Boost"
    },
    "weightkg": 17.5,
    "evos": [
      "Linoone"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "linoone": {
    "num": 264,
    "name": "Linoone",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 73,
      "atk": 95,
      "def": 71,
      "spe": 120,
      "spa": 50,
      "spd": 71
    },
    "abilities": {
      "0": "Tough Claws",
      "1": "Speed Boost"
    },
    "weightkg": 32.5,
    "prevo": "Zigzagoon",
    "evoLevel": 20,
    "eggGroups": [
      "Field"
    ]
  },
  "wurmple": {
    "num": 265,
    "name": "Wurmple",
    "types": [
      "Bug"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 45,
      "def": 40,
      "spe": 25,
      "spa": 45,
      "spd": 50
    },
    "abilities": {
      "0": "Poison Point",
      "1": "Sap Sipper"
    },
    "weightkg": 3.6,
    "evos": [
      "Silcoon",
      "Cascoon"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "silcoon": {
    "num": 266,
    "name": "Silcoon",
    "types": [
      "Bug"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 40,
      "def": 95,
      "spe": 15,
      "spa": 55,
      "spd": 95
    },
    "abilities": {
      "0": "Tangling Hair",
      "1": "Sturdy"
    },
    "weightkg": 10.0,
    "prevo": "Wurmple",
    "evoLevel": 10,
    "evos": [
      "Beautifly"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "beautifly": {
    "num": 267,
    "name": "Beautifly",
    "types": [
      "Bug",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 45,
      "def": 60,
      "spe": 100,
      "spa": 115,
      "spd": 95
    },
    "abilities": {
      "0": "Serene Grace",
      "1": "Ruthless",
      "H": "Dazzling"
    },
    "weightkg": 28.4,
    "prevo": "Silcoon",
    "evoLevel": 20,
    "eggGroups": [
      "Bug"
    ]
  },
  "cascoon": {
    "num": 268,
    "name": "Cascoon",
    "types": [
      "Bug"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 40,
      "def": 95,
      "spe": 15,
      "spa": 55,
      "spd": 95
    },
    "abilities": {
      "0": "Poison Point",
      "1": "Sturdy"
    },
    "weightkg": 11.5,
    "prevo": "Wurmple",
    "evoLevel": 10,
    "evos": [
      "Dustox"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "dustox": {
    "num": 269,
    "name": "Dustox",
    "types": [
      "Bug",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 40,
      "def": 80,
      "spe": 80,
      "spa": 95,
      "spd": 115
    },
    "abilities": {
      "0": "Prankster",
      "1": "Levitate"
    },
    "weightkg": 31.6,
    "prevo": "Cascoon",
    "evoLevel": 20,
    "eggGroups": [
      "Bug"
    ]
  },
  "lotad": {
    "num": 270,
    "name": "Lotad",
    "types": [
      "Water",
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 40,
      "def": 45,
      "spe": 40,
      "spa": 65,
      "spd": 65
    },
    "abilities": {
      "0": "Rain Dish",
      "1": "Sap Sipper"
    },
    "weightkg": 2.6,
    "evos": [
      "Lombre"
    ],
    "eggGroups": [
      "Water 1",
      "Grass"
    ]
  },
  "lombre": {
    "num": 271,
    "name": "Lombre",
    "types": [
      "Water",
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 90,
      "def": 60,
      "spe": 80,
      "spa": 85,
      "spd": 75
    },
    "abilities": {
      "0": "Swift Swim",
      "1": "Prankster"
    },
    "weightkg": 32.5,
    "prevo": "Lotad",
    "evoLevel": 17,
    "evos": [
      "Ludicolo"
    ],
    "eggGroups": [
      "Water 1",
      "Grass"
    ]
  },
  "ludicolo": {
    "num": 272,
    "name": "Ludicolo",
    "types": [
      "Water",
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 90,
      "atk": 90,
      "def": 90,
      "spe": 70,
      "spa": 105,
      "spd": 105
    },
    "abilities": {
      "0": "Drizzle",
      "1": "Grassy Surge"
    },
    "weightkg": 55.0,
    "prevo": "Lombre",
    "evoLevel": 32,
    "evoType": "levelHold",
    "evoItem": "Water Gem",
    "eggGroups": [
      "Water 1",
      "Grass"
    ]
  },
  "seedot": {
    "num": 273,
    "name": "Seedot",
    "types": [
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 40,
      "def": 75,
      "spe": 30,
      "spa": 55,
      "spd": 60
    },
    "abilities": {
      "0": "Harvest",
      "1": "Grassy Guard"
    },
    "weightkg": 4.0,
    "evos": [
      "Nuzleaf"
    ],
    "eggGroups": [
      "Field",
      "Grass"
    ]
  },
  "nuzleaf": {
    "num": 274,
    "name": "Nuzleaf",
    "types": [
      "Grass",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 90,
      "def": 75,
      "spe": 80,
      "spa": 85,
      "spd": 60
    },
    "abilities": {
      "0": "Proficiency",
      "1": "Prankster"
    },
    "weightkg": 28.0,
    "prevo": "Seedot",
    "evoLevel": 17,
    "evos": [
      "Shiftry"
    ],
    "eggGroups": [
      "Field",
      "Grass"
    ]
  },
  "shiftry": {
    "num": 275,
    "name": "Shiftry",
    "types": [
      "Grass",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 105,
      "def": 95,
      "spe": 110,
      "spa": 105,
      "spd": 60
    },
    "abilities": {
      "0": "Versatility",
      "1": "Ruthless"
    },
    "weightkg": 59.6,
    "prevo": "Nuzleaf",
    "evoLevel": 32,
    "evoType": "levelHold",
    "evoItem": "Dark Gem",
    "eggGroups": [
      "Field",
      "Grass"
    ]
  },
  "taillow": {
    "num": 276,
    "name": "Taillow",
    "types": [
      "Normal",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 65,
      "def": 30,
      "spe": 105,
      "spa": 60,
      "spd": 30
    },
    "abilities": {
      "0": "Hustle",
      "1": "Defiant"
    },
    "weightkg": 2.3,
    "evos": [
      "Swellow"
    ],
    "eggGroups": [
      "Flying"
    ]
  },
  "swellow": {
    "num": 277,
    "name": "Swellow",
    "types": [
      "Normal",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 95,
      "def": 60,
      "spe": 135,
      "spa": 85,
      "spd": 60
    },
    "abilities": {
      "0": "Hustle",
      "1": "Instinct",
      "H": "Guts"
    },
    "weightkg": 19.8,
    "prevo": "Taillow",
    "evoLevel": 22,
    "eggGroups": [
      "Flying"
    ]
  },
  "wingull": {
    "num": 278,
    "name": "Wingull",
    "types": [
      "Water",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 30,
      "def": 45,
      "spe": 95,
      "spa": 65,
      "spd": 45
    },
    "abilities": {
      "0": "Gale Wings",
      "1": "Bird's Eye View"
    },
    "weightkg": 9.5,
    "evos": [
      "Pelipper"
    ],
    "eggGroups": [
      "Water 1",
      "Flying"
    ]
  },
  "pelipper": {
    "num": 279,
    "name": "Pelipper",
    "types": [
      "Water",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 45,
      "def": 100,
      "spe": 65,
      "spa": 95,
      "spd": 95
    },
    "abilities": {
      "0": "Drizzle",
      "1": "Simple"
    },
    "weightkg": 28.0,
    "prevo": "Wingull",
    "evoLevel": 20,
    "eggGroups": [
      "Water 1",
      "Flying"
    ]
  },
  "ralts": {
    "num": 280,
    "name": "Ralts",
    "types": [
      "Psychic",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 25,
      "def": 40,
      "spe": 55,
      "spa": 80,
      "spd": 70
    },
    "abilities": {
      "0": "Trace",
      "1": "Magic Guard"
    },
    "weightkg": 6.6,
    "evos": [
      "Kirlia"
    ],
    "eggGroups": [
      "Amorphous"
    ]
  },
  "kirlia": {
    "num": 281,
    "name": "Kirlia",
    "types": [
      "Psychic",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 55,
      "atk": 40,
      "def": 55,
      "spe": 75,
      "spa": 95,
      "spd": 90
    },
    "abilities": {
      "0": "Trace",
      "1": "Magic Guard"
    },
    "weightkg": 20.2,
    "prevo": "Ralts",
    "evoLevel": 17,
    "evos": [
      "Gardevoir",
      "Gallade"
    ],
    "eggGroups": [
      "Amorphous"
    ]
  },
  "gardevoir": {
    "num": 282,
    "name": "Gardevoir",
    "types": [
      "Psychic",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 55,
      "def": 65,
      "spe": 100,
      "spa": 125,
      "spd": 115
    },
    "abilities": {
      "0": "Trace",
      "1": "Magic Guard"
    },
    "weightkg": 48.4,
    "prevo": "Kirlia",
    "evoLevel": 33,
    "evoType": "levelHold",
    "evoItem": "Psychic Gem",
    "eggGroups": [
      "Amorphous"
    ],
    "formes": [
      "Gardevoir",
      "Gardevoir-Mega"
    ]
  },
  "gardevoirmega": {
    "num": 282,
    "name": "Gardevoir-Mega",
    "types": [
      "Psychic",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 55,
      "def": 75,
      "spe": 100,
      "spa": 170,
      "spd": 160
    },
    "abilities": {
      "0": "Fairy Aura",
      "1": "Magic Bounce"
    },
    "weightkg": 48.4,
    "eggGroups": [
      "Amorphous"
    ],
    "baseSpecies": "Gardevoir",
    "forme": "Mega",
    "formes": [
      "Gardevoir",
      "Gardevoir-Mega"
    ],
    "requiredItems": [
      "Mega Stone I",
      "Gardevoirite"
    ]
  },
  "surskit": {
    "num": 283,
    "name": "Surskit",
    "types": [
      "Bug",
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 20,
      "def": 32,
      "spe": 97,
      "spa": 79,
      "spd": 62
    },
    "abilities": {
      "0": "Emergency Exit",
      "1": "Swift Swim"
    },
    "weightkg": 1.7,
    "evos": [
      "Masquerain"
    ],
    "eggGroups": [
      "Water 1",
      "Bug"
    ]
  },
  "masquerain": {
    "num": 284,
    "name": "Masquerain",
    "types": [
      "Bug",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 25,
      "def": 62,
      "spe": 127,
      "spa": 114,
      "spd": 82
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Drizzle"
    },
    "weightkg": 3.6,
    "prevo": "Surskit",
    "evoLevel": 20,
    "eggGroups": [
      "Water 1",
      "Bug"
    ]
  },
  "shroomish": {
    "num": 285,
    "name": "Shroomish",
    "types": [
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 40,
      "def": 80,
      "spe": 35,
      "spa": 55,
      "spd": 80
    },
    "abilities": {
      "0": "Grassy Guard",
      "1": "Regenerator",
      "H": "Poison Heal"
    },
    "weightkg": 4.5,
    "evos": [
      "Breloom"
    ],
    "eggGroups": [
      "Fairy",
      "Grass"
    ]
  },
  "breloom": {
    "num": 286,
    "name": "Breloom",
    "types": [
      "Grass",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 130,
      "def": 80,
      "spe": 105,
      "spa": 60,
      "spd": 80
    },
    "abilities": {
      "0": "Technician",
      "1": "Regenerator",
      "H": "Toxic Boost"
    },
    "weightkg": 39.2,
    "prevo": "Shroomish",
    "evoLevel": 23,
    "eggGroups": [
      "Fairy",
      "Grass"
    ]
  },
  "slakoth": {
    "num": 287,
    "name": "Slakoth",
    "types": [
      "Normal",
      "Ice"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 70,
      "def": 70,
      "spe": 30,
      "spa": 30,
      "spd": 70
    },
    "abilities": {
      "0": "Metabolism",
      "1": "Truant"
    },
    "weightkg": 24.0,
    "evos": [
      "Vigoroth"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "vigoroth": {
    "num": 288,
    "name": "Vigoroth",
    "types": [
      "Normal",
      "Ice"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 110,
      "def": 70,
      "spe": 110,
      "spa": 40,
      "spd": 70
    },
    "abilities": {
      "0": "Hustle",
      "1": "Unburden",
      "H": "Quick Feet"
    },
    "weightkg": 46.5,
    "prevo": "Slakoth",
    "evoLevel": 20,
    "evos": [
      "Slaking"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "slaking": {
    "num": 289,
    "name": "Slaking",
    "types": [
      "Normal",
      "Ice"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 125,
      "atk": 160,
      "def": 80,
      "spe": 80,
      "spa": 50,
      "spd": 80
    },
    "abilities": {
      "0": "Hustle",
      "1": "Slush Rush"
    },
    "weightkg": 130.5,
    "prevo": "Vigoroth",
    "evoLevel": 40,
    "evoType": "levelHold",
    "evoItem": "Ice Gem",
    "eggGroups": [
      "Field"
    ]
  },
  "nincada": {
    "num": 290,
    "name": "Nincada",
    "types": [
      "Bug",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 51,
      "atk": 71,
      "def": 91,
      "spe": 40,
      "spa": 46,
      "spd": 71
    },
    "abilities": {
      "0": "Sap Sipper",
      "1": "Tough Claws"
    },
    "weightkg": 5.5,
    "evos": [
      "Ninjask"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "ninjask": {
    "num": 291,
    "name": "Ninjask",
    "types": [
      "Bug",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 61,
      "atk": 101,
      "def": 51,
      "spe": 170,
      "spa": 91,
      "spd": 51
    },
    "abilities": {
      "0": "Versatility",
      "1": "Aerilate",
      "H": "Tinted Lens"
    },
    "weightkg": 12.0,
    "prevo": "Nincada",
    "evoLevel": 22,
    "eggGroups": [
      "Bug"
    ]
  },
  "shedinja": {
    "num": 292,
    "name": "Shedinja",
    "types": [
      "Bug",
      "Ghost"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 1,
      "atk": 30,
      "def": 45,
      "spe": 60,
      "spa": 111,
      "spd": 45
    },
    "abilities": {
      "0": "Wonder Guard"
    },
    "weightkg": 1.2,
    "eggGroups": [
      "Mineral"
    ]
  },
  "whismur": {
    "num": 293,
    "name": "Whismur",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 54,
      "atk": 51,
      "def": 63,
      "spe": 53,
      "spa": 76,
      "spd": 63
    },
    "abilities": {
      "0": "Wimp Out",
      "1": "Amplifier",
      "H": "Scrappy"
    },
    "weightkg": 16.3,
    "evos": [
      "Loudred"
    ],
    "eggGroups": [
      "Monster",
      "Field"
    ]
  },
  "loudred": {
    "num": 294,
    "name": "Loudred",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 74,
      "atk": 86,
      "def": 73,
      "spe": 68,
      "spa": 106,
      "spd": 73
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Amplifier",
      "H": "Scrappy"
    },
    "weightkg": 40.5,
    "prevo": "Whismur",
    "evoLevel": 25,
    "evos": [
      "Exploud"
    ],
    "eggGroups": [
      "Monster",
      "Field"
    ]
  },
  "exploud": {
    "num": 295,
    "name": "Exploud",
    "types": [
      "Normal",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 109,
      "atk": 121,
      "def": 78,
      "spe": 73,
      "spa": 141,
      "spd": 78
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Amplifier",
      "H": "Scrappy"
    },
    "weightkg": 84.0,
    "prevo": "Loudred",
    "evoLevel": 45,
    "evoType": "levelHold",
    "evoItem": "Dragon Gem",
    "eggGroups": [
      "Monster",
      "Field"
    ]
  },
  "makuhita": {
    "num": 296,
    "name": "Makuhita",
    "types": [
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.75,
      "F": 0.25
    },
    "baseStats": {
      "hp": 72,
      "atk": 96,
      "def": 86,
      "spe": 20,
      "spa": 20,
      "spd": 76
    },
    "abilities": {
      "0": "Resilient",
      "1": "Thick Fat"
    },
    "weightkg": 86.4,
    "evos": [
      "Hariyama"
    ],
    "eggGroups": [
      "Human-Like"
    ]
  },
  "hariyama": {
    "num": 297,
    "name": "Hariyama",
    "types": [
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.75,
      "F": 0.25
    },
    "baseStats": {
      "hp": 144,
      "atk": 144,
      "def": 96,
      "spe": 40,
      "spa": 40,
      "spd": 86
    },
    "abilities": {
      "0": "Resilient",
      "1": "Thick Fat"
    },
    "weightkg": 253.8,
    "prevo": "Makuhita",
    "evoLevel": 34,
    "eggGroups": [
      "Human-Like"
    ]
  },
  "azurill": {
    "num": 298,
    "name": "Azurill",
    "types": [
      "Fire",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 50,
      "atk": 20,
      "def": 50,
      "spe": 50,
      "spa": 65,
      "spd": 65
    },
    "abilities": {
      "0": "Prankster",
      "1": "Huge Power"
    },
    "weightkg": 2.0,
    "evos": [
      "Marill"
    ],
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "nosepass": {
    "num": 299,
    "name": "Nosepass",
    "types": [
      "Rock"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 30,
      "def": 135,
      "spe": 15,
      "spa": 80,
      "spd": 115
    },
    "abilities": {
      "0": "Lightning Rod",
      "1": "Sand Stream"
    },
    "weightkg": 97.0,
    "evos": [
      "Probopass"
    ],
    "eggGroups": [
      "Mineral"
    ]
  },
  "skitty": {
    "num": 300,
    "name": "Skitty",
    "types": [
      "Normal",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 50,
      "atk": 48,
      "def": 45,
      "spe": 77,
      "spa": 65,
      "spd": 65
    },
    "abilities": {
      "0": "Fur Coat",
      "1": "Simple"
    },
    "weightkg": 11.0,
    "evos": [
      "Delcatty"
    ],
    "eggGroups": [
      "Field",
      "Fairy"
    ]
  },
  "delcatty": {
    "num": 301,
    "name": "Delcatty",
    "types": [
      "Normal",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 70,
      "atk": 73,
      "def": 70,
      "spe": 112,
      "spa": 95,
      "spd": 95
    },
    "abilities": {
      "0": "Fur Coat",
      "1": "Simple"
    },
    "weightkg": 32.6,
    "prevo": "Skitty",
    "evoLevel": 23,
    "eggGroups": [
      "Field",
      "Fairy"
    ]
  },
  "sableye": {
    "num": 302,
    "name": "Sableye",
    "types": [
      "Ghost",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 95,
      "def": 85,
      "spe": 95,
      "spa": 95,
      "spd": 95
    },
    "abilities": {
      "0": "Prankster",
      "1": "Tough Claws",
      "H": "Tinted Lens"
    },
    "weightkg": 11.0,
    "eggGroups": [
      "Human-Like"
    ],
    "formes": [
      "Sableye",
      "Sableye-Mega"
    ]
  },
  "sableyemega": {
    "num": 302,
    "name": "Sableye-Mega",
    "types": [
      "Ghost",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 95,
      "def": 170,
      "spe": 20,
      "spa": 110,
      "spd": 170
    },
    "abilities": {
      "0": "Magic Bounce",
      "1": "Energy Shield"
    },
    "weightkg": 161.0,
    "eggGroups": [
      "Human-Like"
    ],
    "baseSpecies": "Sableye",
    "forme": "Mega",
    "formes": [
      "Sableye",
      "Sableye-Mega"
    ],
    "requiredItems": [
      "Mega Stone I"
    ]
  },
  "mawile": {
    "num": 303,
    "name": "Mawile",
    "types": [
      "Steel",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 128,
      "def": 115,
      "spe": 52,
      "spa": 55,
      "spd": 100
    },
    "abilities": {
      "0": "Strong Jaw",
      "1": "Intimidate"
    },
    "weightkg": 11.5,
    "eggGroups": [
      "Field",
      "Fairy"
    ],
    "formes": [
      "Mawile",
      "Mawile-Mega"
    ]
  },
  "mawilemega": {
    "num": 303,
    "name": "Mawile-Mega",
    "types": [
      "Steel",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 188,
      "def": 125,
      "spe": 62,
      "spa": 65,
      "spd": 110
    },
    "abilities": {
      "0": "Sheer Force",
      "1": "Hustle"
    },
    "weightkg": 23.5,
    "eggGroups": [
      "Field",
      "Fairy"
    ],
    "baseSpecies": "Mawile",
    "forme": "Mega",
    "formes": [
      "Mawile",
      "Mawile-Mega"
    ],
    "requiredItems": [
      "Mega Stone I"
    ]
  },
  "aron": {
    "num": 304,
    "name": "Aron",
    "types": [
      "Steel",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 70,
      "def": 120,
      "spe": 30,
      "spa": 40,
      "spd": 50
    },
    "abilities": {
      "0": "Filter",
      "1": "Battle Armor"
    },
    "weightkg": 60.0,
    "evos": [
      "Lairon"
    ],
    "eggGroups": [
      "Monster"
    ]
  },
  "lairon": {
    "num": 305,
    "name": "Lairon",
    "types": [
      "Steel",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 100,
      "def": 140,
      "spe": 40,
      "spa": 50,
      "spd": 70
    },
    "abilities": {
      "0": "Filter",
      "1": "Battle Armor"
    },
    "weightkg": 120.0,
    "prevo": "Aron",
    "evoLevel": 25,
    "evos": [
      "Aggron"
    ],
    "eggGroups": [
      "Monster"
    ]
  },
  "aggron": {
    "num": 306,
    "name": "Aggron",
    "types": [
      "Steel",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 115,
      "atk": 135,
      "def": 150,
      "spe": 60,
      "spa": 60,
      "spd": 80
    },
    "abilities": {
      "0": "Headstrong",
      "1": "Hustle",
      "H": "Ruthless"
    },
    "weightkg": 360.0,
    "prevo": "Lairon",
    "evoLevel": 45,
    "evoType": "levelHold",
    "evoItem": "Steel Gem",
    "eggGroups": [
      "Monster"
    ],
    "formes": [
      "Aggron",
      "Aggron-Mega"
    ]
  },
  "aggronmega": {
    "num": 306,
    "name": "Aggron-Mega",
    "types": [
      "Steel",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 115,
      "atk": 165,
      "def": 200,
      "spe": 45,
      "spa": 60,
      "spd": 115
    },
    "abilities": {
      "0": "Sheer Force",
      "1": "Bulletproof",
      "H": "Iron Barbs"
    },
    "weightkg": 395.0,
    "eggGroups": [
      "Monster"
    ],
    "baseSpecies": "Aggron",
    "forme": "Mega",
    "formes": [
      "Aggron",
      "Aggron-Mega"
    ],
    "requiredItems": [
      "Mega Stone II",
      "Aggronite"
    ]
  },
  "meditite": {
    "num": 307,
    "name": "Meditite",
    "types": [
      "Fighting",
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 40,
      "def": 55,
      "spe": 90,
      "spa": 95,
      "spd": 80
    },
    "abilities": {
      "0": "Pure Power",
      "1": "Technician"
    },
    "weightkg": 11.2,
    "evos": [
      "Medicham"
    ],
    "eggGroups": [
      "Human-Like"
    ]
  },
  "medicham": {
    "num": 308,
    "name": "Medicham",
    "types": [
      "Fighting",
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 65,
      "def": 70,
      "spe": 95,
      "spa": 125,
      "spd": 100
    },
    "abilities": {
      "0": "Pure Power",
      "1": "Psychic Surge"
    },
    "weightkg": 31.5,
    "prevo": "Meditite",
    "evoLevel": 34,
    "eggGroups": [
      "Human-Like"
    ],
    "formes": [
      "Medicham",
      "Medicham-Mega"
    ]
  },
  "medichammega": {
    "num": 308,
    "name": "Medicham-Mega",
    "types": [
      "Fighting",
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 100,
      "def": 75,
      "spe": 105,
      "spa": 165,
      "spd": 110
    },
    "abilities": {
      "0": "Pure Power",
      "1": "Sixth Sense"
    },
    "weightkg": 31.5,
    "eggGroups": [
      "Human-Like"
    ],
    "baseSpecies": "Medicham",
    "forme": "Mega",
    "formes": [
      "Medicham",
      "Medicham-Mega"
    ],
    "requiredItems": [
      "Mega Stone I",
      "Medichamite"
    ]
  },
  "electrike": {
    "num": 309,
    "name": "Electrike",
    "types": [
      "Electric",
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 45,
      "def": 50,
      "spe": 90,
      "spa": 90,
      "spd": 50
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Speed Boost"
    },
    "weightkg": 15.2,
    "evos": [
      "Manectric"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "manectric": {
    "num": 310,
    "name": "Manectric",
    "types": [
      "Electric",
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 95,
      "def": 70,
      "spe": 115,
      "spa": 115,
      "spd": 70
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Speed Boost"
    },
    "weightkg": 40.2,
    "prevo": "Electrike",
    "evoLevel": 23,
    "eggGroups": [
      "Field"
    ],
    "formes": [
      "Manectric",
      "Manectric-Mega"
    ]
  },
  "manectricmega": {
    "num": 310,
    "name": "Manectric-Mega",
    "types": [
      "Electric",
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 120,
      "def": 80,
      "spe": 140,
      "spa": 145,
      "spd": 80
    },
    "abilities": {
      "0": "Electric Surge",
      "1": "Instinct"
    },
    "weightkg": 44.0,
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Manectric",
    "forme": "Mega",
    "formes": [
      "Manectric",
      "Manectric-Mega"
    ],
    "requiredItems": [
      "Mega Stone I"
    ]
  },
  "plusle": {
    "num": 311,
    "name": "Plusle",
    "types": [
      "Electric",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 55,
      "def": 55,
      "spe": 110,
      "spa": 115,
      "spd": 100
    },
    "abilities": {
      "0": "Serene Grace",
      "1": "Speed Boost",
      "H": "Battery"
    },
    "weightkg": 4.2,
    "eggGroups": [
      "Fairy"
    ]
  },
  "minun": {
    "num": 312,
    "name": "Minun",
    "types": [
      "Electric",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 45,
      "def": 65,
      "spe": 110,
      "spa": 100,
      "spd": 115
    },
    "abilities": {
      "0": "Dazzling",
      "1": "Fur Coat",
      "H": "Friend Guard"
    },
    "weightkg": 4.2,
    "eggGroups": [
      "Fairy"
    ]
  },
  "volbeat": {
    "num": 313,
    "name": "Volbeat",
    "types": [
      "Bug",
      "Electric"
    ],
    "gender": "M",
    "baseStats": {
      "hp": 70,
      "atk": 47,
      "def": 89,
      "spe": 85,
      "spa": 118,
      "spd": 106
    },
    "abilities": {
      "0": "Dazzling",
      "1": "Technician",
      "H": "Volt Rush"
    },
    "weightkg": 17.7,
    "eggGroups": [
      "Bug",
      "Human-Like"
    ]
  },
  "illumise": {
    "num": 314,
    "name": "Illumise",
    "types": [
      "Bug",
      "Fairy"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 70,
      "atk": 47,
      "def": 90,
      "spe": 85,
      "spa": 105,
      "spd": 118
    },
    "abilities": {
      "0": "Prankster",
      "1": "Technician",
      "H": "Tinted Lens"
    },
    "weightkg": 17.7,
    "eggGroups": [
      "Bug",
      "Human-Like"
    ]
  },
  "roselia": {
    "num": 315,
    "name": "Roselia",
    "types": [
      "Grass",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 60,
      "def": 50,
      "spe": 85,
      "spa": 100,
      "spd": 95
    },
    "abilities": {
      "0": "Solar Power",
      "1": "Serene Grace"
    },
    "weightkg": 2.0,
    "prevo": "Budew",
    "evoLevel": 17,
    "evos": [
      "Roserade"
    ],
    "eggGroups": [
      "Fairy",
      "Grass"
    ]
  },
  "gulpin": {
    "num": 316,
    "name": "Gulpin",
    "types": [
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 74,
      "atk": 42,
      "def": 68,
      "spe": 20,
      "spa": 68,
      "spd": 98
    },
    "abilities": {
      "0": "Gastro Acid",
      "1": "Metabolism",
      "H": "Corrosion"
    },
    "weightkg": 10.3,
    "evos": [
      "Swalot"
    ],
    "eggGroups": [
      "Amorphous"
    ]
  },
  "swalot": {
    "num": 317,
    "name": "Swalot",
    "types": [
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 148,
      "atk": 48,
      "def": 88,
      "spe": 25,
      "spa": 108,
      "spd": 118
    },
    "abilities": {
      "0": "Gastro Acid",
      "1": "Metabolism",
      "H": "Corrosion"
    },
    "weightkg": 80.0,
    "prevo": "Gulpin",
    "evoLevel": 31,
    "eggGroups": [
      "Amorphous"
    ]
  },
  "carvanha": {
    "num": 318,
    "name": "Carvanha",
    "types": [
      "Water",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 95,
      "def": 35,
      "spe": 90,
      "spa": 70,
      "spd": 35
    },
    "abilities": {
      "0": "Strong Jaw",
      "1": "Speed Boost"
    },
    "weightkg": 20.8,
    "evos": [
      "Sharpedo"
    ],
    "eggGroups": [
      "Water 2"
    ]
  },
  "sharpedo": {
    "num": 319,
    "name": "Sharpedo",
    "types": [
      "Water",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 130,
      "def": 50,
      "spe": 120,
      "spa": 105,
      "spd": 50
    },
    "abilities": {
      "0": "Strong Jaw",
      "1": "Speed Boost"
    },
    "weightkg": 88.8,
    "prevo": "Carvanha",
    "evoLevel": 29,
    "eggGroups": [
      "Water 2"
    ],
    "formes": [
      "Sharpedo",
      "Sharpedo-Mega"
    ]
  },
  "sharpedomega": {
    "num": 319,
    "name": "Sharpedo-Mega",
    "types": [
      "Water",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 160,
      "def": 60,
      "spe": 130,
      "spa": 145,
      "spd": 60
    },
    "abilities": {
      "0": "Sheer Force",
      "1": "Instinct"
    },
    "weightkg": 130.3,
    "eggGroups": [
      "Water 2"
    ],
    "baseSpecies": "Sharpedo",
    "forme": "Mega",
    "formes": [
      "Sharpedo",
      "Sharpedo-Mega"
    ],
    "requiredItems": [
      "Mega Stone I",
      "Sharpedonite"
    ]
  },
  "wailmer": {
    "num": 320,
    "name": "Wailmer",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 100,
      "atk": 75,
      "def": 75,
      "spe": 55,
      "spa": 100,
      "spd": 75
    },
    "abilities": {
      "0": "Simple",
      "1": "Drizzle"
    },
    "weightkg": 130.0,
    "evos": [
      "Wailord"
    ],
    "eggGroups": [
      "Field",
      "Water 2"
    ]
  },
  "wailord": {
    "num": 321,
    "name": "Wailord",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 200,
      "atk": 75,
      "def": 75,
      "spe": 45,
      "spa": 130,
      "spd": 75
    },
    "abilities": {
      "0": "Huge Power",
      "1": "Drizzle"
    },
    "weightkg": 999.0,
    "prevo": "Wailmer",
    "evoLevel": 40,
    "evoType": "levelHold",
    "evoItem": "Water Gem",
    "eggGroups": [
      "Field",
      "Water 2"
    ]
  },
  "numel": {
    "num": 322,
    "name": "Numel",
    "types": [
      "Fire",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 70,
      "def": 95,
      "spe": 20,
      "spa": 80,
      "spd": 70
    },
    "abilities": {
      "0": "Simple",
      "1": "Unaware"
    },
    "weightkg": 24.0,
    "evos": [
      "Camerupt"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "camerupt": {
    "num": 323,
    "name": "Camerupt",
    "types": [
      "Fire",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 100,
      "atk": 120,
      "def": 110,
      "spe": 45,
      "spa": 125,
      "spd": 75
    },
    "abilities": {
      "0": "Drought",
      "1": "Berserk"
    },
    "weightkg": 220.0,
    "prevo": "Numel",
    "evoLevel": 35,
    "eggGroups": [
      "Field"
    ],
    "formes": [
      "Camerupt",
      "Camerupt-Mega"
    ]
  },
  "cameruptmega": {
    "num": 323,
    "name": "Camerupt-Mega",
    "types": [
      "Fire",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 100,
      "atk": 145,
      "def": 115,
      "spe": 45,
      "spa": 165,
      "spd": 105
    },
    "abilities": {
      "0": "Solar Rush",
      "1": "Sweltering Sun"
    },
    "weightkg": 320.5,
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Camerupt",
    "forme": "Mega",
    "formes": [
      "Camerupt",
      "Camerupt-Mega"
    ],
    "requiredItems": [
      "Mega Stone I",
      "Cameruptite"
    ]
  },
  "torkoal": {
    "num": 324,
    "name": "Torkoal",
    "types": [
      "Fire",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 60,
      "def": 145,
      "spe": 20,
      "spa": 100,
      "spd": 125
    },
    "abilities": {
      "0": "Drought",
      "1": "Shell Armor"
    },
    "weightkg": 80.4,
    "eggGroups": [
      "Field"
    ]
  },
  "spoink": {
    "num": 325,
    "name": "Spoink",
    "types": [
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 45,
      "def": 60,
      "spe": 60,
      "spa": 90,
      "spd": 95
    },
    "abilities": {
      "0": "Magic Bounce",
      "1": "Unburden"
    },
    "weightkg": 30.6,
    "evos": [
      "Grumpig"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "grumpig": {
    "num": 326,
    "name": "Grumpig",
    "types": [
      "Dark",
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 95,
      "atk": 55,
      "def": 70,
      "spe": 80,
      "spa": 125,
      "spd": 110
    },
    "abilities": {
      "0": "Psychic Surge",
      "1": "Pure Power"
    },
    "weightkg": 71.5,
    "prevo": "Spoink",
    "evoLevel": 32,
    "eggGroups": [
      "Field"
    ]
  },
  "spinda": {
    "num": 327,
    "name": "Spinda",
    "types": [
      "Psychic",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 80,
      "def": 80,
      "spe": 95,
      "spa": 95,
      "spd": 105
    },
    "abilities": {
      "0": "Contrary",
      "1": "Psychic Surge"
    },
    "weightkg": 5.0,
    "eggGroups": [
      "Field",
      "Human-Like"
    ]
  },
  "trapinch": {
    "num": 328,
    "name": "Trapinch",
    "types": [
      "Bug",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 47,
      "atk": 113,
      "def": 95,
      "spe": 10,
      "spa": 45,
      "spd": 50
    },
    "abilities": {
      "0": "Strong Jaw",
      "1": "Sand Force",
      "H": "Arena Trap"
    },
    "weightkg": 15.0,
    "evos": [
      "Vibrava"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "vibrava": {
    "num": 329,
    "name": "Vibrava",
    "types": [
      "Bug",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 62,
      "atk": 73,
      "def": 55,
      "spe": 122,
      "spa": 113,
      "spd": 55
    },
    "abilities": {
      "0": "Amplifier",
      "1": "Levitate"
    },
    "weightkg": 15.3,
    "prevo": "Trapinch",
    "evoLevel": 25,
    "evos": [
      "Flygon"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "flygon": {
    "num": 330,
    "name": "Flygon",
    "types": [
      "Bug",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 92,
      "atk": 118,
      "def": 80,
      "spe": 112,
      "spa": 118,
      "spd": 80
    },
    "abilities": {
      "0": "Amplifier",
      "1": "Levitate"
    },
    "weightkg": 15.3,
    "prevo": "Vibrava",
    "evoLevel": 45,
    "evoType": "levelHold",
    "evoItem": "Dragon Gem",
    "eggGroups": [
      "Bug"
    ]
  },
  "cacnea": {
    "num": 331,
    "name": "Cacnea",
    "types": [
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 47,
      "atk": 87,
      "def": 77,
      "spe": 47,
      "spa": 45,
      "spd": 47
    },
    "abilities": {
      "0": "Sand Rush",
      "1": "Moxie",
      "H": "Stakeout"
    },
    "weightkg": 51.3,
    "evos": [
      "Cacturne"
    ],
    "eggGroups": [
      "Grass",
      "Human-Like"
    ]
  },
  "cacturne": {
    "num": 332,
    "name": "Cacturne",
    "types": [
      "Grass",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 77,
      "atk": 127,
      "def": 107,
      "spe": 77,
      "spa": 60,
      "spd": 77
    },
    "abilities": {
      "0": "Sand Rush",
      "1": "Moxie",
      "H": "Stakeout"
    },
    "weightkg": 77.4,
    "prevo": "Cacnea",
    "evoLevel": 26,
    "eggGroups": [
      "Grass",
      "Human-Like"
    ]
  },
  "swablu": {
    "num": 333,
    "name": "Swablu",
    "types": [
      "Normal",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 40,
      "def": 60,
      "spe": 65,
      "spa": 65,
      "spd": 95
    },
    "abilities": {
      "0": "Amplifier",
      "1": "Fluffy"
    },
    "weightkg": 1.2,
    "evos": [
      "Altaria"
    ],
    "eggGroups": [
      "Flying",
      "Dragon"
    ]
  },
  "altaria": {
    "num": 334,
    "name": "Altaria",
    "types": [
      "Dragon",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 70,
      "def": 90,
      "spe": 90,
      "spa": 95,
      "spd": 115
    },
    "abilities": {
      "0": "Serene Grace",
      "1": "Fluffy"
    },
    "weightkg": 20.6,
    "prevo": "Swablu",
    "evoLevel": 31,
    "eggGroups": [
      "Flying",
      "Dragon"
    ],
    "formes": [
      "Altaria",
      "Altaria-Mega"
    ]
  },
  "altariamega": {
    "num": 334,
    "name": "Altaria-Mega",
    "types": [
      "Dragon",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 110,
      "def": 95,
      "spe": 90,
      "spa": 120,
      "spd": 145
    },
    "abilities": {
      "0": "Pixilate",
      "1": "Fluffy"
    },
    "weightkg": 20.6,
    "eggGroups": [
      "Flying",
      "Dragon"
    ],
    "baseSpecies": "Altaria",
    "forme": "Mega",
    "formes": [
      "Altaria",
      "Altaria-Mega"
    ],
    "requiredItems": [
      "Mega Stone I"
    ]
  },
  "zangoose": {
    "num": 335,
    "name": "Zangoose",
    "types": [
      "Normal",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 73,
      "atk": 123,
      "def": 73,
      "spe": 113,
      "spa": 60,
      "spd": 73
    },
    "abilities": {
      "0": "Ruthless",
      "1": "Tough Claws",
      "H": "Toxic Boost"
    },
    "weightkg": 40.3,
    "eggGroups": [
      "Field"
    ]
  },
  "seviper": {
    "num": 336,
    "name": "Seviper",
    "types": [
      "Poison",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 73,
      "atk": 123,
      "def": 73,
      "spe": 113,
      "spa": 60,
      "spd": 73
    },
    "abilities": {
      "0": "Ruthless",
      "1": "Strong Jaw",
      "H": "Stakeout"
    },
    "weightkg": 52.5,
    "eggGroups": [
      "Field",
      "Dragon"
    ]
  },
  "lunatone": {
    "num": 337,
    "name": "Lunatone",
    "types": [
      "Rock",
      "Dark"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 90,
      "atk": 40,
      "def": 110,
      "spe": 60,
      "spa": 125,
      "spd": 125
    },
    "abilities": {
      "0": "Energy Shield",
      "1": "Levitate",
      "H": "Interstellar"
    },
    "weightkg": 168.0,
    "eggGroups": [
      "Mineral"
    ]
  },
  "solrock": {
    "num": 338,
    "name": "Solrock",
    "types": [
      "Rock",
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 90,
      "atk": 40,
      "def": 125,
      "spe": 60,
      "spa": 125,
      "spd": 110
    },
    "abilities": {
      "0": "Levitate",
      "1": "Sweltering Sun",
      "H": "Interstellar"
    },
    "weightkg": 154.0,
    "eggGroups": [
      "Mineral"
    ]
  },
  "barboach": {
    "num": 339,
    "name": "Barboach",
    "types": [
      "Water",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 55,
      "atk": 61,
      "def": 81,
      "spe": 61,
      "spa": 61,
      "spd": 81
    },
    "abilities": {
      "0": "Dry Skin",
      "1": "Gooey"
    },
    "weightkg": 1.9,
    "evos": [
      "Whiscash"
    ],
    "eggGroups": [
      "Water 2"
    ]
  },
  "whiscash": {
    "num": 340,
    "name": "Whiscash",
    "types": [
      "Water",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 120,
      "atk": 101,
      "def": 93,
      "spe": 39,
      "spa": 91,
      "spd": 91
    },
    "abilities": {
      "0": "Metabolism",
      "1": "Berserk"
    },
    "weightkg": 23.6,
    "prevo": "Barboach",
    "evoLevel": 29,
    "eggGroups": [
      "Water 2"
    ]
  },
  "corphish": {
    "num": 341,
    "name": "Corphish",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 53,
      "atk": 85,
      "def": 85,
      "spe": 32,
      "spa": 50,
      "spd": 65
    },
    "abilities": {
      "0": "Tough Claws",
      "1": "Hustle"
    },
    "weightkg": 11.5,
    "evos": [
      "Crawdaunt"
    ],
    "eggGroups": [
      "Water 1",
      "Water 3"
    ]
  },
  "crawdaunt": {
    "num": 342,
    "name": "Crawdaunt",
    "types": [
      "Water",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 73,
      "atk": 125,
      "def": 115,
      "spe": 57,
      "spa": 60,
      "spd": 95
    },
    "abilities": {
      "0": "Tough Claws",
      "1": "Ruthless"
    },
    "weightkg": 32.8,
    "prevo": "Corphish",
    "evoLevel": 29,
    "eggGroups": [
      "Water 1",
      "Water 3"
    ]
  },
  "baltoy": {
    "num": 343,
    "name": "Baltoy",
    "types": [
      "Ground",
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 50,
      "atk": 40,
      "def": 95,
      "spe": 65,
      "spa": 95,
      "spd": 95
    },
    "abilities": {
      "0": "Levitate",
      "1": "Energy Shield"
    },
    "weightkg": 21.5,
    "evos": [
      "Claydol"
    ],
    "eggGroups": [
      "Mineral"
    ]
  },
  "claydol": {
    "num": 344,
    "name": "Claydol",
    "types": [
      "Ground",
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 80,
      "atk": 50,
      "def": 105,
      "spe": 75,
      "spa": 120,
      "spd": 120
    },
    "abilities": {
      "0": "Levitate",
      "1": "Energy Shield",
      "H": "Psychic Surge"
    },
    "weightkg": 108.0,
    "prevo": "Baltoy",
    "evoLevel": 33,
    "eggGroups": [
      "Mineral"
    ]
  },
  "lileep": {
    "num": 345,
    "name": "Lileep",
    "types": [
      "Rock",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 66,
      "atk": 41,
      "def": 97,
      "spe": 23,
      "spa": 76,
      "spd": 97
    },
    "abilities": {
      "0": "Sand Stream",
      "1": "Storm Drain",
      "H": "Corrosion"
    },
    "weightkg": 23.8,
    "evos": [
      "Cradily"
    ],
    "eggGroups": [
      "Water 3"
    ]
  },
  "cradily": {
    "num": 346,
    "name": "Cradily",
    "types": [
      "Rock",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 96,
      "atk": 81,
      "def": 122,
      "spe": 23,
      "spa": 106,
      "spd": 122
    },
    "abilities": {
      "0": "Sand Stream",
      "1": "Storm Drain",
      "H": "Corrosion"
    },
    "weightkg": 60.4,
    "prevo": "Lileep",
    "evoLevel": 33,
    "eggGroups": [
      "Water 3"
    ]
  },
  "anorith": {
    "num": 347,
    "name": "Anorith",
    "types": [
      "Rock",
      "Bug"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 46,
      "atk": 98,
      "def": 90,
      "spe": 76,
      "spa": 30,
      "spd": 60
    },
    "abilities": {
      "0": "Tinted Lens",
      "1": "Swift Swim"
    },
    "weightkg": 12.5,
    "evos": [
      "Armaldo"
    ],
    "eggGroups": [
      "Water 3"
    ]
  },
  "armaldo": {
    "num": 348,
    "name": "Armaldo",
    "types": [
      "Rock",
      "Bug"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 96,
      "atk": 133,
      "def": 125,
      "spe": 66,
      "spa": 40,
      "spd": 90
    },
    "abilities": {
      "0": "Ruthless",
      "1": "Swift Swim"
    },
    "weightkg": 68.2,
    "prevo": "Anorith",
    "evoLevel": 33,
    "eggGroups": [
      "Water 3"
    ]
  },
  "feebas": {
    "num": 349,
    "name": "Feebas",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 15,
      "def": 49,
      "spe": 61,
      "spa": 45,
      "spd": 85
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Multiscale"
    },
    "weightkg": 7.4,
    "evos": [
      "Milotic"
    ],
    "eggGroups": [
      "Water 1",
      "Dragon"
    ]
  },
  "milotic": {
    "num": 350,
    "name": "Milotic",
    "types": [
      "Water",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 114,
      "atk": 80,
      "def": 94,
      "spe": 81,
      "spa": 106,
      "spd": 125
    },
    "abilities": {
      "0": "Serene Grace",
      "1": "Multiscale",
      "H": "Marvel Scale"
    },
    "weightkg": 162.0,
    "prevo": "Feebas",
    "evoLevel": 40,
    "eggGroups": [
      "Water 1",
      "Dragon"
    ]
  },
  "castform": {
    "num": 351,
    "name": "Castform",
    "types": [
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 55,
      "def": 70,
      "spe": 110,
      "spa": 110,
      "spd": 110
    },
    "abilities": {
      "0": "Guarding Gale",
      "1": "Forecast"
    },
    "weightkg": 0.8,
    "eggGroups": [
      "Fairy",
      "Amorphous"
    ],
    "formes": [
      "Castform",
      "Castform-Sunny",
      "Castform-Rainy",
      "Castform-Snowy"
    ]
  },
  "castformsunny": {
    "num": 351,
    "name": "Castform-Sunny",
    "types": [
      "Fire",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 55,
      "def": 70,
      "spe": 150,
      "spa": 115,
      "spd": 115
    },
    "abilities": {
      "0": "Forecast"
    },
    "weightkg": 0.8,
    "eggGroups": [
      "Fairy",
      "Amorphous"
    ],
    "baseSpecies": "Castform",
    "forme": "Sunny",
    "formes": [
      "Castform",
      "Castform-Sunny",
      "Castform-Rainy",
      "Castform-Snowy"
    ]
  },
  "castformrainy": {
    "num": 351,
    "name": "Castform-Rainy",
    "types": [
      "Water",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 55,
      "def": 70,
      "spe": 150,
      "spa": 115,
      "spd": 115
    },
    "abilities": {
      "0": "Forecast"
    },
    "weightkg": 0.8,
    "eggGroups": [
      "Fairy",
      "Amorphous"
    ],
    "baseSpecies": "Castform",
    "forme": "Rainy",
    "formes": [
      "Castform",
      "Castform-Sunny",
      "Castform-Rainy",
      "Castform-Snowy"
    ]
  },
  "castformsnowy": {
    "num": 351,
    "name": "Castform-Snowy",
    "types": [
      "Ice",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 55,
      "def": 70,
      "spe": 150,
      "spa": 115,
      "spd": 115
    },
    "abilities": {
      "0": "Forecast"
    },
    "weightkg": 0.8,
    "eggGroups": [
      "Fairy",
      "Amorphous"
    ],
    "baseSpecies": "Castform",
    "forme": "Snowy",
    "formes": [
      "Castform",
      "Castform-Sunny",
      "Castform-Rainy",
      "Castform-Snowy"
    ]
  },
  "kecleon": {
    "num": 352,
    "name": "Kecleon",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 94,
      "def": 81,
      "spe": 71,
      "spa": 94,
      "spd": 125
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Versatility"
    },
    "weightkg": 22.0,
    "eggGroups": [
      "Field"
    ]
  },
  "shuppet": {
    "num": 353,
    "name": "Shuppet",
    "types": [
      "Ghost",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 75,
      "def": 40,
      "spe": 95,
      "spa": 75,
      "spd": 40
    },
    "abilities": {
      "0": "Prankster",
      "1": "Levitate",
      "H": "Envy"
    },
    "weightkg": 2.3,
    "evos": [
      "Banette"
    ],
    "eggGroups": [
      "Amorphous"
    ]
  },
  "banette": {
    "num": 354,
    "name": "Banette",
    "types": [
      "Ghost",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 115,
      "def": 65,
      "spe": 100,
      "spa": 115,
      "spd": 65
    },
    "abilities": {
      "0": "Prankster",
      "1": "Sinister"
    },
    "weightkg": 12.5,
    "prevo": "Shuppet",
    "evoLevel": 25,
    "eggGroups": [
      "Amorphous"
    ],
    "formes": [
      "Banette",
      "Banette-Mega"
    ]
  },
  "banettemega": {
    "num": 354,
    "name": "Banette-Mega",
    "types": [
      "Ghost",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 165,
      "def": 65,
      "spe": 100,
      "spa": 165,
      "spd": 65
    },
    "abilities": {
      "0": "Tough Claws",
      "1": "Hubris",
      "H": "Shadow Tag"
    },
    "weightkg": 13.0,
    "eggGroups": [
      "Amorphous"
    ],
    "baseSpecies": "Banette",
    "forme": "Mega",
    "formes": [
      "Banette",
      "Banette-Mega"
    ],
    "requiredItems": [
      "Mega Stone I",
      "Banettite"
    ]
  },
  "duskull": {
    "num": 355,
    "name": "Duskull",
    "types": [
      "Ghost"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 60,
      "def": 80,
      "spe": 20,
      "spa": 60,
      "spd": 100
    },
    "abilities": {
      "0": "Levitate",
      "1": "Flash Fire"
    },
    "weightkg": 15.0,
    "evos": [
      "Dusclops"
    ],
    "eggGroups": [
      "Amorphous"
    ]
  },
  "dusclops": {
    "num": 356,
    "name": "Dusclops",
    "types": [
      "Ghost"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 80,
      "def": 100,
      "spe": 20,
      "spa": 80,
      "spd": 120
    },
    "abilities": {
      "0": "Sinister",
      "1": "Flash Fire"
    },
    "weightkg": 30.6,
    "prevo": "Duskull",
    "evoLevel": 25,
    "evos": [
      "Dusknoir"
    ],
    "eggGroups": [
      "Amorphous"
    ]
  },
  "tropius": {
    "num": 357,
    "name": "Tropius",
    "types": [
      "Grass",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 129,
      "atk": 103,
      "def": 103,
      "spe": 36,
      "spa": 102,
      "spd": 102
    },
    "abilities": {
      "0": "Grassy Surge",
      "1": "Regenerator",
      "H": "Harvest"
    },
    "weightkg": 100.0,
    "eggGroups": [
      "Monster",
      "Grass"
    ]
  },
  "chimecho": {
    "num": 358,
    "name": "Chimecho",
    "types": [
      "Psychic",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 50,
      "def": 80,
      "spe": 95,
      "spa": 115,
      "spd": 110
    },
    "abilities": {
      "0": "Guarding Gale",
      "1": "Aerilate"
    },
    "weightkg": 1.0,
    "prevo": "Chingling",
    "evoLevel": 22,
    "eggGroups": [
      "Amorphous"
    ]
  },
  "absol": {
    "num": 359,
    "name": "Absol",
    "types": [
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 130,
      "def": 65,
      "spe": 115,
      "spa": 75,
      "spd": 65
    },
    "abilities": {
      "0": "Proficiency",
      "1": "Super Luck"
    },
    "weightkg": 47.0,
    "eggGroups": [
      "Field"
    ],
    "formes": [
      "Absol",
      "Absol-Mega"
    ]
  },
  "absolmega": {
    "num": 359,
    "name": "Absol-Mega",
    "types": [
      "Dark",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 150,
      "def": 70,
      "spe": 130,
      "spa": 130,
      "spd": 70
    },
    "abilities": {
      "0": "Pixilate",
      "1": "Dazzling"
    },
    "weightkg": 49.0,
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Absol",
    "forme": "Mega",
    "formes": [
      "Absol",
      "Absol-Mega"
    ],
    "requiredItems": [
      "Mega Stone I",
      "Absolite"
    ]
  },
  "wynaut": {
    "num": 360,
    "name": "Wynaut",
    "types": [
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 95,
      "atk": 23,
      "def": 93,
      "spe": 23,
      "spa": 23,
      "spd": 93
    },
    "abilities": {
      "0": "Emergency Exit",
      "1": "Unaware",
      "H": "Shadow Tag"
    },
    "weightkg": 14.0,
    "evos": [
      "Wobbuffet"
    ],
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "snorunt": {
    "num": 361,
    "name": "Snorunt",
    "types": [
      "Ice"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 50,
      "def": 80,
      "spe": 50,
      "spa": 60,
      "spd": 80
    },
    "abilities": {
      "0": "Prankster",
      "1": "Wimp Out"
    },
    "weightkg": 16.8,
    "evos": [
      "Glalie",
      "Froslass"
    ],
    "eggGroups": [
      "Fairy",
      "Mineral"
    ]
  },
  "glalie": {
    "num": 362,
    "name": "Glalie",
    "types": [
      "Ice"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 90,
      "def": 105,
      "spe": 55,
      "spa": 100,
      "spd": 105
    },
    "abilities": {
      "0": "Weak Armor",
      "1": "Intimidate"
    },
    "weightkg": 256.5,
    "prevo": "Snorunt",
    "evoLevel": 25,
    "evoType": "levelHold",
    "evoItem": "Ice Gem",
    "eggGroups": [
      "Fairy",
      "Mineral"
    ],
    "formes": [
      "Glalie",
      "Glalie-Mega"
    ]
  },
  "glaliemega": {
    "num": 362,
    "name": "Glalie-Mega",
    "types": [
      "Ice",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 140,
      "def": 80,
      "spe": 105,
      "spa": 150,
      "spd": 80
    },
    "abilities": {
      "0": "Sheer Force",
      "1": "Berserk"
    },
    "weightkg": 350.2,
    "eggGroups": [
      "Fairy",
      "Mineral"
    ],
    "baseSpecies": "Glalie",
    "forme": "Mega",
    "formes": [
      "Glalie",
      "Glalie-Mega"
    ],
    "requiredItems": [
      "Mega Stone I"
    ]
  },
  "spheal": {
    "num": 363,
    "name": "Spheal",
    "types": [
      "Ice",
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 60,
      "def": 65,
      "spe": 25,
      "spa": 60,
      "spd": 65
    },
    "abilities": {
      "0": "Unaware",
      "1": "Resilient"
    },
    "weightkg": 39.5,
    "evos": [
      "Sealeo"
    ],
    "eggGroups": [
      "Water 1",
      "Field"
    ]
  },
  "sealeo": {
    "num": 364,
    "name": "Sealeo",
    "types": [
      "Ice",
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 95,
      "atk": 80,
      "def": 85,
      "spe": 30,
      "spa": 80,
      "spd": 85
    },
    "abilities": {
      "0": "Unaware",
      "1": "Resilient"
    },
    "weightkg": 87.6,
    "prevo": "Spheal",
    "evoLevel": 20,
    "evos": [
      "Walrein"
    ],
    "eggGroups": [
      "Water 1",
      "Field"
    ]
  },
  "walrein": {
    "num": 365,
    "name": "Walrein",
    "types": [
      "Ice",
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 130,
      "atk": 130,
      "def": 95,
      "spe": 30,
      "spa": 95,
      "spd": 95
    },
    "abilities": {
      "0": "Sheer Force",
      "1": "Resilient"
    },
    "weightkg": 150.6,
    "prevo": "Sealeo",
    "evoLevel": 40,
    "evoType": "levelHold",
    "evoItem": "Ice Gem",
    "eggGroups": [
      "Water 1",
      "Field"
    ]
  },
  "clamperl": {
    "num": 366,
    "name": "Clamperl",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 47,
      "atk": 43,
      "def": 107,
      "spe": 32,
      "spa": 74,
      "spd": 107
    },
    "abilities": {
      "0": "Shell Armor",
      "1": "Sturdy"
    },
    "weightkg": 52.5,
    "evos": [
      "Huntail",
      "Gorebyss"
    ],
    "eggGroups": [
      "Water 1"
    ]
  },
  "huntail": {
    "num": 367,
    "name": "Huntail",
    "types": [
      "Water",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 87,
      "atk": 114,
      "def": 107,
      "spe": 67,
      "spa": 53,
      "spd": 107
    },
    "abilities": {
      "0": "Multiscale",
      "1": "Sinister",
      "H": "Dazzling"
    },
    "weightkg": 27.0,
    "prevo": "Clamperl",
    "evoLevel": 32,
    "evoType": "levelHold",
    "evoItem": "Dark Gem",
    "eggGroups": [
      "Water 1"
    ]
  },
  "gorebyss": {
    "num": 368,
    "name": "Gorebyss",
    "types": [
      "Water",
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 87,
      "atk": 53,
      "def": 107,
      "spe": 67,
      "spa": 114,
      "spd": 107
    },
    "abilities": {
      "0": "Multiscale",
      "1": "Sap Sipper",
      "H": "Dazzling"
    },
    "weightkg": 22.6,
    "prevo": "Clamperl",
    "evoLevel": 32,
    "evoType": "levelHold",
    "evoItem": "Psychic Gem",
    "eggGroups": [
      "Water 1"
    ]
  },
  "relicanth": {
    "num": 369,
    "name": "Relicanth",
    "types": [
      "Water",
      "Rock"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 100,
      "atk": 90,
      "def": 145,
      "spe": 30,
      "spa": 45,
      "spd": 115
    },
    "abilities": {
      "0": "Multiscale",
      "1": "Stamina"
    },
    "weightkg": 23.4,
    "eggGroups": [
      "Water 1",
      "Water 2"
    ]
  },
  "luvdisc": {
    "num": 370,
    "name": "Luvdisc",
    "types": [
      "Water",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 55,
      "atk": 23,
      "def": 65,
      "spe": 102,
      "spa": 75,
      "spd": 115
    },
    "abilities": {
      "0": "Regenerator",
      "1": "Trace"
    },
    "weightkg": 8.7,
    "evos": [
      "Alomomola"
    ],
    "eggGroups": [
      "Water 2",
      "Water 3"
    ]
  },
  "bagon": {
    "num": 371,
    "name": "Bagon",
    "types": [
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 75,
      "def": 75,
      "spe": 60,
      "spa": 40,
      "spd": 60
    },
    "abilities": {
      "0": "Hustle",
      "1": "Rough Skin"
    },
    "weightkg": 42.1,
    "evos": [
      "Shelgon"
    ],
    "eggGroups": [
      "Dragon"
    ]
  },
  "shelgon": {
    "num": 372,
    "name": "Shelgon",
    "types": [
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 95,
      "def": 135,
      "spe": 35,
      "spa": 35,
      "spd": 110
    },
    "abilities": {
      "0": "Shell Armor",
      "1": "Rough Skin"
    },
    "weightkg": 110.5,
    "prevo": "Bagon",
    "evoLevel": 25,
    "evos": [
      "Salamence"
    ],
    "eggGroups": [
      "Dragon"
    ]
  },
  "salamence": {
    "num": 373,
    "name": "Salamence",
    "types": [
      "Dragon",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 95,
      "atk": 135,
      "def": 80,
      "spe": 100,
      "spa": 110,
      "spd": 80
    },
    "abilities": {
      "0": "Berserk",
      "1": "Intimidate"
    },
    "weightkg": 102.6,
    "prevo": "Shelgon",
    "evoLevel": 45,
    "evoType": "levelHold",
    "evoItem": "Flying Gem",
    "eggGroups": [
      "Dragon"
    ],
    "formes": [
      "Salamence",
      "Salamence-Mega"
    ]
  },
  "salamencemega": {
    "num": 373,
    "name": "Salamence-Mega",
    "types": [
      "Dragon",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 95,
      "atk": 145,
      "def": 110,
      "spe": 120,
      "spa": 140,
      "spd": 90
    },
    "abilities": {
      "0": "Proficiency",
      "1": "Levitate"
    },
    "weightkg": 112.6,
    "eggGroups": [
      "Dragon"
    ],
    "baseSpecies": "Salamence",
    "forme": "Mega",
    "formes": [
      "Salamence",
      "Salamence-Mega"
    ],
    "requiredItems": [
      "Mega Stone II"
    ]
  },
  "beldum": {
    "num": 374,
    "name": "Beldum",
    "types": [
      "Steel",
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 40,
      "atk": 60,
      "def": 110,
      "spe": 20,
      "spa": 60,
      "spd": 70
    },
    "abilities": {
      "0": "Analytic",
      "1": "Levitate",
      "H": "Magnet Pull"
    },
    "weightkg": 95.2,
    "evos": [
      "Metang"
    ],
    "eggGroups": [
      "Mineral"
    ]
  },
  "metang": {
    "num": 375,
    "name": "Metang",
    "types": [
      "Steel",
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 70,
      "atk": 90,
      "def": 125,
      "spe": 20,
      "spa": 90,
      "spd": 85
    },
    "abilities": {
      "0": "Analytic",
      "1": "Levitate",
      "H": "Magnet Pull"
    },
    "weightkg": 202.5,
    "prevo": "Beldum",
    "evoLevel": 25,
    "evos": [
      "Metagross"
    ],
    "eggGroups": [
      "Mineral"
    ]
  },
  "metagross": {
    "num": 376,
    "name": "Metagross",
    "types": [
      "Steel",
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 100,
      "atk": 135,
      "def": 130,
      "spe": 20,
      "spa": 125,
      "spd": 90
    },
    "abilities": {
      "0": "Analytic",
      "1": "Hubris",
      "H": "Magnet Pull"
    },
    "weightkg": 550.0,
    "prevo": "Metang",
    "evoLevel": 45,
    "evoType": "levelHold",
    "evoItem": "Steel Gem",
    "eggGroups": [
      "Mineral"
    ],
    "formes": [
      "Metagross",
      "Metagross-Mega"
    ]
  },
  "metagrossmega": {
    "num": 376,
    "name": "Metagross-Mega",
    "types": [
      "Steel",
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 100,
      "atk": 145,
      "def": 130,
      "spe": 110,
      "spa": 125,
      "spd": 90
    },
    "abilities": {
      "0": "Tough Claws",
      "1": "Levitate"
    },
    "weightkg": 942.9,
    "eggGroups": [
      "Mineral"
    ],
    "baseSpecies": "Metagross",
    "forme": "Mega",
    "formes": [
      "Metagross",
      "Metagross-Mega"
    ],
    "requiredItems": [
      "Mega Stone II",
      "Metagrossite"
    ]
  },
  "regirock": {
    "num": 377,
    "name": "Regirock",
    "types": [
      "Rock"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 85,
      "atk": 150,
      "def": 200,
      "spe": 15,
      "spa": 50,
      "spd": 100
    },
    "abilities": {
      "0": "Regenerator",
      "1": "Solid Rock"
    },
    "weightkg": 230.0,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "regice": {
    "num": 378,
    "name": "Regice",
    "types": [
      "Ice"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 85,
      "atk": 50,
      "def": 100,
      "spe": 15,
      "spa": 150,
      "spd": 200
    },
    "abilities": {
      "0": "Refrigerate",
      "1": "Resilient"
    },
    "weightkg": 175.0,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "registeel": {
    "num": 379,
    "name": "Registeel",
    "types": [
      "Steel"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 85,
      "atk": 100,
      "def": 150,
      "spe": 15,
      "spa": 100,
      "spd": 150
    },
    "abilities": {
      "0": "Steelworker",
      "1": "Filter"
    },
    "weightkg": 205.0,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "latias": {
    "num": 380,
    "name": "Latias",
    "types": [
      "Dragon",
      "Fairy"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 80,
      "atk": 70,
      "def": 80,
      "spe": 130,
      "spa": 110,
      "spd": 130
    },
    "abilities": {
      "0": "Magic Bounce",
      "1": "Levitate"
    },
    "weightkg": 40.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "formes": [
      "Latias",
      "Latias-Mega"
    ]
  },
  "latiasmega": {
    "num": 380,
    "name": "Latias-Mega",
    "types": [
      "Dragon",
      "Fairy"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 80,
      "atk": 80,
      "def": 110,
      "spe": 130,
      "spa": 140,
      "spd": 160
    },
    "abilities": {
      "0": "Speed Boost",
      "1": "Levitate"
    },
    "weightkg": 52.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Latias",
    "forme": "Mega",
    "formes": [
      "Latias",
      "Latias-Mega"
    ],
    "requiredItems": [
      "Latiasite"
    ]
  },
  "latios": {
    "num": 381,
    "name": "Latios",
    "types": [
      "Dragon",
      "Psychic"
    ],
    "gender": "M",
    "baseStats": {
      "hp": 80,
      "atk": 80,
      "def": 70,
      "spe": 130,
      "spa": 130,
      "spd": 110
    },
    "abilities": {
      "0": "Magic Guard",
      "1": "Levitate"
    },
    "weightkg": 60.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "formes": [
      "Latios",
      "Latios-Mega"
    ]
  },
  "latiosmega": {
    "num": 381,
    "name": "Latios-Mega",
    "types": [
      "Dragon",
      "Psychic"
    ],
    "gender": "M",
    "baseStats": {
      "hp": 80,
      "atk": 140,
      "def": 80,
      "spe": 130,
      "spa": 160,
      "spd": 110
    },
    "abilities": {
      "0": "Speed Boost",
      "1": "Levitate"
    },
    "weightkg": 70.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Latios",
    "forme": "Mega",
    "formes": [
      "Latios",
      "Latios-Mega"
    ],
    "requiredItems": [
      "Latiasite"
    ]
  },
  "kyogre": {
    "num": 382,
    "name": "Kyogre",
    "types": [
      "Water"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 160,
      "atk": 120,
      "def": 90,
      "spe": 80,
      "spa": 160,
      "spd": 140
    },
    "abilities": {
      "0": "Drizzle"
    },
    "weightkg": 352.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "formes": [
      "Kyogre",
      "Kyogre-Primal"
    ],
    "unusable": true
  },
  "kyogreprimal": {
    "num": 382,
    "name": "Kyogre-Primal",
    "types": [
      "Water"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 160,
      "atk": 150,
      "def": 100,
      "spe": 80,
      "spa": 200,
      "spd": 160
    },
    "abilities": {
      "0": "Stormy Seas"
    },
    "weightkg": 430.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Kyogre",
    "forme": "Primal",
    "formes": [
      "Kyogre",
      "Kyogre-Primal"
    ],
    "unusable": true
  },
  "groudon": {
    "num": 383,
    "name": "Groudon",
    "types": [
      "Ground"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 160,
      "atk": 160,
      "def": 160,
      "spe": 50,
      "spa": 130,
      "spd": 90
    },
    "abilities": {
      "0": "Drought"
    },
    "weightkg": 950.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "formes": [
      "Groudon",
      "Groudon-Primal"
    ],
    "unusable": true
  },
  "groudonprimal": {
    "num": 383,
    "name": "Groudon-Primal",
    "types": [
      "Ground",
      "Fire"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 160,
      "atk": 200,
      "def": 160,
      "spe": 50,
      "spa": 180,
      "spd": 100
    },
    "abilities": {
      "0": "Sweltering Sun"
    },
    "weightkg": 999.7,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Groudon",
    "forme": "Primal",
    "formes": [
      "Groudon",
      "Groudon-Primal"
    ],
    "unusable": true
  },
  "rayquaza": {
    "num": 384,
    "name": "Rayquaza",
    "types": [
      "Dragon",
      "Flying"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 150,
      "atk": 175,
      "def": 90,
      "spe": 120,
      "spa": 175,
      "spd": 90
    },
    "abilities": {
      "0": "Intimidate"
    },
    "weightkg": 206.5,
    "eggGroups": [
      "Undiscovered"
    ],
    "formes": [
      "Rayquaza",
      "Rayquaza-Mega"
    ],
    "unusable": true
  },
  "rayquazamega": {
    "num": 384,
    "name": "Rayquaza-Mega",
    "types": [
      "Dragon",
      "Flying"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 150,
      "atk": 200,
      "def": 100,
      "spe": 150,
      "spa": 200,
      "spd": 100
    },
    "abilities": {
      "0": "Guarding Gale"
    },
    "weightkg": 392.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Rayquaza",
    "forme": "Mega",
    "formes": [
      "Rayquaza",
      "Rayquaza-Mega"
    ],
    "unusable": true
  },
  "jirachi": {
    "num": 385,
    "name": "Jirachi",
    "types": [
      "Fairy",
      "Steel"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 60,
      "atk": 80,
      "def": 120,
      "spe": 100,
      "spa": 100,
      "spd": 140
    },
    "abilities": {
      "0": "Levitate",
      "1": "Serene Grace",
      "H": "Magic Guard"
    },
    "weightkg": 1.1,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "deoxys": {
    "num": 386,
    "name": "Deoxys",
    "types": [
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 80,
      "atk": 120,
      "def": 80,
      "spe": 120,
      "spa": 120,
      "spd": 80
    },
    "abilities": {
      "0": "Versatility",
      "1": "Neuroforce",
      "H": "Interstellar"
    },
    "weightkg": 60.8,
    "eggGroups": [
      "Undiscovered"
    ],
    "formes": [
      "Deoxys",
      "Deoxys-Attack",
      "Deoxys-Defense",
      "Deoxys-Speed"
    ]
  },
  "deoxysattack": {
    "num": 386,
    "name": "Deoxys-Attack",
    "types": [
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 80,
      "atk": 180,
      "def": 20,
      "spe": 120,
      "spa": 180,
      "spd": 20
    },
    "abilities": {
      "0": "Proficiency",
      "1": "Neuroforce",
      "H": "Interstellar"
    },
    "weightkg": 60.8,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Deoxys",
    "forme": "Attack",
    "formes": [
      "Deoxys",
      "Deoxys-Attack",
      "Deoxys-Defense",
      "Deoxys-Speed"
    ]
  },
  "deoxysdefense": {
    "num": 386,
    "name": "Deoxys-Defense",
    "types": [
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 80,
      "atk": 70,
      "def": 180,
      "spe": 20,
      "spa": 70,
      "spd": 180
    },
    "abilities": {
      "0": "Resilient",
      "1": "Regenerator",
      "H": "Interstellar"
    },
    "weightkg": 60.8,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Deoxys",
    "forme": "Defense",
    "formes": [
      "Deoxys",
      "Deoxys-Attack",
      "Deoxys-Defense",
      "Deoxys-Speed"
    ]
  },
  "deoxysspeed": {
    "num": 386,
    "name": "Deoxys-Speed",
    "types": [
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 80,
      "atk": 70,
      "def": 100,
      "spe": 180,
      "spa": 70,
      "spd": 100
    },
    "abilities": {
      "0": "Speed Boost",
      "1": "Regenerator",
      "H": "Interstellar"
    },
    "weightkg": 60.8,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Deoxys",
    "forme": "Speed",
    "formes": [
      "Deoxys",
      "Deoxys-Attack",
      "Deoxys-Defense",
      "Deoxys-Speed"
    ]
  },
  "turtwig": {
    "num": 387,
    "name": "Turtwig",
    "types": [
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 55,
      "atk": 64,
      "def": 75,
      "spe": 31,
      "spa": 30,
      "spd": 65
    },
    "abilities": {
      "0": "Overgrow",
      "1": "Harvest",
      "H": "Grassy Guard"
    },
    "weightkg": 10.2,
    "evos": [
      "Grotle"
    ],
    "eggGroups": [
      "Monster",
      "Grass"
    ]
  },
  "grotle": {
    "num": 388,
    "name": "Grotle",
    "types": [
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 94,
      "def": 115,
      "spe": 36,
      "spa": 35,
      "spd": 80
    },
    "abilities": {
      "0": "Overgrow",
      "1": "Harvest",
      "H": "Grassy Guard"
    },
    "weightkg": 10.2,
    "prevo": "Turtwig",
    "evoLevel": 17,
    "evos": [
      "Torterra"
    ],
    "eggGroups": [
      "Monster",
      "Grass"
    ]
  },
  "torterra": {
    "num": 389,
    "name": "Torterra",
    "types": [
      "Grass",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 120,
      "atk": 124,
      "def": 120,
      "spe": 56,
      "spa": 40,
      "spd": 90
    },
    "abilities": {
      "0": "Headstrong",
      "1": "Grassy Surge",
      "H": "Grassy Guard"
    },
    "weightkg": 310.0,
    "prevo": "Grotle",
    "evoLevel": 36,
    "eggGroups": [
      "Monster",
      "Grass"
    ]
  },
  "chimchar": {
    "num": 390,
    "name": "Chimchar",
    "types": [
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 44,
      "atk": 63,
      "def": 44,
      "spe": 62,
      "spa": 63,
      "spd": 44
    },
    "abilities": {
      "0": "Unburden",
      "1": "Blaze"
    },
    "weightkg": 6.2,
    "evos": [
      "Monferno"
    ],
    "eggGroups": [
      "Field",
      "Human-Like"
    ]
  },
  "monferno": {
    "num": 391,
    "name": "Monferno",
    "types": [
      "Fire",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 56,
      "atk": 92,
      "def": 52,
      "spe": 91,
      "spa": 92,
      "spd": 52
    },
    "abilities": {
      "0": "Unburden",
      "1": "Blaze"
    },
    "weightkg": 22.0,
    "prevo": "Chimchar",
    "evoLevel": 17,
    "evos": [
      "Infernape"
    ],
    "eggGroups": [
      "Field",
      "Human-Like"
    ]
  },
  "infernape": {
    "num": 392,
    "name": "Infernape",
    "types": [
      "Fire",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 71,
      "atk": 114,
      "def": 66,
      "spe": 119,
      "spa": 114,
      "spd": 66
    },
    "abilities": {
      "0": "Technician",
      "1": "Proficiency"
    },
    "weightkg": 55.0,
    "prevo": "Monferno",
    "evoLevel": 36,
    "eggGroups": [
      "Field",
      "Human-Like"
    ]
  },
  "piplup": {
    "num": 393,
    "name": "Piplup",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 54,
      "atk": 56,
      "def": 53,
      "spe": 40,
      "spa": 61,
      "spd": 56
    },
    "abilities": {
      "0": "Swift Swim",
      "1": "Torrent"
    },
    "weightkg": 5.2,
    "evos": [
      "Prinplup"
    ],
    "eggGroups": [
      "Water 1",
      "Field"
    ]
  },
  "prinplup": {
    "num": 394,
    "name": "Prinplup",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 69,
      "atk": 96,
      "def": 73,
      "spe": 50,
      "spa": 61,
      "spd": 86
    },
    "abilities": {
      "0": "Swift Swim",
      "1": "Torrent"
    },
    "weightkg": 23.0,
    "prevo": "Piplup",
    "evoLevel": 17,
    "evos": [
      "Empoleon"
    ],
    "eggGroups": [
      "Water 1",
      "Field"
    ]
  },
  "empoleon": {
    "num": 395,
    "name": "Empoleon",
    "types": [
      "Water",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 84,
      "atk": 122,
      "def": 122,
      "spe": 60,
      "spa": 61,
      "spd": 101
    },
    "abilities": {
      "0": "Swift Swim",
      "1": "Ruthless"
    },
    "weightkg": 84.5,
    "prevo": "Prinplup",
    "evoLevel": 36,
    "eggGroups": [
      "Water 1",
      "Field"
    ]
  },
  "starly": {
    "num": 396,
    "name": "Starly",
    "types": [
      "Normal",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 60,
      "def": 40,
      "spe": 80,
      "spa": 40,
      "spd": 40
    },
    "abilities": {
      "0": "Defiant",
      "1": "Emergency Exit",
      "H": "Stakeout"
    },
    "weightkg": 2.0,
    "evos": [
      "Staravia"
    ],
    "eggGroups": [
      "Flying"
    ]
  },
  "staravia": {
    "num": 397,
    "name": "Staravia",
    "types": [
      "Normal",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 55,
      "atk": 90,
      "def": 55,
      "spe": 100,
      "spa": 45,
      "spd": 55
    },
    "abilities": {
      "0": "Defiant",
      "1": "Intimidate",
      "H": "Stakeout"
    },
    "weightkg": 15.5,
    "prevo": "Starly",
    "evoLevel": 15,
    "evos": [
      "Staraptor"
    ],
    "eggGroups": [
      "Flying"
    ]
  },
  "staraptor": {
    "num": 398,
    "name": "Staraptor",
    "types": [
      "Normal",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 85,
      "atk": 120,
      "def": 80,
      "spe": 110,
      "spa": 50,
      "spd": 70
    },
    "abilities": {
      "0": "Reckless",
      "1": "Intimidate",
      "H": "Stakeout"
    },
    "weightkg": 24.9,
    "prevo": "Staravia",
    "evoLevel": 31,
    "eggGroups": [
      "Flying"
    ]
  },
  "bidoof": {
    "num": 399,
    "name": "Bidoof",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 59,
      "atk": 65,
      "def": 60,
      "spe": 51,
      "spa": 35,
      "spd": 60
    },
    "abilities": {
      "0": "Simple",
      "1": "Sap Sipper"
    },
    "weightkg": 20.0,
    "evos": [
      "Bibarel"
    ],
    "eggGroups": [
      "Water 1",
      "Field"
    ]
  },
  "bibarel": {
    "num": 400,
    "name": "Bibarel",
    "types": [
      "Normal",
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 94,
      "atk": 90,
      "def": 85,
      "spe": 71,
      "spa": 55,
      "spd": 85
    },
    "abilities": {
      "0": "Simple",
      "1": "Sap Sipper"
    },
    "weightkg": 31.5,
    "prevo": "Bidoof",
    "evoLevel": 20,
    "eggGroups": [
      "Water 1",
      "Field"
    ]
  },
  "kricketot": {
    "num": 401,
    "name": "Kricketot",
    "types": [
      "Bug",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 47,
      "atk": 41,
      "def": 55,
      "spe": 61,
      "spa": 71,
      "spd": 55
    },
    "abilities": {
      "0": "Wimp Out",
      "1": "Technician",
      "H": "Tinted Lens"
    },
    "weightkg": 2.2,
    "evos": [
      "Kricketune"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "kricketune": {
    "num": 402,
    "name": "Kricketune",
    "types": [
      "Bug",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 67,
      "atk": 101,
      "def": 55,
      "spe": 101,
      "spa": 101,
      "spd": 55
    },
    "abilities": {
      "0": "Amplifier",
      "1": "Technician",
      "H": "Tinted Lens"
    },
    "weightkg": 25.5,
    "prevo": "Kricketot",
    "evoLevel": 20,
    "eggGroups": [
      "Bug"
    ]
  },
  "shinx": {
    "num": 403,
    "name": "Shinx",
    "types": [
      "Electric"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 65,
      "def": 35,
      "spe": 80,
      "spa": 60,
      "spd": 35
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Volt Rush"
    },
    "weightkg": 9.5,
    "evos": [
      "Luxio"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "luxio": {
    "num": 404,
    "name": "Luxio",
    "types": [
      "Electric",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 95,
      "def": 45,
      "spe": 95,
      "spa": 90,
      "spd": 45
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Volt Rush"
    },
    "weightkg": 30.5,
    "prevo": "Shinx",
    "evoLevel": 17,
    "evos": [
      "Luxray"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "luxray": {
    "num": 405,
    "name": "Luxray",
    "types": [
      "Electric",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 120,
      "def": 70,
      "spe": 105,
      "spa": 110,
      "spd": 70
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Volt Rush",
      "H": "Tinted Lens"
    },
    "weightkg": 42.0,
    "prevo": "Luxio",
    "evoLevel": 32,
    "eggGroups": [
      "Field"
    ]
  },
  "budew": {
    "num": 406,
    "name": "Budew",
    "types": [
      "Grass",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 30,
      "def": 45,
      "spe": 55,
      "spa": 65,
      "spd": 85
    },
    "abilities": {
      "0": "Solar Power",
      "1": "Grassy Guard"
    },
    "weightkg": 1.2,
    "evos": [
      "Roselia"
    ],
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "roserade": {
    "num": 407,
    "name": "Roserade",
    "types": [
      "Poison",
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 95,
      "def": 60,
      "spe": 105,
      "spa": 125,
      "spd": 105
    },
    "abilities": {
      "0": "Technician",
      "1": "Serene Grace"
    },
    "weightkg": 14.5,
    "prevo": "Roselia",
    "evoLevel": 32,
    "evoType": "levelHold",
    "evoItem": "Grass Gem",
    "eggGroups": [
      "Fairy",
      "Grass"
    ]
  },
  "cranidos": {
    "num": 408,
    "name": "Cranidos",
    "types": [
      "Rock",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 62,
      "atk": 105,
      "def": 95,
      "spe": 78,
      "spa": 30,
      "spd": 30
    },
    "abilities": {
      "0": "Mold Breaker",
      "1": "Hustle"
    },
    "weightkg": 31.5,
    "evos": [
      "Rampardos"
    ],
    "eggGroups": [
      "Monster"
    ]
  },
  "rampardos": {
    "num": 409,
    "name": "Rampardos",
    "types": [
      "Rock",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 102,
      "atk": 150,
      "def": 115,
      "spe": 93,
      "spa": 35,
      "spd": 55
    },
    "abilities": {
      "0": "Headstrong",
      "1": "Hustle"
    },
    "weightkg": 102.5,
    "prevo": "Cranidos",
    "evoLevel": 34,
    "eggGroups": [
      "Monster"
    ]
  },
  "shieldon": {
    "num": 410,
    "name": "Shieldon",
    "types": [
      "Rock",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 62,
      "atk": 62,
      "def": 138,
      "spe": 10,
      "spa": 20,
      "spd": 108
    },
    "abilities": {
      "0": "Filter",
      "1": "Sturdy"
    },
    "weightkg": 57.0,
    "evos": [
      "Bastiodon"
    ],
    "eggGroups": [
      "Monster"
    ]
  },
  "bastiodon": {
    "num": 411,
    "name": "Bastiodon",
    "types": [
      "Rock",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 102,
      "atk": 102,
      "def": 168,
      "spe": 15,
      "spa": 25,
      "spd": 138
    },
    "abilities": {
      "0": "Filter",
      "1": "Rough Skin"
    },
    "weightkg": 149.5,
    "prevo": "Shieldon",
    "evoLevel": 34,
    "eggGroups": [
      "Monster"
    ]
  },
  "burmy": {
    "num": 412,
    "name": "Burmy",
    "types": [
      "Bug"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 42,
      "atk": 28,
      "def": 68,
      "spe": 36,
      "spa": 48,
      "spd": 88
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Regenerator"
    },
    "weightkg": 3.4,
    "evos": [
      "Wormadam",
      "Mothim"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "wormadam": {
    "num": 413,
    "name": "Wormadam",
    "types": [
      "Bug",
      "Grass"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 72,
      "atk": 48,
      "def": 98,
      "spe": 36,
      "spa": 98,
      "spd": 128
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Regenerator"
    },
    "weightkg": 6.5,
    "prevo": "Burmy",
    "evoLevel": 20,
    "eggGroups": [
      "Bug"
    ],
    "formes": [
      "Wormadam",
      "Wormadam-Sandy",
      "Wormadam-Trash"
    ]
  },
  "wormadamsandy": {
    "num": 413,
    "name": "Wormadam-Sandy",
    "types": [
      "Bug",
      "Ground"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 72,
      "atk": 98,
      "def": 128,
      "spe": 36,
      "spa": 48,
      "spd": 98
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Regenerator"
    },
    "weightkg": 6.5,
    "eggGroups": [
      "Bug"
    ],
    "baseSpecies": "Wormadam",
    "forme": "Sandy",
    "formes": [
      "Wormadam",
      "Wormadam-Sandy",
      "Wormadam-Trash"
    ]
  },
  "wormadamtrash": {
    "num": 413,
    "name": "Wormadam-Trash",
    "types": [
      "Bug",
      "Steel"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 72,
      "atk": 58,
      "def": 113,
      "spe": 36,
      "spa": 88,
      "spd": 113
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Regenerator"
    },
    "weightkg": 6.5,
    "eggGroups": [
      "Bug"
    ],
    "baseSpecies": "Wormadam",
    "forme": "Trash",
    "formes": [
      "Wormadam",
      "Wormadam-Sandy",
      "Wormadam-Trash"
    ]
  },
  "mothim": {
    "num": 414,
    "name": "Mothim",
    "types": [
      "Bug",
      "Flying"
    ],
    "gender": "M",
    "baseStats": {
      "hp": 72,
      "atk": 58,
      "def": 63,
      "spe": 116,
      "spa": 108,
      "spd": 63
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Hubris"
    },
    "weightkg": 23.3,
    "prevo": "Burmy",
    "evoLevel": 20,
    "eggGroups": [
      "Bug"
    ]
  },
  "combee": {
    "num": 415,
    "name": "Combee",
    "types": [
      "Bug",
      "Flying"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 41,
      "atk": 30,
      "def": 77,
      "spe": 90,
      "spa": 55,
      "spd": 77
    },
    "abilities": {
      "0": "Wimp Out",
      "1": "Guarding Gale"
    },
    "weightkg": 5.5,
    "evos": [
      "Vespiquen"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "vespiquen": {
    "num": 416,
    "name": "Vespiquen",
    "types": [
      "Bug",
      "Flying"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 96,
      "atk": 95,
      "def": 117,
      "spe": 30,
      "spa": 95,
      "spd": 117
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Guarding Gale",
      "H": "Queenly Majesty"
    },
    "weightkg": 38.5,
    "prevo": "Combee",
    "evoLevel": 25,
    "eggGroups": [
      "Bug"
    ]
  },
  "pachirisu": {
    "num": 417,
    "name": "Pachirisu",
    "types": [
      "Electric",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 45,
      "def": 70,
      "spe": 115,
      "spa": 95,
      "spd": 110
    },
    "abilities": {
      "0": "Electric Surge",
      "1": "Prankster"
    },
    "weightkg": 3.9,
    "eggGroups": [
      "Field",
      "Fairy"
    ]
  },
  "buizel": {
    "num": 418,
    "name": "Buizel",
    "types": [
      "Water",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 55,
      "atk": 73,
      "def": 40,
      "spe": 97,
      "spa": 65,
      "spd": 40
    },
    "abilities": {
      "0": "Technician",
      "1": "Swift Swim",
      "H": "Guts"
    },
    "weightkg": 29.5,
    "evos": [
      "Floatzel"
    ],
    "eggGroups": [
      "Water 1",
      "Field"
    ]
  },
  "floatzel": {
    "num": 419,
    "name": "Floatzel",
    "types": [
      "Water",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 113,
      "def": 70,
      "spe": 117,
      "spa": 95,
      "spd": 70
    },
    "abilities": {
      "0": "Technician",
      "1": "Swift Swim",
      "H": "Guts"
    },
    "weightkg": 33.5,
    "prevo": "Buizel",
    "evoLevel": 26,
    "eggGroups": [
      "Water 1",
      "Field"
    ]
  },
  "cherubi": {
    "num": 420,
    "name": "Cherubi",
    "types": [
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 35,
      "def": 50,
      "spe": 65,
      "spa": 67,
      "spd": 68
    },
    "abilities": {
      "0": "Grassy Guard",
      "1": "Wimp Out"
    },
    "weightkg": 3.3,
    "evos": [
      "Cherrim"
    ],
    "eggGroups": [
      "Fairy",
      "Grass"
    ]
  },
  "cherrim": {
    "num": 421,
    "name": "Cherrim",
    "types": [
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 55,
      "def": 85,
      "spe": 85,
      "spa": 92,
      "spd": 93
    },
    "abilities": {
      "0": "Grassy Guard",
      "1": "Flower Gift"
    },
    "weightkg": 9.3,
    "prevo": "Cherubi",
    "evoLevel": 20,
    "eggGroups": [
      "Fairy",
      "Grass"
    ],
    "formes": [
      "Cherrim",
      "Cherrim-Sunshine"
    ]
  },
  "cherrimsunshine": {
    "num": 421,
    "name": "Cherrim-Sunshine",
    "types": [
      "Fire",
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 70,
      "def": 65,
      "spe": 135,
      "spa": 112,
      "spd": 98
    },
    "abilities": {
      "0": "Flower Gift"
    },
    "weightkg": 9.3,
    "eggGroups": [
      "Fairy",
      "Grass"
    ],
    "baseSpecies": "Cherrim",
    "forme": "Sunshine",
    "formes": [
      "Cherrim",
      "Cherrim-Sunshine"
    ]
  },
  "shellos": {
    "num": 422,
    "name": "Shellos",
    "types": [
      "Poison",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 58,
      "atk": 35,
      "def": 58,
      "spe": 23,
      "spa": 83,
      "spd": 93
    },
    "abilities": {
      "0": "Regenerator",
      "1": "Storm Drain"
    },
    "weightkg": 6.3,
    "evos": [
      "Gastrodon"
    ],
    "eggGroups": [
      "Water 1",
      "Amorphous"
    ],
    "formes": [
      "Shellos",
      "Shellos-East"
    ]
  },
  "shelloseast": {
    "num": 422,
    "name": "Shellos-East",
    "types": [
      "Water",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 58,
      "atk": 35,
      "def": 58,
      "spe": 23,
      "spa": 78,
      "spd": 98
    },
    "abilities": {
      "0": "Regenerator",
      "1": "Storm Drain"
    },
    "weightkg": 6.3,
    "evos": [
      "Gastrodon"
    ],
    "eggGroups": [
      "Water 1",
      "Amorphous"
    ],
    "baseSpecies": "Shellos",
    "forme": "East",
    "formes": [
      "Shellos",
      "Shellos-East"
    ]
  },
  "gastrodon": {
    "num": 423,
    "name": "Gastrodon",
    "types": [
      "Poison",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 88,
      "atk": 60,
      "def": 88,
      "spe": 28,
      "spa": 113,
      "spd": 123
    },
    "abilities": {
      "0": "Regenerator",
      "1": "Storm Drain"
    },
    "weightkg": 29.9,
    "prevo": "Shellos-East",
    "evoLevel": 29,
    "eggGroups": [
      "Water 1",
      "Amorphous"
    ],
    "formes": [
      "Gastrodon",
      "Gastrodon-East"
    ]
  },
  "gastrodoneast": {
    "num": 423,
    "name": "Gastrodon-East",
    "types": [
      "Water",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 88,
      "atk": 60,
      "def": 88,
      "spe": 28,
      "spa": 108,
      "spd": 128
    },
    "abilities": {
      "0": "Regenerator",
      "1": "Storm Drain"
    },
    "weightkg": 29.9,
    "eggGroups": [
      "Water 1",
      "Amorphous"
    ],
    "baseSpecies": "Gastrodon",
    "forme": "East",
    "formes": [
      "Gastrodon",
      "Gastrodon-East"
    ]
  },
  "ambipom": {
    "num": 424,
    "name": "Ambipom",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 109,
      "def": 70,
      "spe": 116,
      "spa": 60,
      "spd": 70
    },
    "abilities": {
      "0": "Technician",
      "1": "Expertise"
    },
    "weightkg": 20.3,
    "prevo": "Aipom",
    "evoLevel": 26,
    "eggGroups": [
      "Field"
    ]
  },
  "drifloon": {
    "num": 425,
    "name": "Drifloon",
    "types": [
      "Ghost",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 20,
      "def": 50,
      "spe": 70,
      "spa": 90,
      "spd": 90
    },
    "abilities": {
      "0": "Flash Fire",
      "1": "Unburden",
      "H": "Flare Boost"
    },
    "weightkg": 1.2,
    "evos": [
      "Drifblim"
    ],
    "eggGroups": [
      "Amorphous"
    ]
  },
  "drifblim": {
    "num": 426,
    "name": "Drifblim",
    "types": [
      "Ghost",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 150,
      "atk": 40,
      "def": 60,
      "spe": 80,
      "spa": 110,
      "spd": 110
    },
    "abilities": {
      "0": "Guarding Gale",
      "1": "Unburden",
      "H": "Flare Boost"
    },
    "weightkg": 15.0,
    "prevo": "Drifloon",
    "evoLevel": 31,
    "eggGroups": [
      "Amorphous"
    ]
  },
  "buneary": {
    "num": 427,
    "name": "Buneary",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 55,
      "atk": 66,
      "def": 45,
      "spe": 95,
      "spa": 44,
      "spd": 45
    },
    "abilities": {
      "0": "Serene Grace",
      "1": "Unburden"
    },
    "weightkg": 5.5,
    "evos": [
      "Lopunny"
    ],
    "eggGroups": [
      "Field",
      "Human-Like"
    ]
  },
  "lopunny": {
    "num": 428,
    "name": "Lopunny",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 96,
      "def": 70,
      "spe": 115,
      "spa": 54,
      "spd": 70
    },
    "abilities": {
      "0": "Serene Grace",
      "1": "Unburden"
    },
    "weightkg": 33.3,
    "prevo": "Buneary",
    "evoLevel": 20,
    "eggGroups": [
      "Field",
      "Human-Like"
    ],
    "formes": [
      "Lopunny",
      "Lopunny-Mega"
    ]
  },
  "lopunnymega": {
    "num": 428,
    "name": "Lopunny-Mega",
    "types": [
      "Normal",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 139,
      "def": 82,
      "spe": 138,
      "spa": 64,
      "spd": 82
    },
    "abilities": {
      "0": "Scrappy",
      "1": "Reckless"
    },
    "weightkg": 28.3,
    "eggGroups": [
      "Field",
      "Human-Like"
    ],
    "baseSpecies": "Lopunny",
    "forme": "Mega",
    "formes": [
      "Lopunny",
      "Lopunny-Mega"
    ],
    "requiredItems": [
      "Mega Stone I",
      "Lopunnite"
    ]
  },
  "mismagius": {
    "num": 429,
    "name": "Mismagius",
    "types": [
      "Ghost",
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 50,
      "def": 60,
      "spe": 135,
      "spa": 135,
      "spd": 135
    },
    "abilities": {
      "0": "Levitate",
      "1": "Magic Guard"
    },
    "weightkg": 4.4,
    "prevo": "Misdreavus",
    "evoLevel": 35,
    "evoType": "levelHold",
    "evoItem": "Psychic Gem",
    "eggGroups": [
      "Amorphous"
    ]
  },
  "honchkrow": {
    "num": 430,
    "name": "Honchkrow",
    "types": [
      "Dark",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 77,
      "atk": 125,
      "def": 71,
      "spe": 101,
      "spa": 105,
      "spd": 71
    },
    "abilities": {
      "0": "Moxie",
      "1": "Ruthless"
    },
    "weightkg": 27.3,
    "prevo": "Murkrow",
    "evoLevel": 31,
    "evoType": "levelHold",
    "evoItem": "Dark Gem",
    "eggGroups": [
      "Flying"
    ]
  },
  "glameow": {
    "num": 431,
    "name": "Glameow",
    "types": [
      "Normal",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 51,
      "atk": 67,
      "def": 49,
      "spe": 97,
      "spa": 37,
      "spd": 49
    },
    "abilities": {
      "0": "Moxie",
      "1": "Prankster"
    },
    "weightkg": 3.9,
    "evos": [
      "Purugly"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "purugly": {
    "num": 432,
    "name": "Purugly",
    "types": [
      "Normal",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 101,
      "atk": 112,
      "def": 84,
      "spe": 92,
      "spa": 62,
      "spd": 84
    },
    "abilities": {
      "0": "Moxie",
      "1": "Intimidate"
    },
    "weightkg": 43.8,
    "prevo": "Glameow",
    "evoLevel": 25,
    "eggGroups": [
      "Field"
    ]
  },
  "chingling": {
    "num": 433,
    "name": "Chingling",
    "types": [
      "Psychic",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 30,
      "def": 65,
      "spe": 60,
      "spa": 85,
      "spd": 80
    },
    "abilities": {
      "0": "Wimp Out",
      "1": "Aerilate"
    },
    "weightkg": 0.6,
    "evos": [
      "Chimecho"
    ],
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "stunky": {
    "num": 434,
    "name": "Stunky",
    "types": [
      "Poison",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 51,
      "atk": 63,
      "def": 50,
      "spe": 76,
      "spa": 60,
      "spd": 50
    },
    "abilities": {
      "0": "Instinct",
      "1": "Prankster"
    },
    "weightkg": 19.2,
    "evos": [
      "Skuntank"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "skuntank": {
    "num": 435,
    "name": "Skuntank",
    "types": [
      "Poison",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 101,
      "atk": 93,
      "def": 80,
      "spe": 91,
      "spa": 90,
      "spd": 80
    },
    "abilities": {
      "0": "Instinct",
      "1": "Prankster"
    },
    "weightkg": 38.0,
    "prevo": "Stunky",
    "evoLevel": 25,
    "eggGroups": [
      "Field"
    ]
  },
  "bronzor": {
    "num": 436,
    "name": "Bronzor",
    "types": [
      "Steel",
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 47,
      "atk": 24,
      "def": 101,
      "spe": 23,
      "spa": 74,
      "spd": 101
    },
    "abilities": {
      "0": "Levitate",
      "1": "Magic Bounce"
    },
    "weightkg": 60.5,
    "evos": [
      "Bronzong"
    ],
    "eggGroups": [
      "Mineral"
    ]
  },
  "bronzong": {
    "num": 437,
    "name": "Bronzong",
    "types": [
      "Steel",
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 77,
      "atk": 44,
      "def": 141,
      "spe": 33,
      "spa": 114,
      "spd": 141
    },
    "abilities": {
      "0": "Levitate",
      "1": "Drizzle"
    },
    "weightkg": 187.0,
    "prevo": "Bronzor",
    "evoLevel": 35,
    "eggGroups": [
      "Mineral"
    ]
  },
  "bonsly": {
    "num": 438,
    "name": "Bonsly",
    "types": [
      "Rock"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 65,
      "def": 95,
      "spe": 50,
      "spa": 25,
      "spd": 65
    },
    "abilities": {
      "0": "Contrary",
      "1": "Sap Sipper"
    },
    "weightkg": 15.0,
    "evos": [
      "Sudowoodo"
    ],
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "mimejr": {
    "num": 439,
    "name": "Mime Jr.",
    "types": [
      "Psychic",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 25,
      "def": 45,
      "spe": 65,
      "spa": 80,
      "spd": 110
    },
    "abilities": {
      "0": "Technician",
      "1": "Prankster"
    },
    "weightkg": 13.0,
    "evos": [
      "Mr. Mime"
    ],
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "happiny": {
    "num": 440,
    "name": "Happiny",
    "types": [
      "Normal",
      "Fairy"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 100,
      "atk": 10,
      "def": 20,
      "spe": 35,
      "spa": 65,
      "spd": 100
    },
    "abilities": {
      "0": "Serene Grace",
      "1": "Natural Cure",
      "H": "Friend Guard"
    },
    "weightkg": 24.4,
    "evos": [
      "Chansey"
    ],
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "chatot": {
    "num": 441,
    "name": "Chatot",
    "types": [
      "Normal",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 65,
      "def": 65,
      "spe": 111,
      "spa": 109,
      "spd": 65
    },
    "abilities": {
      "0": "Prankster",
      "1": "Amplifier"
    },
    "weightkg": 1.9,
    "eggGroups": [
      "Flying"
    ]
  },
  "spiritomb": {
    "num": 442,
    "name": "Spiritomb",
    "types": [
      "Ghost",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 108,
      "atk": 45,
      "def": 108,
      "spe": 8,
      "spa": 148,
      "spd": 108
    },
    "abilities": {
      "0": "Dark Aura",
      "1": "Sinister",
      "H": "Magic Guard"
    },
    "weightkg": 108.0,
    "eggGroups": [
      "Amorphous"
    ]
  },
  "gible": {
    "num": 443,
    "name": "Gible",
    "types": [
      "Dragon",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 58,
      "atk": 90,
      "def": 65,
      "spe": 57,
      "spa": 40,
      "spd": 50
    },
    "abilities": {
      "0": "Rough Skin",
      "1": "Strong Jaw"
    },
    "weightkg": 20.5,
    "evos": [
      "Gabite"
    ],
    "eggGroups": [
      "Monster",
      "Dragon"
    ]
  },
  "gabite": {
    "num": 444,
    "name": "Gabite",
    "types": [
      "Dragon",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 73,
      "atk": 110,
      "def": 80,
      "spe": 102,
      "spa": 50,
      "spd": 65
    },
    "abilities": {
      "0": "Rough Skin",
      "1": "Strong Jaw"
    },
    "weightkg": 56.0,
    "prevo": "Gible",
    "evoLevel": 25,
    "evos": [
      "Garchomp"
    ],
    "eggGroups": [
      "Monster",
      "Dragon"
    ]
  },
  "garchomp": {
    "num": 445,
    "name": "Garchomp",
    "types": [
      "Dragon",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 108,
      "atk": 130,
      "def": 95,
      "spe": 112,
      "spa": 70,
      "spd": 85
    },
    "abilities": {
      "0": "Rough Skin",
      "1": "Reckless"
    },
    "weightkg": 95.0,
    "prevo": "Gabite",
    "evoLevel": 45,
    "evoType": "levelHold",
    "evoItem": "Dragon Gem",
    "eggGroups": [
      "Monster",
      "Dragon"
    ],
    "formes": [
      "Garchomp",
      "Garchomp-Mega"
    ]
  },
  "garchompmega": {
    "num": 445,
    "name": "Garchomp-Mega",
    "types": [
      "Dragon",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 108,
      "atk": 170,
      "def": 120,
      "spe": 102,
      "spa": 100,
      "spd": 100
    },
    "abilities": {
      "0": "Sand Rush",
      "1": "Tough Claws"
    },
    "weightkg": 95.0,
    "eggGroups": [
      "Monster",
      "Dragon"
    ],
    "baseSpecies": "Garchomp",
    "forme": "Mega",
    "formes": [
      "Garchomp",
      "Garchomp-Mega"
    ],
    "requiredItems": [
      "Mega Stone II",
      "Garchompite"
    ]
  },
  "munchlax": {
    "num": 446,
    "name": "Munchlax",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 90,
      "atk": 85,
      "def": 75,
      "spe": 20,
      "spa": 40,
      "spd": 90
    },
    "abilities": {
      "0": "Metabolism",
      "1": "Thick Fat"
    },
    "weightkg": 105.0,
    "evos": [
      "Snorlax"
    ],
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "riolu": {
    "num": 447,
    "name": "Riolu",
    "types": [
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 45,
      "atk": 85,
      "def": 40,
      "spe": 95,
      "spa": 70,
      "spd": 40
    },
    "abilities": {
      "0": "Prankster",
      "1": "Defiant"
    },
    "weightkg": 20.2,
    "evos": [
      "Lucario"
    ],
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "lucario": {
    "num": 448,
    "name": "Lucario",
    "types": [
      "Fighting",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 70,
      "atk": 115,
      "def": 70,
      "spe": 110,
      "spa": 115,
      "spd": 70
    },
    "abilities": {
      "0": "Super Luck",
      "1": "Mega Launcher"
    },
    "weightkg": 54.0,
    "prevo": "Riolu",
    "evoLevel": 25,
    "eggGroups": [
      "Field",
      "Human-Like"
    ],
    "formes": [
      "Lucario",
      "Lucario-Mega"
    ]
  },
  "lucariomega": {
    "num": 448,
    "name": "Lucario-Mega",
    "types": [
      "Fighting",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 70,
      "atk": 145,
      "def": 90,
      "spe": 120,
      "spa": 145,
      "spd": 80
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Versatility"
    },
    "weightkg": 57.5,
    "eggGroups": [
      "Field",
      "Human-Like"
    ],
    "baseSpecies": "Lucario",
    "forme": "Mega",
    "formes": [
      "Lucario",
      "Lucario-Mega"
    ],
    "requiredItems": [
      "Mega Stone I",
      "Lucarionite"
    ]
  },
  "hippopotas": {
    "num": 449,
    "name": "Hippopotas",
    "types": [
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 68,
      "atk": 87,
      "def": 93,
      "spe": 32,
      "spa": 28,
      "spd": 62
    },
    "abilities": {
      "0": "Sand Stream",
      "1": "Strong Jaw"
    },
    "weightkg": 49.5,
    "evos": [
      "Hippowdon"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "hippowdon": {
    "num": 450,
    "name": "Hippowdon",
    "types": [
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 123,
      "atk": 132,
      "def": 123,
      "spe": 47,
      "spa": 38,
      "spd": 87
    },
    "abilities": {
      "0": "Sand Stream",
      "1": "Strong Jaw"
    },
    "weightkg": 300.0,
    "prevo": "Hippopotas",
    "evoLevel": 34,
    "eggGroups": [
      "Field"
    ]
  },
  "skorupi": {
    "num": 451,
    "name": "Skorupi",
    "types": [
      "Poison",
      "Bug"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 90,
      "def": 90,
      "spe": 75,
      "spa": 20,
      "spd": 55
    },
    "abilities": {
      "0": "Merciless",
      "1": "Sand Rush"
    },
    "weightkg": 12.0,
    "evos": [
      "Drapion"
    ],
    "eggGroups": [
      "Bug",
      "Water 3"
    ]
  },
  "drapion": {
    "num": 452,
    "name": "Drapion",
    "types": [
      "Poison",
      "Bug"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 90,
      "atk": 125,
      "def": 125,
      "spe": 95,
      "spa": 30,
      "spd": 85
    },
    "abilities": {
      "0": "Sheer Force",
      "1": "Sand Rush"
    },
    "weightkg": 61.5,
    "prevo": "Skorupi",
    "evoLevel": 32,
    "eggGroups": [
      "Bug",
      "Water 3"
    ]
  },
  "croagunk": {
    "num": 453,
    "name": "Croagunk",
    "types": [
      "Poison",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 71,
      "def": 40,
      "spe": 98,
      "spa": 71,
      "spd": 40
    },
    "abilities": {
      "0": "Prankster",
      "1": "Dry Skin",
      "H": "Corrosion"
    },
    "weightkg": 23.0,
    "evos": [
      "Toxicroak"
    ],
    "eggGroups": [
      "Human-Like"
    ]
  },
  "toxicroak": {
    "num": 454,
    "name": "Toxicroak",
    "types": [
      "Poison",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 126,
      "def": 65,
      "spe": 123,
      "spa": 86,
      "spd": 65
    },
    "abilities": {
      "0": "Ruthless",
      "1": "Dry Skin",
      "H": "Corrosion"
    },
    "weightkg": 44.4,
    "prevo": "Croagunk",
    "evoLevel": 30,
    "eggGroups": [
      "Human-Like"
    ]
  },
  "carnivine": {
    "num": 455,
    "name": "Carnivine",
    "types": [
      "Grass",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 82,
      "atk": 117,
      "def": 92,
      "spe": 92,
      "spa": 50,
      "spd": 92
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Regenerator"
    },
    "weightkg": 27.0,
    "eggGroups": [
      "Grass"
    ]
  },
  "finneon": {
    "num": 456,
    "name": "Finneon",
    "types": [
      "Water",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 49,
      "atk": 39,
      "def": 56,
      "spe": 71,
      "spa": 74,
      "spd": 81
    },
    "abilities": {
      "0": "Swift Swim",
      "1": "Storm Drain"
    },
    "weightkg": 7.0,
    "evos": [
      "Lumineon"
    ],
    "eggGroups": [
      "Water 2"
    ]
  },
  "lumineon": {
    "num": 457,
    "name": "Lumineon",
    "types": [
      "Water",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 69,
      "atk": 59,
      "def": 76,
      "spe": 96,
      "spa": 109,
      "spd": 116
    },
    "abilities": {
      "0": "Swift Swim",
      "1": "Drizzle",
      "H": "Dazzling"
    },
    "weightkg": 24.0,
    "prevo": "Finneon",
    "evoLevel": 29,
    "eggGroups": [
      "Water 2"
    ]
  },
  "mantyke": {
    "num": 458,
    "name": "Mantyke",
    "types": [
      "Water",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 20,
      "def": 60,
      "spe": 55,
      "spa": 65,
      "spd": 120
    },
    "abilities": {
      "0": "Swift Swim",
      "1": "Water Absorb"
    },
    "weightkg": 65.0,
    "evos": [
      "Mantine"
    ],
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "snover": {
    "num": 459,
    "name": "Snover",
    "types": [
      "Grass",
      "Ice"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 62,
      "atk": 72,
      "def": 87,
      "spe": 30,
      "spa": 82,
      "spd": 87
    },
    "abilities": {
      "0": "Snow Warning",
      "1": "Grassy Surge"
    },
    "weightkg": 50.5,
    "evos": [
      "Abomasnow"
    ],
    "eggGroups": [
      "Monster",
      "Grass"
    ]
  },
  "abomasnow": {
    "num": 460,
    "name": "Abomasnow",
    "types": [
      "Grass",
      "Ice"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 122,
      "atk": 117,
      "def": 97,
      "spe": 35,
      "spa": 107,
      "spd": 97
    },
    "abilities": {
      "0": "Snow Warning",
      "1": "Grassy Surge"
    },
    "weightkg": 135.5,
    "prevo": "Snover",
    "evoLevel": 35,
    "eggGroups": [
      "Monster",
      "Grass"
    ],
    "formes": [
      "Abomasnow",
      "Abomasnow-Mega"
    ]
  },
  "abomasnowmega": {
    "num": 460,
    "name": "Abomasnow-Mega",
    "types": [
      "Grass",
      "Ice"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 122,
      "atk": 157,
      "def": 107,
      "spe": 35,
      "spa": 147,
      "spd": 107
    },
    "abilities": {
      "0": "Slush Rush",
      "1": "Grassy Guard"
    },
    "weightkg": 185.0,
    "eggGroups": [
      "Monster",
      "Grass"
    ],
    "baseSpecies": "Abomasnow",
    "forme": "Mega",
    "formes": [
      "Abomasnow",
      "Abomasnow-Mega"
    ],
    "requiredItems": [
      "Mega Stone I",
      "Abomasite"
    ]
  },
  "weavile": {
    "num": 461,
    "name": "Weavile",
    "types": [
      "Dark",
      "Ice"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 120,
      "def": 65,
      "spe": 133,
      "spa": 62,
      "spd": 65
    },
    "abilities": {
      "0": "Refrigerate",
      "1": "Ruthless"
    },
    "weightkg": 34.0,
    "prevo": "Sneasel",
    "evoLevel": 35,
    "evoType": "levelHold",
    "evoItem": "Dark Gem",
    "eggGroups": [
      "Field"
    ]
  },
  "magnezone": {
    "num": 462,
    "name": "Magnezone",
    "types": [
      "Electric",
      "Steel"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 80,
      "atk": 70,
      "def": 130,
      "spe": 75,
      "spa": 145,
      "spd": 100
    },
    "abilities": {
      "0": "Levitate",
      "1": "Galvanize",
      "H": "Magnet Pull"
    },
    "weightkg": 180.0,
    "prevo": "Magneton",
    "evoLevel": 45,
    "evoType": "levelHold",
    "evoItem": "Electric Gem",
    "eggGroups": [
      "Mineral"
    ]
  },
  "lickilicky": {
    "num": 463,
    "name": "Lickilicky",
    "types": [
      "Normal",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 125,
      "atk": 100,
      "def": 100,
      "spe": 50,
      "spa": 100,
      "spd": 100
    },
    "abilities": {
      "0": "Simple",
      "1": "Liquid Veil"
    },
    "weightkg": 140.0,
    "prevo": "Lickitung",
    "evoLevel": 35,
    "evoType": "levelHold",
    "evoItem": "Normal Gem",
    "eggGroups": [
      "Monster"
    ]
  },
  "rhyperior": {
    "num": 464,
    "name": "Rhyperior",
    "types": [
      "Ground",
      "Rock"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 115,
      "atk": 143,
      "def": 150,
      "spe": 32,
      "spa": 40,
      "spd": 95
    },
    "abilities": {
      "0": "Sand Stream",
      "1": "Bulletproof"
    },
    "weightkg": 282.8,
    "prevo": "Rhydon",
    "evoLevel": 40,
    "evoType": "levelHold",
    "evoItem": "Rock Gem",
    "eggGroups": [
      "Monster",
      "Field"
    ]
  },
  "tangrowth": {
    "num": 465,
    "name": "Tangrowth",
    "types": [
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 130,
      "atk": 115,
      "def": 125,
      "spe": 20,
      "spa": 100,
      "spd": 85
    },
    "abilities": {
      "0": "Sheer Force",
      "1": "Regenerator"
    },
    "weightkg": 128.6,
    "prevo": "Tangela",
    "evoLevel": 35,
    "evoType": "levelHold",
    "evoItem": "Grass Gem",
    "eggGroups": [
      "Grass"
    ]
  },
  "electivire": {
    "num": 466,
    "name": "Electivire",
    "types": [
      "Electric",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.75,
      "F": 0.25
    },
    "baseStats": {
      "hp": 85,
      "atk": 123,
      "def": 70,
      "spe": 107,
      "spa": 115,
      "spd": 75
    },
    "abilities": {
      "0": "Volt Rush",
      "1": "Electric Surge"
    },
    "weightkg": 138.6,
    "prevo": "Electabuzz",
    "evoLevel": 40,
    "evoType": "levelHold",
    "evoItem": "Fighting Gem",
    "eggGroups": [
      "Human-Like"
    ]
  },
  "magmortar": {
    "num": 467,
    "name": "Magmortar",
    "types": [
      "Fire",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.75,
      "F": 0.25
    },
    "baseStats": {
      "hp": 85,
      "atk": 102,
      "def": 95,
      "spe": 73,
      "spa": 125,
      "spd": 95
    },
    "abilities": {
      "0": "Rapid Fire",
      "1": "Drought"
    },
    "weightkg": 68.0,
    "prevo": "Magmar",
    "evoLevel": 40,
    "evoType": "levelHold",
    "evoItem": "Steel Gem",
    "eggGroups": [
      "Human-Like"
    ]
  },
  "togekiss": {
    "num": 468,
    "name": "Togekiss",
    "types": [
      "Fairy",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 85,
      "atk": 50,
      "def": 85,
      "spe": 90,
      "spa": 120,
      "spd": 120
    },
    "abilities": {
      "0": "Aerilate",
      "1": "Serene Grace"
    },
    "weightkg": 38.0,
    "prevo": "Togetic",
    "evoLevel": 32,
    "evoType": "levelHold",
    "evoItem": "Flying Gem",
    "eggGroups": [
      "Flying",
      "Fairy"
    ]
  },
  "yanmega": {
    "num": 469,
    "name": "Yanmega",
    "types": [
      "Bug",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 99,
      "atk": 96,
      "def": 59,
      "spe": 146,
      "spa": 116,
      "spd": 59
    },
    "abilities": {
      "0": "Levitate",
      "1": "Instinct",
      "H": "Tinted Lens"
    },
    "weightkg": 51.5,
    "prevo": "Yanma",
    "evoLevel": 35,
    "evoType": "levelHold",
    "evoItem": "Dragon Gem",
    "eggGroups": [
      "Bug"
    ]
  },
  "leafeon": {
    "num": 470,
    "name": "Leafeon",
    "types": [
      "Grass"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 65,
      "atk": 115,
      "def": 70,
      "spe": 110,
      "spa": 95,
      "spd": 70
    },
    "abilities": {
      "0": "Grassy Surge",
      "1": "Solar Rush",
      "H": "Evoboost"
    },
    "weightkg": 25.5,
    "prevo": "Eevee",
    "evoLevel": 25,
    "evoType": "levelHold",
    "evoItem": "Grass Gem",
    "evoCondition": "in the day",
    "eggGroups": [
      "Field"
    ]
  },
  "glaceon": {
    "num": 471,
    "name": "Glaceon",
    "types": [
      "Ice"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 65,
      "atk": 65,
      "def": 80,
      "spe": 90,
      "spa": 115,
      "spd": 110
    },
    "abilities": {
      "0": "Snow Warning",
      "1": "Refrigerate",
      "H": "Evoboost"
    },
    "weightkg": 25.9,
    "prevo": "Eevee",
    "evoLevel": 25,
    "evoType": "levelHold",
    "evoItem": "Ice Gem",
    "evoCondition": "in the night",
    "eggGroups": [
      "Field"
    ]
  },
  "gliscor": {
    "num": 472,
    "name": "Gliscor",
    "types": [
      "Poison",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 120,
      "def": 125,
      "spe": 105,
      "spa": 45,
      "spd": 75
    },
    "abilities": {
      "0": "Levitate",
      "1": "Tough Claws"
    },
    "weightkg": 42.5,
    "prevo": "Gligar",
    "evoLevel": 35,
    "evoType": "levelHold",
    "evoItem": "Dark Gem",
    "eggGroups": [
      "Bug"
    ]
  },
  "mamoswine": {
    "num": 473,
    "name": "Mamoswine",
    "types": [
      "Ice",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 130,
      "atk": 145,
      "def": 90,
      "spe": 80,
      "spa": 60,
      "spd": 70
    },
    "abilities": {
      "0": "Refrigerate",
      "1": "Slush Rush"
    },
    "weightkg": 291.0,
    "prevo": "Piloswine",
    "evoLevel": 40,
    "evoType": "levelHold",
    "evoItem": "Ice Gem",
    "eggGroups": [
      "Field"
    ]
  },
  "porygonz": {
    "num": 474,
    "name": "Porygon-Z",
    "types": [
      "Electric",
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 75,
      "atk": 80,
      "def": 50,
      "spe": 120,
      "spa": 150,
      "spd": 75
    },
    "abilities": {
      "0": "Galvanize",
      "1": "Levitate"
    },
    "weightkg": 34.0,
    "prevo": "Porygon2",
    "evoLevel": 40,
    "evoType": "levelHold",
    "evoItem": "Dubious Disc",
    "evos": [
      "Porygon2"
    ],
    "eggGroups": [
      "Mineral"
    ]
  },
  "gallade": {
    "num": 475,
    "name": "Gallade",
    "types": [
      "Psychic",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 125,
      "def": 75,
      "spe": 110,
      "spa": 60,
      "spd": 90
    },
    "abilities": {
      "0": "Ruthless",
      "1": "Proficiency"
    },
    "weightkg": 52.0,
    "prevo": "Kirlia",
    "evoLevel": 33,
    "evoType": "levelHold",
    "evoItem": "Fighting Gem",
    "eggGroups": [
      "Amorphous"
    ],
    "formes": [
      "Gallade",
      "Gallade-Mega"
    ]
  },
  "gallademega": {
    "num": 475,
    "name": "Gallade-Mega",
    "types": [
      "Psychic",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 170,
      "def": 95,
      "spe": 120,
      "spa": 60,
      "spd": 115
    },
    "abilities": {
      "0": "Defiant",
      "1": "Super Luck"
    },
    "weightkg": 56.4,
    "eggGroups": [
      "Amorphous"
    ],
    "baseSpecies": "Gallade",
    "forme": "Mega",
    "formes": [
      "Gallade",
      "Gallade-Mega"
    ],
    "requiredItems": [
      "Mega Stone I",
      "Galladite"
    ]
  },
  "probopass": {
    "num": 476,
    "name": "Probopass",
    "types": [
      "Rock",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 85,
      "atk": 50,
      "def": 150,
      "spe": 30,
      "spa": 110,
      "spd": 150
    },
    "abilities": {
      "0": "Lightning Rod",
      "1": "Levitate"
    },
    "weightkg": 340.0,
    "prevo": "Nosepass",
    "evoLevel": 35,
    "evoType": "levelHold",
    "evoItem": "Steel Gem",
    "eggGroups": [
      "Mineral"
    ]
  },
  "dusknoir": {
    "num": 477,
    "name": "Dusknoir",
    "types": [
      "Ghost",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 120,
      "atk": 120,
      "def": 100,
      "spe": 20,
      "spa": 120,
      "spd": 120
    },
    "abilities": {
      "0": "Sinister",
      "1": "Levitate"
    },
    "weightkg": 106.6,
    "prevo": "Dusclops",
    "evoLevel": 45,
    "evoType": "levelHold",
    "evoItem": "Fighting Gem",
    "eggGroups": [
      "Amorphous"
    ]
  },
  "froslass": {
    "num": 478,
    "name": "Froslass",
    "types": [
      "Ice",
      "Ghost"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 70,
      "atk": 40,
      "def": 70,
      "spe": 130,
      "spa": 130,
      "spd": 95
    },
    "abilities": {
      "0": "Snow Warning",
      "1": "Magic Guard"
    },
    "weightkg": 26.6,
    "prevo": "Snorunt",
    "evoLevel": 25,
    "evoType": "levelHold",
    "evoItem": "Ghost Gem",
    "eggGroups": [
      "Fairy",
      "Mineral"
    ]
  },
  "rotom": {
    "num": 479,
    "name": "Rotom",
    "types": [
      "Electric",
      "Ghost"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 50,
      "atk": 35,
      "def": 57,
      "spe": 161,
      "spa": 125,
      "spd": 97
    },
    "abilities": {
      "0": "Levitate",
      "1": "Galvanize"
    },
    "weightkg": 0.3,
    "eggGroups": [
      "Amorphous"
    ],
    "formes": [
      "Rotom",
      "Rotom-Heat",
      "Rotom-Wash",
      "Rotom-Frost",
      "Rotom-Fan",
      "Rotom-Mow"
    ]
  },
  "rotomheat": {
    "num": 479,
    "name": "Rotom-Heat",
    "types": [
      "Electric",
      "Fire"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 65,
      "atk": 45,
      "def": 107,
      "spe": 101,
      "spa": 125,
      "spd": 107
    },
    "abilities": {
      "0": "Levitate",
      "1": "Flash Fire"
    },
    "weightkg": 0.3,
    "eggGroups": [
      "Amorphous"
    ],
    "baseSpecies": "Rotom",
    "forme": "Heat",
    "formes": [
      "Rotom",
      "Rotom-Heat",
      "Rotom-Wash",
      "Rotom-Frost",
      "Rotom-Fan",
      "Rotom-Mow"
    ]
  },
  "rotomwash": {
    "num": 479,
    "name": "Rotom-Wash",
    "types": [
      "Electric",
      "Water"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 80,
      "atk": 45,
      "def": 107,
      "spe": 86,
      "spa": 125,
      "spd": 107
    },
    "abilities": {
      "0": "Levitate",
      "1": "Storm Drain"
    },
    "weightkg": 0.3,
    "eggGroups": [
      "Amorphous"
    ],
    "baseSpecies": "Rotom",
    "forme": "Wash",
    "formes": [
      "Rotom",
      "Rotom-Heat",
      "Rotom-Wash",
      "Rotom-Frost",
      "Rotom-Fan",
      "Rotom-Mow"
    ]
  },
  "rotomfrost": {
    "num": 479,
    "name": "Rotom-Frost",
    "types": [
      "Electric",
      "Ice"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 75,
      "atk": 45,
      "def": 107,
      "spe": 91,
      "spa": 125,
      "spd": 107
    },
    "abilities": {
      "0": "Levitate",
      "1": "Refrigerate"
    },
    "weightkg": 0.3,
    "eggGroups": [
      "Amorphous"
    ],
    "baseSpecies": "Rotom",
    "forme": "Frost",
    "formes": [
      "Rotom",
      "Rotom-Heat",
      "Rotom-Wash",
      "Rotom-Frost",
      "Rotom-Fan",
      "Rotom-Mow"
    ]
  },
  "rotomfan": {
    "num": 479,
    "name": "Rotom-Fan",
    "types": [
      "Electric",
      "Flying"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 60,
      "atk": 45,
      "def": 97,
      "spe": 126,
      "spa": 125,
      "spd": 97
    },
    "abilities": {
      "0": "Motor Drive",
      "1": "Aerilate"
    },
    "weightkg": 0.3,
    "eggGroups": [
      "Amorphous"
    ],
    "baseSpecies": "Rotom",
    "forme": "Fan",
    "formes": [
      "Rotom",
      "Rotom-Heat",
      "Rotom-Wash",
      "Rotom-Frost",
      "Rotom-Fan",
      "Rotom-Mow"
    ]
  },
  "rotommow": {
    "num": 479,
    "name": "Rotom-Mow",
    "types": [
      "Electric",
      "Grass"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 70,
      "atk": 45,
      "def": 107,
      "spe": 96,
      "spa": 125,
      "spd": 107
    },
    "abilities": {
      "0": "Levitate",
      "1": "Sap Sipper"
    },
    "weightkg": 0.3,
    "eggGroups": [
      "Amorphous"
    ],
    "baseSpecies": "Rotom",
    "forme": "Mow",
    "formes": [
      "Rotom",
      "Rotom-Heat",
      "Rotom-Wash",
      "Rotom-Frost",
      "Rotom-Fan",
      "Rotom-Mow"
    ]
  },
  "uxie": {
    "num": 480,
    "name": "Uxie",
    "types": [
      "Psychic",
      "Normal"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 65,
      "atk": 40,
      "def": 130,
      "spe": 100,
      "spa": 105,
      "spd": 160
    },
    "abilities": {
      "0": "Magic Bounce",
      "1": "Levitate",
      "H": "Magic Guard"
    },
    "weightkg": 0.3,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "mesprit": {
    "num": 481,
    "name": "Mesprit",
    "types": [
      "Psychic",
      "Fairy"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 65,
      "atk": 60,
      "def": 105,
      "spe": 115,
      "spa": 125,
      "spd": 130
    },
    "abilities": {
      "0": "Sixth Sense",
      "1": "Levitate",
      "H": "Magic Guard"
    },
    "weightkg": 0.3,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "azelf": {
    "num": 482,
    "name": "Azelf",
    "types": [
      "Psychic",
      "Fighting"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 65,
      "atk": 80,
      "def": 80,
      "spe": 130,
      "spa": 145,
      "spd": 100
    },
    "abilities": {
      "0": "Competitive",
      "1": "Levitate",
      "H": "Magic Guard"
    },
    "weightkg": 0.3,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "dialga": {
    "num": 483,
    "name": "Dialga",
    "types": [
      "Steel",
      "Dragon"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 120,
      "atk": 120,
      "def": 150,
      "spe": 90,
      "spa": 200,
      "spd": 120
    },
    "abilities": {
      "0": "Filter"
    },
    "weightkg": 683.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "unusable": true
  },
  "palkia": {
    "num": 484,
    "name": "Palkia",
    "types": [
      "Water",
      "Dragon"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 120,
      "atk": 120,
      "def": 120,
      "spe": 90,
      "spa": 200,
      "spd": 150
    },
    "abilities": {
      "0": "Psychic Surge"
    },
    "weightkg": 336.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "unusable": true
  },
  "heatran": {
    "num": 485,
    "name": "Heatran",
    "types": [
      "Fire",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 101,
      "atk": 90,
      "def": 116,
      "spe": 47,
      "spa": 130,
      "spd": 116
    },
    "abilities": {
      "0": "Rough Skin",
      "1": "Weak Armor"
    },
    "weightkg": 430.0,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "regigigas": {
    "num": 486,
    "name": "Regigigas",
    "types": [
      "Normal",
      "Ground"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 195,
      "atk": 250,
      "def": 110,
      "spe": 35,
      "spa": 100,
      "spd": 110
    },
    "abilities": {
      "0": "Slow Start"
    },
    "weightkg": 420.0,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "giratina": {
    "num": 487,
    "name": "Giratina",
    "types": [
      "Ghost",
      "Dragon"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 120,
      "atk": 100,
      "def": 140,
      "spe": 66,
      "spa": 100,
      "spd": 140
    },
    "abilities": {
      "0": "Sinister",
      "1": "Pressure"
    },
    "weightkg": 750.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "formes": [
      "Giratina",
      "Giratina-Origin"
    ]
  },
  "giratinaorigin": {
    "num": 487,
    "name": "Giratina-Origin",
    "types": [
      "Ghost",
      "Dragon"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 120,
      "atk": 140,
      "def": 60,
      "spe": 146,
      "spa": 140,
      "spd": 60
    },
    "abilities": {
      "0": "No Guard",
      "1": "Levitate"
    },
    "weightkg": 650.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Giratina",
    "forme": "Origin",
    "formes": [
      "Giratina",
      "Giratina-Origin"
    ]
  },
  "cresselia": {
    "num": 488,
    "name": "Cresselia",
    "types": [
      "Psychic",
      "Fairy"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 85,
      "atk": 60,
      "def": 120,
      "spe": 75,
      "spa": 110,
      "spd": 150
    },
    "abilities": {
      "0": "Dazzling",
      "1": "Levitate"
    },
    "weightkg": 85.6,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "phione": {
    "num": 489,
    "name": "Phione",
    "types": [
      "Water"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 65,
      "atk": 50,
      "def": 85,
      "spe": 80,
      "spa": 85,
      "spd": 135
    },
    "abilities": {
      "0": "Hydration",
      "1": "Dry Skin"
    },
    "weightkg": 3.1,
    "evos": [
      "Manaphy"
    ],
    "eggGroups": [
      "Water 1",
      "Fairy"
    ]
  },
  "manaphy": {
    "num": 490,
    "name": "Manaphy",
    "types": [
      "Water",
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 65,
      "atk": 50,
      "def": 85,
      "spe": 80,
      "spa": 135,
      "spd": 135
    },
    "abilities": {
      "0": "Drizzle",
      "1": "Adaptability"
    },
    "weightkg": 1.4,
    "prevo": "Phione",
    "evoLevel": 35,
    "evoType": "levelHold",
    "evoItem": "Psychic Gem",
    "eggGroups": [
      "Water 1",
      "Fairy"
    ]
  },
  "darkrai": {
    "num": 491,
    "name": "Darkrai",
    "types": [
      "Dark"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 70,
      "atk": 70,
      "def": 60,
      "spe": 140,
      "spa": 150,
      "spd": 110
    },
    "abilities": {
      "0": "Levitate",
      "1": "Bad Dreams"
    },
    "weightkg": 50.5,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "shaymin": {
    "num": 492,
    "name": "Shaymin",
    "types": [
      "Grass",
      "Fairy"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 65,
      "atk": 43,
      "def": 90,
      "spe": 62,
      "spa": 115,
      "spd": 125
    },
    "abilities": {
      "0": "Grassy Surge",
      "1": "Pixilate"
    },
    "weightkg": 2.1,
    "eggGroups": [
      "Undiscovered"
    ],
    "formes": [
      "Shaymin",
      "Shaymin-Sky"
    ]
  },
  "shayminsky": {
    "num": 492,
    "name": "Shaymin-Sky",
    "types": [
      "Flying",
      "Grass"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 65,
      "atk": 93,
      "def": 70,
      "spe": 137,
      "spa": 125,
      "spd": 110
    },
    "abilities": {
      "0": "Serene Grace",
      "1": "Aerilate"
    },
    "weightkg": 5.2,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Shaymin",
    "forme": "Sky",
    "formes": [
      "Shaymin",
      "Shaymin-Sky"
    ],
    "requiredItems": [
      "Mega Stone I"
    ]
  },
  "arceus": {
    "num": 493,
    "name": "Arceus",
    "types": [
      "Normal"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 250,
      "atk": 250,
      "def": 250,
      "spe": 250,
      "spa": 250,
      "spd": 250
    },
    "abilities": {
      "0": "Versatility"
    },
    "weightkg": 320.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "unusable": true
  },
  "victini": {
    "num": 494,
    "name": "Victini",
    "types": [
      "Fairy",
      "Fire"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 60,
      "atk": 115,
      "def": 75,
      "spe": 110,
      "spa": 125,
      "spd": 115
    },
    "abilities": {
      "0": "Reckless",
      "1": "Competitive"
    },
    "weightkg": 4.0,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "snivy": {
    "num": 495,
    "name": "Snivy",
    "types": [
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 47,
      "atk": 45,
      "def": 45,
      "spe": 73,
      "spa": 55,
      "spd": 55
    },
    "abilities": {
      "0": "Overgrow",
      "1": "Hubris"
    },
    "weightkg": 8.1,
    "evos": [
      "Servine"
    ],
    "eggGroups": [
      "Field",
      "Grass"
    ]
  },
  "servine": {
    "num": 496,
    "name": "Servine",
    "types": [
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 62,
      "atk": 55,
      "def": 65,
      "spe": 93,
      "spa": 80,
      "spd": 80
    },
    "abilities": {
      "0": "Overgrow",
      "1": "Hubris"
    },
    "weightkg": 16.0,
    "prevo": "Snivy",
    "evoLevel": 17,
    "evos": [
      "Serperior"
    ],
    "eggGroups": [
      "Field",
      "Grass"
    ]
  },
  "serperior": {
    "num": 497,
    "name": "Serperior",
    "types": [
      "Grass",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 102,
      "atk": 60,
      "def": 80,
      "spe": 123,
      "spa": 90,
      "spd": 95
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Hubris"
    },
    "weightkg": 63.0,
    "prevo": "Servine",
    "evoLevel": 36,
    "eggGroups": [
      "Field",
      "Grass"
    ]
  },
  "tepig": {
    "num": 498,
    "name": "Tepig",
    "types": [
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 68,
      "def": 55,
      "spe": 47,
      "spa": 45,
      "spd": 55
    },
    "abilities": {
      "0": "Blaze",
      "1": "Solar Rush"
    },
    "weightkg": 9.9,
    "evos": [
      "Pignite"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "pignite": {
    "num": 499,
    "name": "Pignite",
    "types": [
      "Fire",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 98,
      "def": 70,
      "spe": 57,
      "spa": 60,
      "spd": 70
    },
    "abilities": {
      "0": "Blaze",
      "1": "Solar Rush"
    },
    "weightkg": 55.5,
    "prevo": "Tepig",
    "evoLevel": 17,
    "evos": [
      "Emboar"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "emboar": {
    "num": 500,
    "name": "Emboar",
    "types": [
      "Fire",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 110,
      "atk": 133,
      "def": 85,
      "spe": 67,
      "spa": 70,
      "spd": 85
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Solar Rush"
    },
    "weightkg": 180.0,
    "prevo": "Pignite",
    "evoLevel": 36,
    "eggGroups": [
      "Field"
    ]
  },
  "oshawott": {
    "num": 501,
    "name": "Oshawott",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 65,
      "def": 45,
      "spe": 65,
      "spa": 55,
      "spd": 45
    },
    "abilities": {
      "0": "Torrent",
      "1": "Defiant"
    },
    "weightkg": 5.9,
    "evos": [
      "Dewott"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "dewott": {
    "num": 502,
    "name": "Dewott",
    "types": [
      "Water",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 95,
      "def": 60,
      "spe": 90,
      "spa": 65,
      "spd": 60
    },
    "abilities": {
      "0": "Torrent",
      "1": "Defiant"
    },
    "weightkg": 24.5,
    "prevo": "Oshawott",
    "evoLevel": 17,
    "evos": [
      "Samurott"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "samurott": {
    "num": 503,
    "name": "Samurott",
    "types": [
      "Water",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 95,
      "atk": 120,
      "def": 90,
      "spe": 95,
      "spa": 70,
      "spd": 80
    },
    "abilities": {
      "0": "Ruthless",
      "1": "Intimidate"
    },
    "weightkg": 94.6,
    "prevo": "Dewott",
    "evoLevel": 36,
    "eggGroups": [
      "Field"
    ]
  },
  "patrat": {
    "num": 504,
    "name": "Patrat",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 47,
      "atk": 58,
      "def": 45,
      "spe": 72,
      "spa": 58,
      "spd": 50
    },
    "abilities": {
      "0": "Instinct",
      "1": "Emergency Exit",
      "H": "Tinted Lens"
    },
    "weightkg": 11.6,
    "evos": [
      "Watchog"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "watchog": {
    "num": 505,
    "name": "Watchog",
    "types": [
      "Normal",
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 72,
      "atk": 93,
      "def": 70,
      "spe": 102,
      "spa": 93,
      "spd": 85
    },
    "abilities": {
      "0": "Instinct",
      "1": "Sap Sipper",
      "H": "Tinted Lens"
    },
    "weightkg": 27.0,
    "prevo": "Patrat",
    "evoLevel": 22,
    "eggGroups": [
      "Field"
    ]
  },
  "lillipup": {
    "num": 506,
    "name": "Lillipup",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 60,
      "def": 45,
      "spe": 75,
      "spa": 30,
      "spd": 45
    },
    "abilities": {
      "0": "Fur Coat",
      "1": "Slush Rush"
    },
    "weightkg": 4.1,
    "evos": [
      "Herdier"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "herdier": {
    "num": 507,
    "name": "Herdier",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 80,
      "def": 65,
      "spe": 85,
      "spa": 40,
      "spd": 65
    },
    "abilities": {
      "0": "Fur Coat",
      "1": "Slush Rush"
    },
    "weightkg": 14.7,
    "prevo": "Lillipup",
    "evoLevel": 16,
    "evos": [
      "Stoutland"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "stoutland": {
    "num": 508,
    "name": "Stoutland",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 100,
      "atk": 110,
      "def": 90,
      "spe": 90,
      "spa": 45,
      "spd": 90
    },
    "abilities": {
      "0": "Fur Coat",
      "1": "Slush Rush"
    },
    "weightkg": 61.0,
    "prevo": "Herdier",
    "evoLevel": 32,
    "eggGroups": [
      "Field"
    ]
  },
  "purrloin": {
    "num": 509,
    "name": "Purrloin",
    "types": [
      "Dark",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 64,
      "def": 45,
      "spe": 91,
      "spa": 40,
      "spd": 45
    },
    "abilities": {
      "0": "Prankster",
      "1": "Technician"
    },
    "weightkg": 10.1,
    "evos": [
      "Liepard"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "liepard": {
    "num": 510,
    "name": "Liepard",
    "types": [
      "Dark",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 109,
      "def": 60,
      "spe": 121,
      "spa": 55,
      "spd": 60
    },
    "abilities": {
      "0": "Ruthless",
      "1": "Technician"
    },
    "weightkg": 37.5,
    "prevo": "Purrloin",
    "evoLevel": 20,
    "eggGroups": [
      "Field"
    ]
  },
  "pansage": {
    "num": 511,
    "name": "Pansage",
    "types": [
      "Grass"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 50,
      "atk": 64,
      "def": 48,
      "spe": 96,
      "spa": 64,
      "spd": 48
    },
    "abilities": {
      "0": "Prankster",
      "1": "Overgrow"
    },
    "weightkg": 10.5,
    "evos": [
      "Simisage"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "simisage": {
    "num": 512,
    "name": "Simisage",
    "types": [
      "Grass"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 75,
      "atk": 99,
      "def": 68,
      "spe": 116,
      "spa": 99,
      "spd": 68
    },
    "abilities": {
      "0": "Instinct",
      "1": "Grassy Surge"
    },
    "weightkg": 30.5,
    "prevo": "Pansage",
    "evoLevel": 25,
    "eggGroups": [
      "Field"
    ]
  },
  "pansear": {
    "num": 513,
    "name": "Pansear",
    "types": [
      "Fire"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 50,
      "atk": 64,
      "def": 48,
      "spe": 96,
      "spa": 64,
      "spd": 48
    },
    "abilities": {
      "0": "Prankster",
      "1": "Blaze"
    },
    "weightkg": 11.0,
    "evos": [
      "Simisear"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "simisear": {
    "num": 514,
    "name": "Simisear",
    "types": [
      "Fire"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 75,
      "atk": 99,
      "def": 68,
      "spe": 116,
      "spa": 99,
      "spd": 68
    },
    "abilities": {
      "0": "Instinct",
      "1": "Drought"
    },
    "weightkg": 28.0,
    "prevo": "Pansear",
    "evoLevel": 25,
    "eggGroups": [
      "Field"
    ]
  },
  "panpour": {
    "num": 515,
    "name": "Panpour",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 50,
      "atk": 64,
      "def": 48,
      "spe": 96,
      "spa": 64,
      "spd": 48
    },
    "abilities": {
      "0": "Prankster",
      "1": "Torrent"
    },
    "weightkg": 13.5,
    "evos": [
      "Simipour"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "simipour": {
    "num": 516,
    "name": "Simipour",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 75,
      "atk": 99,
      "def": 68,
      "spe": 116,
      "spa": 99,
      "spd": 68
    },
    "abilities": {
      "0": "Instinct",
      "1": "Drizzle"
    },
    "weightkg": 29.0,
    "prevo": "Panpour",
    "evoLevel": 25,
    "eggGroups": [
      "Field"
    ]
  },
  "munna": {
    "num": 517,
    "name": "Munna",
    "types": [
      "Psychic",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 66,
      "atk": 25,
      "def": 65,
      "spe": 24,
      "spa": 87,
      "spd": 103
    },
    "abilities": {
      "0": "Levitate",
      "1": "Misty Surge"
    },
    "weightkg": 23.3,
    "evos": [
      "Musharna"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "musharna": {
    "num": 518,
    "name": "Musharna",
    "types": [
      "Psychic",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 116,
      "atk": 35,
      "def": 95,
      "spe": 29,
      "spa": 117,
      "spd": 143
    },
    "abilities": {
      "0": "Levitate",
      "1": "Misty Surge"
    },
    "weightkg": 60.5,
    "prevo": "Munna",
    "evoLevel": 26,
    "eggGroups": [
      "Field"
    ]
  },
  "pidove": {
    "num": 519,
    "name": "Pidove",
    "types": [
      "Normal",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 60,
      "def": 45,
      "spe": 63,
      "spa": 57,
      "spd": 40
    },
    "abilities": {
      "0": "Super Luck",
      "1": "Unaware"
    },
    "weightkg": 2.1,
    "evos": [
      "Tranquill"
    ],
    "eggGroups": [
      "Flying"
    ]
  },
  "tranquill": {
    "num": 520,
    "name": "Tranquill",
    "types": [
      "Normal",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 85,
      "def": 60,
      "spe": 98,
      "spa": 77,
      "spd": 50
    },
    "abilities": {
      "0": "Super Luck",
      "1": "Competitive"
    },
    "weightkg": 15.0,
    "prevo": "Pidove",
    "evoLevel": 17,
    "evos": [
      "Unfezant"
    ],
    "eggGroups": [
      "Flying"
    ]
  },
  "unfezant": {
    "num": 521,
    "name": "Unfezant",
    "types": [
      "Normal",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 115,
      "def": 80,
      "spe": 108,
      "spa": 107,
      "spd": 60
    },
    "abilities": {
      "0": "Super Luck",
      "1": "Proficiency"
    },
    "weightkg": 29.0,
    "prevo": "Tranquill",
    "evoLevel": 32,
    "eggGroups": [
      "Flying"
    ]
  },
  "blitzle": {
    "num": 522,
    "name": "Blitzle",
    "types": [
      "Electric",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 55,
      "atk": 80,
      "def": 55,
      "spe": 110,
      "spa": 75,
      "spd": 55
    },
    "abilities": {
      "0": "Sap Sipper",
      "1": "Speed Boost",
      "H": "Headstrong"
    },
    "weightkg": 29.8,
    "evos": [
      "Zebstrika"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "zebstrika": {
    "num": 523,
    "name": "Zebstrika",
    "types": [
      "Electric",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 110,
      "def": 70,
      "spe": 125,
      "spa": 100,
      "spd": 70
    },
    "abilities": {
      "0": "Reckless",
      "1": "Speed Boost",
      "H": "Guts"
    },
    "weightkg": 79.5,
    "prevo": "Blitzle",
    "evoLevel": 30,
    "eggGroups": [
      "Field"
    ]
  },
  "roggenrola": {
    "num": 524,
    "name": "Roggenrola",
    "types": [
      "Rock"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 75,
      "def": 105,
      "spe": 10,
      "spa": 75,
      "spd": 55
    },
    "abilities": {
      "0": "Rough Skin",
      "1": "Energy Shield"
    },
    "weightkg": 18.0,
    "evos": [
      "Boldore"
    ],
    "eggGroups": [
      "Mineral"
    ]
  },
  "boldore": {
    "num": 525,
    "name": "Boldore",
    "types": [
      "Rock"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 105,
      "def": 120,
      "spe": 10,
      "spa": 105,
      "spd": 70
    },
    "abilities": {
      "0": "Versatility",
      "1": "Energy Shield"
    },
    "weightkg": 102.0,
    "prevo": "Roggenrola",
    "evoLevel": 25,
    "evos": [
      "Gigalith"
    ],
    "eggGroups": [
      "Mineral"
    ]
  },
  "gigalith": {
    "num": 526,
    "name": "Gigalith",
    "types": [
      "Rock"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 110,
      "atk": 135,
      "def": 130,
      "spe": 10,
      "spa": 135,
      "spd": 80
    },
    "abilities": {
      "0": "Versatility",
      "1": "Sand Stream"
    },
    "weightkg": 260.0,
    "prevo": "Boldore",
    "evoLevel": 45,
    "evoType": "levelHold",
    "evoItem": "Rock Gem",
    "eggGroups": [
      "Mineral"
    ]
  },
  "woobat": {
    "num": 527,
    "name": "Woobat",
    "types": [
      "Fairy",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 47,
      "atk": 37,
      "def": 45,
      "spe": 99,
      "spa": 77,
      "spd": 65
    },
    "abilities": {
      "0": "Simple",
      "1": "Pixilate"
    },
    "weightkg": 2.1,
    "evos": [
      "Swoobat"
    ],
    "eggGroups": [
      "Field",
      "Flying"
    ]
  },
  "swoobat": {
    "num": 528,
    "name": "Swoobat",
    "types": [
      "Fairy",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 67,
      "atk": 57,
      "def": 60,
      "spe": 114,
      "spa": 107,
      "spd": 95
    },
    "abilities": {
      "0": "Simple",
      "1": "Pixilate"
    },
    "weightkg": 10.5,
    "prevo": "Woobat",
    "evoLevel": 22,
    "eggGroups": [
      "Field",
      "Flying"
    ]
  },
  "drilbur": {
    "num": 529,
    "name": "Drilbur",
    "types": [
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 95,
      "def": 72,
      "spe": 78,
      "spa": 30,
      "spd": 45
    },
    "abilities": {
      "0": "Sand Rush",
      "1": "Mold Breaker"
    },
    "weightkg": 8.5,
    "evos": [
      "Excadrill"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "excadrill": {
    "num": 530,
    "name": "Excadrill",
    "types": [
      "Ground",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 135,
      "def": 107,
      "spe": 98,
      "spa": 50,
      "spd": 65
    },
    "abilities": {
      "0": "Sand Rush",
      "1": "Ruthless"
    },
    "weightkg": 40.4,
    "prevo": "Drilbur",
    "evoLevel": 29,
    "eggGroups": [
      "Field"
    ]
  },
  "audino": {
    "num": 531,
    "name": "Audino",
    "types": [
      "Normal",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 103,
      "atk": 60,
      "def": 91,
      "spe": 50,
      "spa": 80,
      "spd": 116
    },
    "abilities": {
      "0": "Regenerator",
      "1": "Trace"
    },
    "weightkg": 31.0,
    "eggGroups": [
      "Fairy"
    ],
    "formes": [
      "Audino",
      "Audino-Mega"
    ]
  },
  "audinomega": {
    "num": 531,
    "name": "Audino-Mega",
    "types": [
      "Fairy",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 103,
      "atk": 60,
      "def": 126,
      "spe": 50,
      "spa": 105,
      "spd": 156
    },
    "abilities": {
      "0": "Regenerator",
      "1": "Magic Bounce"
    },
    "weightkg": 32.0,
    "eggGroups": [
      "Fairy"
    ],
    "baseSpecies": "Audino",
    "forme": "Mega",
    "formes": [
      "Audino",
      "Audino-Mega"
    ],
    "requiredItems": [
      "Mega Stone I"
    ]
  },
  "timburr": {
    "num": 532,
    "name": "Timburr",
    "types": [
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.75,
      "F": 0.25
    },
    "baseStats": {
      "hp": 55,
      "atk": 90,
      "def": 80,
      "spe": 35,
      "spa": 30,
      "spd": 40
    },
    "abilities": {
      "0": "Technician",
      "1": "Sap Sipper",
      "H": "Guts"
    },
    "weightkg": 12.5,
    "evos": [
      "Gurdurr"
    ],
    "eggGroups": [
      "Human-Like"
    ]
  },
  "gurdurr": {
    "num": 533,
    "name": "Gurdurr",
    "types": [
      "Fighting",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.75,
      "F": 0.25
    },
    "baseStats": {
      "hp": 80,
      "atk": 120,
      "def": 110,
      "spe": 40,
      "spa": 40,
      "spd": 50
    },
    "abilities": {
      "0": "Technician",
      "1": "Filter",
      "H": "Guts"
    },
    "weightkg": 40.0,
    "prevo": "Timburr",
    "evoLevel": 20,
    "evos": [
      "Conkeldurr"
    ],
    "eggGroups": [
      "Human-Like"
    ]
  },
  "conkeldurr": {
    "num": 534,
    "name": "Conkeldurr",
    "types": [
      "Fighting",
      "Rock"
    ],
    "genderRatio": {
      "M": 0.75,
      "F": 0.25
    },
    "baseStats": {
      "hp": 105,
      "atk": 145,
      "def": 120,
      "spe": 45,
      "spa": 55,
      "spd": 80
    },
    "abilities": {
      "0": "Technician",
      "1": "Solid Rock",
      "H": "Guts"
    },
    "weightkg": 87.0,
    "prevo": "Gurdurr",
    "evoLevel": 36,
    "evoType": "levelHold",
    "evoItem": "Rock Gem",
    "eggGroups": [
      "Human-Like"
    ]
  },
  "tympole": {
    "num": 535,
    "name": "Tympole",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 50,
      "def": 45,
      "spe": 70,
      "spa": 60,
      "spd": 45
    },
    "abilities": {
      "0": "Dry Skin",
      "1": "Amplifier"
    },
    "weightkg": 4.5,
    "evos": [
      "Palpitoad"
    ],
    "eggGroups": [
      "Water 1"
    ]
  },
  "palpitoad": {
    "num": 536,
    "name": "Palpitoad",
    "types": [
      "Water",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 70,
      "def": 75,
      "spe": 55,
      "spa": 70,
      "spd": 75
    },
    "abilities": {
      "0": "Dry Skin",
      "1": "Amplifier"
    },
    "weightkg": 17.0,
    "prevo": "Tympole",
    "evoLevel": 18,
    "evos": [
      "Seismitoad"
    ],
    "eggGroups": [
      "Water 1"
    ]
  },
  "seismitoad": {
    "num": 537,
    "name": "Seismitoad",
    "types": [
      "Water",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 110,
      "atk": 115,
      "def": 90,
      "spe": 40,
      "spa": 105,
      "spd": 90
    },
    "abilities": {
      "0": "Dry Skin",
      "1": "Sheer Force",
      "H": "Poison Heal"
    },
    "weightkg": 62.0,
    "prevo": "Palpitoad",
    "evoLevel": 36,
    "eggGroups": [
      "Water 1"
    ]
  },
  "throh": {
    "num": 538,
    "name": "Throh",
    "types": [
      "Fighting"
    ],
    "gender": "M",
    "baseStats": {
      "hp": 100,
      "atk": 115,
      "def": 115,
      "spe": 45,
      "spa": 30,
      "spd": 95
    },
    "abilities": {
      "0": "Stamina",
      "1": "Expertise"
    },
    "weightkg": 55.5,
    "eggGroups": [
      "Human-Like"
    ]
  },
  "sawk": {
    "num": 539,
    "name": "Sawk",
    "types": [
      "Fighting"
    ],
    "gender": "M",
    "baseStats": {
      "hp": 75,
      "atk": 125,
      "def": 90,
      "spe": 100,
      "spa": 30,
      "spd": 80
    },
    "abilities": {
      "0": "Versatility",
      "1": "Expertise"
    },
    "weightkg": 51.0,
    "eggGroups": [
      "Human-Like"
    ]
  },
  "sewaddle": {
    "num": 540,
    "name": "Sewaddle",
    "types": [
      "Bug",
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 53,
      "def": 70,
      "spe": 29,
      "spa": 63,
      "spd": 70
    },
    "abilities": {
      "0": "Grassy Guard",
      "1": "Harvest"
    },
    "weightkg": 2.5,
    "evos": [
      "Swadloon"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "swadloon": {
    "num": 541,
    "name": "Swadloon",
    "types": [
      "Bug",
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 63,
      "def": 95,
      "spe": 44,
      "spa": 73,
      "spd": 95
    },
    "abilities": {
      "0": "Grassy Guard",
      "1": "Harvest"
    },
    "weightkg": 7.3,
    "prevo": "Sewaddle",
    "evoLevel": 17,
    "evos": [
      "Leavanny"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "leavanny": {
    "num": 542,
    "name": "Leavanny",
    "types": [
      "Bug",
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 108,
      "def": 80,
      "spe": 109,
      "spa": 98,
      "spd": 80
    },
    "abilities": {
      "0": "Grassy Surge",
      "1": "Technician",
      "H": "Tinted Lens"
    },
    "weightkg": 20.5,
    "prevo": "Swadloon",
    "evoLevel": 32,
    "eggGroups": [
      "Bug"
    ]
  },
  "venipede": {
    "num": 543,
    "name": "Venipede",
    "types": [
      "Bug",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 41,
      "atk": 65,
      "def": 71,
      "spe": 72,
      "spa": 30,
      "spd": 51
    },
    "abilities": {
      "0": "Speed Boost",
      "1": "Merciless",
      "H": "Battle Armor"
    },
    "weightkg": 5.3,
    "evos": [
      "Whirlipede"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "whirlipede": {
    "num": 544,
    "name": "Whirlipede",
    "types": [
      "Bug",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 66,
      "atk": 70,
      "def": 101,
      "spe": 82,
      "spa": 40,
      "spd": 81
    },
    "abilities": {
      "0": "Speed Boost",
      "1": "Merciless",
      "H": "Battle Armor"
    },
    "weightkg": 58.5,
    "prevo": "Venipede",
    "evoLevel": 19,
    "evos": [
      "Scolipede"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "scolipede": {
    "num": 545,
    "name": "Scolipede",
    "types": [
      "Bug",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 106,
      "atk": 120,
      "def": 91,
      "spe": 112,
      "spa": 50,
      "spd": 71
    },
    "abilities": {
      "0": "Speed Boost",
      "1": "Intimidate"
    },
    "weightkg": 200.5,
    "prevo": "Whirlipede",
    "evoLevel": 33,
    "eggGroups": [
      "Bug"
    ]
  },
  "cottonee": {
    "num": 546,
    "name": "Cottonee",
    "types": [
      "Grass",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 27,
      "def": 60,
      "spe": 76,
      "spa": 72,
      "spd": 75
    },
    "abilities": {
      "0": "Prankster",
      "1": "Fluffy"
    },
    "weightkg": 0.6,
    "evos": [
      "Whimsicott"
    ],
    "eggGroups": [
      "Grass",
      "Fairy"
    ]
  },
  "whimsicott": {
    "num": 547,
    "name": "Whimsicott",
    "types": [
      "Grass",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 57,
      "def": 85,
      "spe": 116,
      "spa": 97,
      "spd": 100
    },
    "abilities": {
      "0": "Prankster",
      "1": "Fluffy"
    },
    "weightkg": 6.6,
    "prevo": "Cottonee",
    "evoLevel": 25,
    "eggGroups": [
      "Grass",
      "Fairy"
    ]
  },
  "petilil": {
    "num": 548,
    "name": "Petilil",
    "types": [
      "Grass",
      "Fairy"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 45,
      "atk": 35,
      "def": 55,
      "spe": 60,
      "spa": 85,
      "spd": 70
    },
    "abilities": {
      "0": "Harvest",
      "1": "Solar Rush"
    },
    "weightkg": 6.6,
    "evos": [
      "Lilligant"
    ],
    "eggGroups": [
      "Grass"
    ]
  },
  "lilligant": {
    "num": 549,
    "name": "Lilligant",
    "types": [
      "Fairy",
      "Grass"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 70,
      "atk": 50,
      "def": 80,
      "spe": 95,
      "spa": 115,
      "spd": 105
    },
    "abilities": {
      "0": "Serene Grace",
      "1": "Solar Rush"
    },
    "weightkg": 16.3,
    "prevo": "Petilil",
    "evoLevel": 25,
    "eggGroups": [
      "Grass"
    ]
  },
  "basculin": {
    "num": 550,
    "name": "Basculin",
    "types": [
      "Water",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 107,
      "def": 65,
      "spe": 118,
      "spa": 95,
      "spd": 65
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Instinct"
    },
    "weightkg": 18.0,
    "eggGroups": [
      "Water 2"
    ],
    "formes": [
      "Basculin",
      "Basculin-Blue-Striped"
    ]
  },
  "basculinbluestriped": {
    "num": 550,
    "name": "Basculin-Blue-Striped",
    "types": [
      "Water",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 107,
      "def": 65,
      "spe": 118,
      "spa": 95,
      "spd": 65
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Instinct"
    },
    "weightkg": 18.0,
    "eggGroups": [
      "Water 2"
    ],
    "baseSpecies": "Basculin",
    "forme": "Blue-Striped",
    "formes": [
      "Basculin",
      "Basculin-Blue-Striped"
    ]
  },
  "sandile": {
    "num": 551,
    "name": "Sandile",
    "types": [
      "Ground",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 93,
      "def": 50,
      "spe": 67,
      "spa": 35,
      "spd": 40
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Sand Rush"
    },
    "weightkg": 15.2,
    "evos": [
      "Krokorok"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "krokorok": {
    "num": 552,
    "name": "Krokorok",
    "types": [
      "Ground",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 113,
      "def": 70,
      "spe": 92,
      "spa": 45,
      "spd": 60
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Moxie"
    },
    "weightkg": 33.4,
    "prevo": "Sandile",
    "evoLevel": 20,
    "evos": [
      "Krookodile"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "krookodile": {
    "num": 553,
    "name": "Krookodile",
    "types": [
      "Ground",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 105,
      "atk": 138,
      "def": 95,
      "spe": 97,
      "spa": 55,
      "spd": 85
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Strong Jaw"
    },
    "weightkg": 96.3,
    "prevo": "Krokorok",
    "evoLevel": 40,
    "evoType": "levelHold",
    "evoItem": "Dark Gem",
    "eggGroups": [
      "Field"
    ]
  },
  "darumaka": {
    "num": 554,
    "name": "Darumaka",
    "types": [
      "Fire",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 90,
      "def": 65,
      "spe": 75,
      "spa": 15,
      "spd": 45
    },
    "abilities": {
      "0": "Hustle",
      "1": "Flash Fire"
    },
    "weightkg": 37.5,
    "evos": [
      "Darmanitan"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "darmanitan": {
    "num": 555,
    "name": "Darmanitan",
    "types": [
      "Fire",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 105,
      "atk": 150,
      "def": 70,
      "spe": 105,
      "spa": 30,
      "spd": 55
    },
    "abilities": {
      "0": "Hustle",
      "1": "Reckless"
    },
    "weightkg": 92.9,
    "prevo": "Darumaka",
    "evoLevel": 32,
    "eggGroups": [
      "Field"
    ],
    "formes": [
      "Darmanitan",
      "Darmanitan-Zen"
    ]
  },
  "darmanitanzen": {
    "num": 555,
    "name": "Darmanitan-Zen",
    "types": [
      "Fire",
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 105,
      "atk": 30,
      "def": 125,
      "spe": 10,
      "spa": 180,
      "spd": 165
    },
    "abilities": {
      "0": "Psychic Surge",
      "1": "Drought"
    },
    "weightkg": 92.9,
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Darmanitan",
    "forme": "Zen",
    "formes": [
      "Darmanitan",
      "Darmanitan-Zen"
    ],
    "requiredItems": [
      "Mega Stone I"
    ]
  },
  "maractus": {
    "num": 556,
    "name": "Maractus",
    "types": [
      "Ground",
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 86,
      "def": 107,
      "spe": 65,
      "spa": 110,
      "spd": 92
    },
    "abilities": {
      "0": "Solar Rush",
      "1": "Storm Drain"
    },
    "weightkg": 28.0,
    "eggGroups": [
      "Grass"
    ]
  },
  "dwebble": {
    "num": 557,
    "name": "Dwebble",
    "types": [
      "Bug",
      "Rock"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 65,
      "def": 95,
      "spe": 55,
      "spa": 35,
      "spd": 70
    },
    "abilities": {
      "0": "Tough Claws",
      "1": "Solid Rock"
    },
    "weightkg": 14.5,
    "evos": [
      "Crustle"
    ],
    "eggGroups": [
      "Bug",
      "Mineral"
    ]
  },
  "crustle": {
    "num": 558,
    "name": "Crustle",
    "types": [
      "Bug",
      "Rock"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 110,
      "def": 145,
      "spe": 45,
      "spa": 65,
      "spd": 80
    },
    "abilities": {
      "0": "Tough Claws",
      "1": "Sand Stream"
    },
    "weightkg": 200.0,
    "prevo": "Dwebble",
    "evoLevel": 32,
    "eggGroups": [
      "Bug",
      "Mineral"
    ]
  },
  "scraggy": {
    "num": 559,
    "name": "Scraggy",
    "types": [
      "Dark",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 77,
      "def": 75,
      "spe": 58,
      "spa": 35,
      "spd": 75
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Moxie"
    },
    "weightkg": 11.8,
    "evos": [
      "Scrafty"
    ],
    "eggGroups": [
      "Field",
      "Dragon"
    ]
  },
  "scrafty": {
    "num": 560,
    "name": "Scrafty",
    "types": [
      "Dark",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 107,
      "def": 115,
      "spe": 73,
      "spa": 45,
      "spd": 115
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Moxie"
    },
    "weightkg": 30.0,
    "prevo": "Scraggy",
    "evoLevel": 31,
    "eggGroups": [
      "Field",
      "Dragon"
    ]
  },
  "sigilyph": {
    "num": 561,
    "name": "Sigilyph",
    "types": [
      "Psychic",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 72,
      "atk": 43,
      "def": 80,
      "spe": 127,
      "spa": 133,
      "spd": 95
    },
    "abilities": {
      "0": "Magic Guard",
      "1": "Neuroforce"
    },
    "weightkg": 14.0,
    "eggGroups": [
      "Flying"
    ]
  },
  "yamask": {
    "num": 562,
    "name": "Yamask",
    "types": [
      "Ghost"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 48,
      "atk": 30,
      "def": 90,
      "spe": 30,
      "spa": 82,
      "spd": 90
    },
    "abilities": {
      "0": "Levitate",
      "1": "Sinister"
    },
    "weightkg": 1.5,
    "evos": [
      "Cofagrigus"
    ],
    "eggGroups": [
      "Mineral",
      "Amorphous"
    ]
  },
  "cofagrigus": {
    "num": 563,
    "name": "Cofagrigus",
    "types": [
      "Ghost",
      "Rock"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 88,
      "atk": 50,
      "def": 145,
      "spe": 30,
      "spa": 117,
      "spd": 105
    },
    "abilities": {
      "0": "Sand Stream",
      "1": "Sinister",
      "H": "Magic Guard"
    },
    "weightkg": 76.5,
    "prevo": "Yamask",
    "evoLevel": 32,
    "eggGroups": [
      "Mineral",
      "Amorphous"
    ]
  },
  "tirtouga": {
    "num": 564,
    "name": "Tirtouga",
    "types": [
      "Water",
      "Rock"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 54,
      "atk": 78,
      "def": 118,
      "spe": 22,
      "spa": 48,
      "spd": 80
    },
    "abilities": {
      "0": "Strong Jaw",
      "1": "Solid Rock"
    },
    "weightkg": 16.5,
    "evos": [
      "Carracosta"
    ],
    "eggGroups": [
      "Water 1",
      "Water 3"
    ]
  },
  "carracosta": {
    "num": 565,
    "name": "Carracosta",
    "types": [
      "Water",
      "Rock"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 84,
      "atk": 118,
      "def": 143,
      "spe": 32,
      "spa": 53,
      "spd": 120
    },
    "abilities": {
      "0": "Sheer Force",
      "1": "Bulletproof"
    },
    "weightkg": 81.0,
    "prevo": "Tirtouga",
    "evoLevel": 33,
    "eggGroups": [
      "Water 1",
      "Water 3"
    ]
  },
  "archen": {
    "num": 566,
    "name": "Archen",
    "types": [
      "Rock",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 55,
      "atk": 85,
      "def": 45,
      "spe": 99,
      "spa": 71,
      "spd": 45
    },
    "abilities": {
      "0": "Hustle",
      "1": "Unburden"
    },
    "weightkg": 9.5,
    "evos": [
      "Archeops"
    ],
    "eggGroups": [
      "Flying",
      "Water 3"
    ]
  },
  "archeops": {
    "num": 567,
    "name": "Archeops",
    "types": [
      "Rock",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 75,
      "atk": 120,
      "def": 65,
      "spe": 119,
      "spa": 106,
      "spd": 65
    },
    "abilities": {
      "0": "Hustle",
      "1": "Reckless"
    },
    "weightkg": 32.0,
    "prevo": "Archen",
    "evoLevel": 33,
    "eggGroups": [
      "Flying",
      "Water 3"
    ]
  },
  "trubbish": {
    "num": 568,
    "name": "Trubbish",
    "types": [
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 62,
      "atk": 60,
      "def": 72,
      "spe": 44,
      "spa": 60,
      "spd": 72
    },
    "abilities": {
      "0": "Weak Armor",
      "1": "Heatproof"
    },
    "weightkg": 31.0,
    "evos": [
      "Garbodor"
    ],
    "eggGroups": [
      "Mineral"
    ]
  },
  "garbodor": {
    "num": 569,
    "name": "Garbodor",
    "types": [
      "Poison",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 112,
      "atk": 95,
      "def": 102,
      "spe": 44,
      "spa": 95,
      "spd": 102
    },
    "abilities": {
      "0": "Heatproof",
      "1": "Weak Armor",
      "H": "Flare Boost"
    },
    "weightkg": 107.3,
    "prevo": "Trubbish",
    "evoLevel": 33,
    "eggGroups": [
      "Mineral"
    ]
  },
  "zorua": {
    "num": 570,
    "name": "Zorua",
    "types": [
      "Dark"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 50,
      "atk": 65,
      "def": 40,
      "spe": 90,
      "spa": 85,
      "spd": 40
    },
    "abilities": {
      "0": "Illusion",
      "1": "Prankster"
    },
    "weightkg": 12.5,
    "evos": [
      "Zoroark"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "zoroark": {
    "num": 571,
    "name": "Zoroark",
    "types": [
      "Dark"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 75,
      "atk": 115,
      "def": 60,
      "spe": 115,
      "spa": 125,
      "spd": 60
    },
    "abilities": {
      "0": "Illusion",
      "1": "Dark Aura"
    },
    "weightkg": 81.1,
    "prevo": "Zorua",
    "evoLevel": 25,
    "eggGroups": [
      "Field"
    ]
  },
  "minccino": {
    "num": 572,
    "name": "Minccino",
    "types": [
      "Normal",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 50,
      "atk": 60,
      "def": 50,
      "spe": 95,
      "spa": 60,
      "spd": 55
    },
    "abilities": {
      "0": "Technician",
      "1": "Wimp Out"
    },
    "weightkg": 5.8,
    "evos": [
      "Cinccino"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "cinccino": {
    "num": 573,
    "name": "Cinccino",
    "types": [
      "Normal",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 65,
      "atk": 95,
      "def": 65,
      "spe": 115,
      "spa": 95,
      "spd": 80
    },
    "abilities": {
      "0": "Technician",
      "1": "Skill Link"
    },
    "weightkg": 7.5,
    "prevo": "Minccino",
    "evoLevel": 22,
    "eggGroups": [
      "Field"
    ]
  },
  "gothita": {
    "num": 574,
    "name": "Gothita",
    "types": [
      "Fairy",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 45,
      "atk": 30,
      "def": 50,
      "spe": 45,
      "spa": 75,
      "spd": 80
    },
    "abilities": {
      "0": "Psychic Surge",
      "1": "Magic Bounce",
      "H": "Magic Guard"
    },
    "weightkg": 5.8,
    "evos": [
      "Gothorita"
    ],
    "eggGroups": [
      "Human-Like"
    ]
  },
  "gothorita": {
    "num": 575,
    "name": "Gothorita",
    "types": [
      "Fairy",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 60,
      "atk": 45,
      "def": 70,
      "spe": 55,
      "spa": 95,
      "spd": 100
    },
    "abilities": {
      "0": "Psychic Surge",
      "1": "Magic Bounce",
      "H": "Magic Guard"
    },
    "weightkg": 18.0,
    "prevo": "Gothita",
    "evoLevel": 18,
    "evos": [
      "Gothitelle"
    ],
    "eggGroups": [
      "Human-Like"
    ]
  },
  "gothitelle": {
    "num": 576,
    "name": "Gothitelle",
    "types": [
      "Fairy",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 80,
      "atk": 55,
      "def": 95,
      "spe": 65,
      "spa": 125,
      "spd": 130
    },
    "abilities": {
      "0": "Psychic Surge",
      "1": "Magic Bounce",
      "H": "Magic Guard"
    },
    "weightkg": 44.0,
    "prevo": "Gothorita",
    "evoLevel": 32,
    "eggGroups": [
      "Human-Like"
    ]
  },
  "solosis": {
    "num": 577,
    "name": "Solosis",
    "types": [
      "Psychic",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 30,
      "def": 40,
      "spe": 20,
      "spa": 105,
      "spd": 60
    },
    "abilities": {
      "0": "Regenerator",
      "1": "Liquid Veil",
      "H": "Water Absorb"
    },
    "weightkg": 1.0,
    "evos": [
      "Duosion"
    ],
    "eggGroups": [
      "Amorphous"
    ]
  },
  "duosion": {
    "num": 578,
    "name": "Duosion",
    "types": [
      "Psychic",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 40,
      "def": 70,
      "spe": 20,
      "spa": 115,
      "spd": 90
    },
    "abilities": {
      "0": "Regenerator",
      "1": "Liquid Veil",
      "H": "Water Absorb"
    },
    "weightkg": 8.0,
    "prevo": "Solosis",
    "evoLevel": 18,
    "evos": [
      "Reuniclus"
    ],
    "eggGroups": [
      "Amorphous"
    ]
  },
  "reuniclus": {
    "num": 579,
    "name": "Reuniclus",
    "types": [
      "Psychic",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 110,
      "atk": 115,
      "def": 80,
      "spe": 20,
      "spa": 125,
      "spd": 100
    },
    "abilities": {
      "0": "Regenerator",
      "1": "Liquid Veil",
      "H": "Water Absorb"
    },
    "weightkg": 20.1,
    "prevo": "Duosion",
    "evoLevel": 33,
    "eggGroups": [
      "Amorphous"
    ]
  },
  "ducklett": {
    "num": 580,
    "name": "Ducklett",
    "types": [
      "Water",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 55,
      "atk": 58,
      "def": 53,
      "spe": 83,
      "spa": 68,
      "spd": 53
    },
    "abilities": {
      "0": "Unaware",
      "1": "Sap Sipper"
    },
    "weightkg": 5.5,
    "evos": [
      "Swanna"
    ],
    "eggGroups": [
      "Water 1",
      "Flying"
    ]
  },
  "swanna": {
    "num": 581,
    "name": "Swanna",
    "types": [
      "Water",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 98,
      "def": 73,
      "spe": 108,
      "spa": 108,
      "spd": 73
    },
    "abilities": {
      "0": "Serene Grace",
      "1": "Stamina"
    },
    "weightkg": 24.2,
    "prevo": "Ducklett",
    "evoLevel": 24,
    "eggGroups": [
      "Water 1",
      "Flying"
    ]
  },
  "vanillite": {
    "num": 582,
    "name": "Vanillite",
    "types": [
      "Ice"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 41,
      "atk": 30,
      "def": 50,
      "spe": 74,
      "spa": 75,
      "spd": 60
    },
    "abilities": {
      "0": "Weak Armor",
      "1": "Water Absorb"
    },
    "weightkg": 5.7,
    "evos": [
      "Vanillish"
    ],
    "eggGroups": [
      "Mineral"
    ]
  },
  "vanillish": {
    "num": 583,
    "name": "Vanillish",
    "types": [
      "Ice"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 61,
      "atk": 40,
      "def": 75,
      "spe": 84,
      "spa": 95,
      "spd": 85
    },
    "abilities": {
      "0": "Weak Armor",
      "1": "Water Absorb"
    },
    "weightkg": 41.0,
    "prevo": "Vanillite",
    "evoLevel": 19,
    "evos": [
      "Vanilluxe"
    ],
    "eggGroups": [
      "Mineral"
    ]
  },
  "vanilluxe": {
    "num": 584,
    "name": "Vanilluxe",
    "types": [
      "Ice"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 81,
      "atk": 50,
      "def": 90,
      "spe": 94,
      "spa": 125,
      "spd": 110
    },
    "abilities": {
      "0": "Weak Armor",
      "1": "Water Absorb",
      "H": "Snow Warning"
    },
    "weightkg": 57.5,
    "prevo": "Vanillish",
    "evoLevel": 31,
    "eggGroups": [
      "Mineral"
    ]
  },
  "deerling": {
    "num": 585,
    "name": "Deerling",
    "types": [
      "Grass",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 70,
      "def": 50,
      "spe": 100,
      "spa": 40,
      "spd": 50
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Versatility"
    },
    "weightkg": 19.5,
    "evos": [
      "Sawsbuck"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "sawsbuck": {
    "num": 586,
    "name": "Sawsbuck",
    "types": [
      "Grass",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 95,
      "atk": 110,
      "def": 80,
      "spe": 110,
      "spa": 60,
      "spd": 80
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Versatility"
    },
    "weightkg": 92.5,
    "prevo": "Deerling",
    "evoLevel": 29,
    "eggGroups": [
      "Field"
    ]
  },
  "emolga": {
    "num": 587,
    "name": "Emolga",
    "types": [
      "Flying",
      "Electric"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 60,
      "def": 60,
      "spe": 138,
      "spa": 107,
      "spd": 90
    },
    "abilities": {
      "0": "Galvanize",
      "1": "Lightning Rod"
    },
    "weightkg": 5.0,
    "eggGroups": [
      "Field"
    ]
  },
  "karrablast": {
    "num": 588,
    "name": "Karrablast",
    "types": [
      "Bug"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 85,
      "def": 65,
      "spe": 85,
      "spa": 30,
      "spd": 55
    },
    "abilities": {
      "0": "Hustle",
      "1": "Unburden"
    },
    "weightkg": 5.9,
    "evos": [
      "Escavalier"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "escavalier": {
    "num": 589,
    "name": "Escavalier",
    "types": [
      "Bug",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 135,
      "def": 125,
      "spe": 60,
      "spa": 40,
      "spd": 105
    },
    "abilities": {
      "0": "Shell Armor",
      "1": "Unburden"
    },
    "weightkg": 33.0,
    "prevo": "Karrablast",
    "evoLevel": 32,
    "evoType": "levelHold",
    "evoItem": "Steel Gem",
    "eggGroups": [
      "Bug"
    ]
  },
  "foongus": {
    "num": 590,
    "name": "Foongus",
    "types": [
      "Grass",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 49,
      "atk": 55,
      "def": 75,
      "spe": 15,
      "spa": 65,
      "spd": 91
    },
    "abilities": {
      "0": "Regenerator",
      "1": "Unaware"
    },
    "weightkg": 1.0,
    "evos": [
      "Amoonguss"
    ],
    "eggGroups": [
      "Grass"
    ]
  },
  "amoonguss": {
    "num": 591,
    "name": "Amoonguss",
    "types": [
      "Grass",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 99,
      "atk": 85,
      "def": 95,
      "spe": 30,
      "spa": 95,
      "spd": 111
    },
    "abilities": {
      "0": "Regenerator",
      "1": "Unaware"
    },
    "weightkg": 10.5,
    "prevo": "Foongus",
    "evoLevel": 25,
    "eggGroups": [
      "Grass"
    ]
  },
  "frillish": {
    "num": 592,
    "name": "Frillish",
    "types": [
      "Water",
      "Ghost"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 40,
      "def": 60,
      "spe": 40,
      "spa": 90,
      "spd": 120
    },
    "abilities": {
      "0": "Sinister",
      "1": "Regenerator",
      "H": "Shadow Tag"
    },
    "weightkg": 33.0,
    "evos": [
      "Jellicent"
    ],
    "eggGroups": [
      "Amorphous"
    ]
  },
  "jellicent": {
    "num": 593,
    "name": "Jellicent",
    "types": [
      "Water",
      "Ghost"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 120,
      "atk": 45,
      "def": 80,
      "spe": 45,
      "spa": 110,
      "spd": 135
    },
    "abilities": {
      "0": "Sinister",
      "1": "Regenerator",
      "H": "Shadow Tag"
    },
    "weightkg": 135.0,
    "prevo": "Frillish",
    "evoLevel": 35,
    "eggGroups": [
      "Amorphous"
    ]
  },
  "alomomola": {
    "num": 594,
    "name": "Alomomola",
    "types": [
      "Water",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 155,
      "atk": 38,
      "def": 80,
      "spe": 62,
      "spa": 75,
      "spd": 125
    },
    "abilities": {
      "0": "Regenerator",
      "1": "Magic Bounce",
      "H": "Friend Guard"
    },
    "weightkg": 31.6,
    "prevo": "Luvdisc",
    "evoLevel": 35,
    "evoType": "levelHold",
    "evoItem": "Water Gem",
    "eggGroups": [
      "Water 1",
      "Water 2"
    ]
  },
  "joltik": {
    "num": 595,
    "name": "Joltik",
    "types": [
      "Bug",
      "Electric"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 20,
      "atk": 37,
      "def": 50,
      "spe": 101,
      "spa": 92,
      "spd": 50
    },
    "abilities": {
      "0": "Lightning Rod",
      "1": "Unnerve",
      "H": "Tinted Lens"
    },
    "weightkg": 0.6,
    "evos": [
      "Galvantula"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "galvantula": {
    "num": 596,
    "name": "Galvantula",
    "types": [
      "Bug",
      "Electric"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 97,
      "def": 60,
      "spe": 121,
      "spa": 117,
      "spd": 60
    },
    "abilities": {
      "0": "Electric Surge",
      "1": "Intimidate",
      "H": "Tinted Lens"
    },
    "weightkg": 14.3,
    "prevo": "Joltik",
    "evoLevel": 26,
    "eggGroups": [
      "Bug"
    ]
  },
  "ferroseed": {
    "num": 597,
    "name": "Ferroseed",
    "types": [
      "Grass",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 44,
      "atk": 64,
      "def": 114,
      "spe": 10,
      "spa": 24,
      "spd": 94
    },
    "abilities": {
      "0": "Iron Barbs",
      "1": "Sturdy"
    },
    "weightkg": 18.8,
    "evos": [
      "Ferrothorn"
    ],
    "eggGroups": [
      "Grass",
      "Mineral"
    ]
  },
  "ferrothorn": {
    "num": 598,
    "name": "Ferrothorn",
    "types": [
      "Grass",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 74,
      "atk": 109,
      "def": 144,
      "spe": 20,
      "spa": 54,
      "spd": 124
    },
    "abilities": {
      "0": "Iron Barbs",
      "1": "Skill Link"
    },
    "weightkg": 110.0,
    "prevo": "Ferroseed",
    "evoLevel": 35,
    "eggGroups": [
      "Grass",
      "Mineral"
    ]
  },
  "klink": {
    "num": 599,
    "name": "Klink",
    "types": [
      "Steel"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 40,
      "atk": 60,
      "def": 90,
      "spe": 25,
      "spa": 60,
      "spd": 60
    },
    "abilities": {
      "0": "Levitate",
      "1": "Technician"
    },
    "weightkg": 21.0,
    "evos": [
      "Klang"
    ],
    "eggGroups": [
      "Mineral"
    ]
  },
  "klang": {
    "num": 600,
    "name": "Klang",
    "types": [
      "Steel"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 60,
      "atk": 80,
      "def": 100,
      "spe": 50,
      "spa": 80,
      "spd": 85
    },
    "abilities": {
      "0": "Levitate",
      "1": "Technician"
    },
    "weightkg": 51.0,
    "prevo": "Klink",
    "evoLevel": 20,
    "evos": [
      "Klinklang"
    ],
    "eggGroups": [
      "Mineral"
    ]
  },
  "klinklang": {
    "num": 601,
    "name": "Klinklang",
    "types": [
      "Steel"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 80,
      "atk": 100,
      "def": 120,
      "spe": 75,
      "spa": 100,
      "spd": 100
    },
    "abilities": {
      "0": "Levitate",
      "1": "Technician"
    },
    "weightkg": 81.0,
    "prevo": "Klang",
    "evoLevel": 40,
    "evoType": "levelHold",
    "evoItem": "Steel Gem",
    "eggGroups": [
      "Mineral"
    ]
  },
  "tynamo": {
    "num": 602,
    "name": "Tynamo",
    "types": [
      "Electric"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 35,
      "atk": 34,
      "def": 40,
      "spe": 93,
      "spa": 79,
      "spd": 79
    },
    "abilities": {
      "0": "Levitate",
      "1": "Liquid Veil",
      "H": "Volt Rush"
    },
    "weightkg": 0.3,
    "evos": [
      "Eelektrik"
    ],
    "eggGroups": [
      "Amorphous"
    ]
  },
  "eelektrik": {
    "num": 603,
    "name": "Eelektrik",
    "types": [
      "Electric",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 94,
      "def": 70,
      "spe": 53,
      "spa": 94,
      "spd": 94
    },
    "abilities": {
      "0": "Levitate",
      "1": "Liquid Veil",
      "H": "Volt Rush"
    },
    "weightkg": 22.0,
    "prevo": "Tynamo",
    "evoLevel": 25,
    "evos": [
      "Eelektross"
    ],
    "eggGroups": [
      "Amorphous"
    ]
  },
  "eelektross": {
    "num": 604,
    "name": "Eelektross",
    "types": [
      "Electric",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 100,
      "atk": 119,
      "def": 80,
      "spe": 63,
      "spa": 119,
      "spd": 119
    },
    "abilities": {
      "0": "Levitate",
      "1": "Liquid Veil",
      "H": "Volt Rush"
    },
    "weightkg": 80.5,
    "prevo": "Eelektrik",
    "evoLevel": 45,
    "evoType": "levelHold",
    "evoItem": "Electric Gem",
    "eggGroups": [
      "Amorphous"
    ]
  },
  "elgyem": {
    "num": 605,
    "name": "Elgyem",
    "types": [
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 55,
      "atk": 30,
      "def": 85,
      "spe": 30,
      "spa": 115,
      "spd": 105
    },
    "abilities": {
      "0": "Analytic",
      "1": "Neuroforce",
      "H": "Tinted Lens"
    },
    "weightkg": 9.0,
    "evos": [
      "Beheeyem"
    ],
    "eggGroups": [
      "Human-Like"
    ]
  },
  "beheeyem": {
    "num": 606,
    "name": "Beheeyem",
    "types": [
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 50,
      "def": 105,
      "spe": 30,
      "spa": 150,
      "spd": 140
    },
    "abilities": {
      "0": "Analytic",
      "1": "Neuroforce",
      "H": "Interstellar"
    },
    "weightkg": 34.5,
    "prevo": "Elgyem",
    "evoLevel": 33,
    "eggGroups": [
      "Human-Like"
    ]
  },
  "litwick": {
    "num": 607,
    "name": "Litwick",
    "types": [
      "Ghost",
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 30,
      "def": 55,
      "spe": 20,
      "spa": 95,
      "spd": 90
    },
    "abilities": {
      "0": "Cursed Body",
      "1": "Flash Fire",
      "H": "Dazzling"
    },
    "weightkg": 3.1,
    "evos": [
      "Lampent"
    ],
    "eggGroups": [
      "Amorphous"
    ]
  },
  "lampent": {
    "num": 608,
    "name": "Lampent",
    "types": [
      "Ghost",
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 40,
      "def": 60,
      "spe": 75,
      "spa": 115,
      "spd": 95
    },
    "abilities": {
      "0": "Levitate",
      "1": "Flash Fire",
      "H": "Dazzling"
    },
    "weightkg": 13.0,
    "prevo": "Litwick",
    "evoLevel": 20,
    "evos": [
      "Chandelure"
    ],
    "eggGroups": [
      "Amorphous"
    ]
  },
  "chandelure": {
    "num": 609,
    "name": "Chandelure",
    "types": [
      "Ghost",
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 55,
      "def": 90,
      "spe": 85,
      "spa": 145,
      "spd": 125
    },
    "abilities": {
      "0": "Levitate",
      "1": "Weak Armor",
      "H": "Dazzling"
    },
    "weightkg": 34.3,
    "prevo": "Lampent",
    "evoLevel": 40,
    "evoType": "levelHold",
    "evoItem": "Ghost Gem",
    "eggGroups": [
      "Amorphous"
    ]
  },
  "axew": {
    "num": 610,
    "name": "Axew",
    "types": [
      "Dragon",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 47,
      "atk": 87,
      "def": 77,
      "spe": 67,
      "spa": 35,
      "spd": 47
    },
    "abilities": {
      "0": "Hustle",
      "1": "Defiant",
      "H": "Scrappy"
    },
    "weightkg": 18.0,
    "evos": [
      "Fraxure"
    ],
    "eggGroups": [
      "Monster",
      "Dragon"
    ]
  },
  "fraxure": {
    "num": 611,
    "name": "Fraxure",
    "types": [
      "Dragon",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 77,
      "atk": 117,
      "def": 97,
      "spe": 77,
      "spa": 45,
      "spd": 67
    },
    "abilities": {
      "0": "Hustle",
      "1": "Intimidate",
      "H": "Scrappy"
    },
    "weightkg": 36.0,
    "prevo": "Axew",
    "evoLevel": 25,
    "evos": [
      "Haxorus"
    ],
    "eggGroups": [
      "Monster",
      "Dragon"
    ]
  },
  "haxorus": {
    "num": 612,
    "name": "Haxorus",
    "types": [
      "Dragon",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 107,
      "atk": 147,
      "def": 107,
      "spe": 97,
      "spa": 65,
      "spd": 77
    },
    "abilities": {
      "0": "Ruthless",
      "1": "Intimidate",
      "H": "Scrappy"
    },
    "weightkg": 105.5,
    "prevo": "Fraxure",
    "evoLevel": 45,
    "evoType": "levelHold",
    "evoItem": "Dragon Gem",
    "eggGroups": [
      "Monster",
      "Dragon"
    ]
  },
  "cubchoo": {
    "num": 613,
    "name": "Cubchoo",
    "types": [
      "Ice",
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 62,
      "atk": 75,
      "def": 65,
      "spe": 53,
      "spa": 50,
      "spd": 65
    },
    "abilities": {
      "0": "Slush Rush",
      "1": "Hustle"
    },
    "weightkg": 8.5,
    "evos": [
      "Beartic"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "beartic": {
    "num": 614,
    "name": "Beartic",
    "types": [
      "Ice",
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 102,
      "atk": 135,
      "def": 80,
      "spe": 83,
      "spa": 55,
      "spd": 80
    },
    "abilities": {
      "0": "Slush Rush",
      "1": "Intimidate"
    },
    "weightkg": 260.0,
    "prevo": "Cubchoo",
    "evoLevel": 29,
    "eggGroups": [
      "Field"
    ]
  },
  "cryogonal": {
    "num": 615,
    "name": "Cryogonal",
    "types": [
      "Ice",
      "Flying"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 80,
      "atk": 40,
      "def": 60,
      "spe": 110,
      "spa": 125,
      "spd": 135
    },
    "abilities": {
      "0": "Energy Shield",
      "1": "Regenerator"
    },
    "weightkg": 148.0,
    "eggGroups": [
      "Mineral"
    ]
  },
  "shelmet": {
    "num": 616,
    "name": "Shelmet",
    "types": [
      "Bug",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 40,
      "def": 110,
      "spe": 25,
      "spa": 55,
      "spd": 90
    },
    "abilities": {
      "0": "Dry Skin",
      "1": "Shell Armor"
    },
    "weightkg": 7.7,
    "evos": [
      "Accelgor"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "accelgor": {
    "num": 617,
    "name": "Accelgor",
    "types": [
      "Bug",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 95,
      "def": 40,
      "spe": 165,
      "spa": 105,
      "spd": 60
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Versatility"
    },
    "weightkg": 25.3,
    "prevo": "Shelmet",
    "evoLevel": 32,
    "evoType": "levelHold",
    "evoItem": "Dark Gem",
    "eggGroups": [
      "Bug"
    ]
  },
  "stunfisk": {
    "num": 618,
    "name": "Stunfisk",
    "types": [
      "Ground",
      "Electric"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 89,
      "atk": 65,
      "def": 119,
      "spe": 32,
      "spa": 101,
      "spd": 119
    },
    "abilities": {
      "0": "Electric Surge",
      "1": "Water Absorb"
    },
    "weightkg": 11.0,
    "eggGroups": [
      "Water 1",
      "Amorphous"
    ]
  },
  "mienfoo": {
    "num": 619,
    "name": "Mienfoo",
    "types": [
      "Fighting",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 85,
      "def": 45,
      "spe": 95,
      "spa": 55,
      "spd": 45
    },
    "abilities": {
      "0": "Proficiency",
      "1": "Technician",
      "H": "Regenerator"
    },
    "weightkg": 20.0,
    "evos": [
      "Mienshao"
    ],
    "eggGroups": [
      "Field",
      "Human-Like"
    ]
  },
  "mienshao": {
    "num": 620,
    "name": "Mienshao",
    "types": [
      "Fighting",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 125,
      "def": 60,
      "spe": 115,
      "spa": 95,
      "spd": 60
    },
    "abilities": {
      "0": "Proficiency",
      "1": "Technician",
      "H": "Regenerator"
    },
    "weightkg": 35.5,
    "prevo": "Mienfoo",
    "evoLevel": 26,
    "eggGroups": [
      "Field",
      "Human-Like"
    ]
  },
  "druddigon": {
    "num": 621,
    "name": "Druddigon",
    "types": [
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 107,
      "atk": 130,
      "def": 115,
      "spe": 73,
      "spa": 60,
      "spd": 90
    },
    "abilities": {
      "0": "Multiscale",
      "1": "Tough Claws"
    },
    "weightkg": 139.0,
    "eggGroups": [
      "Dragon",
      "Monster"
    ]
  },
  "golett": {
    "num": 622,
    "name": "Golett",
    "types": [
      "Ground",
      "Ghost"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 69,
      "atk": 101,
      "def": 100,
      "spe": 35,
      "spa": 35,
      "spd": 90
    },
    "abilities": {
      "0": "Energy Shield",
      "1": "Weak Armor"
    },
    "weightkg": 92.0,
    "evos": [
      "Golurk"
    ],
    "eggGroups": [
      "Mineral"
    ]
  },
  "golurk": {
    "num": 623,
    "name": "Golurk",
    "types": [
      "Ground",
      "Ghost"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 129,
      "atk": 151,
      "def": 110,
      "spe": 55,
      "spa": 55,
      "spd": 100
    },
    "abilities": {
      "0": "Energy Shield",
      "1": "Weak Armor"
    },
    "weightkg": 330.0,
    "prevo": "Golett",
    "evoLevel": 40,
    "eggGroups": [
      "Mineral"
    ]
  },
  "pawniard": {
    "num": 624,
    "name": "Pawniard",
    "types": [
      "Dark",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 95,
      "def": 80,
      "spe": 75,
      "spa": 35,
      "spd": 40
    },
    "abilities": {
      "0": "Moxie",
      "1": "Defiant"
    },
    "weightkg": 10.2,
    "evos": [
      "Bisharp"
    ],
    "eggGroups": [
      "Human-Like"
    ]
  },
  "bisharp": {
    "num": 625,
    "name": "Bisharp",
    "types": [
      "Dark",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 130,
      "def": 110,
      "spe": 100,
      "spa": 55,
      "spd": 70
    },
    "abilities": {
      "0": "Moxie",
      "1": "Ruthless"
    },
    "weightkg": 70.0,
    "prevo": "Pawniard",
    "evoLevel": 29,
    "eggGroups": [
      "Human-Like"
    ]
  },
  "bouffalant": {
    "num": 626,
    "name": "Bouffalant",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 95,
      "atk": 150,
      "def": 95,
      "spe": 80,
      "spa": 35,
      "spd": 95
    },
    "abilities": {
      "0": "Headstrong",
      "1": "Fluffy"
    },
    "weightkg": 94.6,
    "eggGroups": [
      "Field"
    ]
  },
  "rufflet": {
    "num": 627,
    "name": "Rufflet",
    "types": [
      "Flying",
      "Normal"
    ],
    "gender": "M",
    "baseStats": {
      "hp": 50,
      "atk": 83,
      "def": 60,
      "spe": 80,
      "spa": 37,
      "spd": 60
    },
    "abilities": {
      "0": "Hustle",
      "1": "Defiant",
      "H": "Scrappy"
    },
    "weightkg": 10.5,
    "evos": [
      "Braviary"
    ],
    "eggGroups": [
      "Flying"
    ]
  },
  "braviary": {
    "num": 628,
    "name": "Braviary",
    "types": [
      "Flying",
      "Fighting"
    ],
    "gender": "M",
    "baseStats": {
      "hp": 100,
      "atk": 123,
      "def": 75,
      "spe": 105,
      "spa": 57,
      "spd": 75
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Sheer Force",
      "H": "Scrappy"
    },
    "weightkg": 41.0,
    "prevo": "Rufflet",
    "evoLevel": 32,
    "eggGroups": [
      "Flying"
    ]
  },
  "vullaby": {
    "num": 629,
    "name": "Vullaby",
    "types": [
      "Dark",
      "Flying"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 50,
      "atk": 55,
      "def": 85,
      "spe": 50,
      "spa": 45,
      "spd": 85
    },
    "abilities": {
      "0": "Sinister",
      "1": "Prankster"
    },
    "weightkg": 9.0,
    "evos": [
      "Mandibuzz"
    ],
    "eggGroups": [
      "Flying"
    ]
  },
  "mandibuzz": {
    "num": 630,
    "name": "Mandibuzz",
    "types": [
      "Dark",
      "Flying"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 100,
      "atk": 90,
      "def": 105,
      "spe": 80,
      "spa": 55,
      "spd": 105
    },
    "abilities": {
      "0": "Sinister",
      "1": "Intimidate"
    },
    "weightkg": 39.5,
    "prevo": "Vullaby",
    "evoLevel": 32,
    "eggGroups": [
      "Flying"
    ]
  },
  "heatmor": {
    "num": 631,
    "name": "Heatmor",
    "types": [
      "Fire",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 85,
      "atk": 97,
      "def": 101,
      "spe": 35,
      "spa": 116,
      "spd": 101
    },
    "abilities": {
      "0": "Tough Claws",
      "1": "Flash Fire"
    },
    "weightkg": 58.0,
    "eggGroups": [
      "Field"
    ]
  },
  "durant": {
    "num": 632,
    "name": "Durant",
    "types": [
      "Bug",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 63,
      "atk": 113,
      "def": 133,
      "spe": 113,
      "spa": 50,
      "spd": 63
    },
    "abilities": {
      "0": "Hustle",
      "1": "Strong Jaw"
    },
    "weightkg": 33.0,
    "eggGroups": [
      "Bug"
    ]
  },
  "deino": {
    "num": 633,
    "name": "Deino",
    "types": [
      "Dark",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 52,
      "atk": 75,
      "def": 55,
      "spe": 53,
      "spa": 70,
      "spd": 55
    },
    "abilities": {
      "0": "Hustle",
      "1": "Berserk"
    },
    "weightkg": 17.3,
    "evos": [
      "Zweilous"
    ],
    "eggGroups": [
      "Dragon"
    ]
  },
  "zweilous": {
    "num": 634,
    "name": "Zweilous",
    "types": [
      "Dark",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 77,
      "atk": 100,
      "def": 70,
      "spe": 68,
      "spa": 95,
      "spd": 70
    },
    "abilities": {
      "0": "Hustle",
      "1": "Berserk"
    },
    "weightkg": 50.0,
    "prevo": "Deino",
    "evoLevel": 25,
    "evos": [
      "Hydreigon"
    ],
    "eggGroups": [
      "Dragon"
    ]
  },
  "hydreigon": {
    "num": 635,
    "name": "Hydreigon",
    "types": [
      "Dark",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 97,
      "atk": 120,
      "def": 75,
      "spe": 108,
      "spa": 125,
      "spd": 75
    },
    "abilities": {
      "0": "Levitate",
      "1": "Sheer Force"
    },
    "weightkg": 160.0,
    "prevo": "Zweilous",
    "evoLevel": 45,
    "evoType": "levelHold",
    "evoItem": "Dragon Gem",
    "eggGroups": [
      "Dragon"
    ]
  },
  "larvesta": {
    "num": 636,
    "name": "Larvesta",
    "types": [
      "Bug",
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 55,
      "atk": 40,
      "def": 65,
      "spe": 70,
      "spa": 95,
      "spd": 85
    },
    "abilities": {
      "0": "Flash Fire",
      "1": "Solar Rush"
    },
    "weightkg": 28.8,
    "evos": [
      "Volcarona"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "volcarona": {
    "num": 637,
    "name": "Volcarona",
    "types": [
      "Bug",
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 90,
      "atk": 60,
      "def": 75,
      "spe": 100,
      "spa": 135,
      "spd": 115
    },
    "abilities": {
      "0": "Levitate",
      "1": "Solar Rush"
    },
    "weightkg": 46.0,
    "prevo": "Larvesta",
    "evoLevel": 35,
    "eggGroups": [
      "Bug"
    ]
  },
  "cobalion": {
    "num": 638,
    "name": "Cobalion",
    "types": [
      "Steel",
      "Fighting"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 91,
      "atk": 120,
      "def": 119,
      "spe": 118,
      "spa": 70,
      "spd": 82
    },
    "abilities": {
      "0": "Proficiency",
      "1": "Intimidate"
    },
    "weightkg": 250.0,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "terrakion": {
    "num": 639,
    "name": "Terrakion",
    "types": [
      "Rock",
      "Fighting"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 101,
      "atk": 139,
      "def": 110,
      "spe": 108,
      "spa": 62,
      "spd": 80
    },
    "abilities": {
      "0": "Proficiency",
      "1": "Headstrong"
    },
    "weightkg": 260.0,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "virizion": {
    "num": 640,
    "name": "Virizion",
    "types": [
      "Grass",
      "Fighting"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 91,
      "atk": 120,
      "def": 77,
      "spe": 128,
      "spa": 70,
      "spd": 114
    },
    "abilities": {
      "0": "Proficiency",
      "1": "Grassy Surge"
    },
    "weightkg": 200.0,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "tornadus": {
    "num": 641,
    "name": "Tornadus",
    "types": [
      "Flying"
    ],
    "gender": "M",
    "baseStats": {
      "hp": 79,
      "atk": 115,
      "def": 75,
      "spe": 131,
      "spa": 125,
      "spd": 75
    },
    "abilities": {
      "0": "Proficiency",
      "1": "Aerilate"
    },
    "weightkg": 63.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "formes": [
      "Tornadus",
      "Tornadus-Therian"
    ]
  },
  "tornadustherian": {
    "num": 641,
    "name": "Tornadus-Therian",
    "types": [
      "Flying"
    ],
    "gender": "M",
    "baseStats": {
      "hp": 79,
      "atk": 95,
      "def": 95,
      "spe": 121,
      "spa": 115,
      "spd": 95
    },
    "abilities": {
      "0": "Regenerator",
      "1": "Aerilate"
    },
    "weightkg": 63.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Tornadus",
    "forme": "Therian",
    "formes": [
      "Tornadus",
      "Tornadus-Therian"
    ]
  },
  "thundurus": {
    "num": 642,
    "name": "Thundurus",
    "types": [
      "Electric",
      "Flying"
    ],
    "gender": "M",
    "baseStats": {
      "hp": 79,
      "atk": 125,
      "def": 75,
      "spe": 121,
      "spa": 125,
      "spd": 75
    },
    "abilities": {
      "0": "Proficiency",
      "1": "Aerilate"
    },
    "weightkg": 61.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "formes": [
      "Thundurus",
      "Thundurus-Therian"
    ]
  },
  "thundurustherian": {
    "num": 642,
    "name": "Thundurus-Therian",
    "types": [
      "Electric",
      "Flying"
    ],
    "gender": "M",
    "baseStats": {
      "hp": 79,
      "atk": 115,
      "def": 75,
      "spe": 111,
      "spa": 145,
      "spd": 75
    },
    "abilities": {
      "0": "Tough Claws",
      "1": "Aerilate"
    },
    "weightkg": 61.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Thundurus",
    "forme": "Therian",
    "formes": [
      "Thundurus",
      "Thundurus-Therian"
    ]
  },
  "reshiram": {
    "num": 643,
    "name": "Reshiram",
    "types": [
      "Dragon",
      "Fire"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 125,
      "atk": 120,
      "def": 110,
      "spe": 95,
      "spa": 175,
      "spd": 125
    },
    "abilities": {
      "0": "Sweltering Sun"
    },
    "weightkg": 330.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "unusable": true
  },
  "zekrom": {
    "num": 644,
    "name": "Zekrom",
    "types": [
      "Dragon",
      "Electric"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 125,
      "atk": 175,
      "def": 125,
      "spe": 95,
      "spa": 120,
      "spd": 110
    },
    "abilities": {
      "0": "Electric Surge"
    },
    "weightkg": 345.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "unusable": true
  },
  "landorus": {
    "num": 645,
    "name": "Landorus",
    "types": [
      "Ground",
      "Flying"
    ],
    "gender": "M",
    "baseStats": {
      "hp": 89,
      "atk": 125,
      "def": 80,
      "spe": 111,
      "spa": 115,
      "spd": 80
    },
    "abilities": {
      "0": "Sheer Force",
      "1": "Aerilate"
    },
    "weightkg": 68.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "formes": [
      "Landorus",
      "Landorus-Therian"
    ]
  },
  "landorustherian": {
    "num": 645,
    "name": "Landorus-Therian",
    "types": [
      "Ground",
      "Flying"
    ],
    "gender": "M",
    "baseStats": {
      "hp": 89,
      "atk": 145,
      "def": 90,
      "spe": 91,
      "spa": 95,
      "spd": 90
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Aerilate"
    },
    "weightkg": 68.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Landorus",
    "forme": "Therian",
    "formes": [
      "Landorus",
      "Landorus-Therian"
    ]
  },
  "kyurem": {
    "num": 646,
    "name": "Kyurem",
    "types": [
      "Ice",
      "Dragon"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 125,
      "atk": 120,
      "def": 90,
      "spe": 95,
      "spa": 140,
      "spd": 90
    },
    "abilities": {
      "0": "Refrigerate",
      "1": "Slush Rush"
    },
    "weightkg": 325.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "formes": [
      "Kyurem",
      "Kyurem-White",
      "Kyurem-Black"
    ]
  },
  "kyuremwhite": {
    "num": 646,
    "name": "Kyurem-White",
    "types": [
      "Ice",
      "Fire"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 125,
      "atk": 140,
      "def": 100,
      "spe": 95,
      "spa": 190,
      "spd": 110
    },
    "abilities": {
      "0": "Sweltering Sun",
      "1": "Solar Rush"
    },
    "weightkg": 325.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Kyurem",
    "forme": "White",
    "formes": [
      "Kyurem",
      "Kyurem-White",
      "Kyurem-Black"
    ],
    "requiredItems": [
      "Light Stone"
    ]
  },
  "kyuremblack": {
    "num": 646,
    "name": "Kyurem-Black",
    "types": [
      "Ice",
      "Electric"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 125,
      "atk": 190,
      "def": 110,
      "spe": 95,
      "spa": 140,
      "spd": 100
    },
    "abilities": {
      "0": "Galvanize",
      "1": "Volt Rush"
    },
    "weightkg": 325.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Kyurem",
    "forme": "Black",
    "formes": [
      "Kyurem",
      "Kyurem-White",
      "Kyurem-Black"
    ],
    "requiredItems": [
      "Dark Stone"
    ]
  },
  "keldeo": {
    "num": 647,
    "name": "Keldeo",
    "types": [
      "Water",
      "Fighting"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 71,
      "atk": 117,
      "def": 75,
      "spe": 123,
      "spa": 119,
      "spd": 75
    },
    "abilities": {
      "0": "Proficiency",
      "1": "Reckless"
    },
    "weightkg": 48.5,
    "eggGroups": [
      "Undiscovered"
    ],
    "formes": [
      "Keldeo",
      "Keldeo-Resolute"
    ]
  },
  "keldeoresolute": {
    "num": 647,
    "name": "Keldeo-Resolute",
    "types": [
      "Water",
      "Fairy"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 71,
      "atk": 127,
      "def": 75,
      "spe": 123,
      "spa": 129,
      "spd": 75
    },
    "abilities": {
      "0": "Proficiency",
      "1": "Reckless"
    },
    "weightkg": 48.5,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Keldeo",
    "forme": "Resolute",
    "formes": [
      "Keldeo",
      "Keldeo-Resolute"
    ]
  },
  "meloetta": {
    "num": 648,
    "name": "Meloetta",
    "types": [
      "Psychic",
      "Fairy"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 70,
      "atk": 77,
      "def": 77,
      "spe": 100,
      "spa": 138,
      "spd": 138
    },
    "abilities": {
      "0": "Pixilate",
      "1": "Serene Grace"
    },
    "weightkg": 6.5,
    "eggGroups": [
      "Undiscovered"
    ],
    "formes": [
      "Meloetta",
      "Meloetta-Pirouette"
    ]
  },
  "meloettapirouette": {
    "num": 648,
    "name": "Meloetta-Pirouette",
    "types": [
      "Fighting",
      "Fairy"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 70,
      "atk": 128,
      "def": 77,
      "spe": 128,
      "spa": 120,
      "spd": 77
    },
    "abilities": {
      "0": "Pixilate",
      "1": "Serene Grace"
    },
    "weightkg": 6.5,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Meloetta",
    "forme": "Pirouette",
    "formes": [
      "Meloetta",
      "Meloetta-Pirouette"
    ]
  },
  "genesect": {
    "num": 649,
    "name": "Genesect",
    "types": [
      "Bug",
      "Steel"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 70,
      "atk": 120,
      "def": 90,
      "spe": 120,
      "spa": 130,
      "spd": 70
    },
    "abilities": {
      "0": "Instinct",
      "1": "Versatility",
      "H": "Tinted Lens"
    },
    "weightkg": 82.5,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "chespin": {
    "num": 650,
    "name": "Chespin",
    "types": [
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 56,
      "atk": 66,
      "def": 70,
      "spe": 43,
      "spa": 33,
      "spd": 52
    },
    "abilities": {
      "0": "Overgrow",
      "1": "Grassy Guard"
    },
    "weightkg": 9.0,
    "evos": [
      "Quilladin"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "quilladin": {
    "num": 651,
    "name": "Quilladin",
    "types": [
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 81,
      "atk": 83,
      "def": 102,
      "spe": 57,
      "spa": 39,
      "spd": 73
    },
    "abilities": {
      "0": "Overgrow",
      "1": "Grassy Guard"
    },
    "weightkg": 29.0,
    "prevo": "Chespin",
    "evoLevel": 17,
    "evos": [
      "Chesnaught"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "chesnaught": {
    "num": 652,
    "name": "Chesnaught",
    "types": [
      "Grass",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 103,
      "atk": 127,
      "def": 132,
      "spe": 49,
      "spa": 44,
      "spd": 95
    },
    "abilities": {
      "0": "Bulletproof",
      "1": "Battle Armor",
      "H": "Grassy Guard"
    },
    "weightkg": 130.0,
    "prevo": "Quilladin",
    "evoLevel": 36,
    "eggGroups": [
      "Field"
    ]
  },
  "fennekin": {
    "num": 653,
    "name": "Fennekin",
    "types": [
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 45,
      "def": 40,
      "spe": 65,
      "spa": 70,
      "spd": 60
    },
    "abilities": {
      "0": "Blaze",
      "1": "Magician"
    },
    "weightkg": 9.4,
    "evos": [
      "Braixen"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "braixen": {
    "num": 654,
    "name": "Braixen",
    "types": [
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 59,
      "atk": 50,
      "def": 58,
      "spe": 98,
      "spa": 95,
      "spd": 75
    },
    "abilities": {
      "0": "Blaze",
      "1": "Magician"
    },
    "weightkg": 14.5,
    "prevo": "Fennekin",
    "evoLevel": 17,
    "evos": [
      "Delphox"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "delphox": {
    "num": 655,
    "name": "Delphox",
    "types": [
      "Fire",
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 60,
      "def": 72,
      "spe": 104,
      "spa": 124,
      "spd": 115
    },
    "abilities": {
      "0": "Magic Bounce",
      "1": "Magic Guard"
    },
    "weightkg": 39.0,
    "prevo": "Braixen",
    "evoLevel": 36,
    "eggGroups": [
      "Field"
    ]
  },
  "froakie": {
    "num": 656,
    "name": "Froakie",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 41,
      "atk": 56,
      "def": 40,
      "spe": 77,
      "spa": 62,
      "spd": 44
    },
    "abilities": {
      "0": "Torrent",
      "1": "Technician"
    },
    "weightkg": 7.0,
    "evos": [
      "Frogadier"
    ],
    "eggGroups": [
      "Water 1"
    ]
  },
  "frogadier": {
    "num": 657,
    "name": "Frogadier",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 54,
      "atk": 73,
      "def": 52,
      "spe": 112,
      "spa": 88,
      "spd": 56
    },
    "abilities": {
      "0": "Torrent",
      "1": "Technician"
    },
    "weightkg": 10.9,
    "prevo": "Froakie",
    "evoLevel": 17,
    "evos": [
      "Greninja"
    ],
    "eggGroups": [
      "Water 1"
    ]
  },
  "greninja": {
    "num": 658,
    "name": "Greninja",
    "types": [
      "Water",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 72,
      "atk": 100,
      "def": 67,
      "spe": 132,
      "spa": 108,
      "spd": 71
    },
    "abilities": {
      "0": "Expertise",
      "1": "Versatility"
    },
    "weightkg": 40.0,
    "prevo": "Frogadier",
    "evoLevel": 36,
    "eggGroups": [
      "Water 1"
    ],
    "formes": [
      "Greninja",
      "Greninja-Ash"
    ]
  },
  "greninjaash": {
    "num": 658,
    "name": "Greninja-Ash",
    "types": [
      "Water",
      "Dark"
    ],
    "gender": "M",
    "baseStats": {
      "hp": 72,
      "atk": 145,
      "def": 67,
      "spe": 142,
      "spa": 153,
      "spd": 71
    },
    "abilities": {
      "0": "Proficiency",
      "1": "Technician"
    },
    "weightkg": 40.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Greninja",
    "forme": "Ash",
    "formes": [
      "Greninja",
      "Greninja-Ash"
    ],
    "requiredItems": [
      "Mega Stone I"
    ]
  },
  "bunnelby": {
    "num": 659,
    "name": "Bunnelby",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 49,
      "atk": 41,
      "def": 47,
      "spe": 84,
      "spa": 32,
      "spd": 47
    },
    "abilities": {
      "0": "Huge Power",
      "1": "Fur Coat"
    },
    "weightkg": 5.0,
    "evos": [
      "Diggersby"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "diggersby": {
    "num": 660,
    "name": "Diggersby",
    "types": [
      "Normal",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 109,
      "atk": 69,
      "def": 87,
      "spe": 78,
      "spa": 50,
      "spd": 87
    },
    "abilities": {
      "0": "Huge Power",
      "1": "Fur Coat"
    },
    "weightkg": 42.4,
    "prevo": "Bunnelby",
    "evoLevel": 20,
    "eggGroups": [
      "Field"
    ]
  },
  "fletchling": {
    "num": 661,
    "name": "Fletchling",
    "types": [
      "Normal",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 56,
      "def": 43,
      "spe": 87,
      "spa": 40,
      "spd": 39
    },
    "abilities": {
      "0": "Bird's Eye View",
      "1": "Gale Wings"
    },
    "weightkg": 1.7,
    "evos": [
      "Fletchinder"
    ],
    "eggGroups": [
      "Flying"
    ]
  },
  "fletchinder": {
    "num": 662,
    "name": "Fletchinder",
    "types": [
      "Fire",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 62,
      "atk": 81,
      "def": 58,
      "spe": 107,
      "spa": 56,
      "spd": 56
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Gale Wings"
    },
    "weightkg": 16.0,
    "prevo": "Fletchling",
    "evoLevel": 17,
    "evos": [
      "Talonflame"
    ],
    "eggGroups": [
      "Flying"
    ]
  },
  "talonflame": {
    "num": 663,
    "name": "Talonflame",
    "types": [
      "Fire",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 78,
      "atk": 111,
      "def": 71,
      "spe": 147,
      "spa": 74,
      "spd": 69
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Reckless"
    },
    "weightkg": 24.5,
    "prevo": "Fletchinder",
    "evoLevel": 33,
    "eggGroups": [
      "Flying"
    ]
  },
  "scatterbug": {
    "num": 664,
    "name": "Scatterbug",
    "types": [
      "Bug"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 38,
      "atk": 35,
      "def": 40,
      "spe": 35,
      "spa": 53,
      "spd": 49
    },
    "abilities": {
      "0": "Shield Dust",
      "1": "Sap Sipper"
    },
    "weightkg": 2.5,
    "evos": [
      "Spewpa"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "spewpa": {
    "num": 665,
    "name": "Spewpa",
    "types": [
      "Bug"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 22,
      "def": 98,
      "spe": 29,
      "spa": 53,
      "spd": 98
    },
    "abilities": {
      "0": "Shield Dust",
      "1": "Sturdy"
    },
    "weightkg": 8.4,
    "prevo": "Scatterbug",
    "evoLevel": 10,
    "evos": [
      "Vivillon"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "vivillon": {
    "num": 666,
    "name": "Vivillon",
    "types": [
      "Bug",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 52,
      "def": 63,
      "spe": 95,
      "spa": 100,
      "spd": 90
    },
    "abilities": {
      "0": "Multiscale",
      "1": "Versatility"
    },
    "weightkg": 17.0,
    "prevo": "Spewpa",
    "evoLevel": 20,
    "eggGroups": [
      "Bug"
    ]
  },
  "litleo": {
    "num": 667,
    "name": "Litleo",
    "types": [
      "Fire",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.1171875,
      "F": 0.8828125
    },
    "baseStats": {
      "hp": 56,
      "atk": 73,
      "def": 58,
      "spe": 86,
      "spa": 73,
      "spd": 54
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Instinct",
      "H": "Quick Feet"
    },
    "weightkg": 13.5,
    "evos": [
      "Pyroar"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "pyroar": {
    "num": 668,
    "name": "Pyroar",
    "types": [
      "Fire",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.1171875,
      "F": 0.8828125
    },
    "baseStats": {
      "hp": 86,
      "atk": 109,
      "def": 72,
      "spe": 108,
      "spa": 109,
      "spd": 66
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Instinct",
      "H": "Quick Feet"
    },
    "weightkg": 81.5,
    "prevo": "Litleo",
    "evoLevel": 32,
    "eggGroups": [
      "Field"
    ]
  },
  "flabebe": {
    "num": 669,
    "name": "Flabebe",
    "types": [
      "Fairy"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 44,
      "atk": 38,
      "def": 41,
      "spe": 42,
      "spa": 61,
      "spd": 94
    },
    "abilities": {
      "0": "Grassy Guard",
      "1": "Harvest"
    },
    "weightkg": 0.1,
    "evos": [
      "Floette"
    ],
    "eggGroups": [
      "Fairy"
    ]
  },
  "floette": {
    "num": 670,
    "name": "Floette",
    "types": [
      "Fairy"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 54,
      "atk": 45,
      "def": 54,
      "spe": 67,
      "spa": 87,
      "spd": 113
    },
    "abilities": {
      "0": "Grassy Guard",
      "1": "Harvest"
    },
    "weightkg": 0.9,
    "prevo": "Flabebe",
    "evoLevel": 16,
    "evos": [
      "Florges"
    ],
    "eggGroups": [
      "Fairy"
    ],
    "formes": [
      "Floette",
      "Floette-Eternal"
    ]
  },
  "floetteeternal": {
    "num": 670,
    "name": "Floette-Eternal",
    "types": [
      "Fairy",
      "Dark"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 67,
      "atk": 52,
      "def": 67,
      "spe": 97,
      "spa": 154,
      "spd": 113
    },
    "abilities": {
      "0": "Dark Aura",
      "1": "Fairy Aura"
    },
    "weightkg": 0.9,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Floette",
    "forme": "Eternal",
    "formes": [
      "Floette",
      "Floette-Eternal"
    ]
  },
  "florges": {
    "num": 671,
    "name": "Florges",
    "types": [
      "Fairy"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 78,
      "atk": 52,
      "def": 78,
      "spe": 75,
      "spa": 113,
      "spd": 154
    },
    "abilities": {
      "0": "Serene Grace",
      "1": "Harvest",
      "H": "Grassy Guard"
    },
    "weightkg": 10.0,
    "prevo": "Floette",
    "evoLevel": 32,
    "eggGroups": [
      "Fairy"
    ]
  },
  "skiddo": {
    "num": 672,
    "name": "Skiddo",
    "types": [
      "Grass",
      "Rock"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 63,
      "atk": 80,
      "def": 83,
      "spe": 93,
      "spa": 40,
      "spd": 61
    },
    "abilities": {
      "0": "Grassy Guard",
      "1": "Sap Sipper"
    },
    "weightkg": 31.0,
    "evos": [
      "Gogoat"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "gogoat": {
    "num": 673,
    "name": "Gogoat",
    "types": [
      "Grass",
      "Rock"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 103,
      "atk": 110,
      "def": 103,
      "spe": 103,
      "spa": 50,
      "spd": 81
    },
    "abilities": {
      "0": "Grassy Surge",
      "1": "Sap Sipper"
    },
    "weightkg": 91.0,
    "prevo": "Skiddo",
    "evoLevel": 29,
    "eggGroups": [
      "Field"
    ]
  },
  "pancham": {
    "num": 674,
    "name": "Pancham",
    "types": [
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 82,
      "def": 68,
      "spe": 58,
      "spa": 36,
      "spd": 66
    },
    "abilities": {
      "0": "Hustle",
      "1": "Sap Sipper"
    },
    "weightkg": 8.0,
    "evos": [
      "Pangoro"
    ],
    "eggGroups": [
      "Field",
      "Human-Like"
    ]
  },
  "pangoro": {
    "num": 675,
    "name": "Pangoro",
    "types": [
      "Fighting",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 115,
      "atk": 134,
      "def": 88,
      "spe": 63,
      "spa": 49,
      "spd": 86
    },
    "abilities": {
      "0": "Hustle",
      "1": "Headstrong"
    },
    "weightkg": 136.0,
    "prevo": "Pancham",
    "evoLevel": 31,
    "eggGroups": [
      "Field",
      "Human-Like"
    ]
  },
  "furfrou": {
    "num": 676,
    "name": "Furfrou",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 93,
      "def": 70,
      "spe": 102,
      "spa": 80,
      "spd": 95
    },
    "abilities": {
      "0": "Fur Coat",
      "1": "Adaptability"
    },
    "weightkg": 28.0,
    "eggGroups": [
      "Field"
    ],
    "formes": [
      "Furfrou",
      "Furfrou-Heart",
      "Furfrou-Star",
      "Furfrou-Diamond",
      "Furfrou-Debutante",
      "Furfrou-Matron",
      "Furfrou-Dandy",
      "Furfrou-La Reine",
      "Furfrou-Kabuki",
      "Furfrou-Pharaoh"
    ]
  },
  "furfrouheart": {
    "num": 676,
    "name": "Furfrou-Heart",
    "types": [
      "Fairy",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 93,
      "def": 70,
      "spe": 102,
      "spa": 80,
      "spd": 95
    },
    "abilities": {
      "0": "Fur Coat",
      "1": "Adaptability"
    },
    "weightkg": 28.0,
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Furfrou",
    "forme": "Heart",
    "formes": [
      "Furfrou",
      "Furfrou-Heart",
      "Furfrou-Star",
      "Furfrou-Diamond",
      "Furfrou-Debutante",
      "Furfrou-Matron",
      "Furfrou-Dandy",
      "Furfrou-La Reine",
      "Furfrou-Kabuki",
      "Furfrou-Pharaoh"
    ]
  },
  "furfroustar": {
    "num": 676,
    "name": "Furfrou-Star",
    "types": [
      "Ice",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 93,
      "def": 70,
      "spe": 102,
      "spa": 80,
      "spd": 95
    },
    "abilities": {
      "0": "Fur Coat",
      "1": "Adaptability"
    },
    "weightkg": 28.0,
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Furfrou",
    "forme": "Star",
    "formes": [
      "Furfrou",
      "Furfrou-Heart",
      "Furfrou-Star",
      "Furfrou-Diamond",
      "Furfrou-Debutante",
      "Furfrou-Matron",
      "Furfrou-Dandy",
      "Furfrou-La Reine",
      "Furfrou-Kabuki",
      "Furfrou-Pharaoh"
    ]
  },
  "furfroudiamond": {
    "num": 676,
    "name": "Furfrou-Diamond",
    "types": [
      "Rock",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 93,
      "def": 70,
      "spe": 102,
      "spa": 80,
      "spd": 95
    },
    "abilities": {
      "0": "Fur Coat",
      "1": "Adaptability"
    },
    "weightkg": 28.0,
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Furfrou",
    "forme": "Diamond",
    "formes": [
      "Furfrou",
      "Furfrou-Heart",
      "Furfrou-Star",
      "Furfrou-Diamond",
      "Furfrou-Debutante",
      "Furfrou-Matron",
      "Furfrou-Dandy",
      "Furfrou-La Reine",
      "Furfrou-Kabuki",
      "Furfrou-Pharaoh"
    ]
  },
  "furfroudebutante": {
    "num": 676,
    "name": "Furfrou-Debutante",
    "types": [
      "Electric",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 93,
      "def": 70,
      "spe": 102,
      "spa": 80,
      "spd": 95
    },
    "abilities": {
      "0": "Fur Coat",
      "1": "Adaptability"
    },
    "weightkg": 28.0,
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Furfrou",
    "forme": "Debutante",
    "formes": [
      "Furfrou",
      "Furfrou-Heart",
      "Furfrou-Star",
      "Furfrou-Diamond",
      "Furfrou-Debutante",
      "Furfrou-Matron",
      "Furfrou-Dandy",
      "Furfrou-La Reine",
      "Furfrou-Kabuki",
      "Furfrou-Pharaoh"
    ]
  },
  "furfroumatron": {
    "num": 676,
    "name": "Furfrou-Matron",
    "types": [
      "Poison",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 93,
      "def": 70,
      "spe": 102,
      "spa": 80,
      "spd": 95
    },
    "abilities": {
      "0": "Fur Coat",
      "1": "Adaptability"
    },
    "weightkg": 28.0,
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Furfrou",
    "forme": "Matron",
    "formes": [
      "Furfrou",
      "Furfrou-Heart",
      "Furfrou-Star",
      "Furfrou-Diamond",
      "Furfrou-Debutante",
      "Furfrou-Matron",
      "Furfrou-Dandy",
      "Furfrou-La Reine",
      "Furfrou-Kabuki",
      "Furfrou-Pharaoh"
    ]
  },
  "furfroudandy": {
    "num": 676,
    "name": "Furfrou-Dandy",
    "types": [
      "Grass",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 93,
      "def": 70,
      "spe": 102,
      "spa": 80,
      "spd": 95
    },
    "abilities": {
      "0": "Fur Coat",
      "1": "Adaptability"
    },
    "weightkg": 28.0,
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Furfrou",
    "forme": "Dandy",
    "formes": [
      "Furfrou",
      "Furfrou-Heart",
      "Furfrou-Star",
      "Furfrou-Diamond",
      "Furfrou-Debutante",
      "Furfrou-Matron",
      "Furfrou-Dandy",
      "Furfrou-La Reine",
      "Furfrou-Kabuki",
      "Furfrou-Pharaoh"
    ]
  },
  "furfroulareine": {
    "num": 676,
    "name": "Furfrou-La Reine",
    "types": [
      "Water",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 93,
      "def": 70,
      "spe": 102,
      "spa": 80,
      "spd": 95
    },
    "abilities": {
      "0": "Fur Coat",
      "1": "Adaptability"
    },
    "weightkg": 28.0,
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Furfrou",
    "forme": "La Reine",
    "formes": [
      "Furfrou",
      "Furfrou-Heart",
      "Furfrou-Star",
      "Furfrou-Diamond",
      "Furfrou-Debutante",
      "Furfrou-Matron",
      "Furfrou-Dandy",
      "Furfrou-La Reine",
      "Furfrou-Kabuki",
      "Furfrou-Pharaoh"
    ]
  },
  "furfroukabuki": {
    "num": 676,
    "name": "Furfrou-Kabuki",
    "types": [
      "Fighting",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 93,
      "def": 70,
      "spe": 102,
      "spa": 80,
      "spd": 95
    },
    "abilities": {
      "0": "Fur Coat",
      "1": "Adaptability"
    },
    "weightkg": 28.0,
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Furfrou",
    "forme": "Kabuki",
    "formes": [
      "Furfrou",
      "Furfrou-Heart",
      "Furfrou-Star",
      "Furfrou-Diamond",
      "Furfrou-Debutante",
      "Furfrou-Matron",
      "Furfrou-Dandy",
      "Furfrou-La Reine",
      "Furfrou-Kabuki",
      "Furfrou-Pharaoh"
    ]
  },
  "furfroupharaoh": {
    "num": 676,
    "name": "Furfrou-Pharaoh",
    "types": [
      "Dark",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 93,
      "def": 70,
      "spe": 102,
      "spa": 80,
      "spd": 95
    },
    "abilities": {
      "0": "Fur Coat",
      "1": "Adaptability"
    },
    "weightkg": 28.0,
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Furfrou",
    "forme": "Pharaoh",
    "formes": [
      "Furfrou",
      "Furfrou-Heart",
      "Furfrou-Star",
      "Furfrou-Diamond",
      "Furfrou-Debutante",
      "Furfrou-Matron",
      "Furfrou-Dandy",
      "Furfrou-La Reine",
      "Furfrou-Kabuki",
      "Furfrou-Pharaoh"
    ]
  },
  "espurr": {
    "num": 677,
    "name": "Espurr",
    "types": [
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 52,
      "atk": 38,
      "def": 54,
      "spe": 68,
      "spa": 94,
      "spd": 94
    },
    "abilities": {
      "0": "Sheer Force",
      "1": "Prankster"
    },
    "weightkg": 3.5,
    "evos": [
      "Meowstic"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "meowstic": {
    "num": 678,
    "name": "Meowstic",
    "types": [
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 74,
      "atk": 48,
      "def": 81,
      "spe": 109,
      "spa": 94,
      "spd": 119
    },
    "abilities": {
      "0": "Energy Shield",
      "1": "Prankster"
    },
    "weightkg": 8.5,
    "prevo": "Espurr",
    "evoLevel": 25,
    "eggGroups": [
      "Field"
    ],
    "formes": [
      "Meowstic",
      "Meowstic-F"
    ]
  },
  "meowsticf": {
    "num": 678,
    "name": "Meowstic-F",
    "types": [
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 74,
      "atk": 48,
      "def": 76,
      "spe": 114,
      "spa": 119,
      "spd": 94
    },
    "abilities": {
      "0": "Sheer Force",
      "1": "Hubris"
    },
    "weightkg": 8.5,
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Meowstic",
    "forme": "F",
    "formes": [
      "Meowstic",
      "Meowstic-F"
    ]
  },
  "honedge": {
    "num": 679,
    "name": "Honedge",
    "types": [
      "Steel",
      "Ghost"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 100,
      "def": 100,
      "spe": 45,
      "spa": 35,
      "spd": 45
    },
    "abilities": {
      "0": "Levitate",
      "1": "Technician"
    },
    "weightkg": 2.0,
    "evos": [
      "Doublade"
    ],
    "eggGroups": [
      "Mineral"
    ]
  },
  "doublade": {
    "num": 680,
    "name": "Doublade",
    "types": [
      "Steel",
      "Ghost"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 125,
      "def": 150,
      "spe": 50,
      "spa": 45,
      "spd": 65
    },
    "abilities": {
      "0": "Levitate",
      "1": "Expertise"
    },
    "weightkg": 4.5,
    "prevo": "Honedge",
    "evoLevel": 30,
    "evos": [
      "Aegislash"
    ],
    "eggGroups": [
      "Mineral"
    ]
  },
  "aegislash": {
    "num": 681,
    "name": "Aegislash",
    "types": [
      "Steel",
      "Ghost"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 50,
      "def": 150,
      "spe": 75,
      "spa": 50,
      "spd": 150
    },
    "abilities": {
      "0": "Stance Change",
      "1": "Levitate"
    },
    "weightkg": 53.0,
    "prevo": "Doublade",
    "evoLevel": 40,
    "evoType": "levelHold",
    "evoItem": "Ghost Gem",
    "eggGroups": [
      "Mineral"
    ],
    "formes": [
      "Aegislash",
      "Aegislash-Blade"
    ]
  },
  "aegislashblade": {
    "num": 681,
    "name": "Aegislash-Blade",
    "types": [
      "Steel",
      "Ghost"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 150,
      "def": 50,
      "spe": 75,
      "spa": 150,
      "spd": 50
    },
    "abilities": {
      "0": "Stance Change"
    },
    "weightkg": 53.0,
    "eggGroups": [
      "Mineral"
    ],
    "baseSpecies": "Aegislash",
    "forme": "Blade",
    "formes": [
      "Aegislash",
      "Aegislash-Blade"
    ]
  },
  "spritzee": {
    "num": 682,
    "name": "Spritzee",
    "types": [
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 48,
      "atk": 32,
      "def": 60,
      "spe": 52,
      "spa": 79,
      "spd": 99
    },
    "abilities": {
      "0": "Levitate",
      "1": "Prankster"
    },
    "weightkg": 0.5,
    "evos": [
      "Aromatisse"
    ],
    "eggGroups": [
      "Fairy"
    ]
  },
  "aromatisse": {
    "num": 683,
    "name": "Aromatisse",
    "types": [
      "Fairy",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 81,
      "atk": 72,
      "def": 72,
      "spe": 52,
      "spa": 119,
      "spd": 129
    },
    "abilities": {
      "0": "Fur Coat",
      "1": "Prankster"
    },
    "weightkg": 15.5,
    "prevo": "Spritzee",
    "evoLevel": 30,
    "eggGroups": [
      "Fairy"
    ]
  },
  "swirlix": {
    "num": 684,
    "name": "Swirlix",
    "types": [
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 52,
      "atk": 48,
      "def": 66,
      "spe": 49,
      "spa": 64,
      "spd": 91
    },
    "abilities": {
      "0": "Unburden",
      "1": "Fluffy"
    },
    "weightkg": 3.5,
    "evos": [
      "Slurpuff"
    ],
    "eggGroups": [
      "Fairy"
    ]
  },
  "slurpuff": {
    "num": 685,
    "name": "Slurpuff",
    "types": [
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 82,
      "atk": 80,
      "def": 86,
      "spe": 72,
      "spa": 90,
      "spd": 115
    },
    "abilities": {
      "0": "Unburden",
      "1": "Fluffy"
    },
    "weightkg": 5.0,
    "prevo": "Swirlix",
    "evoLevel": 25,
    "eggGroups": [
      "Fairy"
    ]
  },
  "inkay": {
    "num": 686,
    "name": "Inkay",
    "types": [
      "Dark",
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 53,
      "atk": 54,
      "def": 53,
      "spe": 63,
      "spa": 79,
      "spd": 98
    },
    "abilities": {
      "0": "Contrary",
      "1": "Liquid Veil"
    },
    "weightkg": 3.5,
    "evos": [
      "Malamar"
    ],
    "eggGroups": [
      "Water 1",
      "Water 2"
    ]
  },
  "malamar": {
    "num": 687,
    "name": "Malamar",
    "types": [
      "Dark",
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 86,
      "atk": 92,
      "def": 88,
      "spe": 73,
      "spa": 93,
      "spd": 118
    },
    "abilities": {
      "0": "Contrary",
      "1": "Liquid Veil"
    },
    "weightkg": 47.0,
    "prevo": "Inkay",
    "evoLevel": 26,
    "eggGroups": [
      "Water 1",
      "Water 2"
    ]
  },
  "binacle": {
    "num": 688,
    "name": "Binacle",
    "types": [
      "Rock",
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 42,
      "atk": 82,
      "def": 92,
      "spe": 50,
      "spa": 39,
      "spd": 65
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Tough Claws"
    },
    "weightkg": 31.0,
    "evos": [
      "Barbaracle"
    ],
    "eggGroups": [
      "Water 3"
    ]
  },
  "barbaracle": {
    "num": 689,
    "name": "Barbaracle",
    "types": [
      "Rock",
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 87,
      "atk": 120,
      "def": 115,
      "spe": 73,
      "spa": 54,
      "spd": 86
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Tough Claws"
    },
    "weightkg": 96.0,
    "prevo": "Binacle",
    "evoLevel": 32,
    "eggGroups": [
      "Water 3"
    ]
  },
  "skrelp": {
    "num": 690,
    "name": "Skrelp",
    "types": [
      "Poison",
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 55,
      "atk": 60,
      "def": 70,
      "spe": 30,
      "spa": 87,
      "spd": 98
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Sap Sipper",
      "H": "Corrosion"
    },
    "weightkg": 7.3,
    "evos": [
      "Dragalge"
    ],
    "eggGroups": [
      "Water 1",
      "Dragon"
    ]
  },
  "dragalge": {
    "num": 691,
    "name": "Dragalge",
    "types": [
      "Poison",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 101,
      "atk": 75,
      "def": 90,
      "spe": 44,
      "spa": 117,
      "spd": 123
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Drizzle",
      "H": "Corrosion"
    },
    "weightkg": 81.5,
    "prevo": "Skrelp",
    "evoLevel": 33,
    "eggGroups": [
      "Water 1",
      "Dragon"
    ]
  },
  "clauncher": {
    "num": 692,
    "name": "Clauncher",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 53,
      "atk": 53,
      "def": 82,
      "spe": 44,
      "spa": 95,
      "spd": 73
    },
    "abilities": {
      "0": "Mega Launcher",
      "1": "Technician"
    },
    "weightkg": 8.3,
    "evos": [
      "Clawitzer"
    ],
    "eggGroups": [
      "Water 1",
      "Water 3"
    ]
  },
  "clawitzer": {
    "num": 693,
    "name": "Clawitzer",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 71,
      "atk": 73,
      "def": 108,
      "spe": 59,
      "spa": 145,
      "spd": 94
    },
    "abilities": {
      "0": "Mega Launcher",
      "1": "Technician"
    },
    "weightkg": 8.3,
    "prevo": "Clauncher",
    "evoLevel": 29,
    "eggGroups": [
      "Water 1",
      "Water 3"
    ]
  },
  "helioptile": {
    "num": 694,
    "name": "Helioptile",
    "types": [
      "Electric",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 44,
      "atk": 38,
      "def": 43,
      "spe": 96,
      "spa": 86,
      "spd": 63
    },
    "abilities": {
      "0": "Dry Skin",
      "1": "Solar Power"
    },
    "weightkg": 6.0,
    "evos": [
      "Heliolisk"
    ],
    "eggGroups": [
      "Monster",
      "Dragon"
    ]
  },
  "heliolisk": {
    "num": 695,
    "name": "Heliolisk",
    "types": [
      "Electric",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 71,
      "atk": 55,
      "def": 67,
      "spe": 129,
      "spa": 119,
      "spd": 94
    },
    "abilities": {
      "0": "Sweltering Sun",
      "1": "Solar Power"
    },
    "weightkg": 21.0,
    "prevo": "Helioptile",
    "evoLevel": 28,
    "eggGroups": [
      "Monster",
      "Dragon"
    ]
  },
  "tyrunt": {
    "num": 696,
    "name": "Tyrunt",
    "types": [
      "Rock",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 63,
      "atk": 109,
      "def": 96,
      "spe": 61,
      "spa": 42,
      "spd": 54
    },
    "abilities": {
      "0": "Strong Jaw",
      "1": "Intimidate"
    },
    "weightkg": 26.0,
    "evos": [
      "Tyrantrum"
    ],
    "eggGroups": [
      "Monster",
      "Dragon"
    ]
  },
  "tyrantrum": {
    "num": 697,
    "name": "Tyrantrum",
    "types": [
      "Rock",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 123,
      "atk": 151,
      "def": 119,
      "spe": 71,
      "spa": 47,
      "spd": 64
    },
    "abilities": {
      "0": "Strong Jaw",
      "1": "Intimidate"
    },
    "weightkg": 270.0,
    "prevo": "Tyrunt",
    "evoLevel": 35,
    "eggGroups": [
      "Monster",
      "Dragon"
    ]
  },
  "amaura": {
    "num": 698,
    "name": "Amaura",
    "types": [
      "Rock",
      "Ice"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 77,
      "atk": 39,
      "def": 77,
      "spe": 46,
      "spa": 93,
      "spd": 93
    },
    "abilities": {
      "0": "Refrigerate",
      "1": "Energy Shield",
      "H": "Dazzling"
    },
    "weightkg": 25.2,
    "evos": [
      "Aurorus"
    ],
    "eggGroups": [
      "Monster"
    ]
  },
  "aurorus": {
    "num": 699,
    "name": "Aurorus",
    "types": [
      "Rock",
      "Ice"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 123,
      "atk": 57,
      "def": 92,
      "spe": 58,
      "spa": 133,
      "spd": 112
    },
    "abilities": {
      "0": "Refrigerate",
      "1": "Energy Shield",
      "H": "Dazzling"
    },
    "weightkg": 225.0,
    "prevo": "Amaura",
    "evoLevel": 35,
    "eggGroups": [
      "Monster"
    ]
  },
  "sylveon": {
    "num": 700,
    "name": "Sylveon",
    "types": [
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.875,
      "F": 0.125
    },
    "baseStats": {
      "hp": 65,
      "atk": 65,
      "def": 65,
      "spe": 90,
      "spa": 110,
      "spd": 130
    },
    "abilities": {
      "0": "Fairy Aura",
      "1": "Pixilate",
      "H": "Evoboost"
    },
    "weightkg": 23.5,
    "prevo": "Eevee",
    "evoLevel": 25,
    "evoType": "levelHold",
    "evoItem": "Fairy Gem",
    "evoCondition": "in the day",
    "eggGroups": [
      "Field"
    ]
  },
  "hawlucha": {
    "num": 701,
    "name": "Hawlucha",
    "types": [
      "Fighting",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 112,
      "def": 75,
      "spe": 133,
      "spa": 65,
      "spd": 75
    },
    "abilities": {
      "0": "Reckless",
      "1": "Moxie"
    },
    "weightkg": 21.5,
    "eggGroups": [
      "Human-Like"
    ]
  },
  "dedenne": {
    "num": 702,
    "name": "Dedenne",
    "types": [
      "Electric",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 67,
      "atk": 58,
      "def": 72,
      "spe": 106,
      "spa": 106,
      "spd": 106
    },
    "abilities": {
      "0": "Prankster",
      "1": "Volt Rush"
    },
    "weightkg": 2.2,
    "eggGroups": [
      "Field",
      "Fairy"
    ]
  },
  "carbink": {
    "num": 703,
    "name": "Carbink",
    "types": [
      "Rock",
      "Fairy"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 50,
      "atk": 30,
      "def": 150,
      "spe": 30,
      "spa": 90,
      "spd": 150
    },
    "abilities": {
      "0": "Levitate",
      "1": "Solid Rock"
    },
    "weightkg": 5.7,
    "evos": [
      "Diancie"
    ],
    "eggGroups": [
      "Fairy",
      "Mineral"
    ]
  },
  "goomy": {
    "num": 704,
    "name": "Goomy",
    "types": [
      "Dragon",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 50,
      "def": 60,
      "spe": 20,
      "spa": 75,
      "spd": 110
    },
    "abilities": {
      "0": "Liquid Veil",
      "1": "Regenerator"
    },
    "weightkg": 2.8,
    "evos": [
      "Sliggoo"
    ],
    "eggGroups": [
      "Dragon"
    ]
  },
  "sliggoo": {
    "num": 705,
    "name": "Sliggoo",
    "types": [
      "Dragon",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 75,
      "def": 75,
      "spe": 20,
      "spa": 100,
      "spd": 135
    },
    "abilities": {
      "0": "Liquid Veil",
      "1": "Regenerator"
    },
    "weightkg": 17.5,
    "prevo": "Goomy",
    "evoLevel": 25,
    "evos": [
      "Goodra"
    ],
    "eggGroups": [
      "Dragon"
    ]
  },
  "goodra": {
    "num": 706,
    "name": "Goodra",
    "types": [
      "Dragon",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 115,
      "atk": 100,
      "def": 80,
      "spe": 45,
      "spa": 110,
      "spd": 150
    },
    "abilities": {
      "0": "Liquid Veil",
      "1": "Regenerator"
    },
    "weightkg": 150.5,
    "prevo": "Sliggoo",
    "evoLevel": 45,
    "evoType": "levelHold",
    "evoItem": "Dragon Gem",
    "eggGroups": [
      "Dragon"
    ]
  },
  "klefki": {
    "num": 707,
    "name": "Klefki",
    "types": [
      "Steel",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 62,
      "atk": 50,
      "def": 119,
      "spe": 90,
      "spa": 85,
      "spd": 119
    },
    "abilities": {
      "0": "Levitate",
      "1": "Prankster"
    },
    "weightkg": 3.0,
    "eggGroups": [
      "Mineral"
    ]
  },
  "phantump": {
    "num": 708,
    "name": "Phantump",
    "types": [
      "Ghost",
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 48,
      "atk": 70,
      "def": 87,
      "spe": 38,
      "spa": 40,
      "spd": 87
    },
    "abilities": {
      "0": "Wimp Out",
      "1": "Grassy Guard"
    },
    "weightkg": 7.0,
    "evos": [
      "Trevenant"
    ],
    "eggGroups": [
      "Grass",
      "Amorphous"
    ]
  },
  "trevenant": {
    "num": 709,
    "name": "Trevenant",
    "types": [
      "Ghost",
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 97,
      "atk": 127,
      "def": 97,
      "spe": 57,
      "spa": 60,
      "spd": 97
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Grassy Surge"
    },
    "weightkg": 71.0,
    "prevo": "Phantump",
    "evoLevel": 30,
    "eggGroups": [
      "Grass",
      "Amorphous"
    ]
  },
  "pumpkaboo": {
    "num": 710,
    "name": "Pumpkaboo",
    "types": [
      "Ghost",
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 49,
      "atk": 30,
      "def": 92,
      "spe": 51,
      "spa": 74,
      "spd": 74
    },
    "abilities": {
      "0": "Harvest",
      "1": "Flash Fire"
    },
    "weightkg": 5.0,
    "evos": [
      "Gourgeist-Super",
      "Gourgeist-Small"
    ],
    "eggGroups": [
      "Amorphous"
    ],
    "formes": [
      "Pumpkaboo"
    ]
  },
  "gourgeistsmall": {
    "num": 711,
    "name": "Gourgeist-Small",
    "types": [
      "Ghost",
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 56,
      "atk": 40,
      "def": 122,
      "spe": 99,
      "spa": 109,
      "spd": 109
    },
    "abilities": {
      "0": "Unburden",
      "1": "Flash Fire",
      "H": "Flare Boost"
    },
    "weightkg": 9.5,
    "prevo": "Pumpkaboo",
    "evoLevel": 30,
    "evoType": "levelHold",
    "evoItem": "Ghost Gem",
    "eggGroups": [
      "Amorphous"
    ],
    "baseSpecies": "Gourgeist",
    "forme": "Small",
    "formes": [
      "Gourgeist-Small",
      "Gourgeist-Super"
    ]
  },
  "gourgeistsuper": {
    "num": 711,
    "name": "Gourgeist-Super",
    "types": [
      "Ghost",
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 101,
      "atk": 50,
      "def": 122,
      "spe": 44,
      "spa": 109,
      "spd": 109
    },
    "abilities": {
      "0": "Harvest",
      "1": "Flash Fire",
      "H": "Grassy Guard"
    },
    "weightkg": 39.0,
    "prevo": "Pumpkaboo",
    "evoLevel": 30,
    "evoType": "levelHold",
    "evoItem": "Grass Gem",
    "eggGroups": [
      "Amorphous"
    ],
    "baseSpecies": "Gourgeist",
    "forme": "Super",
    "formes": [
      "Gourgeist-Small",
      "Gourgeist-Super"
    ]
  },
  "bergmite": {
    "num": 712,
    "name": "Bergmite",
    "types": [
      "Ice"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 66,
      "atk": 73,
      "def": 134,
      "spe": 23,
      "spa": 28,
      "spd": 76
    },
    "abilities": {
      "0": "Resilient",
      "1": "Regenerator"
    },
    "weightkg": 99.5,
    "evos": [
      "Avalugg"
    ],
    "eggGroups": [
      "Monster"
    ]
  },
  "avalugg": {
    "num": 713,
    "name": "Avalugg",
    "types": [
      "Ice"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 121,
      "atk": 138,
      "def": 184,
      "spe": 23,
      "spa": 28,
      "spd": 81
    },
    "abilities": {
      "0": "Resilient",
      "1": "Regenerator"
    },
    "weightkg": 505.0,
    "prevo": "Bergmite",
    "evoLevel": 35,
    "eggGroups": [
      "Monster"
    ]
  },
  "noibat": {
    "num": 714,
    "name": "Noibat",
    "types": [
      "Flying",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 30,
      "def": 45,
      "spe": 113,
      "spa": 92,
      "spd": 45
    },
    "abilities": {
      "0": "Amplifier",
      "1": "Aerilate"
    },
    "weightkg": 8.0,
    "evos": [
      "Noivern"
    ],
    "eggGroups": [
      "Flying"
    ]
  },
  "noivern": {
    "num": 715,
    "name": "Noivern",
    "types": [
      "Flying",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 60,
      "def": 80,
      "spe": 133,
      "spa": 117,
      "spd": 80
    },
    "abilities": {
      "0": "Amplifier",
      "1": "Aerilate"
    },
    "weightkg": 85.0,
    "prevo": "Noibat",
    "evoLevel": 25,
    "eggGroups": [
      "Flying"
    ]
  },
  "xerneas": {
    "num": 716,
    "name": "Xerneas",
    "types": [
      "Fairy"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 126,
      "atk": 131,
      "def": 95,
      "spe": 99,
      "spa": 171,
      "spd": 128
    },
    "abilities": {
      "0": "Fairy Aura"
    },
    "weightkg": 215.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "unusable": true
  },
  "yveltal": {
    "num": 717,
    "name": "Yveltal",
    "types": [
      "Dark",
      "Flying"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 126,
      "atk": 131,
      "def": 95,
      "spe": 99,
      "spa": 171,
      "spd": 128
    },
    "abilities": {
      "0": "Dark Aura"
    },
    "weightkg": 203.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "unusable": true
  },
  "zygarde10": {
    "num": 718,
    "name": "Zygarde-10%",
    "types": [
      "Dragon",
      "Normal"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 62,
      "atk": 106,
      "def": 74,
      "spe": 138,
      "spa": 106,
      "spd": 74
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Instinct",
      "H": "Power Construct"
    },
    "weightkg": 33.5,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Zygarde",
    "forme": "10%",
    "formes": [
      "Zygarde-10%",
      "Zygarde-50%",
      "Zygarde-Complete"
    ]
  },
  "zygarde50": {
    "num": 718,
    "name": "Zygarde-50%",
    "types": [
      "Dragon",
      "Ground"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 124,
      "atk": 124,
      "def": 124,
      "spe": 69,
      "spa": 124,
      "spd": 95
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Regenerator",
      "H": "Power Construct"
    },
    "weightkg": 305.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Zygarde",
    "forme": "50%",
    "formes": [
      "Zygarde-10%",
      "Zygarde-50%",
      "Zygarde-Complete"
    ]
  },
  "zygardecomplete": {
    "num": 718,
    "name": "Zygarde-Complete",
    "types": [
      "Dragon",
      "Ground"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 248,
      "atk": 124,
      "def": 124,
      "spe": 69,
      "spa": 124,
      "spd": 111
    },
    "abilities": {
      "0": "Huge Power"
    },
    "weightkg": 610.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Zygarde",
    "forme": "Complete",
    "formes": [
      "Zygarde-10%",
      "Zygarde-50%",
      "Zygarde-Complete"
    ],
    "requiredItems": [
      "Zygardite"
    ],
    "unusable": true
  },
  "diancie": {
    "num": 719,
    "name": "Diancie",
    "types": [
      "Rock",
      "Fairy"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 75,
      "atk": 50,
      "def": 150,
      "spe": 50,
      "spa": 125,
      "spd": 150
    },
    "abilities": {
      "0": "Levitate",
      "1": "Magic Bounce",
      "H": "Magic Guard"
    },
    "weightkg": 8.8,
    "prevo": "Carbink",
    "evoLevel": 40,
    "evoType": "levelHold",
    "evoItem": "Rock Gem",
    "eggGroups": [
      "Undiscovered"
    ],
    "formes": [
      "Diancie",
      "Diancie-Mega"
    ]
  },
  "dianciemega": {
    "num": 719,
    "name": "Diancie-Mega",
    "types": [
      "Rock",
      "Fairy"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 75,
      "atk": 75,
      "def": 125,
      "spe": 125,
      "spa": 175,
      "spd": 125
    },
    "abilities": {
      "0": "Levitate",
      "1": "Serene Grace",
      "H": "Dazzling"
    },
    "weightkg": 27.8,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Diancie",
    "forme": "Mega",
    "formes": [
      "Diancie",
      "Diancie-Mega"
    ],
    "requiredItems": [
      "Mega Stone II",
      "Diancite"
    ]
  },
  "hoopa": {
    "num": 720,
    "name": "Hoopa",
    "types": [
      "Psychic",
      "Ghost"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 80,
      "atk": 60,
      "def": 60,
      "spe": 120,
      "spa": 150,
      "spd": 130
    },
    "abilities": {
      "0": "Levitate",
      "1": "Psychic Surge",
      "H": "Prankster"
    },
    "weightkg": 9.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "formes": [
      "Hoopa",
      "Hoopa-Unbound"
    ]
  },
  "hoopaunbound": {
    "num": 720,
    "name": "Hoopa-Unbound",
    "types": [
      "Psychic",
      "Dark"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 80,
      "atk": 160,
      "def": 60,
      "spe": 100,
      "spa": 170,
      "spd": 130
    },
    "abilities": {
      "0": "Levitate",
      "1": "Expertise",
      "H": "Magic Guard"
    },
    "weightkg": 490.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Hoopa",
    "forme": "Unbound",
    "formes": [
      "Hoopa",
      "Hoopa-Unbound"
    ]
  },
  "volcanion": {
    "num": 721,
    "name": "Volcanion",
    "types": [
      "Fire",
      "Water"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 95,
      "atk": 90,
      "def": 120,
      "spe": 70,
      "spa": 130,
      "spd": 95
    },
    "abilities": {
      "0": "Sheer Force",
      "1": "Storm Drain"
    },
    "weightkg": 195.0,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "rowlet": {
    "num": 722,
    "name": "Rowlet",
    "types": [
      "Grass",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 53,
      "atk": 55,
      "def": 55,
      "spe": 47,
      "spa": 55,
      "spd": 55
    },
    "abilities": {
      "0": "Overgrow",
      "1": "Technician"
    },
    "weightkg": 1.5,
    "evos": [
      "Dartrix"
    ],
    "eggGroups": [
      "Flying"
    ]
  },
  "dartrix": {
    "num": 723,
    "name": "Dartrix",
    "types": [
      "Grass",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 63,
      "atk": 75,
      "def": 70,
      "spe": 82,
      "spa": 75,
      "spd": 70
    },
    "abilities": {
      "0": "Overgrow",
      "1": "Technician"
    },
    "weightkg": 16.0,
    "prevo": "Rowlet",
    "evoLevel": 17,
    "evos": [
      "Decidueye"
    ],
    "eggGroups": [
      "Flying"
    ]
  },
  "decidueye": {
    "num": 724,
    "name": "Decidueye",
    "types": [
      "Grass",
      "Ghost"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 73,
      "atk": 110,
      "def": 70,
      "spe": 117,
      "spa": 110,
      "spd": 70
    },
    "abilities": {
      "0": "No Guard",
      "1": "Technician",
      "H": "Tinted Lens"
    },
    "weightkg": 36.6,
    "prevo": "Dartrix",
    "evoLevel": 36,
    "eggGroups": [
      "Flying"
    ]
  },
  "litten": {
    "num": 725,
    "name": "Litten",
    "types": [
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 65,
      "def": 45,
      "spe": 75,
      "spa": 45,
      "spd": 45
    },
    "abilities": {
      "0": "Blaze",
      "1": "Intimidate"
    },
    "weightkg": 4.3,
    "evos": [
      "Torracat"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "torracat": {
    "num": 726,
    "name": "Torracat",
    "types": [
      "Fire"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 90,
      "def": 60,
      "spe": 100,
      "spa": 60,
      "spd": 60
    },
    "abilities": {
      "0": "Blaze",
      "1": "Intimidate"
    },
    "weightkg": 25.0,
    "prevo": "Litten",
    "evoLevel": 17,
    "evos": [
      "Incineroar"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "incineroar": {
    "num": 727,
    "name": "Incineroar",
    "types": [
      "Fire",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 95,
      "atk": 125,
      "def": 90,
      "spe": 80,
      "spa": 70,
      "spd": 90
    },
    "abilities": {
      "0": "Moxie",
      "1": "Intimidate"
    },
    "weightkg": 83.0,
    "prevo": "Torracat",
    "evoLevel": 36,
    "eggGroups": [
      "Field"
    ]
  },
  "popplio": {
    "num": 728,
    "name": "Popplio",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 49,
      "def": 54,
      "spe": 40,
      "spa": 66,
      "spd": 61
    },
    "abilities": {
      "0": "Torrent",
      "1": "Competitive"
    },
    "weightkg": 7.5,
    "evos": [
      "Brionne"
    ],
    "eggGroups": [
      "Water 1",
      "Field"
    ]
  },
  "brionne": {
    "num": 729,
    "name": "Brionne",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 64,
      "def": 74,
      "spe": 50,
      "spa": 96,
      "spd": 91
    },
    "abilities": {
      "0": "Torrent",
      "1": "Competitive"
    },
    "weightkg": 17.5,
    "prevo": "Popplio",
    "evoLevel": 17,
    "evos": [
      "Primarina"
    ],
    "eggGroups": [
      "Water 1",
      "Field"
    ]
  },
  "primarina": {
    "num": 730,
    "name": "Primarina",
    "types": [
      "Water",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 85,
      "atk": 74,
      "def": 84,
      "spe": 60,
      "spa": 126,
      "spd": 121
    },
    "abilities": {
      "0": "Pixilate",
      "1": "Competitive"
    },
    "weightkg": 44.0,
    "prevo": "Brionne",
    "evoLevel": 36,
    "eggGroups": [
      "Water 1",
      "Field"
    ]
  },
  "pikipek": {
    "num": 731,
    "name": "Pikipek",
    "types": [
      "Normal",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 75,
      "def": 40,
      "spe": 75,
      "spa": 40,
      "spd": 40
    },
    "abilities": {
      "0": "Bird's Eye View",
      "1": "Rapid Fire"
    },
    "weightkg": 1.2,
    "evos": [
      "Trumbeak"
    ],
    "eggGroups": [
      "Flying"
    ]
  },
  "trumbeak": {
    "num": 732,
    "name": "Trumbeak",
    "types": [
      "Normal",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 55,
      "atk": 90,
      "def": 50,
      "spe": 95,
      "spa": 80,
      "spd": 50
    },
    "abilities": {
      "0": "Amplifier",
      "1": "Rapid Fire"
    },
    "weightkg": 14.8,
    "prevo": "Pikipek",
    "evoLevel": 15,
    "evos": [
      "Toucannon"
    ],
    "eggGroups": [
      "Flying"
    ]
  },
  "toucannon": {
    "num": 733,
    "name": "Toucannon",
    "types": [
      "Normal",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 125,
      "def": 80,
      "spe": 60,
      "spa": 125,
      "spd": 80
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Rapid Fire"
    },
    "weightkg": 26.0,
    "prevo": "Trumbeak",
    "evoLevel": 31,
    "eggGroups": [
      "Flying"
    ]
  },
  "yungoos": {
    "num": 734,
    "name": "Yungoos",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 75,
      "def": 45,
      "spe": 90,
      "spa": 30,
      "spd": 45
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Hustle",
      "H": "Stakeout"
    },
    "weightkg": 6.0,
    "evos": [
      "Gumshoos",
      "Gumshoos-Totem"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "gumshoos": {
    "num": 735,
    "name": "Gumshoos",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 115,
      "def": 75,
      "spe": 90,
      "spa": 50,
      "spd": 75
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Ruthless",
      "H": "Stakeout"
    },
    "weightkg": 14.2,
    "prevo": "Yungoos",
    "evoLevel": 20,
    "eggGroups": [
      "Field"
    ],
    "formes": [
      "Gumshoos",
      "Gumshoos-Totem"
    ]
  },
  "gumshoostotem": {
    "num": 735,
    "name": "Gumshoos-Totem",
    "types": [
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 100,
      "atk": 125,
      "def": 75,
      "spe": 90,
      "spa": 50,
      "spd": 75
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Contrary",
      "H": "Stakeout"
    },
    "weightkg": 60.0,
    "prevo": "Yungoos",
    "evoLevel": 20,
    "evoType": "useItem",
    "evoItem": "Strange Souvenir",
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Gumshoos",
    "forme": "Totem",
    "formes": [
      "Gumshoos",
      "Gumshoos-Totem"
    ]
  },
  "grubbin": {
    "num": 736,
    "name": "Grubbin",
    "types": [
      "Bug"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 47,
      "atk": 72,
      "def": 55,
      "spe": 46,
      "spa": 60,
      "spd": 55
    },
    "abilities": {
      "0": "Sap Sipper",
      "1": "Volt Absorb"
    },
    "weightkg": 4.4,
    "evos": [
      "Charjabug"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "charjabug": {
    "num": 737,
    "name": "Charjabug",
    "types": [
      "Bug",
      "Electric"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 62,
      "atk": 82,
      "def": 110,
      "spe": 36,
      "spa": 75,
      "spd": 90
    },
    "abilities": {
      "0": "Battle Armor",
      "1": "Volt Absorb",
      "H": "Battery"
    },
    "weightkg": 10.5,
    "prevo": "Grubbin",
    "evoLevel": 20,
    "evos": [
      "Vikavolt",
      "Vikavolt-Totem"
    ],
    "eggGroups": [
      "Bug"
    ]
  },
  "vikavolt": {
    "num": 738,
    "name": "Vikavolt",
    "types": [
      "Bug",
      "Electric"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 72,
      "atk": 70,
      "def": 90,
      "spe": 123,
      "spa": 145,
      "spd": 75
    },
    "abilities": {
      "0": "No Guard",
      "1": "Levitate"
    },
    "weightkg": 45.0,
    "prevo": "Charjabug",
    "evoLevel": 40,
    "evoType": "levelHold",
    "evoItem": "Electric Gem",
    "eggGroups": [
      "Bug"
    ],
    "formes": [
      "Vikavolt",
      "Vikavolt-Totem"
    ]
  },
  "vikavolttotem": {
    "num": 738,
    "name": "Vikavolt-Totem",
    "types": [
      "Bug",
      "Electric"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 92,
      "atk": 100,
      "def": 90,
      "spe": 123,
      "spa": 145,
      "spd": 75
    },
    "abilities": {
      "0": "Hustle",
      "1": "Levitate"
    },
    "weightkg": 147.5,
    "prevo": "Charjabug",
    "evoLevel": 40,
    "evoType": "levelHold",
    "evoItem": "Strange Souvenir",
    "eggGroups": [
      "Bug"
    ],
    "baseSpecies": "Vikavolt",
    "forme": "Totem",
    "formes": [
      "Vikavolt",
      "Vikavolt-Totem"
    ]
  },
  "crabrawler": {
    "num": 739,
    "name": "Crabrawler",
    "types": [
      "Fighting",
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 72,
      "atk": 114,
      "def": 107,
      "spe": 68,
      "spa": 32,
      "spd": 87
    },
    "abilities": {
      "0": "Hustle",
      "1": "Regenerator",
      "H": "Scrappy"
    },
    "weightkg": 7.0,
    "evos": [
      "Crabominable"
    ],
    "eggGroups": [
      "Water 3"
    ]
  },
  "crabominable": {
    "num": 740,
    "name": "Crabominable",
    "types": [
      "Fighting",
      "Ice"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 97,
      "atk": 134,
      "def": 117,
      "spe": 63,
      "spa": 42,
      "spd": 97
    },
    "abilities": {
      "0": "Hustle",
      "1": "Slush Rush",
      "H": "Scrappy"
    },
    "weightkg": 180.0,
    "prevo": "Crabrawler",
    "evoLevel": 32,
    "evoType": "levelHold",
    "evoItem": "Ice Gem",
    "eggGroups": [
      "Water 3"
    ]
  },
  "oricorio": {
    "num": 741,
    "name": "Oricorio",
    "types": [
      "Fire",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 66,
      "atk": 70,
      "def": 70,
      "spe": 109,
      "spa": 114,
      "spd": 86
    },
    "abilities": {
      "0": "Serene Grace",
      "1": "Unburden"
    },
    "weightkg": 3.4,
    "eggGroups": [
      "Flying"
    ],
    "formes": [
      "Oricorio",
      "Oricorio-Pom-Pom",
      "Oricorio-Pa'u",
      "Oricorio-Sensu"
    ]
  },
  "oricoriopompom": {
    "num": 741,
    "name": "Oricorio-Pom-Pom",
    "types": [
      "Electric",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 66,
      "atk": 70,
      "def": 70,
      "spe": 109,
      "spa": 114,
      "spd": 86
    },
    "abilities": {
      "0": "Serene Grace",
      "1": "Unburden"
    },
    "weightkg": 3.4,
    "eggGroups": [
      "Flying"
    ],
    "baseSpecies": "Oricorio",
    "forme": "Pom-Pom",
    "formes": [
      "Oricorio",
      "Oricorio-Pom-Pom",
      "Oricorio-Pa'u",
      "Oricorio-Sensu"
    ]
  },
  "oricoriopau": {
    "num": 741,
    "name": "Oricorio-Pa'u",
    "types": [
      "Psychic",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 66,
      "atk": 70,
      "def": 70,
      "spe": 109,
      "spa": 114,
      "spd": 86
    },
    "abilities": {
      "0": "Serene Grace",
      "1": "Unburden"
    },
    "weightkg": 3.4,
    "eggGroups": [
      "Flying"
    ],
    "baseSpecies": "Oricorio",
    "forme": "Pa'u",
    "formes": [
      "Oricorio",
      "Oricorio-Pom-Pom",
      "Oricorio-Pa'u",
      "Oricorio-Sensu"
    ]
  },
  "oricoriosensu": {
    "num": 741,
    "name": "Oricorio-Sensu",
    "types": [
      "Ghost",
      "Flying"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 66,
      "atk": 70,
      "def": 70,
      "spe": 109,
      "spa": 114,
      "spd": 86
    },
    "abilities": {
      "0": "Serene Grace",
      "1": "Unburden"
    },
    "weightkg": 3.4,
    "eggGroups": [
      "Flying"
    ],
    "baseSpecies": "Oricorio",
    "forme": "Sensu",
    "formes": [
      "Oricorio",
      "Oricorio-Pom-Pom",
      "Oricorio-Pa'u",
      "Oricorio-Sensu"
    ]
  },
  "cutiefly": {
    "num": 742,
    "name": "Cutiefly",
    "types": [
      "Bug",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 40,
      "atk": 45,
      "def": 40,
      "spe": 109,
      "spa": 66,
      "spd": 50
    },
    "abilities": {
      "0": "Levitate",
      "1": "Fairy Aura"
    },
    "weightkg": 0.2,
    "evos": [
      "Ribombee",
      "Ribombee-Totem"
    ],
    "eggGroups": [
      "Bug",
      "Fairy"
    ]
  },
  "ribombee": {
    "num": 743,
    "name": "Ribombee",
    "types": [
      "Fairy",
      "Bug"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 55,
      "def": 60,
      "spe": 134,
      "spa": 111,
      "spd": 95
    },
    "abilities": {
      "0": "Levitate",
      "1": "Fairy Aura"
    },
    "weightkg": 0.5,
    "prevo": "Cutiefly",
    "evoLevel": 22,
    "eggGroups": [
      "Bug",
      "Fairy"
    ],
    "formes": [
      "Ribombee",
      "Ribombee-Totem"
    ]
  },
  "ribombeetotem": {
    "num": 743,
    "name": "Ribombee-Totem",
    "types": [
      "Fairy",
      "Bug"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 85,
      "atk": 55,
      "def": 60,
      "spe": 134,
      "spa": 116,
      "spd": 100
    },
    "abilities": {
      "0": "Levitate",
      "1": "Serene Grace"
    },
    "weightkg": 2.0,
    "prevo": "Cutiefly",
    "evoLevel": 22,
    "evoType": "useItem",
    "evoItem": "Strange Souvenir",
    "eggGroups": [
      "Bug",
      "Fairy"
    ],
    "baseSpecies": "Ribombee",
    "forme": "Totem",
    "formes": [
      "Ribombee",
      "Ribombee-Totem"
    ]
  },
  "rockruff": {
    "num": 744,
    "name": "Rockruff",
    "types": [
      "Rock",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 75,
      "def": 65,
      "spe": 80,
      "spa": 30,
      "spd": 50
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Hustle"
    },
    "weightkg": 0.5,
    "evos": [
      "Lycanroc",
      "Lycanroc-Midnight",
      "Lycanroc-Dusk"
    ],
    "eggGroups": [
      "Field"
    ],
    "formes": [
      "Rockruff"
    ]
  },
  "lycanroc": {
    "num": 745,
    "name": "Lycanroc",
    "types": [
      "Rock",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 120,
      "def": 73,
      "spe": 127,
      "spa": 55,
      "spd": 65
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Hustle",
      "H": "Guts"
    },
    "weightkg": 25.0,
    "prevo": "Rockruff",
    "evoLevel": 28,
    "evoType": "levelHold",
    "evoItem": "Normal Gem",
    "eggGroups": [
      "Field"
    ],
    "formes": [
      "Lycanroc",
      "Lycanroc-Midnight",
      "Lycanroc-Dusk"
    ]
  },
  "lycanrocmidnight": {
    "num": 745,
    "name": "Lycanroc-Midnight",
    "types": [
      "Rock",
      "Dark"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 120,
      "def": 93,
      "spe": 97,
      "spa": 55,
      "spd": 75
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Ruthless"
    },
    "weightkg": 25.0,
    "prevo": "Rockruff",
    "evoLevel": 28,
    "evoType": "levelHold",
    "evoItem": "Dark Gem",
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Lycanroc",
    "forme": "Midnight",
    "formes": [
      "Lycanroc",
      "Lycanroc-Midnight",
      "Lycanroc-Dusk"
    ]
  },
  "lycanrocdusk": {
    "num": 745,
    "name": "Lycanroc-Dusk",
    "types": [
      "Rock",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 75,
      "atk": 120,
      "def": 83,
      "spe": 112,
      "spa": 55,
      "spd": 70
    },
    "abilities": {
      "0": "Intimidate",
      "1": "Reckless"
    },
    "weightkg": 25.0,
    "prevo": "Rockruff",
    "evoLevel": 28,
    "evoType": "levelHold",
    "evoItem": "Fighting Gem",
    "eggGroups": [
      "Field"
    ],
    "baseSpecies": "Lycanroc",
    "forme": "Dusk",
    "formes": [
      "Lycanroc",
      "Lycanroc-Midnight",
      "Lycanroc-Dusk"
    ]
  },
  "wishiwashi": {
    "num": 746,
    "name": "Wishiwashi",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 25,
      "atk": 25,
      "def": 25,
      "spe": 100,
      "spa": 25,
      "spd": 25
    },
    "abilities": {
      "0": "Schooling"
    },
    "weightkg": 0.3,
    "eggGroups": [
      "Water 2"
    ],
    "formes": [
      "Wishiwashi",
      "Wishiwashi-School"
    ]
  },
  "wishiwashischool": {
    "num": 746,
    "name": "Wishiwashi-School",
    "types": [
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 150,
      "atk": 125,
      "def": 150,
      "spe": 25,
      "spa": 125,
      "spd": 150
    },
    "abilities": {
      "0": "Schooling"
    },
    "weightkg": 78.6,
    "eggGroups": [
      "Water 2"
    ],
    "baseSpecies": "Wishiwashi",
    "forme": "School",
    "formes": [
      "Wishiwashi",
      "Wishiwashi-School"
    ]
  },
  "mareanie": {
    "num": 747,
    "name": "Mareanie",
    "types": [
      "Poison",
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 50,
      "atk": 43,
      "def": 92,
      "spe": 40,
      "spa": 63,
      "spd": 82
    },
    "abilities": {
      "0": "Merciless",
      "1": "Regenerator"
    },
    "weightkg": 8.0,
    "evos": [
      "Toxapex"
    ],
    "eggGroups": [
      "Water 1"
    ]
  },
  "toxapex": {
    "num": 748,
    "name": "Toxapex",
    "types": [
      "Poison",
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 53,
      "def": 152,
      "spe": 35,
      "spa": 93,
      "spd": 142
    },
    "abilities": {
      "0": "Merciless",
      "1": "Regenerator"
    },
    "weightkg": 14.5,
    "prevo": "Mareanie",
    "evoLevel": 34,
    "eggGroups": [
      "Water 1"
    ]
  },
  "mudbray": {
    "num": 749,
    "name": "Mudbray",
    "types": [
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 100,
      "def": 85,
      "spe": 45,
      "spa": 45,
      "spd": 65
    },
    "abilities": {
      "0": "Stamina",
      "1": "Sap Sipper"
    },
    "weightkg": 110.0,
    "evos": [
      "Mudsdale"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "mudsdale": {
    "num": 750,
    "name": "Mudsdale",
    "types": [
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 115,
      "atk": 130,
      "def": 115,
      "spe": 35,
      "spa": 55,
      "spd": 85
    },
    "abilities": {
      "0": "Stamina",
      "1": "Sap Sipper"
    },
    "weightkg": 110.0,
    "prevo": "Mudbray",
    "evoLevel": 34,
    "eggGroups": [
      "Field"
    ]
  },
  "dewpider": {
    "num": 751,
    "name": "Dewpider",
    "types": [
      "Water",
      "Bug"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 44,
      "atk": 45,
      "def": 67,
      "spe": 27,
      "spa": 60,
      "spd": 107
    },
    "abilities": {
      "0": "Liquid Veil",
      "1": "Drizzle"
    },
    "weightkg": 4.0,
    "evos": [
      "Araquanid",
      "Araquanid-Totem"
    ],
    "eggGroups": [
      "Water 1",
      "Bug"
    ]
  },
  "araquanid": {
    "num": 752,
    "name": "Araquanid",
    "types": [
      "Water",
      "Bug"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 94,
      "atk": 70,
      "def": 92,
      "spe": 67,
      "spa": 80,
      "spd": 132
    },
    "abilities": {
      "0": "Liquid Veil",
      "1": "Drizzle"
    },
    "weightkg": 82.0,
    "prevo": "Dewpider",
    "evoLevel": 28,
    "eggGroups": [
      "Water 1",
      "Bug"
    ],
    "formes": [
      "Araquanid",
      "Araquanid-Totem"
    ]
  },
  "araquanidtotem": {
    "num": 752,
    "name": "Araquanid-Totem",
    "types": [
      "Water",
      "Bug"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 124,
      "atk": 70,
      "def": 92,
      "spe": 52,
      "spa": 80,
      "spd": 132
    },
    "abilities": {
      "0": "Liquid Veil",
      "1": "Huge Power"
    },
    "weightkg": 217.5,
    "prevo": "Dewpider",
    "evoLevel": 28,
    "evoType": "useItem",
    "evoItem": "Strange Souvenir",
    "eggGroups": [
      "Water 1",
      "Bug"
    ],
    "baseSpecies": "Araquanid",
    "forme": "Totem",
    "formes": [
      "Araquanid",
      "Araquanid-Totem"
    ]
  },
  "fomantis": {
    "num": 753,
    "name": "Fomantis",
    "types": [
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 70,
      "def": 60,
      "spe": 75,
      "spa": 60,
      "spd": 60
    },
    "abilities": {
      "0": "Grassy Guard",
      "1": "Contrary"
    },
    "weightkg": 1.5,
    "evos": [
      "Lurantis",
      "Lurantis-Totem"
    ],
    "eggGroups": [
      "Grass"
    ]
  },
  "lurantis": {
    "num": 754,
    "name": "Lurantis",
    "types": [
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 110,
      "def": 90,
      "spe": 105,
      "spa": 60,
      "spd": 90
    },
    "abilities": {
      "0": "Super Luck",
      "1": "Contrary",
      "H": "Tinted Lens"
    },
    "weightkg": 18.5,
    "prevo": "Fomantis",
    "evoLevel": 22,
    "eggGroups": [
      "Grass"
    ],
    "formes": [
      "Lurantis",
      "Lurantis-Totem"
    ]
  },
  "lurantistotem": {
    "num": 754,
    "name": "Lurantis-Totem",
    "types": [
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 90,
      "atk": 110,
      "def": 90,
      "spe": 95,
      "spa": 100,
      "spd": 90
    },
    "abilities": {
      "0": "Adaptability",
      "1": "Contrary",
      "H": "Tinted Lens"
    },
    "weightkg": 58.0,
    "prevo": "Fomantis",
    "evoLevel": 22,
    "evoType": "useItem",
    "evoItem": "Strange Souvenir",
    "eggGroups": [
      "Grass"
    ],
    "baseSpecies": "Lurantis",
    "forme": "Totem",
    "formes": [
      "Lurantis",
      "Lurantis-Totem"
    ]
  },
  "morelull": {
    "num": 755,
    "name": "Morelull",
    "types": [
      "Poison",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 35,
      "def": 65,
      "spe": 15,
      "spa": 75,
      "spd": 95
    },
    "abilities": {
      "0": "Regenerator",
      "1": "Storm Drain",
      "H": "Dazzling"
    },
    "weightkg": 1.5,
    "evos": [
      "Shiinotic"
    ],
    "eggGroups": [
      "Grass"
    ]
  },
  "shiinotic": {
    "num": 756,
    "name": "Shiinotic",
    "types": [
      "Poison",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 85,
      "atk": 45,
      "def": 95,
      "spe": 30,
      "spa": 115,
      "spd": 145
    },
    "abilities": {
      "0": "Regenerator",
      "1": "Storm Drain",
      "H": "Dazzling"
    },
    "weightkg": 11.5,
    "prevo": "Morelull",
    "evoLevel": 29,
    "eggGroups": [
      "Grass"
    ]
  },
  "salandit": {
    "num": 757,
    "name": "Salandit",
    "types": [
      "Poison",
      "Fire"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 48,
      "atk": 44,
      "def": 40,
      "spe": 94,
      "spa": 91,
      "spd": 53
    },
    "abilities": {
      "0": "Dry Skin",
      "1": "Prankster",
      "H": "Corrosion"
    },
    "weightkg": 4.8,
    "evos": [
      "Salazzle",
      "Salazzle-Totem"
    ],
    "eggGroups": [
      "Monster",
      "Dragon"
    ]
  },
  "salazzle": {
    "num": 758,
    "name": "Salazzle",
    "types": [
      "Poison",
      "Fire"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 73,
      "atk": 64,
      "def": 60,
      "spe": 124,
      "spa": 121,
      "spd": 83
    },
    "abilities": {
      "0": "Dry Skin",
      "1": "Merciless",
      "H": "Corrosion"
    },
    "weightkg": 22.2,
    "prevo": "Salandit",
    "evoLevel": 31,
    "eggGroups": [
      "Monster",
      "Dragon"
    ],
    "formes": [
      "Salazzle",
      "Salazzle-Totem"
    ]
  },
  "salazzletotem": {
    "num": 758,
    "name": "Salazzle-Totem",
    "types": [
      "Poison",
      "Fire"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 98,
      "atk": 64,
      "def": 60,
      "spe": 124,
      "spa": 121,
      "spd": 83
    },
    "abilities": {
      "0": "Dry Skin",
      "1": "Hubris"
    },
    "weightkg": 81.0,
    "prevo": "Salandit",
    "evoLevel": 31,
    "evoType": "useItem",
    "evoItem": "Strange Souvenir",
    "evoCondition": "on female",
    "eggGroups": [
      "Monster",
      "Dragon"
    ],
    "baseSpecies": "Salazzle",
    "forme": "Totem",
    "formes": [
      "Salazzle",
      "Salazzle-Totem"
    ]
  },
  "stufful": {
    "num": 759,
    "name": "Stufful",
    "types": [
      "Normal",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 60,
      "atk": 80,
      "def": 65,
      "spe": 55,
      "spa": 45,
      "spd": 65
    },
    "abilities": {
      "0": "Fluffy",
      "1": "Hustle"
    },
    "weightkg": 6.8,
    "evos": [
      "Bewear"
    ],
    "eggGroups": [
      "Field"
    ]
  },
  "bewear": {
    "num": 760,
    "name": "Bewear",
    "types": [
      "Normal",
      "Fighting"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 120,
      "atk": 130,
      "def": 85,
      "spe": 60,
      "spa": 55,
      "spd": 85
    },
    "abilities": {
      "0": "Fluffy",
      "1": "Hustle"
    },
    "weightkg": 135.0,
    "prevo": "Stufful",
    "evoLevel": 34,
    "eggGroups": [
      "Field"
    ]
  },
  "bounsweet": {
    "num": 761,
    "name": "Bounsweet",
    "types": [
      "Grass"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 42,
      "atk": 30,
      "def": 83,
      "spe": 32,
      "spa": 30,
      "spd": 83
    },
    "abilities": {
      "0": "Grassy Guard",
      "1": "Harvest"
    },
    "weightkg": 3.2,
    "evos": [
      "Steenee"
    ],
    "eggGroups": [
      "Grass"
    ]
  },
  "steenee": {
    "num": 762,
    "name": "Steenee",
    "types": [
      "Grass"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 62,
      "atk": 70,
      "def": 88,
      "spe": 72,
      "spa": 40,
      "spd": 88
    },
    "abilities": {
      "0": "Grassy Guard",
      "1": "Unburden"
    },
    "weightkg": 8.2,
    "prevo": "Bounsweet",
    "evoLevel": 16,
    "evos": [
      "Tsareena"
    ],
    "eggGroups": [
      "Grass"
    ]
  },
  "tsareena": {
    "num": 763,
    "name": "Tsareena",
    "types": [
      "Grass",
      "Fighting"
    ],
    "gender": "F",
    "baseStats": {
      "hp": 77,
      "atk": 125,
      "def": 98,
      "spe": 102,
      "spa": 50,
      "spd": 98
    },
    "abilities": {
      "0": "Queenly Majesty",
      "1": "Expertise"
    },
    "weightkg": 21.4,
    "prevo": "Steenee",
    "evoLevel": 32,
    "eggGroups": [
      "Grass"
    ]
  },
  "comfey": {
    "num": 764,
    "name": "Comfey",
    "types": [
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.25,
      "F": 0.75
    },
    "baseStats": {
      "hp": 66,
      "atk": 42,
      "def": 90,
      "spe": 100,
      "spa": 92,
      "spd": 135
    },
    "abilities": {
      "0": "Regenerator",
      "1": "Grassy Surge",
      "H": "Friend Guard"
    },
    "weightkg": 0.3,
    "eggGroups": [
      "Grass"
    ]
  },
  "oranguru": {
    "num": 765,
    "name": "Oranguru",
    "types": [
      "Psychic",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 90,
      "atk": 60,
      "def": 85,
      "spe": 40,
      "spa": 135,
      "spd": 125
    },
    "abilities": {
      "0": "Pure Power",
      "1": "Grassy Surge"
    },
    "weightkg": 6.9,
    "eggGroups": [
      "Field"
    ]
  },
  "passimian": {
    "num": 766,
    "name": "Passimian",
    "types": [
      "Fighting",
      "Normal"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 100,
      "atk": 130,
      "def": 90,
      "spe": 105,
      "spa": 40,
      "spd": 70
    },
    "abilities": {
      "0": "Unburden",
      "1": "Headstrong",
      "H": "Quick Feet"
    },
    "weightkg": 82.8,
    "eggGroups": [
      "Field"
    ]
  },
  "wimpod": {
    "num": 767,
    "name": "Wimpod",
    "types": [
      "Bug",
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 45,
      "def": 95,
      "spe": 95,
      "spa": 25,
      "spd": 45
    },
    "abilities": {
      "0": "Rattled",
      "1": "Wimp Out"
    },
    "weightkg": 12.0,
    "evos": [
      "Golisopod"
    ],
    "eggGroups": [
      "Bug",
      "Water 3"
    ]
  },
  "golisopod": {
    "num": 768,
    "name": "Golisopod",
    "types": [
      "Bug",
      "Water"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 90,
      "atk": 140,
      "def": 140,
      "spe": 60,
      "spa": 30,
      "spd": 90
    },
    "abilities": {
      "0": "Ruthless",
      "1": "Swift Swim"
    },
    "weightkg": 108.0,
    "prevo": "Wimpod",
    "evoLevel": 30,
    "eggGroups": [
      "Bug",
      "Water 3"
    ]
  },
  "sandygast": {
    "num": 769,
    "name": "Sandygast",
    "types": [
      "Ghost",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 55,
      "atk": 30,
      "def": 95,
      "spe": 15,
      "spa": 80,
      "spd": 95
    },
    "abilities": {
      "0": "Sand Stream",
      "1": "Regenerator"
    },
    "weightkg": 70.0,
    "evos": [
      "Palossand"
    ],
    "eggGroups": [
      "Amorphous"
    ]
  },
  "palossand": {
    "num": 770,
    "name": "Palossand",
    "types": [
      "Ghost",
      "Ground"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 110,
      "atk": 60,
      "def": 115,
      "spe": 25,
      "spa": 110,
      "spd": 115
    },
    "abilities": {
      "0": "Sand Stream",
      "1": "Regenerator"
    },
    "weightkg": 250.0,
    "prevo": "Sandygast",
    "evoLevel": 33,
    "eggGroups": [
      "Amorphous"
    ]
  },
  "pyukumuku": {
    "num": 771,
    "name": "Pyukumuku",
    "types": [
      "Water",
      "Poison"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 65,
      "def": 180,
      "spe": 5,
      "spa": 40,
      "spd": 180
    },
    "abilities": {
      "0": "Oblivious",
      "1": "Simple",
      "H": "Unaware"
    },
    "weightkg": 1.2,
    "eggGroups": [
      "Water 1"
    ]
  },
  "typenull": {
    "num": 772,
    "name": "Type: Null",
    "types": [
      "Normal",
      "Steel"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 95,
      "atk": 115,
      "def": 125,
      "spe": 60,
      "spa": 60,
      "spd": 95
    },
    "abilities": {
      "0": "Filter",
      "1": "Battle Armor",
      "H": "Sturdy"
    },
    "weightkg": 120.5,
    "evos": [
      "Silvally"
    ],
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "silvally": {
    "num": 773,
    "name": "Silvally",
    "types": [
      "Normal"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 95,
      "atk": 115,
      "def": 80,
      "spe": 115,
      "spa": 115,
      "spd": 80
    },
    "abilities": {
      "0": "Adaptability",
      "1": "RKS System"
    },
    "weightkg": 100.5,
    "prevo": "Type: Null",
    "evoLevel": 50,
    "evoType": "levelHold",
    "evoItem": "Normal Gem",
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "minior": {
    "num": 774,
    "name": "Minior",
    "types": [
      "Rock",
      "Flying"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 60,
      "atk": 60,
      "def": 150,
      "spe": 60,
      "spa": 60,
      "spd": 150
    },
    "abilities": {
      "0": "Shields Down"
    },
    "weightkg": 40.0,
    "eggGroups": [
      "Mineral"
    ],
    "formes": [
      "Minior",
      "Minior-Red",
      "Minior-Orange",
      "Minior-Yellow",
      "Minior-Green",
      "Minior-Blue",
      "Minior-Indigo",
      "Minior-Violet"
    ]
  },
  "miniorred": {
    "num": 774,
    "name": "Minior-Red",
    "types": [
      "Rock",
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 60,
      "atk": 60,
      "def": 60,
      "spe": 150,
      "spa": 150,
      "spd": 60
    },
    "abilities": {
      "0": "Shields Down",
      "H": "Interstellar"
    },
    "weightkg": 0.3,
    "eggGroups": [
      "Mineral"
    ],
    "baseSpecies": "Minior",
    "forme": "Red",
    "formes": [
      "Minior",
      "Minior-Red",
      "Minior-Orange",
      "Minior-Yellow",
      "Minior-Green",
      "Minior-Blue",
      "Minior-Indigo",
      "Minior-Violet"
    ]
  },
  "miniororange": {
    "num": 774,
    "name": "Minior-Orange",
    "types": [
      "Rock",
      "Fire"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 60,
      "atk": 60,
      "def": 60,
      "spe": 150,
      "spa": 150,
      "spd": 60
    },
    "abilities": {
      "0": "Shields Down",
      "H": "Interstellar"
    },
    "weightkg": 0.3,
    "eggGroups": [
      "Mineral"
    ],
    "baseSpecies": "Minior",
    "forme": "Orange",
    "formes": [
      "Minior",
      "Minior-Red",
      "Minior-Orange",
      "Minior-Yellow",
      "Minior-Green",
      "Minior-Blue",
      "Minior-Indigo",
      "Minior-Violet"
    ]
  },
  "minioryellow": {
    "num": 774,
    "name": "Minior-Yellow",
    "types": [
      "Rock",
      "Electric"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 60,
      "atk": 60,
      "def": 60,
      "spe": 150,
      "spa": 150,
      "spd": 60
    },
    "abilities": {
      "0": "Shields Down",
      "H": "Interstellar"
    },
    "weightkg": 0.3,
    "eggGroups": [
      "Mineral"
    ],
    "baseSpecies": "Minior",
    "forme": "Yellow",
    "formes": [
      "Minior",
      "Minior-Red",
      "Minior-Orange",
      "Minior-Yellow",
      "Minior-Green",
      "Minior-Blue",
      "Minior-Indigo",
      "Minior-Violet"
    ]
  },
  "miniorgreen": {
    "num": 774,
    "name": "Minior-Green",
    "types": [
      "Rock",
      "Grass"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 60,
      "atk": 60,
      "def": 60,
      "spe": 150,
      "spa": 150,
      "spd": 60
    },
    "abilities": {
      "0": "Shields Down",
      "H": "Interstellar"
    },
    "weightkg": 0.3,
    "eggGroups": [
      "Mineral"
    ],
    "baseSpecies": "Minior",
    "forme": "Green",
    "formes": [
      "Minior",
      "Minior-Red",
      "Minior-Orange",
      "Minior-Yellow",
      "Minior-Green",
      "Minior-Blue",
      "Minior-Indigo",
      "Minior-Violet"
    ]
  },
  "miniorblue": {
    "num": 774,
    "name": "Minior-Blue",
    "types": [
      "Rock",
      "Ice"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 60,
      "atk": 60,
      "def": 60,
      "spe": 150,
      "spa": 150,
      "spd": 60
    },
    "abilities": {
      "0": "Shields Down",
      "H": "Interstellar"
    },
    "weightkg": 0.3,
    "eggGroups": [
      "Mineral"
    ],
    "baseSpecies": "Minior",
    "forme": "Blue",
    "formes": [
      "Minior",
      "Minior-Red",
      "Minior-Orange",
      "Minior-Yellow",
      "Minior-Green",
      "Minior-Blue",
      "Minior-Indigo",
      "Minior-Violet"
    ]
  },
  "miniorindigo": {
    "num": 774,
    "name": "Minior-Indigo",
    "types": [
      "Rock",
      "Water"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 60,
      "atk": 60,
      "def": 60,
      "spe": 150,
      "spa": 150,
      "spd": 60
    },
    "abilities": {
      "0": "Shields Down",
      "H": "Interstellar"
    },
    "weightkg": 0.3,
    "eggGroups": [
      "Mineral"
    ],
    "baseSpecies": "Minior",
    "forme": "Indigo",
    "formes": [
      "Minior",
      "Minior-Red",
      "Minior-Orange",
      "Minior-Yellow",
      "Minior-Green",
      "Minior-Blue",
      "Minior-Indigo",
      "Minior-Violet"
    ]
  },
  "miniorviolet": {
    "num": 774,
    "name": "Minior-Violet",
    "types": [
      "Rock",
      "Dragon"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 60,
      "atk": 60,
      "def": 60,
      "spe": 150,
      "spa": 150,
      "spd": 60
    },
    "abilities": {
      "0": "Shields Down",
      "H": "Interstellar"
    },
    "weightkg": 0.3,
    "eggGroups": [
      "Mineral"
    ],
    "baseSpecies": "Minior",
    "forme": "Violet",
    "formes": [
      "Minior",
      "Minior-Red",
      "Minior-Orange",
      "Minior-Yellow",
      "Minior-Green",
      "Minior-Blue",
      "Minior-Indigo",
      "Minior-Violet"
    ]
  },
  "komala": {
    "num": 775,
    "name": "Komala",
    "types": [
      "Normal",
      "Grass"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 115,
      "def": 115,
      "spe": 65,
      "spa": 75,
      "spd": 95
    },
    "abilities": {
      "0": "Unburden",
      "1": "Comatose"
    },
    "weightkg": 19.9,
    "eggGroups": [
      "Field"
    ]
  },
  "turtonator": {
    "num": 776,
    "name": "Turtonator",
    "types": [
      "Fire",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 100,
      "atk": 78,
      "def": 140,
      "spe": 21,
      "spa": 136,
      "spd": 100
    },
    "abilities": {
      "0": "Rapid Fire",
      "1": "Bulletproof"
    },
    "weightkg": 212.0,
    "eggGroups": [
      "Monster",
      "Dragon"
    ]
  },
  "togedemaru": {
    "num": 777,
    "name": "Togedemaru",
    "types": [
      "Electric",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 65,
      "atk": 98,
      "def": 118,
      "spe": 101,
      "spa": 40,
      "spd": 93
    },
    "abilities": {
      "0": "Hustle",
      "1": "Electric Surge",
      "H": "Volt Rush"
    },
    "weightkg": 3.3,
    "eggGroups": [
      "Field",
      "Fairy"
    ],
    "formes": [
      "Togedemaru",
      "Togedemaru-Totem"
    ]
  },
  "togedemarutotem": {
    "num": 777,
    "name": "Togedemaru-Totem",
    "types": [
      "Electric",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 100,
      "atk": 108,
      "def": 118,
      "spe": 91,
      "spa": 40,
      "spd": 93
    },
    "abilities": {
      "0": "Hustle",
      "1": "Iron Barbs"
    },
    "weightkg": 13.0,
    "eggGroups": [
      "Field",
      "Fairy"
    ],
    "baseSpecies": "Togedemaru",
    "forme": "Totem",
    "formes": [
      "Togedemaru",
      "Togedemaru-Totem"
    ]
  },
  "mimikyu": {
    "num": 778,
    "name": "Mimikyu",
    "types": [
      "Ghost",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 55,
      "atk": 95,
      "def": 55,
      "spe": 106,
      "spa": 95,
      "spd": 119
    },
    "abilities": {
      "0": "Disguise",
      "1": "Prankster"
    },
    "weightkg": 0.7,
    "eggGroups": [
      "Amorphous"
    ],
    "formes": [
      "Mimikyu",
      "Mimikyu-Busted",
      "Mimikyu-Totem",
      "Mimikyu-Busted-Totem"
    ]
  },
  "mimikyubusted": {
    "num": 778,
    "name": "Mimikyu-Busted",
    "types": [
      "Ghost",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 55,
      "atk": 95,
      "def": 55,
      "spe": 106,
      "spa": 95,
      "spd": 119
    },
    "abilities": {
      "0": "Disguise",
      "1": "Prankster"
    },
    "weightkg": 0.7,
    "eggGroups": [
      "Amorphous"
    ],
    "baseSpecies": "Mimikyu",
    "forme": "Busted",
    "formes": [
      "Mimikyu",
      "Mimikyu-Busted",
      "Mimikyu-Totem",
      "Mimikyu-Busted-Totem"
    ]
  },
  "mimikyutotem": {
    "num": 778,
    "name": "Mimikyu-Totem",
    "types": [
      "Ghost",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 100,
      "def": 55,
      "spe": 96,
      "spa": 100,
      "spd": 119
    },
    "abilities": {
      "0": "Disguise",
      "1": "Unburden"
    },
    "weightkg": 2.8,
    "eggGroups": [
      "Amorphous"
    ],
    "baseSpecies": "Mimikyu",
    "forme": "Totem",
    "formes": [
      "Mimikyu",
      "Mimikyu-Busted",
      "Mimikyu-Totem",
      "Mimikyu-Busted-Totem"
    ]
  },
  "mimikyubustedtotem": {
    "num": 778,
    "name": "Mimikyu-Busted-Totem",
    "types": [
      "Ghost",
      "Fairy"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 80,
      "atk": 100,
      "def": 55,
      "spe": 96,
      "spa": 100,
      "spd": 119
    },
    "abilities": {
      "0": "Disguise",
      "1": "Unburden"
    },
    "weightkg": 2.8,
    "eggGroups": [
      "Amorphous"
    ],
    "baseSpecies": "Mimikyu",
    "forme": "Busted-Totem",
    "formes": [
      "Mimikyu",
      "Mimikyu-Busted",
      "Mimikyu-Totem",
      "Mimikyu-Busted-Totem"
    ]
  },
  "bruxish": {
    "num": 779,
    "name": "Bruxish",
    "types": [
      "Water",
      "Psychic"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 68,
      "atk": 115,
      "def": 70,
      "spe": 112,
      "spa": 100,
      "spd": 70
    },
    "abilities": {
      "0": "Psychic Surge",
      "1": "Strong Jaw"
    },
    "weightkg": 19.0,
    "eggGroups": [
      "Water 2"
    ]
  },
  "drampa": {
    "num": 780,
    "name": "Drampa",
    "types": [
      "Normal",
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 138,
      "atk": 60,
      "def": 95,
      "spe": 36,
      "spa": 145,
      "spd": 101
    },
    "abilities": {
      "0": "Simple",
      "1": "Berserk"
    },
    "weightkg": 185.0,
    "eggGroups": [
      "Monster",
      "Dragon"
    ]
  },
  "dhelmise": {
    "num": 781,
    "name": "Dhelmise",
    "types": [
      "Ghost",
      "Grass"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 125,
      "atk": 144,
      "def": 125,
      "spe": 40,
      "spa": 46,
      "spd": 95
    },
    "abilities": {
      "0": "Stormy Seas",
      "1": "Steelworker"
    },
    "weightkg": 210.0,
    "eggGroups": [
      "Mineral"
    ]
  },
  "jangmoo": {
    "num": 782,
    "name": "Jangmo-o",
    "types": [
      "Dragon"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 45,
      "atk": 60,
      "def": 85,
      "spe": 65,
      "spa": 45,
      "spd": 60
    },
    "abilities": {
      "0": "Instinct",
      "1": "Multiscale"
    },
    "weightkg": 29.7,
    "evos": [
      "Hakamo-o"
    ],
    "eggGroups": [
      "Dragon"
    ]
  },
  "hakamoo": {
    "num": 783,
    "name": "Hakamo-o",
    "types": [
      "Dragon",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 70,
      "atk": 95,
      "def": 95,
      "spe": 95,
      "spa": 55,
      "spd": 70
    },
    "abilities": {
      "0": "Instinct",
      "1": "Multiscale"
    },
    "weightkg": 47.0,
    "prevo": "Jangmo-o",
    "evoLevel": 25,
    "evos": [
      "Kommo-o",
      "Kommo-o-Totem"
    ],
    "eggGroups": [
      "Dragon"
    ]
  },
  "kommoo": {
    "num": 784,
    "name": "Kommo-o",
    "types": [
      "Dragon",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 90,
      "atk": 110,
      "def": 125,
      "spe": 85,
      "spa": 110,
      "spd": 80
    },
    "abilities": {
      "0": "Instinct",
      "1": "Multiscale"
    },
    "weightkg": 78.2,
    "prevo": "Hakamo-o",
    "evoLevel": 45,
    "evoType": "levelHold",
    "evoItem": "Dragon Gem",
    "eggGroups": [
      "Dragon"
    ],
    "formes": [
      "Kommo-o",
      "Kommo-o-Totem"
    ]
  },
  "kommoototem": {
    "num": 784,
    "name": "Kommo-o-Totem",
    "types": [
      "Dragon",
      "Steel"
    ],
    "genderRatio": {
      "M": 0.5,
      "F": 0.5
    },
    "baseStats": {
      "hp": 125,
      "atk": 120,
      "def": 125,
      "spe": 65,
      "spa": 110,
      "spd": 80
    },
    "abilities": {
      "0": "Instinct",
      "1": "Intimidate"
    },
    "weightkg": 207.5,
    "prevo": "Hakamo-o",
    "evoLevel": 45,
    "evoType": "levelHold",
    "evoItem": "Strange Souvenir",
    "eggGroups": [
      "Dragon"
    ],
    "baseSpecies": "Kommo-o",
    "forme": "Totem",
    "formes": [
      "Kommo-o",
      "Kommo-o-Totem"
    ],
    "requiredItems": [
      "Kommonium Z"
    ]
  },
  "tapukoko": {
    "num": 785,
    "name": "Tapu Koko",
    "types": [
      "Electric",
      "Fairy"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 70,
      "atk": 115,
      "def": 95,
      "spe": 135,
      "spa": 100,
      "spd": 85
    },
    "abilities": {
      "0": "Electric Surge",
      "1": "Reckless"
    },
    "weightkg": 20.5,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "tapulele": {
    "num": 786,
    "name": "Tapu Lele",
    "types": [
      "Psychic",
      "Fairy"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 70,
      "atk": 85,
      "def": 100,
      "spe": 95,
      "spa": 135,
      "spd": 115
    },
    "abilities": {
      "0": "Psychic Surge",
      "1": "Prankster"
    },
    "weightkg": 18.6,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "tapubulu": {
    "num": 787,
    "name": "Tapu Bulu",
    "types": [
      "Ground",
      "Fairy"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 100,
      "atk": 135,
      "def": 115,
      "spe": 85,
      "spa": 70,
      "spd": 95
    },
    "abilities": {
      "0": "Grassy Surge",
      "1": "Sap Sipper"
    },
    "weightkg": 45.5,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "tapufini": {
    "num": 788,
    "name": "Tapu Fini",
    "types": [
      "Water",
      "Fairy"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 100,
      "atk": 70,
      "def": 115,
      "spe": 85,
      "spa": 95,
      "spd": 135
    },
    "abilities": {
      "0": "Misty Surge",
      "1": "Fairy Aura"
    },
    "weightkg": 21.2,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "cosmog": {
    "num": 789,
    "name": "Cosmog",
    "types": [
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 43,
      "atk": 29,
      "def": 31,
      "spe": 37,
      "spa": 29,
      "spd": 31
    },
    "abilities": {
      "0": "Wimp Out",
      "1": "Unaware",
      "H": "Magic Guard"
    },
    "weightkg": 0.1,
    "evos": [
      "Cosmoem"
    ],
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "cosmoem": {
    "num": 790,
    "name": "Cosmoem",
    "types": [
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 43,
      "atk": 29,
      "def": 181,
      "spe": 37,
      "spa": 29,
      "spd": 181
    },
    "abilities": {
      "0": "Shell Armor",
      "1": "Unaware",
      "H": "Magic Guard"
    },
    "weightkg": 999.9,
    "prevo": "Cosmog",
    "evoLevel": 30,
    "evos": [
      "Solgaleo",
      "Lunala"
    ],
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "solgaleo": {
    "num": 791,
    "name": "Solgaleo",
    "types": [
      "Psychic",
      "Steel"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 139,
      "atk": 157,
      "def": 139,
      "spe": 97,
      "spa": 131,
      "spd": 137
    },
    "abilities": {
      "0": "Sweltering Sun",
      "1": "Sixth Sense",
      "H": "Magic Guard"
    },
    "weightkg": 230.0,
    "prevo": "Cosmoem",
    "evoLevel": 100,
    "evoType": "other",
    "evoCondition": "level-up with Wonder Room",
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "lunala": {
    "num": 792,
    "name": "Lunala",
    "types": [
      "Psychic",
      "Ghost"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 139,
      "atk": 113,
      "def": 113,
      "spe": 109,
      "spa": 163,
      "spd": 163
    },
    "abilities": {
      "0": "Energy Shield",
      "1": "Sixth Sense",
      "H": "Magic Guard"
    },
    "weightkg": 120.0,
    "prevo": "Cosmoem",
    "evoLevel": 100,
    "evoType": "other",
    "evoCondition": "level-up with Magic Room",
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "nihilego": {
    "num": 793,
    "name": "Nihilego",
    "types": [
      "Ice",
      "Poison"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 71,
      "atk": 47,
      "def": 53,
      "spe": 127,
      "spa": 151,
      "spd": 151
    },
    "abilities": {
      "0": "Levitate",
      "1": "Merciless",
      "H": "Magic Guard"
    },
    "weightkg": 55.5,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "buzzwole": {
    "num": 794,
    "name": "Buzzwole",
    "types": [
      "Bug",
      "Fighting"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 107,
      "atk": 151,
      "def": 139,
      "spe": 79,
      "spa": 53,
      "spd": 71
    },
    "abilities": {
      "0": "Moxie",
      "1": "Regenerator"
    },
    "weightkg": 333.6,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "pheromosa": {
    "num": 795,
    "name": "Pheromosa",
    "types": [
      "Bug",
      "Ice"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 83,
      "atk": 139,
      "def": 37,
      "spe": 167,
      "spa": 137,
      "spd": 37
    },
    "abilities": {
      "0": "Queenly Majesty",
      "1": "Technician",
      "H": "Tinted Lens"
    },
    "weightkg": 25.0,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "xurkitree": {
    "num": 796,
    "name": "Xurkitree",
    "types": [
      "Electric",
      "Grass"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 113,
      "atk": 89,
      "def": 71,
      "spe": 53,
      "spa": 173,
      "spd": 101
    },
    "abilities": {
      "0": "Volt Rush",
      "1": "Dazzling"
    },
    "weightkg": 100.0,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "celesteela": {
    "num": 797,
    "name": "Celesteela",
    "types": [
      "Steel",
      "Flying"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 137,
      "atk": 73,
      "def": 103,
      "spe": 47,
      "spa": 137,
      "spd": 103
    },
    "abilities": {
      "0": "Huge Power",
      "1": "Speed Boost"
    },
    "weightkg": 999.9,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "kartana": {
    "num": 798,
    "name": "Kartana",
    "types": [
      "Grass",
      "Steel"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 47,
      "atk": 181,
      "def": 113,
      "spe": 151,
      "spa": 61,
      "spd": 47
    },
    "abilities": {
      "0": "Ruthless",
      "1": "Proficiency"
    },
    "weightkg": 0.1,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "guzzlord": {
    "num": 799,
    "name": "Guzzlord",
    "types": [
      "Dark",
      "Dragon"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 199,
      "atk": 79,
      "def": 79,
      "spe": 13,
      "spa": 151,
      "spd": 79
    },
    "abilities": {
      "0": "Huge Power",
      "1": "Sinister",
      "H": "Intimidate"
    },
    "weightkg": 888.0,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "necrozma": {
    "num": 800,
    "name": "Necrozma",
    "types": [
      "Psychic",
      "Dark"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 139,
      "atk": 149,
      "def": 131,
      "spe": 101,
      "spa": 149,
      "spd": 131
    },
    "abilities": {
      "0": "Ruthless",
      "1": "Berserk"
    },
    "weightkg": 230.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "formes": [
      "Necrozma",
      "Necrozma-Dusk-Mane",
      "Necrozma-Dawn-Wings",
      "Necrozma-Ultra"
    ]
  },
  "necrozmaduskmane": {
    "num": 800,
    "name": "Necrozma-Dusk-Mane",
    "types": [
      "Psychic",
      "Steel"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 139,
      "atk": 173,
      "def": 157,
      "spe": 101,
      "spa": 173,
      "spd": 157
    },
    "abilities": {
      "0": "Sweltering Sun",
      "1": "Berserk"
    },
    "weightkg": 460.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Necrozma",
    "forme": "Dusk-Mane",
    "formes": [
      "Necrozma",
      "Necrozma-Dusk-Mane",
      "Necrozma-Dawn-Wings",
      "Necrozma-Ultra"
    ]
  },
  "necrozmadawnwings": {
    "num": 800,
    "name": "Necrozma-Dawn-Wings",
    "types": [
      "Psychic",
      "Ghost"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 139,
      "atk": 137,
      "def": 139,
      "spe": 127,
      "spa": 179,
      "spd": 179
    },
    "abilities": {
      "0": "Energy Shield",
      "1": "Berserk"
    },
    "weightkg": 350.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Necrozma",
    "forme": "Dawn-Wings",
    "formes": [
      "Necrozma",
      "Necrozma-Dusk-Mane",
      "Necrozma-Dawn-Wings",
      "Necrozma-Ultra"
    ]
  },
  "necrozmaultra": {
    "num": 800,
    "name": "Necrozma-Ultra",
    "types": [
      "Psychic",
      "Dragon"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 139,
      "atk": 199,
      "def": 107,
      "spe": 199,
      "spa": 199,
      "spd": 157
    },
    "abilities": {
      "0": "Dazzling",
      "1": "Neuroforce"
    },
    "weightkg": 230.0,
    "eggGroups": [
      "Undiscovered"
    ],
    "baseSpecies": "Necrozma",
    "forme": "Ultra",
    "formes": [
      "Necrozma",
      "Necrozma-Dusk-Mane",
      "Necrozma-Dawn-Wings",
      "Necrozma-Ultra"
    ]
  },
  "magearna": {
    "num": 801,
    "name": "Magearna",
    "types": [
      "Steel",
      "Fairy"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 80,
      "atk": 65,
      "def": 130,
      "spe": 65,
      "spa": 130,
      "spd": 130
    },
    "abilities": {
      "0": "Steelworker",
      "1": "Fairy Aura"
    },
    "weightkg": 80.5,
    "eggGroups": [
      "Undiscovered"
    ],
    "formes": [
      "Magearna"
    ]
  },
  "marshadow": {
    "num": 802,
    "name": "Marshadow",
    "types": [
      "Fighting",
      "Ghost"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 60,
      "atk": 125,
      "def": 60,
      "spe": 140,
      "spa": 125,
      "spd": 90
    },
    "abilities": {
      "0": "Instinct",
      "1": "Expertise"
    },
    "weightkg": 22.2,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "poipole": {
    "num": 803,
    "name": "Poipole",
    "types": [
      "Poison",
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 67,
      "atk": 31,
      "def": 73,
      "spe": 101,
      "spa": 101,
      "spd": 127
    },
    "abilities": {
      "0": "Levitate",
      "1": "Prankster",
      "H": "Corrosion"
    },
    "weightkg": 1.8,
    "evos": [
      "Naganadel"
    ],
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "naganadel": {
    "num": 804,
    "name": "Naganadel",
    "types": [
      "Poison",
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 73,
      "atk": 127,
      "def": 73,
      "spe": 127,
      "spa": 127,
      "spd": 73
    },
    "abilities": {
      "0": "Levitate",
      "1": "Ruthless",
      "H": "Tinted Lens"
    },
    "weightkg": 150.0,
    "prevo": "Poipole",
    "evoLevel": 45,
    "evoType": "levelHold",
    "evoItem": "Poison Gem",
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "stakataka": {
    "num": 805,
    "name": "Stakataka",
    "types": [
      "Rock",
      "Psychic"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 131,
      "atk": 131,
      "def": 211,
      "spe": 13,
      "spa": 13,
      "spd": 101
    },
    "abilities": {
      "0": "Filter",
      "1": "Magic Bounce"
    },
    "weightkg": 820.0,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "blacephalon": {
    "num": 806,
    "name": "Blacephalon",
    "types": [
      "Fire",
      "Ghost"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 73,
      "atk": 53,
      "def": 53,
      "spe": 127,
      "spa": 167,
      "spd": 127
    },
    "abilities": {
      "0": "Dazzling",
      "1": "Magician",
      "H": "Magic Guard"
    },
    "weightkg": 13.0,
    "eggGroups": [
      "Undiscovered"
    ]
  },
  "zeraora": {
    "num": 807,
    "name": "Zeraora",
    "types": [
      "Electric",
      "Fighting"
    ],
    "gender": "N",
    "baseStats": {
      "hp": 73,
      "atk": 122,
      "def": 70,
      "spe": 148,
      "spa": 117,
      "spd": 70
    },
    "abilities": {
      "0": "No Guard",
      "1": "Galvanize"
    },
    "weightkg": 44.5,
    "eggGroups": [
      "Undiscovered"
    ]
  }
}